import { CommonModule, DatePipe, formatNumber } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, Inject, inject, LOCALE_ID, OnDestroy, OnInit, output, QueryList, signal, ViewChild, ViewChildren, WritableSignal } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { noWhitespaceValidator } from '../../utils/no-whitespace.validator';
import {MatExpansionModule} from '@angular/material/expansion';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderComponent } from "../header/header.component";
import { FooterComponent } from '../footer/footer.component';
import { PropertyService } from '../../services/property.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
// import { MatButtonModule } from '@angular/material/button';
import { SaveConfirmationDialogComponent } from '../save-confirmation-dialog/save-confirmation-dialog.component';
import { IndicationQuoteStepComponent } from '../indication-quote-step/indication-quote-step.component';
import { RequestQuoteReferralStepComponent } from '../request-quote-referral-step/request-quote-referral-step.component';
import { AcceptQuoteStepComponent } from '../accept-quote-step/accept-quote-step.component';
import { RequestBindStepComponent } from '../request-bind-step/request-bind-step.component';
import { BindIssuePolicyStepComponent } from '../bind-issue-policy-step/bind-issue-policy-step.component';
import { ConfirmationDialogComponent } from '../utils/confirmation-dialog/confirmation-dialog.component';
import { Address, clearance,clearanceIndicationData,CopeDetails, IndicationDetails, SaveIndicationAndHomeResponse, UserDetails ,questions, clearanceQuoteData,addresses, IndicationRiskSummary, QuoteRiskSummary, getIndicationDetails, getCopeDetails, getquoteDetails, QuoteDetails, PolicyParametersData, IndicationRagDetailsResponse, PolicyRiskSummary} from '../../models/RequestQuote';
import { IndicationQuoteStepService } from '../../services/indicationQuoteStep.service';
import { DocumentUploadComponent } from '../document-upload/document-upload.component';
import { ToastService } from '../../services/toast.service';
import { IndicationStatus, ToastType } from '../../enums/config.enum';
import { forkJoin, map, Observable, of, Subscription } from 'rxjs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { RequestQuoteService } from '../../services/requestQuote.service';
import { AuthService } from '../../auth/auth.service';
import { SessionCacheHydrationService } from '../../services/session-cache-hydration.service';
import { parseSessionJson } from '../../utils/session-json.util';
import { MessageCenter } from '../message-center/message-center.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MessageCenterService } from '../../services/messageCenter.service';
import { sign } from 'crypto';
import { BrokerQuoteService } from '../../services/brokerQuote.service';
import { NavigationHandlerService } from '../../services/navigationHandler.service';
import { YearPipePipe } from '../../pipes/year-pipe.pipe';
import moment from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS,} from '@angular/material-moment-adapter';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PolicyAdministration } from '../policy-administration/policy-administration.component';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { ReferralDialogComponent } from '../utils/referral-dialog/referral-dialog.component';
import { CopeSpinnerComponent } from '../../cope-spinner.component';
import { formatCurrency } from '@angular/common';
import { ClearanceCheckDialogComponent } from '../utils/clearance-check-dialog/clearance-check-dialog.component';
import { SpinnerComponent } from '../utils/spinner/spinner.component';
import { PolicyAdministrationService } from '../../services/policyAdministration.service';
import { ApprovedStatesRestrictionDialog } from '../utils/approved-states-restriction-dialog/approved-states-restriction-dialog.component';
import { PRService } from '../../services/pr.service';
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';
import { SystemAdminService } from '../../services/system-admin.service';

interface BuildingDetails {
  sqFt: string;
  CrimeScore: string;
  DistanceToCoast: string;
  occupancy: string;
  constructionType: string;
  RoofType: string;
  Age: string;
  PcClass: string;
  RCV: string;
  roofReplaceUpdate: string;
  plumbing: string;
  hvac: string;
  electrical: string;

  [key: string]: any;

}

interface StaticResponses {
  [key: string]: BuildingDetails;
}

interface EditingState {
  RCV: boolean;
  sqFt: boolean;
  PcClass: boolean;
  constructionType: boolean;
  CrimeScore:boolean;
  DistanceToCoast:boolean;
  RoofType: boolean;
  Age: boolean;
  occupancy: boolean;
  roofReplaceUpdate:boolean;
  plumbing:boolean;
  hvac:boolean;
  electrical:boolean;
  story:boolean
}

interface Image {
  type: string; 
  data: string; 
}

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
}

@Component({
  selector: 'app-request-quote-poc',
  standalone: true,
  imports: [MatExpansionModule, CommonModule, FormsModule, ReactiveFormsModule, 
    HeaderComponent,FooterComponent,MatDialogModule, IndicationQuoteStepComponent,
    RequestBindStepComponent, BindIssuePolicyStepComponent, DocumentUploadComponent,
    MessageCenter,MatDatepickerModule,MatNativeDateModule,MatInputModule,
    MatFormFieldModule, YearPipePipe, AcceptQuoteStepComponent, MatCheckboxModule,
    PolicyAdministration, MatSelectModule,MatDialogModule,MatDialogActions,CopeSpinnerComponent,
    SpinnerComponent
  ],
  templateUrl: './request-quote.component.html',
  styleUrl: './request-quote.component.scss',
  providers: [DatePipe, 
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class RequestQuoteComponent implements OnInit, OnDestroy{
  @ViewChild('messageCenterContainer') private messageCenterContainer!: ElementRef;
  @ViewChildren('copeAddressPanel', { read: ElementRef }) private copeAddressPanels!: QueryList<ElementRef<HTMLElement>>;
  @ViewChildren('policyAddressPanel', { read: ElementRef }) private policyAddressPanels!: QueryList<ElementRef<HTMLElement>>;
  step = signal(this.getInitialStepFromStorage());
  visitedStep = signal(this.getInitialStepFromStorage());
  indicationStep: WritableSignal<number> = signal(1);
  clearanceIndicationStep: number | null = null;
  clearanceQuoteStep: number | null = null;
  addresses = signal<FormGroup[]>([]);
  structures = signal<FormGroup[]>([]);
  buildings = signal<FormGroup[]>([]);
  copeLoaderSignal = signal<boolean>(false)
  preferredReportsSignal = signal<boolean>(false)
  getcopeDataSignal = signal<boolean>(false)
  getPolicyDataSignal = signal<boolean>(false)
  question2Checked: boolean = false;
  question1Checked: boolean = false;
  addressForm: FormGroup;
  buildingForm = FormGroup;
  hasUserReplied: boolean = false;
  // namedInsured: string = '';
  namedInsured: WritableSignal<string> = signal('');
  businessIncomeLimits = signal<number>(0);
  // policyType: string = '';
  populatedNamedInsured: string = '';
  populatedTargetPremium:number = 0;
  populatedName: string = '';
  populatedMobileNumber:string = '';
  declineMessage: string | null = null;
  showNotification = false;
  showValidation = false;
  building1Limit: any = 0;
  building2Limit: any = 0;
  sqFtValue: string = '';
  isEditable: boolean = false;
  today1: string = '';
  maxStartDate: string | undefined = '';
  minStartDate: string | undefined = '';
  business: number[] = [];
  formattedBusinessIncomeLimits: string[] = []; 
  formControls: any[] = [];
  //showNamedInsured: boolean = false;
  showNamedInsured: WritableSignal<boolean> = signal(false);
  editMode: { [key: string]: boolean } = {};
  // questions: any[] = [];
  questions = signal<any[]>([]);
  questionAnswers = signal<{ [key: number]: number | string | boolean }>({
    1: false,
    2: false
  });
  quoteType = signal<string | null>('');
  newMessage = signal<string>('');
  userId = signal<string>('');
  userName = signal<string>('');
  tempQuoteId = signal<string | null>('');
  quoteId = signal<string | null>('');
  indicationId = signal<string | null>('');  
  tempQuoteNumber = signal<string | null>('');
  quoteNumber = signal<string | null>('');
  indicationDetails = signal<IndicationDetails | null>(null);
  quoteDetails = signal<QuoteDetails | null>(null);
  getIndicationDetails = signal<getIndicationDetails | null>(null);
  getquoteDetails = signal<getquoteDetails | null>(null);
  CopeDetails = signal<CopeDetails | null>(null);
  isCityStateListFetched = signal<boolean>(false);
  getCopeDetails = signal<getCopeDetails | null>(null);
  stateConditionSignal =signal<boolean>(false)
  submitReferralEmitter = output<boolean>();
  clearanceCheckEmitter = output<boolean>();
  accordionOpen = signal(false);
  systemAdminService = inject(SystemAdminService);
  messages = signal([
    { sender: 'Admin', text: 'Welcome to the Abacus Digital Underwriting System Message Center is your communication space with the underwriter. You can upload any necessary supporting documents in the Uploading Center located right below the Message Center.The Message Center will also display system responses based on the information you have ve provided. All your messages will be reviewed by the underwriter, and their responses for this quote will appear here as well. Please remember that all messages are tracked, and we encourage the use of respectful and professional language.  Please complete the required data to proceed.', time: this.getCurrentDateTime(), isAdmin: true, isInitial: true },
  ]);
  // cities: string[] = [];
  // counties: string[] = [];
  // states: string[] = [];

  buildingDetails = signal<FormGroup[]>([]);
  policyParameters = signal<any[]>([]);
  // populatedStatus: string = '';
  populatedTiv: string = '';
  populatedCalc: string = '';
  populatedQuoteId: string = '';
  // validationMessage: null | undefined;
  ragIndicationColor: WritableSignal<string> = signal("#A99333");
  policyTypes = signal<any[]>([]); 
  selectedPolicyType = signal<any | null>(null);
  selectedCauseOfLoss = signal<any | null>(null);
  Occupancies = signal<any[]>([]);
  coverageType = signal<any[]>([]);
  masterStateList = signal<any[]>([]);
  states: WritableSignal<Map<any, any[]>> = signal(new Map());
  counties: WritableSignal<Map<any, any[]>> = signal(new Map());
  cities: WritableSignal<Map<any, any[]>> = signal(new Map());
  router = inject(Router);
  toastService = inject(ToastService);
  requestQuoteService = inject(RequestQuoteService);
  messageCenterService = inject(MessageCenterService);
  clearance=signal<clearance|null>(null);
  indicationStatus = signal<number | null>(null);
    populatedStatus = signal('');

  clearanceId: number = 0;
  propertyService = inject(PropertyService);
  preferredReportsService = inject(PRService);
  selectedOccupancy: any = null;
  stateRule: any = null;
  dtcRule: any = null;
  role: number | null = null;
  isReadOnly = signal(false);
  isTargetOther = signal(false);
  messageSentFlags = {
    occupancyDecline: false,
    occupancyReferral: false,
    questionsFlagged: false,
  };
  branchId = signal<string | null>('');
  isapiCallSuccessful = signal(false);
  clearanceInfoSave = signal(false);
  copeInfoSave = signal(false)
  PolicyInfoSave = signal(false)
  loading = signal(false)
  // isCheckboxChecked = false;
  // isSubmitAttempted = false;
  // errorMessage = '';
  isLoading = signal(false);
  // isChecked: (() => boolean)[] = [];
  isChecked : WritableSignal<Map<number, boolean>> = signal(new Map());
  // isChecked = new Map<number, boolean>();
   errorMessage = signal<string | null>(null);
  policyParametersOpened = false;  
  addressAccordionOpened: boolean[] = [];
  copeAddressAccordionOpened: boolean[] = [];
  // PreferredReportsSave = signal(false)
  previousOccupancyStatus: string | null = null;
  previousQuestion1Checked: boolean | null = null;
  previousQuestion2Checked: boolean | null = null;
  structureValidationTriggered = signal<boolean>(false);
  staticResponses: StaticResponses = {
    "12345": {
      sqFt: "1500 sq ft",
      CrimeScore: "Low",
      DistanceToCoast: "10 miles",
      occupancy: "Residential",
      constructionType: "Wood Frame",
      RoofType: "Gable",
      Age: "5 years",
      PcClass: "10",
      hvac: "",
      RCV: "",
      roofReplaceUpdate: "",
      plumbing: "",
      electrical: ""
    },
    "67890": {
      sqFt: "2000 sq ft",
      CrimeScore: "Medium",
      DistanceToCoast: "20 miles",
      occupancy: "Commercial",
      constructionType: "Brick",
      RoofType: "Flat",
      Age: "10 years",
      PcClass: "15",
      hvac: "2019",
      RCV: "400,000",
      roofReplaceUpdate: "2019",
      plumbing: "2020",
      electrical: "2018",
    },
    "54321": {
      sqFt: "1800 sq ft",
      CrimeScore: "High",
      DistanceToCoast: "5 miles",
      occupancy: "Residential",
      constructionType: "Concrete",
      RoofType: "Hip",
      Age: "8 years",
      PcClass: "12",
      hvac: "2020",
      RCV: "800,000",
      roofReplaceUpdate: "2020",
      plumbing: "2019",
      electrical: "2020",
    },
    "98765": {
      sqFt: "2200 sq ft",
      CrimeScore: "Low",
      DistanceToCoast: "30 miles",
      occupancy: "Mixed-use",
      constructionType: "Steel",
      RoofType: "Gable",
      Age: "2 years",
      PcClass: "20",
      hvac: "2019",
      RCV: "500,000",
      roofReplaceUpdate: "2022",
      plumbing: "2020",
      electrical: "2018",
    },
    "13579": {
      sqFt: "1500 sq ft",
      CrimeScore: "Medium",
      DistanceToCoast: "15 miles",
      occupancy: "Residential",
      constructionType: "Wood Frame",
      RoofType: "Gable",
      Age: "3 years",
      PcClass: "8",
      hvac: "2017",
      RCV: "225,000",
      roofReplaceUpdate: "2023",
      plumbing: "2018",
      electrical: "2020",
    },
    "24680": {
      sqFt: "1600 sq ft",
      CrimeScore: "Low",
      DistanceToCoast: "25 miles",
      occupancy: "Residential",
      constructionType: "Vinyl",
      RoofType: "Flat",
      Age: "12 years",
      PcClass: "11",
      hvac: "2017",
      RCV: "300,000",
      roofReplaceUpdate: "2018",
      plumbing: "2020",
      electrical: "2019",
    },
    "11111": {
      sqFt: "1400 sq ft",
      CrimeScore: "High",
      DistanceToCoast: "3 miles",
      occupancy: "Commercial",
      constructionType: "Wood Frame",
      RoofType: "Hip",
      Age: "20 years",
      PcClass: "9",
      hvac: "2018",
      RCV: "180,000",
      roofReplaceUpdate: "2015",
      plumbing: "2017",
      electrical: "2020",
    },
    "22222": {
      sqFt: "1300 sq ft",
      CrimeScore: "Medium",
      DistanceToCoast: "7 miles",
      occupancy: "Residential",
      constructionType: "Brick",
      RoofType: "Gable",
      Age: "1 year",
      PcClass: "13",
      hvac: "2019",
      RCV: "235,000",
      roofReplaceUpdate: "2023",
      plumbing: "2020",
      electrical: "2017",
    },
    "33333": {
      sqFt: "1700 sq ft",
      CrimeScore: "Low",
      DistanceToCoast: "12 miles",
      occupancy: "Residential",
      constructionType: "Concrete",
      RoofType: "Flat",
      Age: "5 years",
      PcClass: "14",
      hvac: "2017",
      RCV: "290,000",
      roofReplaceUpdate: "2022",
      plumbing: "2020",
      electrical: "2019",
    },
  };

  staticAddresses = [
    {
      street: '123 Main St',
      city: 'Babylon',
      state: 'New York',
      country: 'Suffolk',
      zipcode: '62701',
      occupancy: 'Residential',
      externalRequestId: '12345',

    },
    {
      street: '456 Elm St',
      city: 'Jber',
      state: 'Alaska',
      country: 'Anchorage',
      zipcode: '12083',
      occupancy: 'Commercial',
      externalRequestId: '67890',
    },
    {
      street: '789 Oak St',
      city: 'Acton',
      state: 'Maine',
      country: 'York',
      zipcode: '98101',
      occupancy: 'Residential',
      externalRequestId: '54321',
    },
    {
      street: '135 Maple Ave',
      city: 'Alfred',
      state: 'Maine',
      country: 'York',
      zipcode: '73301',
      occupancy: 'Mixed-use',
      externalRequestId: '98765',
    },
    {
      street: '246 Pine St',
      city: 'Amawalk',
      state: 'New York',
      country: 'Westchester',
      zipcode: '90001',
      occupancy: 'Residential',
      externalRequestId: '13579',
    },
    {
      street: '369 Cedar St',
      city: 'Boston',
      state: 'New York',
      country: 'Erie',
      zipcode: '33101',
      occupancy: 'Commercial',
      externalRequestId: '24680',
    },
    {
      street: '159 Birch St',
      city: 'Big Lake',
      state: 'Alaska',
      country: 'Matanuska-Susitna',
      zipcode: '02101',
      occupancy: 'Residential',
      externalRequestId: '11111',
    },
    {
      street: '753 Spruce St',
      city: 'Bethel',
      state: 'Alaska',
      country: 'Bethel',
      zipcode: '80201',
      occupancy: 'Residential',
      externalRequestId: '22222',
    },
  ];
  authService = inject(AuthService);
  private sessionCacheHydration = inject(SessionCacheHydrationService);
  brokerQuoteService = inject(BrokerQuoteService);
  navigationHandler = inject(NavigationHandlerService);
  private indicationQuoteService = inject(IndicationQuoteStepService);
  private phoneUtil = PhoneNumberUtil.getInstance();
  targetPremiumSubs = new Subscription();
  clearanceDataSubs = new Subscription();
  tempPrResponse: any = null; // Temporary storage for PR response in draft mode
  isEditedAddressFlags: Map<number, number> = new Map(); // Map of addressId to isEdited flag (0 or 1)
  clearanceEditedAddressFlags: Map<number, number> = new Map(); // Map of addressId to isClearanceAddressEdited flag (0 or 1)
  copeDataSubs = new Subscription();
  policyParameterSubs = new Subscription();
  stateSubs = new Subscription();
  routeSubscription = new Subscription();
  navLogoClickSubscription = new Subscription();

  policyOAndLForm!: FormGroup;
  oAndLDataList = signal<any[]>([]);
  googleStreetImageSrc: WritableSignal<Map<number, string>> = signal(new Map());
  googleMapImageSrc: WritableSignal<Map<number, string>> = signal(new Map());
  buildingCounter = 0; // Initialize a counter
  prPrimaryUrl: string = '';
  prSecondaryUrl: string = '';
  isPolicyType = signal<boolean>(false);
  isreferral = signal<boolean>(false);
  isInceptionReferral = signal<boolean>(false);
  searchState: WritableSignal<Map<number, string>> = signal(new Map());
  searchCounty: WritableSignal<Map<number, string>> = signal(new Map());
  searchCity: WritableSignal<Map<number, string>> = signal(new Map());
  searchOccupancy = signal<any[]>([]);
  filteredStates: WritableSignal<Map<any, any[]>> = signal(new Map());;
  filteredCounty: WritableSignal<Map<any, any[]>> = signal(new Map());
  filteredCity: WritableSignal<Map<any, any[]>> = signal(new Map());
  filteredOccupancy = signal<any[]>([]);
  initialFormValue: any;
  initialAddressesSnapshot : any;
  addressesForPreferredReports: number[] = []; // Track addresses that need Preferred Reports due to empty buildings
  initialNamedInsured: string = '';
  maxYear = moment().endOf('year');
  policyEndDateMin = signal('');
  policyEndDateMax = signal('');
  crimeRatingList = signal<any[]>([]);
  constructionTypeList = signal<any[]>([]);
  roofTypeList = signal<any[]>([]);
  protectionClassList = signal<any[]>([]);
  TargetPremiumHeading = signal<string>('Target Premium Amount');
  policyService = inject(PolicyAdministrationService);
  PRService = inject(PRService);
  // Guard to prevent double save when closing COPE accordion due to Next click
  private suppressClearanceCloseSave: boolean = false;
  private shouldMarkClearanceAddressEdited: boolean = false;
  private pendingClearanceAddressIds: number[] = [];
  private suppressCopeCloseSave: boolean = false;
  private suppressCopePolicyParameterSave: boolean = false;
  private isCopePreviousNavigationInProgress: boolean = false;
  private suppressMainAccordionSaveStepUntil = 0;
  private startupHydrationReady = false;
  private policyContextRetryCount = 0;
  constructor(private fb: FormBuilder,private addressService: PropertyService, private datePipe: DatePipe,private dialog: MatDialog,private cdRef: ChangeDetectorRef,private route:ActivatedRoute,@Inject(LOCALE_ID) private locale: string) {
    this.addressForm = this.fb.group({

      addresses: this.fb.array([this.createAddressGroup()]),
    })
    this.initialFormValue = this.addressForm.getRawValue();
    this.addresses.set(this.addressControls().controls as FormGroup[]);

    this.formControls = this.addresses().map(() => ({}));
    this.policyOAndLForm = this.fb.group({
      oAndLCoverage: this.fb.array([])
    });  
  }


  
  ngOnInit() {
    this.sessionCacheHydration.ensureRestored().subscribe(() => {
      this.initializeRequestQuotePage();
    });
  }

  private initializeRequestQuotePage(): void {
    // Mark that we are in Request Quote flow so header can delegate navigation

    this.isTargetOther.set(false);
    const currentAccordionStepId = sessionStorage.getItem('currentStepId');
    this.isPolicyType.set(this.authService.isPolicyType());
    const routePolicyId = this.route.snapshot.paramMap.get('id');
    if (routePolicyId && this.isPolicyType()) {
      this.indicationQuoteService.setPolicyId(Number(routePolicyId));
    }
    this.route.params.subscribe(params => {
      const id = params['id'];
      if(id){
        // this.PreferredReportsSave.set(true)
        this.clearanceId=id;
        if (this.isPolicyType()) {
          this.indicationQuoteService.setPolicyId(Number(id));
        }
        const isReviewProcess = parseSessionJson<boolean>(
          sessionStorage.getItem('isReview'),
          false
        );
        isReviewProcess === true ? this.isReadOnly.set(true) : this.isReadOnly.set(false);
        this.fetchAccordionDataBasedOnStepId(String(currentAccordionStepId));
        sessionStorage.setItem("id",String(id))
        const currentAccordionStepIds = Number(sessionStorage.getItem('currentStepId'));
        }
    });
    //this.loadQuestions();
    // this.fetchAccordionDataBasedOnStepId(String(currentAccordionStepId));
    const getQuoteType = sessionStorage.getItem('quoteType');
    const tempQuoteId = sessionStorage.getItem('tempQuoteId');
    const tempQuoteNumber = sessionStorage.getItem('tempQuoteNumber');
    const userDetails = this.authService.getUserDetailsFromStorage()?.userDetails;
    // On refresh, restore previously saved step without running leave-step validation.
    this.setStep(Number(currentAccordionStepId), true);
    this.setVisitedStep(Number(currentAccordionStepId));
    if (userDetails?.userId != null) {
      this.userId.set(String(userDetails.userId));
      this.userName.set(userDetails.fullName ?? '');
      this.tempQuoteId.set(tempQuoteId);
      this.tempQuoteNumber.set(tempQuoteNumber);
    }
    if (getQuoteType) {
      this.quoteType.set(getQuoteType);
      if(!this.isIndicationType()){
        const quoteId = sessionStorage.getItem('quoteId');
        const getQuoteNumber = sessionStorage.getItem('quoteNumber');
        this.quoteId.set(quoteId);
        this.quoteNumber.set(getQuoteNumber);
      }
    };
    this.fetchAllRequiredFieldData();
    this.initialNamedInsured = this.namedInsured();
    this.initializeCheckedStates();

    if(this.isPolicyType()){
      this.TargetPremiumHeading.set("Bound Premium Amount")
    }else{
      if (this.isIndicationType()){
        this.TargetPremiumHeading.set("Target Premium Amount")
      }else{
        this.TargetPremiumHeading.set("Quoted Premium Amount")
      }
    }
    this.targetPremiumHeadingHandler();
    
    const isreferral = Number(sessionStorage.getItem("isreferral"))
    isreferral === 1 ? this.isreferral.set(false) : this.isreferral.set(true);   
    
    const inceptionStatus = String(sessionStorage.getItem("inceptionStatus"))
    inceptionStatus === "IDR" ? this.isInceptionReferral.set(false) : this.isInceptionReferral.set(true);

    this.getQuoteConfig();
    

     this.navigationHandler.setInRequestQuote(true);
    // Handle header logo clicks by triggering appropriate save/exit based on current step
    this.navLogoClickSubscription = this.navigationHandler.logoClick$.subscribe(() => {
      const currentStep = this.step();
      if (currentStep === 0) {
        this.clearanceBack();
      } else if (currentStep === 1) {
        this.copeBack();
      } else if (currentStep === 2) {
        this.PolicyParametersback();
      } else if (currentStep === 3) {
        // For step 3 (child components), let the child components handle their own save & exit
        // The child components are already subscribed to logoClick$ and will call their respective methods
        // No need to navigate here as the child components will handle the navigation
      } else {
        this.router.navigate(['/quote']);
      }
    });

    // Allow accordion opened handlers to call APIs only after cache hydration + init sequence.
    this.startupHydrationReady = true;
    if (this.step() === 2) {
      this.getPolicy();
    }
  }

  private getInitialStepFromStorage(): number {
    if (typeof sessionStorage === "undefined") {
      return 0;
    }
    const raw = sessionStorage.getItem("currentStepId");
    const parsed = Number(raw);
    if (!Number.isFinite(parsed) || parsed < 0) {
      return 0;
    }
    return parsed;
  }

  private withPolicyParamContext(run: () => void): void {
    const indicationId = Number(sessionStorage.getItem("indicationId") ?? 0);
    const quoteId = Number(sessionStorage.getItem("quoteId") ?? 0);
    const policyId = Number(this.authService.getUserDetailsFromStorage()?.policyId ?? 0);
    const hasContextId = this.isPolicyType()
      ? policyId > 0
      : this.isIndicationType()
        ? indicationId > 0
        : quoteId > 0;

    if (hasContextId) {
      this.policyContextRetryCount = 0;
      run();
      return;
    }

    if (this.policyContextRetryCount >= 10) {
      this.policyContextRetryCount = 0;
      return;
    }

    this.policyContextRetryCount += 1;
    setTimeout(() => this.withPolicyParamContext(run), 150);
  }

  fetchAllRequiredFieldData() {
    this.loadQuestions();
    this.loadAopDeductibles();
    this.loadWindDeductibles();
    this.loadWaterDamageCoverages();
    this.loadVandalismCoverages();
    this.loadOAndLCoverages();
    this.loadCoverageFactors();
    this.loadCauseOfLossOptions();
    this.loadStates();
    this.getPolicyTypes();
    this.getOccupaniesList();
    this.getPropertyCoverages();
    this.subscribeToCityChanges();
    this.loadCrimeRating();
    this.loadConstructionType();
    this.loadRoofType();
    this.loadProtectionClass();
    this.fetchConfig();
  }

    fetchConfig() {  
      this.PRService.GetAllSystemConfig().subscribe({
        next: (response : any) => {
          this.prPrimaryUrl = response[0].prPrimaryURL;
          this.prSecondaryUrl = response[0].prSecondaryURL;          
        },
        error: (error) => {
          
        }
      })
  }

  fetchAccordionDataBasedOnStepId(currentAccordionStepId: string){
    if(currentAccordionStepId === "0"){
      this.requestQuoteService.onUpdateClearanceStepData(true);
      this.fetchClearanceStepDataHandler();
    } else if(currentAccordionStepId === "1"){
      this.requestQuoteService.onUpdateClearanceStepData(true);
      this.fetchClearanceStepDataHandler();
      this.requestQuoteService.onUpdateCopeStepData(true);
      this.fetchCopeStepDataHandler();
    }else if(currentAccordionStepId === "2"){ 
      // this.requestQuoteService.onUpdateClearanceStepData(true);
      // this.fetchClearanceStepDataHandler();
      if(!this.isPolicyType()){
        this.requestQuoteService.onUpdatePolicyParameterStepData(true);    
        this.fetchPolicyParameterStepDataHandler();
      }
    }else if(currentAccordionStepId === "3"){
      this.getClearanceData();
      this.copeInfoSave.set(true)
      this.PolicyInfoSave.set(true)
      sessionStorage.setItem('copeInfosave',JSON.stringify(true))
      sessionStorage.setItem('PolicyInfoSave',JSON.stringify(true))
    }else if(currentAccordionStepId === "4"){
      this.getClearanceData();
      this.copeInfoSave.set(true);
      this.PolicyInfoSave.set(true);
      sessionStorage.setItem('clearanceInfoSave',JSON.stringify(true))
      sessionStorage.setItem('copeInfosave',JSON.stringify(true))
      sessionStorage.setItem('PolicyInfoSave',JSON.stringify(true))
    }
  }

  initializeCheckedStates() {
    this.isChecked.set(new Map()); // Ensure the map is cleared before reinitializing
    this.isChecked.update((map) => map.set(0, false))    
}

getIsConfirmedForAddress(index: number): number {
  // Find the address form group
  const addressGroup = this.addressControls().at(index) as FormGroup;
  // If the addressGroup has isConfirmed control, use it, else fallback to checkbox logic
  if (addressGroup.get('isConfirmed')) {
    return addressGroup.get('isConfirmed')?.value ? 1 : 0;
  }
  // Fallback: If you still have a checkbox in the template, you can check its value here
  return 0;
}

targetPremiumHeadingHandler(){
  this.targetPremiumSubs = this.requestQuoteService.getTargetPremiumHeading().subscribe({
    next: (response:boolean) => {
      if(response){        
        if(this.isPolicyType()){
          this.TargetPremiumHeading.set("Bound Premium Amount")          
        }else{
          if (this.isIndicationType()){
            this.TargetPremiumHeading.set("Target Premium Amount")

          }else{
            this.TargetPremiumHeading.set("Quoted Premium Amount")
          }
        }    
      }
    }
  })
}


  fetchClearanceStepDataHandler() {
    this.clearanceDataSubs = this.requestQuoteService.getClearanceStepData().subscribe({
      next: (response: boolean) => {
        if(response){
          this.getClearanceData();
          this.getDraftStatusData()          
          const currentAccordionStepId = sessionStorage.getItem('currentStepId');
          if(!this.isPolicyType()){
            this.fetchRiskSummaryData();
            this.getRagData();
          }
          // Call GET API to fetch isEdited flags
          this.fetchIsEditedAddressFlags();
          // this.requestQuoteService.resetClearanceStepData();
        }
      }
    })
  };

  fetchIsEditedAddressFlags() {
    const { id, type } = this.getCurrentIdAndType();
    if (!id) return;

    this.propertyService.getIsEditedAddress(id, type).subscribe({
      next: (response: any) => {
        if (response && response.addresses) {
          // Clear existing flags
          this.isEditedAddressFlags.clear();
          this.clearanceEditedAddressFlags.clear();
          // Store flags in map: addressId -> isEdited
          response.addresses.forEach((addr: any) => {
            if (addr.addressId) {
              this.isEditedAddressFlags.set(Number(addr.addressId), Number(addr.isEdited));
              this.clearanceEditedAddressFlags.set(
                Number(addr.addressId),
                Number(addr.isClearanceAddressEdited ?? 0)
              );
            }
          });
        }
      },
      error: (error) => {
        // Silently fail - flags will default to 0 if not found
        console.error('Failed to fetch isEdited address flags:', error);
      }
    });
  }

  allowOnlyNumbers(event : KeyboardEvent) : void{
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
        event.preventDefault();
    }
  }

  allowStreetNumberCharacters(event: KeyboardEvent): void {
  const allowedPattern = /^[0-9a-zA-Z\-\/ .#]$/;  
  const key = event.key;

  // allow control keys like Backspace, Delete, Tab, Arrow keys
  if (
    key === 'Backspace' ||
    key === 'Delete' ||
    key === 'Tab' ||
    key === 'ArrowLeft' ||
    key === 'ArrowRight'
  ) {
    return;
  }

  if (!allowedPattern.test(key)) {
    event.preventDefault();
  }
}
  allowOnlyAlphanumeric(event: KeyboardEvent): void {
    const key = event.key;
    
    // Check if the key is not an alphanumeric character (0-9, a-z, A-Z)
    if (!/^[a-zA-Z0-9 ]$/.test(key) && key !== "Backspace" && key !== "Delete" && key !== "ArrowLeft" && key !== "ArrowRight") {
        event.preventDefault(); // Prevent non-alphanumeric input
    }
  }

  // trackAddressFormChanges(): void {
  //   // Track changes to the address form
  //   this.addressForm.valueChanges.subscribe(() => {
  //     sessionStorage.setItem('copeInfosave', JSON.stringify(false));
  //   });
  // }

  fetchCopeStepDataHandler() {
    
    this.copeDataSubs = this.requestQuoteService.getCopeStepData().subscribe({
      next: (response: boolean) => {
        if(response){
          // Cope Step Binding Handler
          if(this.isPolicyType()){
            this.fetchPolicyDataCopeStep();
            this.getRagData();
          }else{
            this.getCopeDataWithDraftPreferredReports();
            this.getRagData();
            this.fetchRiskSummaryData();
            // this.requestQuoteService.resetCopeStepData();            
          } 
        }
      }
    }) 
  }

  getCopeDataWithDraftPreferredReports() {
    this.getcopeDataSignal.set(true);
    const { id, type } = this.getCurrentIdAndType();
    if (!id) {
      this.getCopeData(true);
      return;
    }

    this.propertyService.getIsEditedAddress(id, type).subscribe({
      next: (response: any) => {
        this.applyEditedAddressFlags(response);
        this.loadDraftPreferredReportsBeforeCopeBind();
      },
      error: () => {
        this.getcopeDataSignal.set(false);
        this.loadDraftPreferredReportsBeforeCopeBind();
      }
    });
  }

  private applyEditedAddressFlags(response: any) {
    if (!response?.addresses) {
      return;
    }

    this.isEditedAddressFlags.clear();
    this.clearanceEditedAddressFlags.clear();
    response.addresses.forEach((addr: any) => {
      if (addr.addressId) {
        this.isEditedAddressFlags.set(Number(addr.addressId), Number(addr.isEdited));
        this.clearanceEditedAddressFlags.set(
          Number(addr.addressId),
          Number(addr.isClearanceAddressEdited ?? 0)
        );
      }
    });
  }

  private loadDraftPreferredReportsBeforeCopeBind() {
    const draftStatus$ = this.isIndicationType()
      ? this.propertyService.getindicationDraftStatusIndication()
      : this.propertyService.getindicationDraftStatusQuote();

    draftStatus$.subscribe({
      next: (draftStatus: any) => {
        const draftKey = this.isIndicationType() ? 'indicationDraftStatus' : 'quoteDraftStatus';
        if (draftStatus) {
          sessionStorage.setItem(draftKey, JSON.stringify(draftStatus));
        }

        const isDraft = Number(draftStatus?.indicationDraft ?? draftStatus?.quoteDraft ?? 0) === 1;
        const hasEditedAddress = Array.from(this.isEditedAddressFlags.values())
          .some((isEdited) => Number(isEdited) === 1);

        if (isDraft || hasEditedAddress) {
          this.loadPreferredReportsThenCopeData();
        } else {
          this.getCopeData(true);
        }
      },
      error: () => {
        this.getCopeData(true);
      }
    });
  }

  private loadPreferredReportsThenCopeData() {
    const preferredReports$ = this.isIndicationType()
      ? this.propertyService.getGetPRApiResponseIndication()
      : this.propertyService.getGetPRApiResponseQuote();

    preferredReports$.subscribe({
      next: (prResponse: any) => {
        this.tempPrResponse = prResponse;
        this.getCopeData();
      },
      error: () => {
        this.getCopeData();
      }
    });
  }

  fetchPolicyParameterStepDataHandler() {
    this.policyParameterSubs = this.requestQuoteService.getPolicyParameterStepData().subscribe({
      next: (response: boolean) => {
        if(response){
          
          // Policy Parameter Step Binding Handler
          if(this.isPolicyType()) {            
            this.getPolicyDataPolicyParameterStep();
            this.getRagData();
          }else{
            this.getclearanceDataforPolicyParam()
            this.getPolicyParametersData();
            // this.getRagData();
            this.fetchRiskSummaryData()
          }
          // this.requestQuoteService.resetPolicyParameterStepData();

        }
      }
    })
  }

  getParamsIdForRiskSummary() {
 
    let paramsData = this.clearanceId;
    
    if(paramsData === 0){
      const dataForParams = this.isIndicationType() ? 
      this.authService.getUserDetailsFromStorage()?.indicationId : this.authService.getUserDetailsFromStorage()?.quoteId;
      if(dataForParams){
        paramsData = Number(dataForParams);
      }
    }
    return paramsData;
  }

  fetchIndicationRiskSummaryData() {
    const indicationId = sessionStorage.getItem('indicationId')
    this.indicationId.set(indicationId)
    this.indicationQuoteService.getIndicationRiskSummary(Number(this.indicationId())).subscribe({
      next: (response: IndicationRiskSummary) => {
        if(response){
          this.setIndicationQuoteRiskSummaryDetails(response);
        }
      },
      error: (error: any) => {
        this.toastService.addNotification({message: "System error. Failed to retrieve risk summary data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    });
  }

  fetchQuoteRiskSummaryData() {
    const quoteId = sessionStorage.getItem("quoteId")
    this.quoteId.set(quoteId)
    this.indicationQuoteService.getQuoteRiskSummary(Number(this.quoteId())).subscribe({
      next: (response: QuoteRiskSummary) => {
        if(response){
          this.setIndicationQuoteRiskSummaryDetails(response);
        }
      },
      error: (error: any) => {
        this.toastService.addNotification({message: "System error. Failed to retrieve risk summary data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    });
  }

  fetchPolicySummaryData() {
    this.policyService.getPolicyRiskSummary(Number(this.authService.getUserDetailsFromStorage()?.policyId))
    .subscribe({
      next: (response: PolicyRiskSummary) => {
        if(response){
          this.setPolicyRiskSummaryDetails(response);
          sessionStorage.setItem("policyNo",response.policyNo)
        }
      },
      error: (error: any) => {
        this.toastService.addNotification({message: "System error. Failed to retrieve risk summary data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    })
  }

  getRagData() {
    if (this.clearanceId) {
      let type: string;
      if (this.authService?.getUserDetailsFromStorage()?.isPolicyType) {
        type = 'Policy';
      } else if (this.isIndicationType()) { 
        type = 'Indication';
      } else {
        type = 'Quote';
      }

      this.indicationQuoteService.getPolicyRAG(this.clearanceId, type).subscribe(
        response => {
          this.setIndicationQuoteRagDetails(response);
        },
        error => {
        }
      );
    }
  }

  fetchRiskSummaryData() {
    this.isIndicationType() ? this.fetchIndicationRiskSummaryData() : this.fetchQuoteRiskSummaryData();
  }

  validateNamedInsured() {
    // this.showNamedInsured = !this.namedInsured; 
    // this.showNamedInsured = this.namedInsured.trim().length === 0;
    this.showNamedInsured.set(this.namedInsured().trim() === '');
    
  }

  validatePremium(): void {
    if (!this.premium || isNaN(Number(this.premium)) || Number(this.premium) <= 0) {
      this.showPremiumError = true;
    } else {
      this.showPremiumError = false;
    }
  }

  getSelectedYear(input: HTMLInputElement): Date {
    const selectedYear = input.value;
    if (selectedYear) {
      return new Date(Number(selectedYear), 0, 1); // January 1st of the selected year
    }
    return new Date(); // Default to the current date
  }

  private getYearNumber(value: any): number | null {
    if (!value) {
      return null;
    }
    // Handle Date
    if (value instanceof Date && !isNaN(value.getTime())) {
      return value.getFullYear();
    }
    // Handle moment-like objects
    if (value && typeof value.year === 'function') {
      return value.year();
    }
    // Handle string/number year
    const num = Number(String(value).slice(0, 4));
    return isNaN(num) ? null : num;
  }

  getBuildingYearMin(building: FormGroup): any {
    const age = building.get('Age')?.value;
    const year = this.getYearNumber(age);
    return year ? moment().year(year).startOf('year') : null;
  }

  onBuildingAgeYearSelected(event: Date, input: HTMLInputElement, building: FormGroup, dp: any): void {
    const selectedYear = event;
    building.get('Age')?.setValue(selectedYear);
    input.value = String(selectedYear);
    dp.close();

    // If any update years precede the newly selected Year Built, show a toast prompt
    const builtYear = this.getYearNumber(selectedYear);
    if (builtYear) {
      const updates = ['roofReplaceUpdate', 'plumbing', 'hvac', 'electrical'];
      for (const key of updates) {
        const updateYear = this.getYearNumber(building.get(key)?.value);
        if (updateYear && updateYear < builtYear) {
          this.toastService.addNotification({ message: 'Update precedes year built. Please check dates.', type: ToastType.Error });
          break;
        }
      }
    }
  }

  onRoofReplacementYearSelected(event: Date, input: HTMLInputElement, building: FormGroup, dp: any): void {
    const selectedYear = event;
    const builtYear = this.getYearNumber(building.get('Age')?.value);
    if (!builtYear) {
      this.toastService.addNotification({ message: 'Please provide year built', type: ToastType.Error });
      dp.close();
      return;
    }
    const updateYear = this.getYearNumber(selectedYear);
    if (updateYear && updateYear < builtYear) {
      this.toastService.addNotification({ message: 'Update precedes year built. Please check dates.', type: ToastType.Error });
      dp.close();
      return;
    }
    building.get('roofReplaceUpdate')?.setValue(selectedYear);
    input.value = String(selectedYear);
    dp.close();
  }

  onUpdatePlumbingYearSelected(event: Date, input: HTMLInputElement, building: FormGroup, dp: any): void {
    const selectedYear = event;
    const builtYear = this.getYearNumber(building.get('Age')?.value);
    if (!builtYear) {
      this.toastService.addNotification({ message: 'Please provide year built', type: ToastType.Error });
      dp.close();
      return;
    }
    const updateYear = this.getYearNumber(selectedYear);
    if (updateYear && updateYear < builtYear) {
      this.toastService.addNotification({ message: 'Update precedes year built. Please check dates.', type: ToastType.Error });
      dp.close();
      return;
    }
    building.get('plumbing')?.setValue(selectedYear);
    input.value = String(selectedYear);
    dp.close();
  }

  onHvacYearSelected(event: Date, input: HTMLInputElement, building: FormGroup, dp: any): void {
    const selectedYear = event;
    const builtYear = this.getYearNumber(building.get('Age')?.value);
    if (!builtYear) {
      this.toastService.addNotification({ message: 'Please provide year built', type: ToastType.Error });
      dp.close();
      return;
    }
    const updateYear = this.getYearNumber(selectedYear);
    if (updateYear && updateYear < builtYear) {
      this.toastService.addNotification({ message: 'Update precedes year built. Please check dates.', type: ToastType.Error });
      dp.close();
      return;
    }
    building.get('hvac')?.setValue(selectedYear);
    input.value = String(selectedYear);
    dp.close();
  }

  formatDateToYear(date: Date): string {
    return this.datePipe.transform(date, 'yyyy') || '';  // This will return only the year (e.g., '2024')
  }

  onElectricalYearSelected(event: Date, input: HTMLInputElement, building: FormGroup, dp: any): void {
    const selectedYear = event;
    const builtYear = this.getYearNumber(building.get('Age')?.value);
    if (!builtYear) {
      this.toastService.addNotification({ message: 'Please provide year built', type: ToastType.Error });
      dp.close();
      return;
    }
    const updateYear = this.getYearNumber(selectedYear);
    if (updateYear && updateYear < builtYear) {
      this.toastService.addNotification({ message: 'Update precedes year built. Please check dates.', type: ToastType.Error });
      dp.close();
      return;
    }
    building.get('electrical')?.setValue(selectedYear);
    input.value = this.formatDateToYear(event);
    dp.close();
  }

  onRadioChange(event: any) {
    this.policyType = event.target.value;
  }

  private getDtcRuleValue(): string | null {
    if (typeof this.dtcRule !== 'string') {
      return null;
    }
    const trimmed = this.dtcRule.trim();
    return trimmed || null;
  }

  private shouldForceWindHailExcluded(): boolean {
    return this.stateRule === 'AOP Only' || this.getDtcRuleValue() === 'Decline';
  }

  private setDtcRule(dtc: string | null | undefined): void {
    const normalizedDtc = (dtc ?? '').replace(/["']/g, '').trim();
    this.dtcRule = normalizedDtc || null;

    if (normalizedDtc === 'Referral') {
      sessionStorage.setItem('dtcRule', 'Referral');
    } else if (normalizedDtc === 'Decline') {
      sessionStorage.setItem('dtcRule', 'Decline');
    } else {
      sessionStorage.removeItem('dtcRule');
    }

    this.applyWindHailCoverageRules();
  }

  applyWindHailCoverageRules(): void {
    if (this.shouldForceWindHailExcluded()) {
      this.disableWindOptions = true;
      this.formData.windDeductibleFlag = 1;
      const filteredOptions = this.windDeductibles.filter(d => d.description === 'Wind/Hail Excluded');
      this.filterWindDeductible.set(filteredOptions);

      const defaultOption = filteredOptions[0];
      if (defaultOption) {
        this.formData.windDeductibleFactor = defaultOption.factor;
        this.formData.windDeductibleId = defaultOption.deductibleId;
        this.formData.windDeductibleDescription = defaultOption.description;
      }
      this.stateConditionSignal.set(true);
    } else {
      this.disableWindOptions = false;
      this.stateConditionSignal.set(false);
      this.updateFilteredDeductibles();
    }
  }

  OnStateRules(stateOrDtc: any) {
    if (typeof stateOrDtc === 'string' || stateOrDtc === null || stateOrDtc === undefined) {
      this.setDtcRule(stateOrDtc);
      return;
    }

    if (stateOrDtc.ruleName !== undefined) {
      this.stateRule = stateOrDtc.ruleName;
      this.applyWindHailCoverageRules();
    }
  }

  onStateChange(event: MatSelectChange, index: number){
    const selectedState = event;
    const selectedStateId = selectedState.value;

    const state = Array.from(this.filteredStates().values()).flat().find(s => s.stateId === selectedStateId);;
    this.OnStateRules(state)
    
  }

  subscribeToCityChanges() {
   

    const storedRole = sessionStorage.getItem('role');   
    this.role = storedRole ? parseInt(storedRole, 10) : null;
   
    this.checkConditions();
    // this.cdRef.detectChanges();
  }

  loadQuestions() {
    this.propertyService.getQuestions().subscribe({
      next: (response: any[]) => {
        this.questions.set(response);

        const policyId = sessionStorage.getItem("policyId");
        const quoteId = sessionStorage.getItem("quoteId");
        const indicationId = sessionStorage.getItem("indicationId");

         this.route.params.subscribe(params => {
         const id = params['id'];
         if(!id && !policyId && !quoteId && !indicationId){
          // During initial setup if question ID is missing
          const defaultAnswers = this.questions().reduce((acc, q) => {
            acc[q.questionId] = 1; // Center position (grey)
            return acc;
          }, {} as { [key: number]: number });

          this.questionAnswers.set(defaultAnswers);
          }
        });               
      },
      error: (error: any) => {
       
      }
    });
  }

onRangeChange(event: any, questionId: number) {
  const value = parseInt(event.target.value, 10); // 0 = gold, 1 = gray, 2 = gold
  const updatedAnswers = { ...this.questionAnswers(), [questionId]: value };
  this.questionAnswers.set(updatedAnswers);
} 

onRangeChangecope(buildingGroup: FormGroup, controlName: string, event: Event): void {
  const val = Number((event.target as HTMLInputElement).value);
  buildingGroup.get(controlName)?.setValue(val);
}

getToggleColor(value: any): string {
  const val = Number(value);

  // Treat value 0 as center if it's the initial state (optional fallback)
  if (isNaN(val)) return '#ccc';
  switch (val) {
    case 0: return '#FFFAE5'; 
    case 1: return '#ccc';    
    case 2: return '#FFFAE5'; 
    default: return '#ccc';
  }
}

getToggleBorder(value:any): string{
  const val = Number(value);
  if (isNaN(val)) return '#ccc';
  switch (val) {
    case 0: return '1px solid #A99333'; 
    case 1: return '#ccc';    
    case 2: return '1px solid #A99333'; 
    default: return '#ccc';
  }
}


  onQuestionChange(event: any, questionId: number) {
    const isChecked = event.target.checked ? 1 : 0;
  
    // Update the signal state
    const updatedAnswers = { ...this.questionAnswers(), [questionId]: isChecked };
    this.questionAnswers.set(updatedAnswers);
  }

  createAddressGroup(): FormGroup {
    const isDisabled = this.isReadOnly();

    return this.fb.group({
      addressid: [''],
      street: ['', [Validators.required, noWhitespaceValidator]],
      city:  new FormControl('', [Validators.required, noWhitespaceValidator]),
      state:  new FormControl('', [Validators.required, noWhitespaceValidator]),
      country:  new FormControl('', [Validators.required, noWhitespaceValidator]),
      zipcode:['', [Validators.required, noWhitespaceValidator]],
      occupancy:['', [Validators.required, noWhitespaceValidator]],
      unitNum:[''],
      streetNum:['', [Validators.required, noWhitespaceValidator]],
      buildingDetails: this.fb.array([this.createBuildingGroup()]),   
      structures: this.fb.array([this.createStructureGroup()]), 
      isConfirmed: [false] 
    });    

  }

  createStructureGroup(): FormGroup {
    const isDisabled = this.isReadOnly();

    return this.fb.group({
    coverageLimit: new FormControl({ value: '', disabled: isDisabled }, [Validators.required, noWhitespaceValidator]),
      otherStructuresLimit: ['', [Validators.required, noWhitespaceValidator]],
      isOthersSelected: [false],
      otherDescription: ['', [Validators.maxLength(64)]]
    });
  }

  createBuildingGroup(): FormGroup {
    
    return this.fb.group({
      buildingid: [''],
      DistanceToCoast: [''],
      PcClass: ['', [Validators.required, noWhitespaceValidator]],
      CRIMERATING: [''],
      story: ['', [Validators.required, noWhitespaceValidator]],
      RCV: [''],
      sqFt: ['', [Validators.required, noWhitespaceValidator]],
      CONSTTYPE: ['', [Validators.required, noWhitespaceValidator]],
      ROOFTYPE: ['', [Validators.required, noWhitespaceValidator]],
      Age: ['', [Validators.required, noWhitespaceValidator]],
      Occupancy: [''],
      roofReplaceUpdate: [moment()],
      plumbing: [moment()],
      hvac: [moment()],
      electrical: [moment()],
      Burglar: [1, [Validators.required, noWhitespaceValidator]],
      sprinklers: [1, [Validators.required, noWhitespaceValidator]],
      FireAlarm: [1, [Validators.required, noWhitespaceValidator]],
      buildingLimit: [''],
      businessPropertyLimit: [''],
      isCheckboxChecked: [''],
      googleMapImageSrc: [''],
      googleStreetImageSrc:[''],
    })
  }

  onCheckboxChanges(buildingGroup: FormGroup, controlName: string, event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    buildingGroup.get(controlName)?.setValue(isChecked ? 1 : 0);
}
  
  getStateTooltipText(value: string){
    const getStateName = Array.from(this.states().values()).flat().find(s => String(s.stateId) === String(value));
    if(getStateName.length > 0){
      return getStateName[0].stateName;
    }
    return '';
  }

  private resolveAddressId(address: any): number {
    const id =
      address?.addressId ??
      address?.indicationAddressId ??
      address?.quoteAddressId ??
      address?.policyAddressId ??
      null;

    if (typeof id === 'number') {
      return id;
    }

    const parsed = Number(id);
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  createBuildingLimitsGroup(): FormGroup {
    return this.fb.group({
      buildingLimit: ['', [Validators.required, noWhitespaceValidator]],
      businessPropertyLimit: ['', [Validators.required, noWhitespaceValidator]],
    });
  }

  createPolicyParameterGroup(): FormGroup {
    return this.fb.group({
      buildingLimit: '',
      buildingDetails: ''
    });
  }


  addressControls(): FormArray {
    return this.addressForm.get('addresses') as FormArray;
  }

  structureControls(): FormArray {
    return this.addressForm.get('structures') as FormArray;
  }

  buildingControls(): FormArray {
    return this.addressForm.get('buildings') as FormArray;
  }

  buildingControlsForAddress(index: number): FormArray {
    const addressControl = this.addressControls().at(index);
    if (!addressControl) {
      return this.fb.array([]);
    }
    return (addressControl.get('buildingDetails') as FormArray) ?? this.fb.array([]);
  }

  buildingControlsForBuilding(index:number):FormArray {
    const buildingcontrol = this.buildingControls().at(index)
    return buildingcontrol.get('buildingLimits') as FormArray;
  }

  structureControlsForAddress(index: number): FormArray {
    const addressControl = this.addressControls().at(index);
    if (!addressControl) {
      return this.fb.array([]);
    }
    return (addressControl.get('structures') as FormArray) ?? this.fb.array([]);
  }
  

  getFormGroup(control: AbstractControl): FormGroup {
    return control as FormGroup;
  }

  addAdditionalAddress() {
    if (this.addressControls().length < 10) {
      const newAddress = this.createAddressGroup();
      this.addressControls().push(newAddress);
      this.addresses.set(this.addressControls().controls as FormGroup[]);
      this.isChecked.update((map) => map.set(this.addressControls().length - 1, false));
      this.subscribeToCityChanges();
    } else {
        this.toastService.addNotification({message: "Maximum limit reached. Only 10 addresses are permitted per policy.", type: ToastType.Error}); // error notification
    }
  }
  

 addBuildingDetail(addressIndex: number): void {
    const buildingDetailsArray = this.buildingControlsForAddress(addressIndex);
    
    const newBuildingGroup = this.createBuildingGroup();
    
    if (buildingDetailsArray.length > 0) {
        const lastBuildingData = buildingDetailsArray.at(buildingDetailsArray.length - 1).value;
        
        newBuildingGroup.patchValue({
            DistanceToCoast: lastBuildingData.DistanceToCoast || null,
            CRIMERATING: lastBuildingData.CRIMERATING || null,          
            PcClass: lastBuildingData.PcClass || null,
            Age:"",
            roofReplaceUpdate: "",
            plumbing: "",
            hvac: "",
            electrical: "",
            googleMapImageSrc: lastBuildingData.googleMapImageSrc || null,
            googleStreetImageSrc: lastBuildingData.googleStreetImageSrc || null
        });
    }
    
    buildingDetailsArray.push(newBuildingGroup);
}


  addAdditionalBuilding() {
    this.buildingControls().push(this.createBuildingGroup());
    this.buildings.set(this.buildingControls().controls as FormGroup[]);
  }


  addAdditionalStructure(addressIndex: number): void {
    // Add the new structure
    const newStructureGroup = this.createStructureGroup();
    this.structureControlsForAddress(addressIndex).push(newStructureGroup);
  
    // Now apply the same logic to the newly added structure
    this.applyCoverageLimitLogicForStructure(addressIndex, this.structureControlsForAddress(addressIndex).length - 1);
  }
  
  // This method applies the same logic for enabling/disabling 'otherStructuresLimit' based on 'coverageLimit'
  applyCoverageLimitLogicForStructure(addressIndex: number, structureIndex: number): void {
    const structureGroup = this.structureControlsForAddress(addressIndex).at(structureIndex) as FormGroup;
    const selectedValue = structureGroup.get('coverageLimit')?.value;
    const otherStructuresLimitControl = structureGroup.get('otherStructuresLimit');
  
    structureGroup.get('isOthersSelected')?.setValue(selectedValue === '12');
  
    if (selectedValue === '') {
      otherStructuresLimitControl?.reset();
      otherStructuresLimitControl?.disable();
    } else if (!this.isReadOnly()) {
      otherStructuresLimitControl?.enable();
    }
  }
  

  removeStructure(addressIndex: number, structureIndex: number) {
    this.structureControlsForAddress(addressIndex).removeAt(structureIndex);
     this.calculateTotals();
  }

  removeAddress(index: number) {
    if (index > 0) {
      this.addressControls().removeAt(index);
      this.addresses.set(this.addressControls().controls as FormGroup[]);

      this.reindexSignalMap(this.states, index);
      this.reindexSignalMap(this.counties, index);
      this.reindexSignalMap(this.cities, index);
      this.reindexSignalMap(this.filteredStates, index);
      this.reindexSignalMap(this.filteredCounty, index);
      this.reindexSignalMap(this.filteredCity, index);
      this.reindexSignalMap(this.searchState, index);
      this.reindexSignalMap(this.searchCounty, index);
      this.reindexSignalMap(this.searchCity, index);
      this.reindexSignalMap(this.isChecked, index);

      // Clear Business Income values and formatted cache for the removed address index
      // so that when a new address is added later, it does not retain previous values
      if (Array.isArray(this.business)) {
        this.business.splice(index, 1);
      }
      if (Array.isArray(this.formattedBusinessIncomeLimits)) {
        this.formattedBusinessIncomeLimits.splice(index, 1);
      }

      // Recalculate totals after structural change
      this.calculateTotals();
    }
  }

  private reindexSignalMap<T>(mapSignal: WritableSignal<Map<number, T>>, removedIndex: number): void {
    mapSignal.update((map) => {
      const newMap = new Map<number, T>();
      map.forEach((value, key) => {
        if (key < removedIndex) {
          newMap.set(key, value);
        } else if (key > removedIndex) {
          newMap.set(key - 1, value);
        }
      });
      return newMap;
    });
  }

  removeBuilding(index: number) {
    this.buildingControls().removeAt(index);
    this.buildings.set(this.buildingControls().controls as FormGroup[]);
    this.calculateTotals()
  }

  removeBuildingDetail(addressIndex: number, buildingIndex: number) {
    const buildingDetailsArray = this.buildingControlsForAddress(addressIndex);
    
    if (buildingIndex > 0) {      
      buildingDetailsArray.removeAt(buildingIndex);
      // this.googleStreetImageSrc.update((map) => { map.delete(buildingIndex); return map; });
      // this.googleMapImageSrc.update((map) => { map.delete(buildingIndex); return map; });
    }
  }

  getPolicyParametersForAddress(addressIndex: number): FormGroup[] {
    return this.buildingControlsForAddress(addressIndex).controls as FormGroup[];
  }

  checkConditions(): void {
    const addressArray = this.addressControls(); 
    
    if (!addressArray || !addressArray.controls.length) {
        return;
    }

    addressArray.controls.forEach((addressControl: AbstractControl, addressIndex: number) => {
        const addressGroup = this.getFormGroup(addressControl);
        const structureArray = addressGroup.get('structures') as FormArray;

        if (!structureArray || !structureArray.controls.length) {
            return;
        }

        structureArray.controls.forEach((structureControl: AbstractControl, structureIndex: number) => {
            const structureGroup = this.getFormGroup(structureControl);
            const coverageLimitControl = structureGroup.get('coverageLimit');

            if (!coverageLimitControl) {
                return;
            }

            if (this.isReadOnly()) {
                coverageLimitControl.disable();
            } else {
                coverageLimitControl.enable();
            }
        });
    });
  }

  

fetchAllBuildingDetails(event?: Event): void {
  // Prevent event propagation if called from click event
  if (event) {
    event.stopPropagation();
    event.preventDefault();
  }

  const id = sessionStorage.getItem('id');
  const externalRequestId = this.isIndicationType() ? sessionStorage.getItem('indicationNo') : sessionStorage.getItem('quoteNo');
  const addressesFormArray = this.addressControls();
  const payloadAddresses: { externalRequestId: string | null; subRequestId: string; streetNumber: string; unit: string; city: any; state: any; zipcode: string; streetName: string; userId: number | null }[] = [];

  // Process all addresses instead of just edited ones
  addressesFormArray.controls.forEach((addressGroup, index) => {
    const raw = addressGroup.getRawValue();
    const { city, state } = addressGroup.value;

    const getStateName = Array.from(this.states().values()).flat().find(s => String(s.stateId) === String(state));
    const getCityName = Array.from(this.cities().values()).flat().find(c => String(c.cityId) === String(city));

     const storedIndicationAddress = sessionStorage.getItem('indicationAddressId');
     const indicationAddressIds: any[] = (storedIndicationAddress && storedIndicationAddress !== 'undefined' && storedIndicationAddress !== 'null') ? JSON.parse(storedIndicationAddress) : [];
     const storedQuoteAddress = sessionStorage.getItem('quoteAddressId');
     const quoteAddressIds: any[] = (storedQuoteAddress && storedQuoteAddress !== 'undefined' && storedQuoteAddress !== 'null') ? JSON.parse(storedQuoteAddress) : [];

    const subRequestId = this.isIndicationType()
      ? (indicationAddressIds.length > index ? indicationAddressIds[index] : index + 1)
      : (quoteAddressIds.length > index ? quoteAddressIds[index] : index + 1);

    payloadAddresses.push({
      externalRequestId: externalRequestId,
      subRequestId: subRequestId.toString(),
      streetNumber: String(raw.streetNum),
      unit: String(raw.unitNum || ''),
      city: getCityName?.cityName || raw.city,
      state: getStateName?.stateName || raw.state,
      zipcode: String(raw.zipcode),
      streetName: String(raw.street),
      userId: Number(this.authService?.getUserDetailsFromStorage()?.userDetails?.userId)
    });
  });

  if (payloadAddresses.length === 0) return; // Nothing to call

  const body = { Addresses: payloadAddresses };
  this.preferredReportsSignal.set(true);
  if(!this.isReadOnly()){
    this.propertyService.RefreshIcon(body).subscribe({
      next: (response: any) => {
        this.preferredReportsSignal.set(false);

        if (response?.addresses?.length > 0) {
          // Flatten the nested addresses structure first
          const flatAddresses = response.addresses.flat();
          flatAddresses.forEach((addrResponse: any, index: number) => {
            // Pass the single address object and its index
            this.patchBuildingDataToFormConditional(addrResponse, index);
          });
        }
      },
      error: (error:any) => {
        this.preferredReportsSignal.set(false);

        this.addressControls().controls.forEach((_, index) => {
        const buildingForAddress = sessionStorage.getItem('buildingIdforaddress');
        const storedBuildingIdsForAddress = (buildingForAddress && buildingForAddress !== 'undefined' && buildingForAddress !== 'null') ? JSON.parse(buildingForAddress) : [];
        const buildingId = storedBuildingIdsForAddress.length > index ? storedBuildingIdsForAddress[index] : '';
          const buildingControls = this.buildingControlsForAddress(index);
          buildingControls.clear();
          buildingControls.push(this.createBuildingGroup());
          buildingControls.controls.forEach((building) => {
            const buildingFormGroup = building as FormGroup;  
            buildingFormGroup.patchValue({              
                buildingId: buildingId,
                Burglar: 1,
                sprinklers: 1,
                FireAlarm: 1,                
                CRIMERATING: "U - Unknown",
                PcClass: "",
                CONSTTYPE: "",
                ROOFTYPE: "",
                Age:"",
                roofReplaceUpdate: "",
                plumbing: "",
                hvac: "",
                electrical: "", 
            });
          });
        });
      }
    });
  }else{
    this.addressControls().controls.forEach((_, index) => {
          const buildingControls = this.buildingControlsForAddress(index);
          buildingControls.clear();
          buildingControls.push(this.createBuildingGroup());
        });
  }
}

private resolveDropdownCode(value: any, options: any[], candidateKeys: string[]): string {
  const rawValue = value === null || value === undefined ? '' : String(value).trim();
  if (!rawValue || !Array.isArray(options) || options.length === 0) {
    return '';
  }

  const normalize = (v: any): string =>
    String(v ?? '')
      .toLowerCase()
      .replace(/\s+/g, '')
      .trim();

  const valueNormalized = normalize(rawValue);
  const valuePrefixNormalized = valueNormalized.includes(':') ? valueNormalized.split(':')[0] : valueNormalized;

  for (const option of options) {
    for (const key of candidateKeys) {
      const optionValue = option?.[key];
      if (optionValue === null || optionValue === undefined) {
        continue;
      }

      const optionRaw = String(optionValue).trim();
      const optionNormalized = normalize(optionRaw);
      const optionPrefixNormalized = optionNormalized.includes(':') ? optionNormalized.split(':')[0] : optionNormalized;

      if (
        optionNormalized === valueNormalized ||
        optionPrefixNormalized === valuePrefixNormalized ||
        optionNormalized === valuePrefixNormalized ||
        optionPrefixNormalized === valueNormalized
      ) {
        const preferredCode = option?.code;
        if (preferredCode !== null && preferredCode !== undefined && String(preferredCode).trim() !== '') {
          return String(preferredCode).trim();
        }
        return optionRaw;
      }
    }
  }

  // Preserve existing API value when no option mapping is found, so we don't
  // force "Select Option" for a populated backend value.
  return '';
}
patchBuildingDataToForm(addresses: any[], index: number): void {
  
  // Handle different possible response structures
  let flatAddresses: any[] = [];
  
  if (Array.isArray(addresses)) {
    if (Array.isArray(addresses[0])) {
      flatAddresses = addresses.flat();
    } else {
      flatAddresses = addresses;
    }
  } else if (addresses && typeof addresses === 'object') {
    // If addresses is an object, try to extract the addresses array
    if ((addresses as any).addresses && Array.isArray((addresses as any).addresses)) {
      flatAddresses = (addresses as any).addresses;
    } else {
      flatAddresses = [addresses];
    }
  }
  

  // Try different possible property data locations
  let propertyData = null;
  
  // First try: direct propertyData on first address
  if (flatAddresses[0]?.propertyData) {
    propertyData = flatAddresses[0].propertyData;
  }
  // Second try: propertyData as direct property
  else if (flatAddresses[0] && typeof flatAddresses[0] === 'object') {
    propertyData = flatAddresses[0];
  }
  // Third try: look for propertyData in nested structure
  else if (flatAddresses[0]?.data?.propertyData) {
    propertyData = flatAddresses[0].data.propertyData;
  }
  

  
  if (!propertyData) {
     const buildingControls = this.buildingControlsForAddress(index);
  
            // Clear existing building forms
            while (buildingControls.length !== 0) {
              buildingControls.removeAt(0);
            }
  
            buildingControls.push(this.createBuildingGroup()); // Add a new empty form

                    const buildingForAddress = sessionStorage.getItem('buildingIdforaddress');
        const storedBuildingIdsForAddress = (buildingForAddress && buildingForAddress !== 'undefined' && buildingForAddress !== 'null') ? JSON.parse(buildingForAddress) : [];
        const buildingId = storedBuildingIdsForAddress.length > index ? storedBuildingIdsForAddress[index] : '';
  
            buildingControls.controls.forEach((building) => {
              const buildingFormGroup = building as FormGroup;
  
              buildingFormGroup.patchValue({
                buildingId: buildingId,
                Burglar: 1,
                sprinklers: 1,
                FireAlarm: 1,
                occupancy: occupancyValue,
                CRIMERATING: "U - Unknown",
                PcClass: "",
                CONSTTYPE: "",
                ROOFTYPE: "",
                Age:"",
                roofReplaceUpdate: "",
                plumbing: "",
                hvac: "",
                electrical: "",
              });
            });
            return;
   
  }

  const crimeCodes = this.crimeRatingList().map(item => item.code);

  const buildingControls = this.buildingControlsForAddress(index);
 
  
  // Check if this is a newly added address by checking if it has any values
  const currentAddressValue = this.addressControls().at(index).value;
 
  while (buildingControls.length !== 0) buildingControls.removeAt(0);

  // Get the first building from the response (single building per address)
  const buildings = flatAddresses[0]?.buildings || [];
  const firstBuilding = buildings.length > 0 ? buildings[0] : null;
  
  // Create a single building group
  const newBuildingGroup = this.createBuildingGroup();
  buildingControls.push(newBuildingGroup);
  
  // Verify the building group was added properly
 

  const year = propertyData.age ? parseInt(propertyData.age, 10) : null;
  const calculatedAge = String(year ? (new Date().getFullYear() - year) : null);
  const occupancyValue = this.getOccupancyName(this.addressControls().at(index).get('occupancy')?.value);
  
  const googleMapImage = propertyData.images?.find((image: any) => image.type === 'GoogleMapView');
  const googleStreetImage = propertyData.images?.find((image: any) => image.type === 'GoogleStreetView');
  const base64MapSrc = googleMapImage?.data ? `data:image/png;base64,${googleMapImage.data}` : '';
  const base64StreetSrc = googleStreetImage?.data ? `data:image/png;base64,${googleStreetImage.data}` : '';

 
  this.descriptionMap.set(index, occupancyValue); 
  this.googleMapImageSrc.update((map) => map.set(index, base64MapSrc));
  this.googleStreetImageSrc.update((map) => map.set(index, base64StreetSrc));

  
  // Handle date fields properly - convert to moment objects if they have values
  const handleDateField = (value: any) => {
    if (value && typeof value === 'string') {
      return moment(value);
    }
    return moment(); // Default to current date for required date fields
  };
  
          // Retrieve buildingid from session storage based on the address index
        const buildingForAddress = sessionStorage.getItem('buildingIdforaddress');
        const storedBuildingIdsForAddress = (buildingForAddress && buildingForAddress !== 'undefined' && buildingForAddress !== 'null') ? JSON.parse(buildingForAddress) : [];
        const buildingId = storedBuildingIdsForAddress.length > index ? storedBuildingIdsForAddress[index] : '';
  
  const buildingFormValues = {
    DistanceToCoast: propertyData.distanceToCoast || null,
    sqFt: propertyData.sqFt || null,
    CRIMERATING: crimeCodes.includes(propertyData.crimeScore) ? propertyData.crimeScore : "U - Unknown",
    story: propertyData.numberOfStories || null,
    valuationMin: propertyData.valuationMin || null,
    valuationMax: propertyData.valuationMax || null,
    PcClass: this.resolveDropdownCode(propertyData.pcClass, this.protectionClassList(), ['code', 'protectionClassList', 'description']),
    RCV: this.formatCurrencyValue(propertyData.replacementCost) || null,
    CONSTTYPE: this.resolveDropdownCode(propertyData.constructionType, this.constructionTypeList(), ['code', 'description', 'name']),
    ROOFTYPE: this.resolveDropdownCode(propertyData.roofType, this.roofTypeList(), ['code', 'description', 'name']),
    Age: propertyData.age,
    Occupancy: occupancyValue || null,
    roofReplaceUpdate:propertyData.roofReplaceUpdate,
    plumbing: propertyData.plumbing,
    hvac: propertyData.hvac,
    electrical: propertyData.electrical,
    Burglar: 1,
    sprinklers: 1,
    FireAlarm: 1,
    buildingid: buildingId,
    googleMapImageSrc: base64MapSrc,
    googleStreetImageSrc: base64StreetSrc
  };
  
  if (buildingControls && buildingControls.length > 0 && buildingControls.controls[0]) {
    try {
      buildingControls.controls[0].patchValue(buildingFormValues);
    } catch (error) {
    }
    
    // Verify the patching worked
    setTimeout(() => {
      const patchedValues = buildingControls.controls[0].value;
     
    }, 100);
  }

  // Patch images at address level too
  this.addressControls().at(index).patchValue({
    googleMapImageSrc: base64MapSrc,
    googleStreetImageSrc: base64StreetSrc,
    isConfirmed: false  // Uncheck the confirmation checkbox when binding data from patchBuildingDataToForm
  });
  
}

patchBuildingDataToFormConditional(addressData: any, index: number): void {
  
  
  // Handle different possible response structures
  let targetAddress = null;
  
  if (Array.isArray(addressData)) {
    // If it's an array, get the first element
    targetAddress = addressData[0];
  } else if (addressData && typeof addressData === 'object') {
    // If it's an object, use it directly
    targetAddress = addressData;
  }
  
  if (!targetAddress) {
    return;
  }
  
  
  // Try different possible property data locations
  let propertyData = null;
  
  // First try: direct propertyData on target address
  if (targetAddress?.propertyData) {
    propertyData = targetAddress.propertyData;
    
  }
  // Second try: propertyData as direct property
  else if (targetAddress && typeof targetAddress === 'object') {
    propertyData = targetAddress;
  }
  // Third try: look for propertyData in nested structure
  else if (targetAddress?.data?.propertyData) {
    propertyData = targetAddress.data.propertyData;
  }
  
  if (!propertyData) {
    return; // No data to patch
  }

  const crimeCodes = this.crimeRatingList().map(item => item.code);

  const buildingControls = this.buildingControlsForAddress(index);
  
  // Only proceed if there's at least one building control
  if (buildingControls.length === 0) {
    return;
  }

  // Get the first building from the response (single building per address)
  // const buildings = flatAddresses[0]?.buildings || [];
  // const firstBuilding = buildings.length > 0 ? buildings[0] : null;
  
  const occupancyValue = this.getOccupancyName(this.addressControls().at(index).get('occupancy')?.value);
  
  const googleMapImage = propertyData.images?.find((image: any) => image.type === 'GoogleMapView');
  const googleStreetImage = propertyData.images?.find((image: any) => image.type === 'GoogleStreetView');
  const base64MapSrc = googleMapImage?.data ? `data:image/png;base64,${googleMapImage.data}` : '';
  const base64StreetSrc = googleStreetImage?.data ? `data:image/png;base64,${googleStreetImage.data}` : '';

  this.descriptionMap.set(index, occupancyValue); 
  this.googleMapImageSrc.update((map) => map.set(index, base64MapSrc));
  this.googleStreetImageSrc.update((map) => map.set(index, base64StreetSrc));

  // Retrieve first-building id per address from session storage (array of numbers)
  // Example: buildingIdforaddress = [firstIdForAddress0, firstIdForAddress1, ...]
  const perAddressIdsRaw = sessionStorage.getItem('buildingIdforaddress');
  const perAddressIdsParsed = (perAddressIdsRaw && perAddressIdsRaw !== 'undefined' && perAddressIdsRaw !== 'null') ? JSON.parse(perAddressIdsRaw) : null;
  const firstBuildingIdForThisAddress = Array.isArray(perAddressIdsParsed) ? perAddressIdsParsed[index] : undefined;

  // Helper function to check if a value is empty
  const isEmpty = (value: any): boolean => {
    return value === null || value === undefined || value === '' || value === 0;
  };

  // Prepare buildings from response if available
  const responseBuildings = Array.isArray((targetAddress as any)?.buildings) ? (targetAddress as any).buildings : [];

  // Process ALL buildings for this address
  buildingControls.controls.forEach((buildingControl, buildingIndex) => {
    const currentValues = buildingControl.value;
    
    // Create conditional patch object for this building
    const conditionalPatchValues: any = {};
    
    // Always bind these fields if response has value (no condition check needed)
    if (propertyData.distanceToCoast) {
      conditionalPatchValues.DistanceToCoast = propertyData.distanceToCoast;
    }
    
    if (propertyData.replacementCost) {
      conditionalPatchValues.RCV = this.formatCurrencyValue(propertyData.replacementCost);
    }
    
    if (occupancyValue) {
      conditionalPatchValues.Occupancy = occupancyValue;
    }
    
    // Prefer building id from response; fallback to first-building id from session for index 0 only
    const idFromResponse = Array.isArray(responseBuildings) && responseBuildings[buildingIndex]?.buildingid;
    const buildingSpecificId = (idFromResponse !== undefined && idFromResponse !== null && idFromResponse !== '')
      ? idFromResponse
      : (buildingIndex === 0 ? firstBuildingIdForThisAddress : undefined);
    if (buildingSpecificId !== undefined && buildingSpecificId !== null && buildingSpecificId !== '') {
      conditionalPatchValues.buildingid = buildingSpecificId;
    }
    
    if (base64MapSrc) {
      conditionalPatchValues.googleMapImageSrc = base64MapSrc;
    }
    
    if (base64StreetSrc) {
      conditionalPatchValues.googleStreetImageSrc = base64StreetSrc;
    }

    // CRIMERATING: bind if empty or value is "U - Unknown"
    if (propertyData.crimeScore && (isEmpty(currentValues.CRIMERATING) || currentValues.CRIMERATING === "U - Unknown")) {
      conditionalPatchValues.CRIMERATING = crimeCodes.includes(propertyData.crimeScore) ? propertyData.crimeScore : "U - Unknown";
    }

    const resolvedPcClass = this.resolveDropdownCode(propertyData.pcClass, this.protectionClassList(), ['code', 'protectionClassList', 'description']);
    const resolvedConstType = this.resolveDropdownCode(propertyData.constructionType, this.constructionTypeList(), ['code', 'description', 'name']);
    const resolvedRoofType = this.resolveDropdownCode(propertyData.roofType, this.roofTypeList(), ['code', 'description', 'name']);

    // PcClass: bind if empty or legacy default "Unknown"
    if (propertyData.pcClass && (isEmpty(currentValues.PcClass) || currentValues.PcClass === "Unknown")) {
      conditionalPatchValues.PcClass = resolvedPcClass;
    }

    // CONSTTYPE: bind if empty or legacy default "0: Other"
    if (propertyData.constructionType && (isEmpty(currentValues.CONSTTYPE) || currentValues.CONSTTYPE === "0: Other")) {
      conditionalPatchValues.CONSTTYPE = resolvedConstType;
    }

    // ROOFTYPE: bind if empty or legacy default "Other"
    if (propertyData.roofType && (isEmpty(currentValues.ROOFTYPE) || currentValues.ROOFTYPE === "Other")) {
      conditionalPatchValues.ROOFTYPE = resolvedRoofType;
    }

    // Burglar, sprinklers, FireAlarm: bind 1 if value is not 0 or 2
    if (currentValues.Burglar !== 0 && currentValues.Burglar !== 2) {
      conditionalPatchValues.Burglar = 1;
    }
    
    if (currentValues.sprinklers !== 0 && currentValues.sprinklers !== 2) {
      conditionalPatchValues.sprinklers = 1;
    }
    
    if (currentValues.FireAlarm !== 0 && currentValues.FireAlarm !== 2) {
      conditionalPatchValues.FireAlarm = 1;
    }

    // Other form controls: only bind if form control is empty
    if (isEmpty(currentValues.sqFt) && propertyData.sqFt) {
      conditionalPatchValues.sqFt = propertyData.sqFt;
    }
    
    if (isEmpty(currentValues.story) && propertyData.numberOfStories) {
      conditionalPatchValues.story = propertyData.numberOfStories;
    }
    
    if (isEmpty(currentValues.valuationMin) && propertyData.valuationMin) {
      conditionalPatchValues.valuationMin = propertyData.valuationMin;
    }
    
    if (isEmpty(currentValues.valuationMax) && propertyData.valuationMax) {
      conditionalPatchValues.valuationMax = propertyData.valuationMax;
    }
    
    if (isEmpty(currentValues.Age) && propertyData.age) {
      conditionalPatchValues.Age = propertyData.age;
    }
    
    if (isEmpty(currentValues.roofReplaceUpdate) && propertyData.roofReplaceUpdate) {
      conditionalPatchValues.roofReplaceUpdate = propertyData.roofReplaceUpdate;
    }
    
    if (isEmpty(currentValues.plumbing) && propertyData.plumbing) {
      conditionalPatchValues.plumbing = propertyData.plumbing;
    }
    
    if (isEmpty(currentValues.hvac) && propertyData.hvac) {
      conditionalPatchValues.hvac = propertyData.hvac;
    }
    
    if (isEmpty(currentValues.electrical) && propertyData.electrical) {
      conditionalPatchValues.electrical = propertyData.electrical;
    }
    
    // Only patch if there are values to update
    if (Object.keys(conditionalPatchValues).length > 0) {
      try {
        buildingControl.patchValue(conditionalPatchValues);
      } catch (error) {
        console.error(`Error patching building form values for building ${buildingIndex}:`, error);
      }
    }
  });

  // Always patch images at address level if response has values
  const currentAddressControl = this.addressControls().at(index);
  const addressPatchValues: any = {};
  
  if (base64MapSrc) {
    addressPatchValues.googleMapImageSrc = base64MapSrc;
  }
  
  if (base64StreetSrc) {
    addressPatchValues.googleStreetImageSrc = base64StreetSrc;
  }
  
  if (Object.keys(addressPatchValues).length > 0) {
    addressPatchValues.isConfirmed = false;  // Uncheck the confirmation checkbox when binding data from patchBuildingDataToFormConditional
    currentAddressControl.patchValue(addressPatchValues);
  }
}
  fetchBuildingDetails(address: any, index: number): void {
    const id = sessionStorage.getItem('id');
  
    const { city, state } = address.value;
  
    const payload = address.value;
    const getStateName = Array.from(this.states().values()).flat().find(s => String(s.stateId) === String(state));
    const getCityName = Array.from(this.cities().values()).flat().find(c => String(c.cityId) === String(city));
  
    if (getStateName && getCityName) {
      payload.state = getStateName?.stateName;
      payload.city = getCityName?.cityName;
    }
    const crimeCodes = this.crimeRatingList().map(item => item.code);
    this.preferredReportsSignal.set(true);
    this.preferredReportsService.fetchBuildingDetails(payload).subscribe(
      (response:any) => {
        this.preferredReportsSignal.set(false);
        if (response && response.addresses && response.addresses.length > 0) {
          const addressData = response.addresses[0];
          const occupancyValue = this.getOccupancyName(address.get('occupancy')?.value);
  
          if (response.addresses[0].success === false) {
            this.toastService.addNotification({ message: "Unable to fetch COPE information for the address provided. Amend address and try again. ", type: ToastType.Error });
            const buildingControls = this.buildingControlsForAddress(index);
  
            // Clear existing building forms
            while (buildingControls.length !== 0) {
              buildingControls.removeAt(0);
            }
  
            buildingControls.push(this.createBuildingGroup()); // Add a new empty form
  
            buildingControls.controls.forEach((building) => {
              const buildingFormGroup = building as FormGroup;
  
              buildingFormGroup.patchValue({
                Burglar: 1,
                sprinklers: 1,
                FireAlarm: 1,
                occupancy: occupancyValue,
                CRIMERATING: "U - Unknown",
                PcClass: "",
                CONSTTYPE: "",
                ROOFTYPE: "",
                Age:"",
                roofReplaceUpdate: "",
                plumbing: "",
                hvac: "",
                electrical: "",
              });
            });
            return;
          }
  
          if (addressData.propertyData) {
            const propertyData = addressData.propertyData;
  
            const googleMapImage = propertyData.images.find((image: Image) => image.type === 'GoogleMapView');
            const googleStreetImage = propertyData.images.find((image: Image) => image.type === 'GoogleStreetView');
  
            if (propertyData) {
              const base64ImageSrc = googleMapImage?.data ? `data:image/png;base64,${googleMapImage.data}` : '';
              const base64ImageSrc1 = googleStreetImage?.data ? `data:image/png;base64,${googleStreetImage.data}` : '';
  
              const buildingControls = this.buildingControlsForAddress(index);
              this.googleMapImageSrc.update((map) => map.set(index, base64ImageSrc));
              this.googleStreetImageSrc.update((map) => map.set(index, base64ImageSrc1));
              this.addressControls().at(index).patchValue({
                googleMapImageSrc: base64ImageSrc,
                googleStreetImageSrc: base64ImageSrc1,
                isConfirmed: false  // Uncheck the confirmation checkbox when binding data from fetchBuildingDetails
              });
  
              // Clear existing building forms
              while (buildingControls.length !== 0) {
                buildingControls.removeAt(0);
              }
  
              // Push a new building group before patching values
              buildingControls.push(this.createBuildingGroup());
  
              buildingControls.controls.forEach((building) => {
                const buildingFormGroup = building as FormGroup;
  
                const year = propertyData.age ? parseInt(propertyData.age, 10) : null;
                const calculatedAge = String(year ? (new Date().getFullYear() - year) : null);
  
                buildingFormGroup.patchValue({
                  DistanceToCoast: propertyData.distanceToCoast || null,
                  sqFt: propertyData.sqFt || null,
                  CRIMERATING: crimeCodes.includes(propertyData.crimeScore) ? propertyData.crimeScore : "U - Unknown",
                  story: propertyData.numberOfStories || null,
                  valuationMin: propertyData.valuationMin || null,
                  valuationMax: propertyData.valuationMax || null,
                  PcClass: this.resolveDropdownCode(propertyData.pcClass, this.protectionClassList(), ['code', 'protectionClassList', 'description']),
                  RCV: this.formatCurrencyValue(propertyData.replacementCost) || null,
                  CONSTTYPE: this.resolveDropdownCode(propertyData.constructionType, this.constructionTypeList(), ['code', 'description', 'name']),
                  ROOFTYPE: this.resolveDropdownCode(propertyData.roofType, this.roofTypeList(), ['code', 'description', 'name']),
                  Age: propertyData.age || null,
                  Occupancy: occupancyValue || null,
                  roofReplaceUpdate: propertyData.roofReplaceUpdate || null,
                  plumbing: propertyData.plumbing || null,
                  hvac: propertyData.hvac || null,
                  electrical: propertyData.electrical || null,
                  Burglar: 1,
                  sprinklers: 1,
                  FireAlarm: 1,
                  googleMapImageSrc: base64ImageSrc,
                  googleStreetImageSrc: base64ImageSrc1,
                  buildingid: '',
                });
              });
            } else {
              const buildingControls = this.buildingControlsForAddress(index);
  
              buildingControls.controls.forEach((building) => {
                const buildingFormGroup = building as FormGroup;
                buildingFormGroup.reset();
              });
            }
          } else {
            const buildingControls = this.buildingControlsForAddress(index);
  
  
            buildingControls.controls.forEach((building) => {
              const buildingFormGroup = building as FormGroup;
              buildingFormGroup.reset();
            });
          }
        }
      },
      (error) => {
        this.preferredReportsSignal.set(false);
        const buildingControls = this.buildingControlsForAddress(index);
        buildingControls.push(this.createBuildingGroup());
        buildingControls.controls.forEach((building) => {
          const buildingFormGroup = building as FormGroup;
          buildingFormGroup.reset();
        });
      }
    );
  }
  

  fetchBuildingDetailsOnInput(addressGroup: FormGroup): void {
    const matchedAddress = {
      street: addressGroup.value.street,
      city: addressGroup.value.city,
      state: addressGroup.value.state,
      country: addressGroup.value.country,
      zipcode: addressGroup.value.zipcode,
      occupancy: addressGroup.value.occupancy,
    };

    const foundAddress = this.staticAddresses.find(
      (addr) =>
        addr.street === matchedAddress.street &&
        addr.city === matchedAddress.city &&
        addr.state === matchedAddress.state &&
        addr.country === matchedAddress.country &&
        addr.zipcode === matchedAddress.zipcode
    );

    if (foundAddress) {
      const buildingDetails = this.staticResponses[foundAddress.externalRequestId];
      const buildingControls = this.buildingControlsForAddress(this.addressControls().controls.indexOf(addressGroup));
      buildingControls.controls.forEach((building, index) => {
        const buildingFormGroup = building as FormGroup;
        buildingFormGroup.patchValue(buildingDetails);
      });
    } else {
      const buildingControls = this.buildingControlsForAddress(this.addressControls().controls.indexOf(addressGroup));
      buildingControls.controls.forEach((building) => {
        const buildingFormGroup = building as FormGroup;
        buildingFormGroup.reset();
      });
    }

    const stateValue = addressGroup.value.state;
    if (stateValue === 'Louisiana' || stateValue === 'Florida') {
      this.disableWindOptions = true;
      this.formData.windDeductibleFlag = 0;
      this.formData.windDeductibleFactor = null;
      this.formData.windDeductibleId = null;
      this.formData.windDeductibleDescription = '';
    } else {
      this.disableWindOptions = false;
    }
  }
  


  onQuestion1Change(event: any) {
    this.question1Checked = event.target.checked;
  }

  onQuestion2Change(event: any) {
    this.question2Checked = event.target.checked;
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.newMessage.set(input.value);
  }

  updateRagIndicationColor(feedBackType: string = "") {
    switch(feedBackType){
      case "GreenRange":
        this.ragIndicationColor.set("#238823");
        break;
      case "AmberRange":
        this.ragIndicationColor.set("#FFBF00");
        break;
      case "RedRange":
        this.ragIndicationColor.set("#FF0000");
        break;
      case "ReferralRedLow":
        this.ragIndicationColor.set("#FF0000");
        break;
      case "ReferralRedHigh":
        this.ragIndicationColor.set("#238823");
        break;
              
      default:
        this.ragIndicationColor.set('#A99333')  // default gold color
    }
  }

  onSubmitReferral(action: boolean){
    if(action){
      // Call the Messages API to get the system generated message and display in the Message center
    }
  }

   getQuoteConfig(){
    this.systemAdminService.getQuoteConfig().subscribe({
      next: (response: any) => {
        sessionStorage.setItem("maxVersionCount",response[0].versionMaxCount);
        sessionStorage.setItem("inDtMinLimit",response[0].inDtMinLimit);
        sessionStorage.setItem("inDtValidLimit",response[0].inDtValidLimit);
        sessionStorage.setItem("inDtMaxLimit",response[0].inDtMaxLimit);
        if(!this.isUwAdmin()){
     const todayMoment = moment(); // Current date
    this.today1 = todayMoment.format('YYYY-MM-DD'); // For [min]

      if(this.isIndicationType()){
        const maxlimit = sessionStorage.getItem("inDtMaxLimit")
        this.maxStartDate = todayMoment.clone().add(Number(maxlimit), 'days').format('YYYY-MM-DD'); // For [max]
        this.minStartDate = todayMoment.format('YYYY-MM-DD');    
      }else{
        const maxlimit = sessionStorage.getItem("inDtMaxLimit")
        this.maxStartDate = todayMoment.clone().add(maxlimit, 'days').format('YYYY-MM-DD'); // For [max]
        this.minStartDate = todayMoment.format('YYYY-MM-DD');
      }
    }else{
      this.minStartDate = undefined;
    this.maxStartDate = undefined;
    }
    
      },
      error: (error: any) => {

      }
    })
  }

  fetchIndicationRagdetails(){
    forkJoin([
      this.indicationQuoteService.getPolicyRAG(Number(this.authService.getUserDetailsFromStorage()?.indicationId),"Indication"),
      this.indicationQuoteService.getIndicationRiskSummary(Number(this.authService.getUserDetailsFromStorage()?.indicationId)),
    ]).pipe(
      map(([indicationRating, indicationRiskSummary]) => {
        return {indicationRating, indicationRiskSummary};
      })
    ).subscribe({
      next: (response: any) => {
        if(response){
          this.setIndicationQuoteRagDetails(response?.indicationRating);
          this.setIndicationQuoteRiskSummaryDetails(response?.indicationRiskSummary);
        }
      },
      error: (error: any) => {
      }
    })
  }

  fetchQuoteRagdetails(){
    forkJoin([
      this.indicationQuoteService.getPolicyRAG(Number(this.authService.getUserDetailsFromStorage()?.quoteId),"Quote"),
      this.indicationQuoteService.getQuoteRiskSummary(Number(this.authService.getUserDetailsFromStorage()?.quoteId)),
    ]).pipe(
      map(([quoteRating, quoteRiskSummary]) => {
        return {quoteRating, quoteRiskSummary};
      })
    ).subscribe({
      next: (response: any) => {
        if(response){
          this.setIndicationQuoteRagDetails(response?.quoteRating);
          this.setIndicationQuoteRiskSummaryDetails(response?.quoteRiskSummary);
        }
      },
      error: (error: any) => {
      }
    })
  }

  fetchPolicyRagDetails() {
    forkJoin([
        this.indicationQuoteService.getPolicyRAG(Number(this.authService.getUserDetailsFromStorage()?.policyId),"Policy"),
        this.policyService.getPolicyRiskSummary(Number(this.authService.getUserDetailsFromStorage()?.policyId)),
    ]).pipe(
        map(([policyRating, policyRiskSummary]) => {
          return {policyRating, policyRiskSummary};
        })
    ).subscribe({
      next: (response: any) => {
        if(response){
          this.setIndicationQuoteRagDetails(response?.policyRating);
          this.setPolicyRiskSummaryDetails(response?.policyRiskSummary);
        }
      },
      error: (error: any) => {
      }
    });
  }
  

  setStep(index: number, forceRestore = false) {
    // guard before changing step
    if (!forceRestore && !this.canLeaveCurrentStep(index)) {
      return;
    }
    this.step.set(index);
    
    sessionStorage.setItem('currentStepId', String(index));
    if (Date.now() >= this.suppressMainAccordionSaveStepUntil) {
      this.handleMainAccordionSaveStep(index);
    }
    if(index === 3){
      const currentIndicationBindStepID = this.brokerQuoteService.getIndicationBindStepId();
      
      if(currentIndicationBindStepID){
        this.setIndicationStep(Number(currentIndicationBindStepID));
        if(currentIndicationBindStepID !=="1"){
          
          if(!this.isPolicyType()) {
            if(this.isIndicationType()){           
              this.fetchIndicationRagdetails();
            }else{
              this.fetchQuoteRagdetails();
            }
          }
          // this.getRagData()
        }
      }else{
        this.setIndicationStep(1); // default show the first step
      }
    }
    // else{
    //   this.updateRagIndicationColor();
    // }
  }

  setVisitedStep(index: number){
    this.visitedStep.set(index);
  }

  // Guard: validate current step before navigating away
 canLeaveCurrentStep(targetStep: number): boolean {
    const current = this.step();
    // Prevent redundant work
    if (current === targetStep) {
      return true;
    }

 

    // When leaving Policy Parameters (step 2), enforce policy validations
    if (current === 2) {
      if (!this.isReadOnly()) {
       
      const cleanedPremium = this.cleanCurrencyValue(this.premium);


  if (!cleanedPremium || isNaN(cleanedPremium) || cleanedPremium <= 0) {
    this.showPremiumError = true;
    this.toastService.addNotification({ 
      message: "Target Premium Amount is required", 
      type: ToastType.Error 
    });
    return false;
  } else {
    this.showPremiumError = false;
  }
   
    if (this.getTotalTIVLimit() > 2500000){

      this.toastService.addNotification({message: "Maximum TIV limit allowed is $2.5M. Please amend the limits entered or exit to return to landing page.", type: ToastType.Error}); // error notification
      return false;
    }

    if(this.selectedPolicyType() !==3){
    for (let i = 0; i < this.addressControls().length; i++) {
      const buildings = this.getPolicyParametersForAddress(i);
      for (let j = 0; j < buildings.length; j++) {
          const buildingLimit = buildings[j].get('buildingLimit')?.value;
          if (buildingLimit === 0 || buildingLimit === '0' || buildingLimit === '' || buildingLimit === null || buildingLimit === undefined) {
            this.openPolicyAddressAccordion(i);
            this.toastService.addNotification({message: "This type of policy must include building limits. Please edit policy parameters or exit to return to landing page", type: ToastType.Error}); // error notification
            return false;
          }
      }}}
       if(this.selectedPolicyType() ===3){
    for (let i = 0; i < this.addressControls().length; i++) {
      const buildings = this.getPolicyParametersForAddress(i);
      for (let j = 0; j < buildings.length; j++) {
        const buildingLimit = buildings[j].get('buildingLimit')?.value;
          const businessPropertyLimit = buildings[j].get('businessPropertyLimit')?.value;
          const businessIncomeLimit = this.business[i];
          if ((businessPropertyLimit === 0 || businessPropertyLimit === '0' || businessPropertyLimit === '' || businessPropertyLimit === null || businessPropertyLimit === undefined) && (businessIncomeLimit === 0  || businessIncomeLimit === null || businessIncomeLimit === undefined) && (buildingLimit === 0 || buildingLimit === '0' || buildingLimit === '' || buildingLimit === null || buildingLimit === undefined)) {
            this.openPolicyAddressAccordion(i);
            this.toastService.addNotification({message: 'This type of policy must include I&B Limit, or BPP Limit or BI Limit. Please edit policy parameters or exit to return to landing page', type: ToastType.Error}); // error notification
            return false;
          }
      }}}
          // Validate Additional Property Coverages/Limit per address/structure
    this.structureValidationTriggered.set(true); // Trigger validation display
    for (let i = 0; i < this.addressControls().length; i++) {
      const structures = this.structureControlsForAddress(i);
      const total = structures.length;
      for (let j = 0; j < total; j++) {
        const error = this.getStructureError(i, j);
        if (error) {          
          this.openPolicyAddressAccordion(i);
          return false;
        }
      }
    }
    if (this.hasPolicyValidationErrors()) {
      return false;
    }
      }
      
    }    

    // When leaving COPE (step 1), enforce COPE validations similar to Next
    if (current === 1) {
      if (!this.isReadOnly()) {
        // Prevent leaving while inline edits pending
        if (this.isEditing['story'] || this.isEditing['sqFt'] || this.isEditing['RCV'] || this.isEditing['DistanceToCoast']) {
          const editingLocation = this.findEditingFieldLocation();
          if (editingLocation) {
            this.openCopeAddressAccordion(
              editingLocation.addressIdx,
              editingLocation.buildingIdx,
              editingLocation.fieldName
            );
          }
          this.toastService.addNotification({message: "Please confirm/decline the editable field changes before proceeding", type: ToastType.Error});
          return false;
        }
        // Target premium must be valid
        const cleanedPremium = this.cleanCurrencyValue(this.premium);
        if (!cleanedPremium || isNaN(cleanedPremium) || cleanedPremium <= 0) {
          this.showPremiumError = true;
          this.toastService.addNotification({message: "Target Premium Amount is required", type: ToastType.Error});
          return false;
        }
        this.showPremiumError = false;

        // Validate Year Built dependencies across all buildings before proceeding
        const addressesForValidation = this.addressForm.get('addresses') as FormArray;
        for (let a = 0; a < addressesForValidation.length; a++) {
          const addressControl = addressesForValidation.at(a) as FormGroup;
          const buildingDetailsFA = addressControl.get('buildingDetails') as FormArray;
          if (buildingDetailsFA && Array.isArray(buildingDetailsFA.controls)) {
            for (const b of buildingDetailsFA.controls) {
              const buildingGroup = b as FormGroup;
              const msg = this.getBuildingYearsValidationMessage(buildingGroup);
              if (msg) {
                this.toastService.addNotification({ message: msg, type: ToastType.Error });
                this.openCopeAddressAccordion(a);
                this.cdRef.detectChanges();
                return false;
              }
            }
          }
        }

        // Unified COPE validation (fields + alarms + confirmation checkbox)
        if (this.validateCopeFields()) {
          return false;
        }
      }
    }

    // When leaving Clearance (step 0), optionally enforce Clearance validations if needed
    // Currently no explicit clearance validator; keep default behavior

    return true;
  }

  setIndicationStep(index: number = 1){
    this.indicationStep.set(index);
    this.brokerQuoteService.setIndicationBindStepId(String(index)); // setting the indicationBind step id
  }

  setIndicationQuoteRagDetails(response: any){
    this.updateRagIndicationColor(response.metricName);
  }

  /** Appends version to quote number when present, e.g. QN715 + version 1 → QN715-01 */
  private quoteNoWithVersion(quoteNo: string | null | undefined, versionNo: string | number | null | undefined): string {
    if (quoteNo == null || String(quoteNo).trim() === '') {
      return '';
    }
    const base = String(quoteNo).trim();
    if (versionNo === null || versionNo === undefined || versionNo === '') {
      return base;
    }
    const n = Number(versionNo);
    const suffix = Number.isFinite(n) && n >= 0
      ? String(Math.floor(n)).padStart(2, '0')
      : String(versionNo).trim();
    return `${base}-${suffix}`;
  }

  setIndicationQuoteRiskSummaryDetails(response: any) {
    this.populatedNamedInsured = response.nameInsured;
    this.populatedTiv = response.tiv;
    this.populatedCalc = response.calcPremium;
    this.populatedStatus.set(response.status);
    this.populatedQuoteId = response?.indicationNo
      ? response.indicationNo
      : this.quoteNoWithVersion(response.quoteNo, response.versionNo);
    this.populatedName = response.owner;
    const formattedMobile = this.formatMobileByCountry(response.mobileNumber, response.countryId, response.iPhoneExt, response.countryCode);
    this.populatedMobileNumber = formattedMobile;
    this.premium = this.formatCurrencyValue(response.totalPremium);
    if(response.tiv){
      this.propertyService.setTIV(response?.tiv);
      this.PolicyInfoSave.set(true);
    }
  }

  setPolicyRiskSummaryDetails(response: any){
    this.populatedNamedInsured = response.nameInsured;
    this.populatedTiv = response.tiv;
    this.populatedCalc = response.calcPremium;
    this.populatedStatus.set(response.status);
    this.populatedQuoteId = response.policyNo;
     this.populatedName = response.owner;
    const formattedMobile = this.formatMobileByCountry(response.mobileNumber, response.countryId, response.iPhoneExt, response.countryCode);
    this.populatedMobileNumber = formattedMobile;
    this.premium = this.formatCurrencyValue(response.totalPremium);
    if(response.tiv){
      this.propertyService.setTIV(response?.tiv);
    }
  }
  
  private formatMobileByCountry(
    mobile: any,
    countryId: number | null | undefined,
    extension?: string | null,
    countryCode?: string | null
  ): string {
    let formattedMobile = '';
    
    if (mobile == null) {
      const cleanedExtension = typeof extension === 'string' ? extension.trim() : '';
      return cleanedExtension || '';
    }

    const digits = mobile.toString().replace(/\D/g, '');
    
    // If countryCode is available, use library for formatting
    if (countryCode) {
      try {
        // Extract dial code from countryCode (e.g., "+683" -> "683")
        const dialCode = countryCode.replace(/^\+/, '').trim();
        
        // Try to find ISO2 code from dial code
        const iso2Code = this.getISO2FromDialCode(dialCode);
        
        if (iso2Code) {
          try {
            // Parse the phone number with the country code
            const parsedNumber = this.phoneUtil.parse(digits, iso2Code);
            
            // Format as national number
            const formatted = this.phoneUtil.format(parsedNumber, PhoneNumberFormat.NATIONAL);
            
            // Remove any leading country code that might be included
            formattedMobile = formatted.replace(/^\+\d+\s*/, '').trim();
            
            // If formatting succeeded, use it
            if (formattedMobile && formattedMobile.length > 0) {
              const cleanedExtension = typeof extension === 'string' ? extension.trim() : '';
              
              if (formattedMobile && cleanedExtension) {
                return `${countryCode} ${formattedMobile} ${cleanedExtension}`;
              } else if (formattedMobile) {
                return `${countryCode} ${formattedMobile}`;
              }
            }
          } catch (parseError) {
            // If parsing fails, fall through to existing formatting logic
          }
        }
      } catch (error) {
        // If library formatting fails, fall through to existing formatting logic
      }
    }
    
    // Fallback to existing formatting based on countryId
    if (countryId === 1 && digits.length === 10) {
      formattedMobile = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`; // US
    } else if (countryId === 2 && digits.length >= 10) {
      formattedMobile = digits.replace(/(\d{3})(\d{4})(\d{3,4})/, '$1 $2 $3'); // UK 3-4-3/4
    } else {
      formattedMobile = mobile.toString();
    }

    const cleanedExtension = typeof extension === 'string' ? extension.trim() : '';

    if (formattedMobile && countryCode) {
      return `${countryCode} ${formattedMobile} ${cleanedExtension}`;
    } else if (cleanedExtension && !countryCode) {    
      return `${formattedMobile} ${cleanedExtension}`;
    } else if (formattedMobile && cleanedExtension) {    
      return `${countryCode} ${formattedMobile} ${cleanedExtension}`;
    } else if (!formattedMobile && cleanedExtension) {
      return cleanedExtension;
    }

    return formattedMobile;
  }
  
  // Helper function to convert dial code to ISO2 code
  private getISO2FromDialCode(dialCode: string): string | null {
    if (!dialCode) return null;
    
    const codeNum = parseInt(dialCode, 10);
    if (isNaN(codeNum)) return null;
    
    try {
      const supportedRegions = this.phoneUtil.getSupportedRegions();
      for (const region of supportedRegions) {
        try {
          const regionCallingCode = this.phoneUtil.getCountryCodeForRegion(region);
          if (regionCallingCode === codeNum) {
            return region.toUpperCase();
          }
        } catch {
          continue;
        }
      }
    } catch (error) {
      // Fallback to common codes
    }
    
    // Fallback: common dial codes
    if (codeNum === 1) return 'US';
    if (codeNum === 44) return 'GB';
    if (codeNum === 683) return 'NU'; // Niue
    if (codeNum === 93) return 'AF';
    if (codeNum === 355) return 'AL';
    
    return null;
  }
  
  onQuoteMTA(){
    sessionStorage.setItem('isQuoteMTA', JSON.stringify(true));
    sessionStorage.setItem('isReview', JSON.stringify(false));
    this.isReadOnly.set(false);
    this.isCityStateListFetched.set(false); // to fetch zipcode data
    this.setStep(0); // set to clearance step
  }

  onAmmendIndicationAction(action: boolean): void{
    if(action){
      const dialog = this.dialog.open(ConfirmationDialogComponent, {
        data: { message: "Do you want to make changes with the indication?" }
      });

      dialog.afterClosed().subscribe((result: boolean) => {
        if(result){
          this.makeEditable();
        }
      })
    }
  }

  onAmmendQuoteAction(action: boolean): void{
    if(action){
      this.makeEditable();
    }
  }



  onRequestQuoteAction(stepNumber: number): void{
    this.indicationStep.set(stepNumber);
    this.brokerQuoteService.setIndicationBindStepId(String(stepNumber)); // setting the indicationBind step id
  }

  onAcceptAndIssueQuoteAction(stepNumber: number): void {
    this.indicationStep.set(stepNumber);
    this.brokerQuoteService.setIndicationBindStepId(String(stepNumber)); // setting the indicationBind step id
  }

  onRequestBindAction(stepNumber: number): void {
    this.indicationStep.set(stepNumber);
    this.brokerQuoteService.setIndicationBindStepId(String(stepNumber)); // setting the indicationBind step id
  }

  onRequestAndIssuePolicyAction(stepNumber: number): void {
    this.indicationStep.set(stepNumber);
    this.brokerQuoteService.setIndicationBindStepId(String(stepNumber)); // setting the indicationBind step id
  }

  getCurrentTimestamp(): string {
    const now = new Date();
    return now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  getCurrentDateTime() {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const milliseconds = String(now.getMilliseconds()).padStart(3, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
  }

  occupancyOptions = [
    { name: 'Cotton Gins', status: 'decline' },
    { name: 'Farms', status: 'referral' },
    { name: 'Grain and Feedstocks', status: 'referral' },
    { name: 'Greenhouses', status: 'decline' },
    { name: 'Other High hazard', status: 'decline' },
    { name: 'Other Low hazard', status: 'OK' },
    { name: 'Other medium Hazard', status: 'OK' },
    { name: 'Tobacco', status: 'decline' },
    { name: 'Amusements', status: 'referral' },
    { name: 'Bowling Alley', status: 'referral' },
    { name: 'Cinemas / Theatres', status: 'OK' },
    { name: 'Golf Clubs (excl. greens / tees etc.)', status: 'OK' },
    { name: 'Gyms', status: 'OK' },
    { name: 'Marinas', status: 'decline' },
    { name: 'Other High hazard', status: 'decline' },
    { name: 'Other Low hazard', status: 'OK' },
    { name: 'Other medium Hazard', status: 'OK' },
    { name: 'Shooting Range', status: 'referral' },
    { name: 'Sport Domes', status: 'decline' },
    { name: 'Theme parks', status: 'referral' },
    { name: 'Bars & Taverns', status: 'referral' },
    { name: 'Event & Banquet', status: 'OK' },
    { name: 'Night Clubs', status: 'referral' },
    { name: 'Other High hazard', status: 'decline' },
    { name: 'Other Low hazard', status: 'OK' },
    { name: 'Other medium Hazard', status: 'OK' },
    { name: 'Restaurant (BBQ)', status: 'decline' },
    { name: 'Restaurant (Family)', status: 'referral' },
    { name: 'Restaurant (Fast Food)', status: 'referral' },
    { name: 'Restaurant (Takeaway)', status: 'referral' },
    { name: 'Restaurant (Upscale)', status: 'OK' },
    { name: 'B&Bs (Mid range)', status: 'referral' },
    { name: 'Camps', status: 'decline' },
    { name: 'Corporate Retreats', status: 'referral' },
    { name: 'Dude Ranch', status: 'referral' },
    { name: 'Hostels / YMCAs', status: 'referral' },
    { name: 'Hotel / Motel - High End Franchise', status: 'OK' },
    { name: 'Hotel / Motel - High End Independent', status: 'OK' },
    { name: 'Hotel / Motel - Low End Franchise', status: 'referral' },
    { name: 'Hotel / Motel - Low end Independent', status: 'referral' },
    { name: 'Hotel / Motel - Mid End Franchise', status: 'referral' },
    { name: 'Hotel / Motel - Mid End Independent', status: 'OK' },
    { name: 'Hunting Lodge', status: 'OK' },
    { name: 'Other High hazard', status: 'referral' },
    { name: 'Other Low hazard', status: 'OK' },
    { name: 'Other medium Hazard', status: 'referral' },
    { name: 'Resorts (Other)', status: 'OK' },
    { name: 'Resorts (Ski)', status: 'referral' },
    { name: 'Ammunition', status: 'decline' },
    { name: 'Automotive', status: 'OK' },
    { name: 'Bio-Diesel', status: 'decline' },
    { name: 'Boat', status: 'referral' },
    { name: 'Breweries', status: 'OK' },
    { name: 'Chemical High Hazard', status: 'decline' },
    { name: 'Chemical Low Hazard', status: 'referral' },
    { name: 'Chemical Mid Hazard', status: 'referral' },
    { name: 'Electrical', status: 'OK' },
    { name: 'Explosives', status: 'decline' },
    { name: 'Fibreglass', status: 'referral' },
    { name: 'Fireworks', status: 'OK' },
    { name: 'Foods (Cooking)', status: 'decline' },
    { name: 'Foods (Frying)', status: 'referral' },
    { name: 'Foods (Processing Only)', status: 'referral' },
    { name: 'Furniture', status: 'referral' },
    { name: 'Metal Worker Fabrication', status: 'OK' },
    { name: 'Metal Worker Foundry', status: 'decline' },
    { name: 'Other High hazard', status: 'referral' },
    { name: 'Other Low hazard', status: 'OK' },
    { name: 'Other medium Hazard', status: 'referral' },
    { name: 'Paint (Oil Based)', status: 'OK' },
    { name: 'Paint (Water based)', status: 'referral' },
    { name: 'Pharmaceutical', status: 'OK' },
    { name: 'Plastics', status: 'OK' },
    { name: 'Printer', status: 'decline' },
    { name: 'Vineyard / wineries (Ex Stock)', status: 'referral' },
    { name: 'Woodworker', status: 'OK' },
    { name: 'Billboards', status: 'OK' },
    { name: 'Bridges', status: 'referral' },
    { name: 'Builders Risks', status: 'OK' },
    { name: 'Dams', status: 'referral' },
    { name: 'Docks, Piers, wharves', status: 'decline' },
    { name: 'Fraternities', status: 'referral' },
    { name: 'Mixed LRO (High Hazard)', status: 'referral' },
    { name: 'Mixed LRO (Low Hazard)', status: 'referral' },
    { name: 'Mixed LRO (Medium Hazard)', status: 'OK' },
    { name: 'Other High hazard', status: 'referral' },
    { name: 'Other Low hazard', status: 'OK' },
    { name: 'Other medium Hazard', status: 'referral' },
    { name: 'Recycling', status: 'OK' },
    { name: 'Renovation Risks (cosmetic)', status: 'referral' },
    { name: 'Vacant', status: 'referral' },
    { name: 'Aircraft Hangars (excl Tier 1)', status: 'OK' },
    { name: 'Airports (terminals)', status: 'referral' },
    { name: 'Churches', status: 'OK' },
    { name: 'Hospitals', status: 'OK' },
    { name: 'Libraries (excl books)', status: 'OK' },
    { name: 'Municipality (General)', status: 'referral' },
    { name: 'Museum (excl. exhibits)', status: 'referral' },
    { name: 'Other High hazard', status: 'OK' },
    { name: 'Other Low hazard', status: 'referral' },
    { name: 'Other medium Hazard', status: 'referral' },
    { name: 'Prisons / Detention Centres', status: 'decline' },
    { name: 'Schools (Charter)', status: 'referral' },
    { name: 'Schools (Public)', status: 'referral' },
    { name: 'Water / Sewer plants', status: 'decline' },
    { name: 'Assisted Living', status: 'OK' },
    { name: 'Banks / Financial Institutions', status: 'referral' },
    { name: 'Daycare', status: 'OK' },
    { name: 'Medical Offices', status: 'OK' },
    { name: 'Nursing Homes', status: 'referral' },
    { name: 'Offices (general)', status: 'OK' },
    { name: 'Other High hazard', status: 'referral' },
    { name: 'Other Low hazard', status: 'OK' },
    { name: 'Other medium Hazard', status: 'referral' },
    { name: 'Rehab', status: 'OK' },
    { name: 'Apartments (family over $750p/m)', status: 'OK' },
    { name: 'Apartments (family under $750p/m)', status: 'referral' },
    { name: 'Condominiums / Townhomes', status: 'OK' },
    { name: 'Mobile home parks (excl homes)', status: 'referral' },
    { name: 'Other High hazard', status: 'decline' },
    { name: 'Other Low hazard', status: 'OK' },
    { name: 'Other medium Hazard', status: 'referral' },
    { name: 'Rooming Houses', status: 'referral' },
    { name: 'Self-Storage', status: 'OK' },
    { name: 'Dormitories', status: 'referral' },
    { name: 'Warehousing High Hazard', status: 'decline' },
    { name: 'Warehousing Low Hazard', status: 'OK' },
    { name: 'Warehousing Medium Hazard', status: 'referral' },
    { name: 'Warehousing Third Party Logistics', status: 'referral' }
  ];

  descriptionMap: Map<number, string> = new Map<number, string>();

  onOccupancyChange(classId: number) {
    // Find the selected occupancy based on the classId
    this.selectedOccupancy = this.Occupancies().find(
      (occupancy) => Number(occupancy.classId.toString().trim()) === Number(classId.toString().trim())
    );
  
    if (!this.selectedOccupancy) {
    } else {
      // Find ALL addresses with the matching occupancy classId, not just the first one
      this.addresses().forEach((address, addressIndex) => {
        if (address.get('occupancy')?.value === classId) {
          this.descriptionMap.set(addressIndex, this.selectedOccupancy.description);
        }
      });
    }
  }

  showDeclineNotification(message: string) {
    this.declineMessage = message;
    this.showNotification = true;

    setTimeout(() => {
      this.showNotification = false;
      this.declineMessage = null;
    }, 5000);
  }

  private getOccupancyDeclineMessage(occupancyDescription: string): string {
    const resolvedDescription = occupancyDescription?.trim() || 'Unknown Occupancy';
    return `This submission has been declined due to the selected occupancy: ${resolvedDescription}. Please review and update the occupancy to proceed or exit to landing page`;
  }


  getStepClass(index: number): string {
    const currentStep = this.step();
    return index < currentStep ? 'completed' : index === currentStep ? 'current' : '';
  }

  prevStepCope(){    
      // Block navigation if validations fail
      if (!this.canLeaveCurrentStep(0)) {
        return;
      }
      this.isCopePreviousNavigationInProgress = true;
      this.suppressMainAccordionSaveStepUntil = Date.now() + 60000;
      this.CopeSaveForAccordianClose(false, () => {
        this.suppressCopeCloseSave = true;
        this.navigateToPreviousMainAccordionAfterSave(0, () => {
          this.isCopePreviousNavigationInProgress = false;
        });
      });
  }

    prevStepPolicy() {
    // Validate policy parameters before moving back
    if (!this.canLeaveCurrentStep(1)) {
      return;
    }
    if (this.isPolicyType()) {
      this.navigateToPreviousMainAccordionAfterSave(1);
      return;
    }
    this.policyParameterIndicationQuoteSaveforPrevious();
  }



  prevStep() {
    const target = this.step() - 1;
    if (!this.canLeaveCurrentStep(target)) {
      return;
    }
    this.step.set(target);
  }

  panelOpenState = signal(false);

  // Removed dynamic disabling for headers per user request (revert)

  // Disable target panel headers dynamically when current step has blocking errors
  shouldDisablePanel(targetStep: number): boolean {
    const current = this.step();
    // Only constrain cross-navigation cases
    if (current === 2 && targetStep === 1) {
      // From Policy -> COPE
      if (!this.isReadOnly()) {
        this.validatePolicyParameters();
        return Object.values(this.validationMessages).some(msg => msg !== null);
      }
      return false;
    }
    if (current === 1 && targetStep === 2) {
      // From COPE -> Policy
      if (!this.isReadOnly()) {
        return this.hasCopeBlockingErrors();
      }
      return false;
    }
    return false;
  }

  private hasCopeBlockingErrors(): boolean {
    // Inline edits pending
    if (this.isEditing['story'] || this.isEditing['sqFt'] || this.isEditing['RCV'] || this.isEditing['DistanceToCoast']) {
      return true;
    }
    // Target premium must be positive
    const cleanedPremium = this.cleanCurrencyValue(this.premium);
    if (!cleanedPremium || isNaN(cleanedPremium) || cleanedPremium <= 0) {
      return true;
    }
    // Building fields validity across all addresses/buildings
    const addresses = this.addressControls();
    for (const addressControl of addresses.controls) {
      const buildings = addressControl.get('buildingDetails') as FormArray;
      for (const buildingControl of buildings.controls) {
        const group = this.getFormGroup(buildingControl);
        // Touch to reveal errors in UI when user clicks header
        Object.values(group.controls).forEach(ctrl => ctrl?.markAsTouched());
        if (group.invalid) {
          return true;
        }
      }
    }
    // Confirmation checkbox must be checked for each address
    const map = this.isChecked();
    const allChecked = Array.from(map.values()).every(v => v);
    if (!allChecked) {
      return true;
    }
    return false;
  }

  onReturnToDashboardMTA() {
    const dialog = this.dialog.open(ConfirmationDialogComponent, {
        data: { message: "Do you want to return to dashboard?" }
    });
  
    dialog.afterClosed().subscribe((result: boolean) => {
      if(result){
        const isQuoteMTA = sessionStorage.getItem('isQuoteMTA');
        if(isQuoteMTA){
          this.policyService.declineMTAByBroker(Number(this.authService.getUserDetailsFromStorage()?.policyId), true)
          .subscribe({
            next: (response: any) => {
              if(response){
                this.indicationQuoteService.redirectToDashboard(); // redirect to dashboard
              }
            },
            error: (error: any) => {
              this.toastService.addNotification({message: "System error. Failed to save data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
            }
          })
        }else{
          this.indicationQuoteService.redirectToDashboard(); // redirect to dashboard
        }
      }
    }); 
  }

  clearanceBack() {
    if(this.isPolicyType()){
      this.onReturnToDashboardMTA();
    }else{
      sessionStorage.removeItem('tempQuoteNumber');
      const dialogRef = this.dialog.open(SaveConfirmationDialogComponent);

      dialogRef.afterClosed().subscribe((result: string) => {

          if (result === 'cancel') {
              return;
          }

        if (result === 'exit') {// Don't Save
            this.indicationQuoteService.removeIndicationQuoteStorageData();
            this.router.navigate(['/quote']);
        }

        if (result === 'save') {
            this.clearanceVersionCheck(true);
        }
    });
  }
}
  copeBack() {
    if(this.isPolicyType()){
      this.onReturnToDashboardMTA();
    }else{
      sessionStorage.removeItem('tempQuoteNumber');
      // this.router.navigate(['/quote']);
      const dialogRef = this.dialog.open(SaveConfirmationDialogComponent);

      dialogRef.afterClosed().subscribe((result: string) => {
        if(result === 'cancel'){
          return;
        }

      if (result === 'exit') { // Don't Save
        if(this.isIndicationType() && !this.isPolicyType()){
        this.propertyService.UpdateIndicationDraftIndication(1).subscribe({
              next: (draftResponse) => {
                 this.indicationQuoteService.removeIndicationQuoteStorageData();
                 this.router.navigate(['/quote']);
              },
              error: (draftError) => {
              }
            });     
          }else{
            this.propertyService.UpdateIndicationDraftQuote(1).subscribe({
              next: (draftResponse) => {
                this.indicationQuoteService.removeIndicationQuoteStorageData();
                this.router.navigate(['/quote']);
              },
              error: (draftError) => {
              }
            });
          }
      }
      if (result === 'save'){   
        this.copeSave(true);             
      } 
    });
  }
  }

  PolicyParametersback() {
    if(this.isPolicyType()){
      this.onReturnToDashboardMTA();
    }else{
      sessionStorage.removeItem('tempQuoteNumber');
      // this.router.navigate(['/quote']);
      const dialogRef = this.dialog.open(SaveConfirmationDialogComponent);

      dialogRef.afterClosed().subscribe((result: string) => {
        if(result === 'cancel'){
          return;
        }

      if (result === 'exit') { // Don't Save
        this.indicationQuoteService.removeIndicationQuoteStorageData();
        this.router.navigate(['/quote']);
      }

      if (result === 'save'){            
        this.PolicyParametersSave(true); 
      }
    });
  }
  }

 

  saveIndicationAndHome(indicationId: number, branchId: number, userId: number) {
    this.indicationQuoteService.saveIndicationAndHome(indicationId, branchId, userId).subscribe({
      next: (response: SaveIndicationAndHomeResponse) => {
        if (response && response.message) {
          this.handleSaveStep();
          this.indicationQuoteService.removeIndicationQuoteStorageData();
            this.router.navigate(['/quote']);
          }
      },
      error: (error) => {
      }
    })
  }



  saveQuoteAndHome(quoteId: number, branchId: number, userId: number) {
    this.indicationQuoteService.saveQuoteAndHome(quoteId, branchId, userId).subscribe({
      next: (response: SaveIndicationAndHomeResponse) => {
          if(response && response.message){
            this.handleSaveStep();
            this.indicationQuoteService.removeIndicationQuoteStorageData();
            this.router.navigate(['/quote']);
          }
      },
      error: (error) => {
      }
    })
  }

  handleIndicationStepIdFilter(stepID: string) {
    switch(stepID){
      case "1":
        return "4a";
      case "2":
        return "4b";
      case "3":
        return "4c";
      case "4":
        return "4d";
      default:
        return "4a";      
    }
  }

  handleMainAccordionStepIdFilter(stepID: number) {
    switch(stepID){
      case 0:
        return "1";
      case 1:
        return "2";
      case 2:
        return "3";
      default:
        return null;
    }
  }

  handleMainAccordionSaveStep(stepID: number) {
    const saveStepId = this.handleMainAccordionStepIdFilter(stepID);
    if (!saveStepId) {
      return;
    }

    if(this.isPolicyType()){
      const policyId = this.authService.getUserDetailsFromStorage()?.policyId;
      if (policyId) {
        this.onSaveStep(saveStepId, "Policy", String(policyId));
      }
    }else{
      if(this.isIndicationType()){
        const indicationId = this.indicationId() || sessionStorage.getItem("indicationId");
        if (indicationId) {
          this.onSaveStep(saveStepId, "Indication", String(indicationId));
        }
      }else{
        const quoteId = this.authService.getUserDetailsFromStorage()?.quoteId || sessionStorage.getItem("quoteId");
        if (quoteId) {
          this.onSaveStep(saveStepId, "Quote", String(quoteId));
        }
      }
    }
  }

  navigateToPreviousMainAccordionAfterSave(targetStep: number, afterNavigate?: () => void) {
    this.suppressMainAccordionSaveStepUntil = Date.now() + 1000;
    this.setStep(targetStep);

    setTimeout(() => {
      this.handleMainAccordionSaveStep(targetStep);
      this.suppressMainAccordionSaveStepUntil = 0;
      afterNavigate?.();
    }, 1000);
  }

  saveCurrentAccordionThenNavigate(targetStep: number) {
    const currentStep = this.step();

    if (currentStep === 0) {
      this.clearanceVersionCheckAccordionClose(false, () => {
        this.suppressClearanceCloseSave = true;
        this.navigateToPreviousMainAccordionAfterSave(targetStep);
      });
      return;
    }

    if (currentStep === 1) {
      this.isCopePreviousNavigationInProgress = true;
      this.suppressMainAccordionSaveStepUntil = Date.now() + 60000;
      this.CopeSaveForAccordianClose(false, () => {
        this.suppressCopeCloseSave = true;
        this.navigateToPreviousMainAccordionAfterSave(targetStep, () => {
          this.isCopePreviousNavigationInProgress = false;
        });
      });
      return;
    }

    if (currentStep === 2 && !this.isPolicyType()) {
      this.accordianCloseForPolicyParameters(() => {
        this.suppressCopePolicyParameterSave = true;
        this.navigateToPreviousMainAccordionAfterSave(targetStep);
      });
      return;
    }

    this.suppressMainAccordionSaveStepUntil = 0;
    this.setStep(targetStep);
  }

  handleSaveStep() {
    const currentIndicationStepID = this.brokerQuoteService.getIndicationBindStepId();
    if(this.isPolicyType()){
      const getIndicationtepID = this.handleIndicationStepIdFilter(currentIndicationStepID);
      this.onSaveStep(getIndicationtepID, "Policy", String(this.authService.getUserDetailsFromStorage()?.policyId));
    }else{
      if(this.isIndicationType()){
        const getIndicationtepID = this.handleIndicationStepIdFilter(currentIndicationStepID);
        this.onSaveStep(getIndicationtepID, "Indication", String(this.indicationId()));
      }else{
        const getIndicationtepID = this.handleIndicationStepIdFilter(currentIndicationStepID);
        this.onSaveStep(getIndicationtepID, "Quote", String(this.authService.getUserDetailsFromStorage()?.quoteId));
      }
    }
  }

  onSaveStep(step: string, type: string, id: string) {
    if (this.isReadOnly()) {
      return;
    }
    this.indicationQuoteService.saveStepForCurrentUser(step, type, id).subscribe({
        next: (response: any) => {
        },
        error: (error: any) => {
        }
    })
  }

  

  onSaveIndicationHomeAction(event: any) {
    // const dialog = this.dialog.open(ConfirmationDialogComponent, {
    //   data: { message: "Do you want to save before exiting?" }
    // });

    // dialog.afterClosed().subscribe((result: boolean) => {
    //   if(result){
    //     // API Call to Save the Indication Type
    //     if(this.isIndicationType()){
    //       this.saveIndicationAndHome(event.indicationId, event.branchId);
    //     }else{
    //       this.saveQuoteAndHome(event.quoteId, event.branchId);
    //     }
    //   }
    // }) 

    const dialogRef = this.dialog.open(SaveConfirmationDialogComponent, {
       data: { message: "Do you want to save before exiting?" }
    });

      dialogRef.afterClosed().subscribe((result: string) => {

          if (result === 'cancel') {
              return;
          }

        if (result === 'exit') {// Don't Save
            this.indicationQuoteService.removeIndicationQuoteStorageData();
            this.router.navigate(['/quote']);
        }

        if (result === 'save') {
          const payloadRequest = event?.payloadRequest ?? event;
          const persistFeesFn = typeof event?.persistFees === 'function' ? event.persistFees : null;
          const persist$ = persistFeesFn ? persistFeesFn() : of(null);
          persist$.subscribe({
            next: () => {
              this.executeSaveAfterConfirm(payloadRequest);
            },
            error: () => {
              this.toastService.addNotification({message: "Failed to save Surplus Lines taxes/fees. Please retry.", type: ToastType.Error});
            }
          });
        }
    });
  }

  private executeSaveAfterConfirm(payloadRequest: any) {
    if(!payloadRequest){
      return;
    }
    if(this.isIndicationType()){
      this.saveIndicationAndHome(payloadRequest.indicationId, payloadRequest.branchId, payloadRequest.userId);
    }else{
      this.saveQuoteAndHome(payloadRequest.quoteId, payloadRequest.branchId, payloadRequest.userId);
    }
  }

  onConvertIndicationtoquoteDate(event: any){
     const todayMoment = moment(); // Current date
    this.today1 = todayMoment.format('YYYY-MM-DD'); // For [min]
    if(!this.isUwAdmin()){
    if(this.isIndicationType()){
      const maxlimit = sessionStorage.getItem("inDtMaxLimit")
      this.maxStartDate = todayMoment.clone().add(maxlimit, 'days').format('YYYY-MM-DD'); // For [max]
      this.minStartDate = todayMoment.format('YYYY-MM-DD');
    }else{
      const maxlimit = sessionStorage.getItem("inDtMaxLimit")
      this.maxStartDate = todayMoment.clone().add(maxlimit, 'days').format('YYYY-MM-DD'); // For [max]
      this.minStartDate = todayMoment.format('YYYY-MM-DD');
    }
  }else{
      this.minStartDate = undefined;
  this.maxStartDate = undefined;
  }
  }

  totalBuildingsLimit: number = 0;

  calculateTotalBuildingsLimit(): void {
    const building1 = Number(this.building1Limit) || 0;
    const building2 = Number(this.building2Limit) || 0;

    this.totalBuildingsLimit = building1 + building2;
  }

  private tickClicked: boolean = false;

  // Track editing state per building using key: `${addressIdx}-${buildingIdx}-${field}`
  private isEditingMap = new Map<string, boolean>();
  originalValues: Map<string, any> = new Map();
  
  // Helper method to generate unique key for a building field
  private getEditingKey(addressIdx: number, buildingIdx: number, field: keyof EditingState): string {
    return `${addressIdx}-${buildingIdx}-${field}`;
  }
  
  // Helper method to check if a specific building field is being edited
  isFieldEditing(addressIdx: number, buildingIdx: number, field: keyof EditingState): boolean {
    const key = this.getEditingKey(addressIdx, buildingIdx, field);
    return this.isEditingMap.get(key) === true;
  }
  
  // Legacy isEditing object for backward compatibility (will be removed gradually)
  get isEditing(): EditingState {
    // Return a proxy that checks if ANY building has this field in edit mode
    // This is for backward compatibility but should be replaced with isFieldEditing
    return {
      RCV: Array.from(this.isEditingMap.keys()).some(k => k.endsWith('-RCV') && this.isEditingMap.get(k)),
      sqFt: Array.from(this.isEditingMap.keys()).some(k => k.endsWith('-sqFt') && this.isEditingMap.get(k)),
      CrimeScore: Array.from(this.isEditingMap.keys()).some(k => k.endsWith('-CrimeScore') && this.isEditingMap.get(k)),
      DistanceToCoast: Array.from(this.isEditingMap.keys()).some(k => k.endsWith('-DistanceToCoast') && this.isEditingMap.get(k)),
      story: Array.from(this.isEditingMap.keys()).some(k => k.endsWith('-story') && this.isEditingMap.get(k)),
      PcClass: Array.from(this.isEditingMap.keys()).some(k => k.endsWith('-PcClass') && this.isEditingMap.get(k)),
      constructionType: Array.from(this.isEditingMap.keys()).some(k => k.endsWith('-constructionType') && this.isEditingMap.get(k)),
      RoofType: Array.from(this.isEditingMap.keys()).some(k => k.endsWith('-RoofType') && this.isEditingMap.get(k)),
      Age: Array.from(this.isEditingMap.keys()).some(k => k.endsWith('-Age') && this.isEditingMap.get(k)),
      occupancy: Array.from(this.isEditingMap.keys()).some(k => k.endsWith('-occupancy') && this.isEditingMap.get(k)),
      roofReplaceUpdate: Array.from(this.isEditingMap.keys()).some(k => k.endsWith('-roofReplaceUpdate') && this.isEditingMap.get(k)),
      plumbing: Array.from(this.isEditingMap.keys()).some(k => k.endsWith('-plumbing') && this.isEditingMap.get(k)),
      hvac: Array.from(this.isEditingMap.keys()).some(k => k.endsWith('-hvac') && this.isEditingMap.get(k)),
      electrical: Array.from(this.isEditingMap.keys()).some(k => k.endsWith('-electrical') && this.isEditingMap.get(k)),
    };
  } 
   
  

  toggleEdit(field: keyof EditingState, building: FormGroup, inputElement: HTMLInputElement, addressIdx: number, buildingIdx: number): void {
    const control = building.get(field);   
     
    if (this.isReadOnly()) {
      return; // Prevent editing
    }

    if (control) {
      const key = this.getEditingKey(addressIdx, buildingIdx, field);
      this.originalValues.set(key, control.value);
      this.isEditingMap.set(key, true);

      setTimeout(() => {
        inputElement.removeAttribute('readonly');
        inputElement.focus();
      }, 0);
    }
  }

  saveChanges(field: keyof EditingState, building: FormGroup, addressIdx: number, buildingIdx: number): void {
    const control = building.get(field);
    if (control) {
      const key = this.getEditingKey(addressIdx, buildingIdx, field);
      this.isEditingMap.set(key, false);
      this.originalValues.delete(key);

      // Find and update the specific input element for this building
      const addressPanels = this.copeAddressPanels?.toArray() || [];
      if (addressPanels[addressIdx]) {
        const addressPanel = addressPanels[addressIdx].nativeElement;
        const allRows = Array.from(addressPanel.querySelectorAll('.row')) as HTMLElement[];
        const buildingRows: HTMLElement[] = [];
        
        // Find building rows
        for (const row of allRows) {
          const heading = row.querySelector('h5.text-gray-900');
          if (heading) {
            const headingText = heading.textContent?.trim() || '';
            const buildingMatch = headingText.match(/^Building\s+(\d+)$/);
            if (buildingMatch) {
              const hasFormControls = row.querySelector('input[formcontrolname], select[formcontrolname]') !== null;
              if (hasFormControls) {
                buildingRows.push(row);
              }
            }
          }
        }
        
        // Sort building rows by their building number
        buildingRows.sort((a, b) => {
          const headingA = a.querySelector('h5.text-gray-900')?.textContent?.trim() || '';
          const headingB = b.querySelector('h5.text-gray-900')?.textContent?.trim() || '';
          const numA = parseInt(headingA.match(/^Building\s+(\d+)$/)?.[1] || '0');
          const numB = parseInt(headingB.match(/^Building\s+(\d+)$/)?.[1] || '0');
          return numA - numB;
        });
        
        if (buildingRows[buildingIdx]) {
          const fieldInput = buildingRows[buildingIdx].querySelector(`input[formcontrolname="${field}"]`) as HTMLInputElement;
          if (fieldInput) {
            fieldInput.setAttribute('readonly', 'true');
          }
        }
      }
    }
  }

  cancelEdit(field: keyof EditingState, building: FormGroup, addressIdx: number, buildingIdx: number): void {
    const key = this.getEditingKey(addressIdx, buildingIdx, field);
    const originalValue = this.originalValues.get(key);
    if (originalValue !== undefined) {
      const control = building.get(field);
      if (control) {
        control.setValue(originalValue);
      }
    }
    this.isEditingMap.set(key, false);
    this.originalValues.delete(key);
    
    // Find and update the specific input element for this building
    const addressPanels = this.copeAddressPanels?.toArray() || [];
    if (addressPanels[addressIdx]) {
      const addressPanel = addressPanels[addressIdx].nativeElement;
      const allRows = Array.from(addressPanel.querySelectorAll('.row')) as HTMLElement[];
      const buildingRows: HTMLElement[] = [];
      
      // Find building rows
      for (const row of allRows) {
        const heading = row.querySelector('h5.text-gray-900');
        if (heading) {
          const headingText = heading.textContent?.trim() || '';
          const buildingMatch = headingText.match(/^Building\s+(\d+)$/);
          if (buildingMatch) {
            const hasFormControls = row.querySelector('input[formcontrolname], select[formcontrolname]') !== null;
            if (hasFormControls) {
              buildingRows.push(row);
            }
          }
        }
      }
      
      // Sort building rows by their building number
      buildingRows.sort((a, b) => {
        const headingA = a.querySelector('h5.text-gray-900')?.textContent?.trim() || '';
        const headingB = b.querySelector('h5.text-gray-900')?.textContent?.trim() || '';
        const numA = parseInt(headingA.match(/^Building\s+(\d+)$/)?.[1] || '0');
        const numB = parseInt(headingB.match(/^Building\s+(\d+)$/)?.[1] || '0');
        return numA - numB;
      });
      
      if (buildingRows[buildingIdx]) {
        const fieldInput = buildingRows[buildingIdx].querySelector(`input[formcontrolname="${field}"]`) as HTMLInputElement;
        if (fieldInput) {
          fieldInput.setAttribute('readonly', 'true');
        }
      }
    }
  }

  customYearFilter = (date: Date): boolean => {
    const year = date.getFullYear();
    return year >= 2000 && year <= 2024;
  };
  


  policyType: string = 'Owner - Operator';
  premium: string = '';
  // business: string = '';
  totalInsuredValue: string | undefined;
  status: string | undefined;
  showPremiumError: boolean = false;

   private isScrolling = false;
  scrollToTop(): void {
    if (this.isScrolling) {
      return; // Prevent multiple simultaneous scrolls
    }
    this.isScrolling = true;
    const scrollDuration = 500; // milliseconds
    const start = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
const startTime = performance.now();
    const easeInOutQuad = (t: number): number => {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    };
    const smoothScroll = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / scrollDuration, 1);
      const ease = easeInOutQuad(progress);
      const scrollTo = start * (1 - ease);
      window.scrollTo(0, scrollTo);
      if (progress < 1) {
        window.requestAnimationFrame(smoothScroll);
      } else {
        this.isScrolling = false; // allow normal scrolling after animation
      }
    };
     window.requestAnimationFrame(smoothScroll);
  }    
 
  scrollToPolicy(): void {
  const scrollableContainer = document.querySelector('.scrolling') as HTMLElement;

  if (!scrollableContainer) return;

  if (this.isScrolling) {
    return; // Prevent multiple simultaneous scrolls
  }
  this.isScrolling = true;

  const scrollDuration = 500; // milliseconds
  const start = scrollableContainer.scrollTop;
  const startTime = performance.now();

  const easeInOutQuad = (t: number): number => {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  };

  const smoothScroll = (currentTime: number) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / scrollDuration, 1);
    const ease = easeInOutQuad(progress);
    const scrollTo = start * (1 - ease);
    scrollableContainer.scrollTo(0, scrollTo);

    if (progress < 1) {
      window.requestAnimationFrame(smoothScroll);
    } else {
      this.isScrolling = false; // allow normal scrolling after animation
    }
  };

  window.requestAnimationFrame(smoothScroll);
}


//   onAddressAccordionOpen() {
//     const scrollContainer = document.querySelector('.addScoll');
//     if (scrollContainer) {
//         (scrollContainer as HTMLElement).scrollTop = 0;
//     }
// }

  Questions(){
    const indicationQuestionId = JSON.parse(sessionStorage.getItem('indicationQuestionId') || 'null');

  const questionsPayload = this.questions().map((q,index) => ({
    indicationQuestionId: indicationQuestionId && indicationQuestionId.length>0 ? indicationQuestionId[index].indicationQuestionId : q.questionId,
    indicationId:this.authService.getUserDetailsFromStorage().indicationId || 0,
    questionTypeId:q.questionTypeId,
    questionid: q.questionId,
     answer: this.questionAnswers()[q.questionId] ? "yes" : "no",
    value: q.value
  }));
  return questionsPayload
}

QuestionsQuote(){
  const quoteQuestionId = JSON.parse(sessionStorage.getItem('quoteQuestionId') || 'null');

const questionsPayload = this.questions().map((q,index) => ({
  quoteQuestionId: quoteQuestionId && quoteQuestionId.length>0 ? quoteQuestionId[index].quoteQuestionId : q.questionId,
  quoteId:this.authService.getUserDetailsFromStorage().quoteId || 0,
  questionTypeId:q.questionTypeId,
  questionid: q.questionId,
   answer: this.questionAnswers()[q.questionId] ? "yes" : "no",
  value: q.value
}));
return questionsPayload
}

QuestionsPolicyClearance(){
  const policyQuestionId = JSON.parse(sessionStorage.getItem('policyQuestionId') || 'null');
  const questionsPayload = this.questions().map((q,index) => ({
    policyQuestionId: policyQuestionId && policyQuestionId.length>0 ? policyQuestionId[index].policyQuestionId : q.questionId,
    policyId: Number(this.authService.getUserDetailsFromStorage()?.policyId),
    questionTypeId: q.questionTypeId,
    questionId: q.questionId,
    answer: this.questionAnswers()[q.questionId] ? "yes" : "no",
    value: q.value
  }));
  return questionsPayload
}

  onGetSystemUserMessage(){ // update message center get system generated messages
    this.messageCenterService.onUpdateSystemUserMessages(true);
  }

  onRiskSummaryStatusBindHandler(data: any, type: string) {
    const statusList: Record<string, {
      gencodeId: number; code: string;
    }> = this.brokerQuoteService.getStatusListFromStorage();
    if(type === "policy"){
      const statusListResult = Object.entries(statusList).filter(([, value]) => value.gencodeId === data?.policyStatus);
      statusListResult.length > 0 ? this.populatedStatus.set(statusListResult[0][0]) : this.populatedStatus.set('');
    }else{
      if(type === "indication") {
        const statusListResult = Object.entries(statusList).filter(([, value]) => value.gencodeId === data?.indicationStatus);
        statusListResult.length > 0 ? this.populatedStatus.set(statusListResult[0][0]) : this.populatedStatus.set('');        
        sessionStorage.setItem("statusRagCall",statusListResult[0][0])
        const status = statusListResult[0][0];
          sessionStorage.setItem("statusRagCall", status);

          const validStatuses = [
            "Indication - Referral Approved",
            "Indication - Referral Declined",
            "Quote - Referral Approved",
            "Quote - Referral Declined",
            "Indication - Referral Submitted",
            "Quote - Referral Submitted",
            "Bind – Referral Submitted"
          ];

          if (validStatuses.includes(status)) {
            sessionStorage.setItem("statusAvailable", "true");
          } else {
            sessionStorage.setItem("statusAvailable", "false");
            sessionStorage.setItem("RagCall","true");
          }

        
      }else{
        const statusListResult = Object.entries(statusList).filter(([, value]) => value.gencodeId === data?.quoteStatus);
        statusListResult.length > 0 ? this.populatedStatus.set(statusListResult[0][0]) : this.populatedStatus.set('');
        sessionStorage.setItem("statusRagCall",statusListResult[0][0])
       const status = statusListResult[0][0];
          sessionStorage.setItem("statusRagCall", status);

          const validStatuses = [
            "Indication - Referral Approved",
            "Indication - Referral Declined",
            "Quote - Referral Approved",
            "Quote - Referral Declined",
            "Indication - Referral Submitted",
            "Quote - Referral Submitted",
            "Bind – Referral Submitted"
          ];

          
          if (validStatuses.includes(status)) {
            sessionStorage.setItem("statusAvailable", "true");
          } else {
            sessionStorage.setItem("statusAvailable", "false");
            sessionStorage.setItem("RagCall","true");
          }
      }
    }
  }

  private getClearanceCheckEntityContext(): { id: number; type: string } | null {
    const storageData = this.authService.getUserDetailsFromStorage();
    if (!storageData) {
      return null;
    }

    if (this.isIndicationType()) {
      const indicationId = Number(storageData?.indicationId ?? 0);
      return indicationId ? { id: indicationId, type: "indication" } : null;
    }

    const quoteId = Number(storageData?.quoteId ?? 0);
    return quoteId ? { id: quoteId, type: "quote" } : null;
  }

  private shouldRunClearanceCheckFromFlagResponse(response: any): boolean {
    if (!response || (typeof response === "object" && Object.keys(response).length === 0)) {
      return true;
    }

    return Number(response?.isClearanceApprovedByUW ?? 0) !== 1;
  }

  private runClearanceCheckOrContinue(
    onRunCheck: () => void,
    onSkipCheck: () => void
  ): void {
    const context = this.getClearanceCheckEntityContext();
    if (!context) {
      onRunCheck();
      return;
    }

    this.propertyService.GetClearanceCheckFlag(context.id, context.type).subscribe({
      next: (response: any) => {
        if (this.shouldRunClearanceCheckFromFlagResponse(response)) {
          onRunCheck();
        } else {
          onSkipCheck();
        }
      },
      error: () => onRunCheck()
    });
  }

  clearanceVersionCheck(isSaveAndExit: boolean = false){
    const versionNo = Number(sessionStorage.getItem('versionNo'))
   this.suppressClearanceCloseSave = true;
      this.runClearanceCheckOrContinue(
        () => this.clearanceNameAddressCheck(isSaveAndExit),
        () => this.clearanceStep(isSaveAndExit)
      );
    
  }

    clearanceVersionCheckAccordionClose(isSaveAndExit: boolean = false, afterSave?: () => void){
    const versionNo = Number(sessionStorage.getItem('versionNo'))
   
      this.runClearanceCheckOrContinue(
        () => this.clearanceNameAddressCheckAccordionClose(isSaveAndExit, afterSave),
        () => this.clearanceStepAccordianClose(isSaveAndExit, afterSave)
      );
    
  }

  trimFormValues(obj: any): any {
    if (typeof obj !== 'object' || obj === null) return obj; // Return if not an object
  
    if (Array.isArray(obj)) {
      return obj.map(item => this.trimFormValues(item)); // Recursively trim array elements
    }
  
    return Object.keys(obj).reduce((acc, key) => {
      const value = obj[key];
      acc[key] = typeof value === 'string' ? value.trim() : this.trimFormValues(value);
      return acc;
    }, {} as any);
  }

  clearanceNameAddressCheckAccordionClose(isSaveAndExit: boolean = false, afterSave?: () => void){
    if(this.suppressClearanceCloseSave){
      this.suppressClearanceCloseSave = false;
      return;
    }
  if(!this.isReadOnly()){
  if(!this.selectedPolicyType()){
    this.toastService.addNotification({message: "Please select policy type before moving to next step", type: ToastType.Error}); // error notification
    return ;
  }
  const cleanedPremium = this.cleanCurrencyValue(this.premium);

  if (!cleanedPremium || isNaN(cleanedPremium) || cleanedPremium <= 0) {
    this.showPremiumError = true;
    this.toastService.addNotification({ 
      message: "Target Premium Amount is required", 
      type: ToastType.Error 
    });
    return;
  } else {
    this.showPremiumError = false;
  }
  
  const questionList = this.questions(); // read signal
    const answers = this.questionAnswers();

    const allAnswered = questionList.every(q => {
      const val = Number(answers[q.questionId]);
      return val === 0 || val === 2;
    });

    if (!allAnswered && !this.isReadOnly()) {
      this.toastService.addNotification({
        message: "Please respond to the Clearance Questions",
        type: ToastType.Error
      });
      return;
    }
  // const formData = this.addressForm.value;

  const formData = this.trimFormValues(this.addressForm.value); 
  
 
  // const buildingForm = this.createBuildingGroup().value;
  let hasError = false;    

  const addressesArray = this.addressForm.get('addresses') as FormArray;

  addressesArray.controls.forEach((addressGroup: AbstractControl, index: number) => {
    const formGroup = addressGroup as FormGroup;

    const buildingDetailsControl = formGroup.get('buildingDetails') as FormArray;
    const structuresControl = formGroup.get('structures') as FormArray;

    buildingDetailsControl.disable();
    structuresControl.disable();

    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      control?.markAsTouched();
   
    });

    formGroup.updateValueAndValidity();

    if (formGroup.invalid) {
    
      hasError = true;
    }

    buildingDetailsControl.enable();
    structuresControl.enable();
    });


    if(this.namedInsured().trim() === ''){
      this.showNamedInsured.set(true);
      return;
    }else{
      this.showNamedInsured.set(false);
    }

    if (hasError) {
    this.scrollToTop();
    return;
     }      
     const trimmedNamedInsured = this.namedInsured()?.trim() || ''; 
      const clearanceCheckRequest = this.isIndicationType()
        ? this.addressService.clearanceCheck(formData, this.selectedPolicyType(), trimmedNamedInsured, this.Questions(), cleanedPremium)
        : this.addressService.clearanceCheckQuote(formData, [], [], this.selectedPolicyType(), trimmedNamedInsured, this.Questions(), cleanedPremium);

      clearanceCheckRequest.subscribe({
       next: (response) => {
        const { nameInsuredExists, addressExists } = response;

        if (nameInsuredExists || addressExists === true) {
          this.pendingClearanceAddressIds = this.extractClearanceAddressIds(response);
          this.onProceed(isSaveAndExit);
        } else {
         this.pendingClearanceAddressIds = [];
         this.clearanceStepAccordianClose(isSaveAndExit, afterSave)
         
        }
      },
      error: (error) => {
        }
      });
    }else{
      this.clearanceStepAccordianClose(isSaveAndExit);
    }
  }
clearanceNameAddressCheck(isSaveAndExit: boolean = false, submitReferralOnMatch: boolean = false, proceedToRequestQuoteOnNoMatch: boolean = false){
  if(!this.isReadOnly() || proceedToRequestQuoteOnNoMatch){
  if(!this.selectedPolicyType()){
    this.toastService.addNotification({message: "Please select policy type before moving to next step", type: ToastType.Error}); // error notification
    return ;
  }
  const cleanedPremium = this.cleanCurrencyValue(this.premium);

  if (!cleanedPremium || isNaN(cleanedPremium) || cleanedPremium <= 0) {
    this.showPremiumError = true;
    this.toastService.addNotification({ 
      message: "Target Premium Amount is required", 
      type: ToastType.Error 
    });
    return;
  } else {
    this.showPremiumError = false;
  }
  
  const questionList = this.questions(); // read signal
    const answers = this.questionAnswers();

    const allAnswered = questionList.every(q => {
      const val = Number(answers[q.questionId]);
      return val === 0 || val === 2;
    });

    if (!allAnswered && !this.isReadOnly()) {
      this.toastService.addNotification({
        message: "Please respond to the Clearance Questions",
        type: ToastType.Error
      });
      return;
    }
  // const formData = this.addressForm.value;

  const formData = this.trimFormValues(this.addressForm.value); 
  
 
  // const buildingForm = this.createBuildingGroup().value;
  let hasError = false;    

  const addressesArray = this.addressForm.get('addresses') as FormArray;

  addressesArray.controls.forEach((addressGroup: AbstractControl, index: number) => {
    const formGroup = addressGroup as FormGroup;

    const buildingDetailsControl = formGroup.get('buildingDetails') as FormArray;
    const structuresControl = formGroup.get('structures') as FormArray;

    buildingDetailsControl.disable();
    structuresControl.disable();

    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      control?.markAsTouched();
   
    });

    formGroup.updateValueAndValidity();

    if (formGroup.invalid) {
    
      hasError = true;
    }

    buildingDetailsControl.enable();
    structuresControl.enable();
    });


    if(this.namedInsured().trim() === ''){
      this.showNamedInsured.set(true);
      return;
    }else{
      this.showNamedInsured.set(false);
    }

    if (hasError) {
    this.scrollToTop();
    return;
     }      
     const trimmedNamedInsured = this.namedInsured()?.trim() || ''; 
      const clearanceCheckRequest = this.isIndicationType()
        ? this.addressService.clearanceCheck(formData, this.selectedPolicyType(), trimmedNamedInsured, this.Questions(), cleanedPremium)
        : this.addressService.clearanceCheckQuote(formData, [], [], this.selectedPolicyType(), trimmedNamedInsured, this.Questions(), cleanedPremium);

      clearanceCheckRequest.subscribe({
       next: (response) => {
        const { nameInsuredExists, addressExists } = response;

        if (nameInsuredExists || addressExists === true) {
          this.pendingClearanceAddressIds = this.extractClearanceAddressIds(response);
          if (submitReferralOnMatch){
            this.onsubmitClearanceReferral();
          }else{
            this.onProceed(isSaveAndExit);
          }
        } else {
         this.pendingClearanceAddressIds = [];
         if (proceedToRequestQuoteOnNoMatch) {
           this.onRequestQuoteAction(2);
         } else {
           this.clearanceStep(isSaveAndExit)
         }
         
        }
      },
      error: (error) => {
        }
      });
    }else{
      if (proceedToRequestQuoteOnNoMatch) {
        this.onRequestQuoteAction(2);
      } else {
        this.clearanceStep(isSaveAndExit);
      }
    }
  }

  onInvalidStateSelection(message: string){
    const dialog = this.dialog.open(ApprovedStatesRestrictionDialog, {
      data: { message: message }
    });

    return dialog.afterClosed();
  }

  onCheckApprovedStateSelection() {
    const approvedStatesList = this.authService.getApprovedStatesIdsFromStorage();
    if(approvedStatesList?.length === 0){
      return false; // If no approved states not allow clearance save
    }else{
      const formData = this.addressForm.value;
      const selectedStateList: any[] = formData.addresses.map((address: any) => address.state);
      let isApprovedStateSelected = true;
      for (let i = 0; i < selectedStateList?.length; i++) {
        const stateId = selectedStateList[i];
        if (!approvedStatesList.includes(stateId)) {
          isApprovedStateSelected = false;
          break;
        }
      }
      return isApprovedStateSelected;
    }
  }

  onCheckMultipleStateSelected() {
      const formData = this.addressForm.value;
      const selectedStateList: any[] = formData.addresses.map((address: any) => address.state);
      if(formData.addresses?.length > 1){
        const isDuplicates = selectedStateList.filter(item => item !== selectedStateList[0]).length === 0;
        return !isDuplicates;
      }else{
        return false; // allow to proceed save action
      }
  }

  onCheckPrimaryEqualsAdditional() {
    const addressesArray = this.addressForm.get('addresses') as FormArray;
    if (!addressesArray || addressesArray.length <= 1) {
      return false;
    }

    const normalize = (v: any) => (v === null || v === undefined) ? '' : String(v).trim().toLowerCase();

    const seen = new Set<string>();

    for (let i = 0; i < addressesArray.length; i++) {
      const addr = addressesArray.at(i)?.value || {};

      const keyParts = [
        normalize(addr.streetNum),
        normalize(addr.unitNum),
        normalize(addr.street),
        String(addr.city),
        String(addr.state),
        normalize(addr.zipcode)
      ];

      const key = keyParts.join('|');

      if (seen.has(key)) {
        return true; // duplicate address found
      }
      seen.add(key);
    }

    return false;
  }


  clearanceStep(isSaveAndExit: boolean = false) {
    if(!this.selectedPolicyType()){
      this.toastService.addNotification({message: "Please select policy type before moving to next step", type: ToastType.Error}); // error notification
      return ;
    }

    if(this.isBroker() && !this.isReadOnly()){
      
      if(!this.onCheckApprovedStateSelection()){  // check for the ApprovedState selection
        const msg = "The premises address is not in an authorised State. You can edit the clearance information or select Exit to be directed to your landing page.";
          this.onInvalidStateSelection(msg)
          .subscribe((result: boolean) => {});
        return;
      }
      if(this.onCheckMultipleStateSelected()){ // address have different states not allow to save
        const msg = "Multi-State policies are out of scope under this program. Please edit submission to individual states or exit to return to landing page";
        this.onInvalidStateSelection(msg)
        .subscribe((result: boolean) => {});
        return;
      } 
      
    }

    if(!this.isReadOnly()){
      if (this.onCheckPrimaryEqualsAdditional()) { // primary and additional addresses are identical
       
        const msg = "Identical premises addresses are not permitted within a single submission. Please revise the addresses to ensure each property is unique or exit to return to your landing page.";
        this.onInvalidStateSelection(msg)
        .subscribe((result: boolean) => {});
        return;
      }
    }

     const questionList = this.questions(); // read signal
    const answers = this.questionAnswers();

    const allAnswered = questionList.every(q => {
      const val = Number(answers[q.questionId]);
      return val === 0 || val === 2;
    });

    if (!allAnswered && !this.isReadOnly()) {
      this.toastService.addNotification({
        message: "Please respond to the Clearance Questions",
        type: ToastType.Error
      });
      return;
    }

    const cleanedPremium = this.cleanCurrencyValue(this.premium);

    if (!cleanedPremium || isNaN(cleanedPremium) || cleanedPremium <= 0) {
      this.showPremiumError = true;
      this.toastService.addNotification({ 
        message: "Target Premium Amount is required", 
        type: ToastType.Error 
      });
      return;
    } else {
      this.showPremiumError = false;
    }
    const formData = this.trimFormValues(this.addressForm.value);    
    

    // const buildingForm = this.createBuildingGroup().value;
    let hasError = false;    

    const addressesArray = this.addressForm.get('addresses') as FormArray;

    addressesArray.controls.forEach((addressGroup: AbstractControl, index: number) => {
      const formGroup = addressGroup as FormGroup;

      const buildingDetailsControl = formGroup.get('buildingDetails') as FormArray;
      const structuresControl = formGroup.get('structures') as FormArray;

      buildingDetailsControl.disable();
      structuresControl.disable();

      Object.keys(formGroup.controls).forEach((key) => {
        const control = formGroup.get(key);
        control?.markAsTouched();
      });

      formGroup.updateValueAndValidity();

      if (formGroup.invalid) {
        hasError = true;
      }

      buildingDetailsControl.enable();
      structuresControl.enable();
    });
    if(this.namedInsured().trim() === ''){
      this.showNamedInsured.set(true);
      return;
    }else{
      this.showNamedInsured.set(false);
    }
     if (hasError) {
      this.scrollToTop();
      return;
    }     

    let anyOccupancyDeclined = false;
    let anyOccupancyReferred = false;
    let declinedOccupancyDescription = '';

    
     for (const address of this.addresses()) {
    const occupancyClassId = address.get('occupancy')?.value;
    if (occupancyClassId) {
      const associatedOccupancy = this.Occupancies().find(
        (occupancy) => Number(occupancy.classId.toString().trim()) === Number(occupancyClassId.toString().trim())
      );

      if (associatedOccupancy) {
        if (associatedOccupancy.ruleName === 'Decline') {
          anyOccupancyDeclined = true;
          if (!declinedOccupancyDescription) {
            declinedOccupancyDescription = associatedOccupancy.description || associatedOccupancy.name || '';
          }
        }
        else if (associatedOccupancy.ruleName === 'Referral') {
          anyOccupancyReferred = true;
        }
      }
    }
  }

  if (anyOccupancyDeclined) {
    this.showDeclineNotification(this.getOccupancyDeclineMessage(declinedOccupancyDescription));
    return; 
  } else if (anyOccupancyReferred) {
    // Only show referral message if no occupancy was declined
    const getPreviousMessage = this.messages();
    getPreviousMessage.push({
      sender: 'Admin',
      time: this.getCurrentDateTime(),
      text: 'This quote requires further review by Alchemy. Please complete your submission and submit in Step 4.',
      isAdmin: true,
      isInitial: false
    });
    this.messages.set(getPreviousMessage);
  }
 

    if (this.stateRule === 'Decline') {
      this.showDeclineNotification('This state is excluded and this risk is not in appetite. You can edit the clearance information or select Exit to be directed to your landing page.');
      return;
    }

    if(this.isPolicyType()){
      this.policySaveClearanceData(formData);
    }else{
      this.isIndicationType() ? this.clearanceIndicationSave(formData, isSaveAndExit) :
      this.clearanceQuoteSave(formData, isSaveAndExit);
    }
    this.previousOccupancyStatus = this.selectedOccupancy ? this.selectedOccupancy.status : null;

    // this.populatedNamedInsured = this.namedInsured;
}

private triggerEQBDReferralCheck(id: number, type: 'Indication' | 'Quote', versionNo: number): void {
  if (!id) {
    return;
  }
  const userId = Number(this.authService?.getUserDetailsFromStorage()?.userDetails?.userId ?? 0);
  if (!userId) {
    return;
  }
  this.addressService.CheckEQBDReferral(id, type, userId, versionNo).subscribe({
    next: () => {},
    error: () => {}
  });
}

private triggerEQBDReferralCheckAfterClearance(response: any, type: 'Indication' | 'Quote', isSaveAndExit: boolean): void {
  if (isSaveAndExit) {
    return;
  }
  const id = type === 'Indication'
    ? Number(response?.indication?.indicationId ?? response?.indicationId ?? sessionStorage.getItem('indicationId') ?? 0)
    : Number(response?.quote?.quoteId ?? response?.quoteId ?? sessionStorage.getItem('quoteId') ?? 0);

    const versionNo = type === 'Indication'
    ? Number(response?.indication?.versionNo ?? response?.versionNo ?? sessionStorage.getItem('versionNo') ?? 0)
    : Number(response?.quote?.versionNo ?? response?.versionNo ?? sessionStorage.getItem('versionNo') ?? 0);
  this.triggerEQBDReferralCheck(id, type, versionNo);
}

clearanceIndicationSave(formData: any, isSaveAndExit: boolean = false) {
   this.isLoading.set(true);
  if (!this.isReadOnly()) {
    const cleanedPremium = this.cleanCurrencyValue(this.premium);
    const trimmedNamedInsured = this.namedInsured()?.trim() || '';

    // Get edited addresses for Preferred Reports payload
    const editedIndexes = this.getEditedAddresses();
    const addressesFormArray = this.addressControls();
    const preferredReports: any[] = [];
    const preferredReportResponse: any[] = [];

 if (editedIndexes.length > 0) {
  const externalRequestId = this.isIndicationType()
    ? sessionStorage.getItem('indicationNo')
    : sessionStorage.getItem('quoteNo');
  const userId = JSON.parse(sessionStorage.getItem('userDetails') || '{}').userId;

  const addresses: any[] = [];
  const storedIndicationAddress = sessionStorage.getItem('indicationAddressId');
  const indicationAddressIds: any[] = storedIndicationAddress ? JSON.parse(storedIndicationAddress) : [];

  editedIndexes.forEach((index) => {
    const addressGroup = addressesFormArray.at(index);
    const raw = addressGroup.getRawValue();
    const { city, state } = addressGroup.value;

    const getStateName = Array.from(this.states().values())
      .flat()
      .find(s => String(s.stateId) === String(state));
    const getCityName = Array.from(this.cities().values())
      .flat()
      .find(c => String(c.cityId) === String(city));

    addresses.push({
      externalRequestId:  externalRequestId !== null ? String(externalRequestId) : '12345',
      subRequestId: String(indicationAddressIds && indicationAddressIds.length > index && indicationAddressIds[index] ? indicationAddressIds[index] : 1),
      streetNumber: String(raw.streetNum)?.trim(),
      unit: String(raw.unitNum || '')?.trim(),
      city: String(getCityName?.cityName || raw.city)?.trim(),
      state: String(getStateName?.stateName || raw.state)?.trim(),
      zipcode: String(raw.zipcode),
      streetName: String(raw.street)?.trim(),
      userId: Number(this.authService?.getUserDetailsFromStorage()?.userDetails?.userId) // convert to number
      });
    });

    preferredReports.push({
      addresses: addresses
    });  
  }

    preferredReportResponse.push({
        success: true,
        errorMessage: "string",
        addresses: "string"
      });


    const isPRSubmit = !this.initialAddressesSnapshot || editedIndexes.length > 0;
   
    
    this.addressService.clearanceStep(
      formData,preferredReports,preferredReportResponse,
      this.selectedPolicyType(),
      trimmedNamedInsured,
      this.Questions(),
      cleanedPremium,
      isPRSubmit,
      this.clearanceIndicationStep
    ).subscribe({
      next: (response) => {
        this.setIndicationConfigData(response);
        this.mapClearanceData(response.indication, response.questions);
        this.triggerEQBDReferralCheckAfterClearance(response, 'Indication', isSaveAndExit);

        // Update isEdited address flags via POST API (only when there are edits)
        const payload = this.buildIsEditAddressPayload(this.pendingClearanceAddressIds);
        if (payload) {
          this.propertyService.updateIsEditAddress(payload).subscribe({
            next: () => {
              payload.addresses.forEach((addr: any) => {
                this.isEditedAddressFlags.set(addr.addressId, addr.isEdited);
                if (typeof addr.isClearanceAddressEdited !== 'undefined') {
                  this.clearanceEditedAddressFlags.set(addr.addressId, Number(addr.isClearanceAddressEdited));
                }
              });
            },
            error: (updateError) => {
              console.error('Failed to update isEdited address flags:', updateError);
            }
          });
        }
        this.updateClearanceAddressEditedAfterClearanceSave();
         if (isSaveAndExit) {
            const indicationDraft = isPRSubmit ? 1 : 0; // 1 if address edited/added, 0 otherwise
            this.propertyService.UpdateIndicationDraftIndication(indicationDraft).subscribe({
              next: (draftResponse) => {
                this.router.navigate(['/quote']); // redirect user to landing page
                this.indicationQuoteService.removeIndicationQuoteStorageData();
              },
              error: (draftError) => {
              }
            });
           
            
            return;
          }
        // First handle normal clearance data mapping
       
        const indicationDraft = isPRSubmit ? 1 : 0; // 1 if address edited/added, 0 otherwise
            this.propertyService.UpdateIndicationDraftIndication(indicationDraft).subscribe({
              next: (draftResponse) => {
               
              },
              error: (draftError) => {
              }
            });
        this.isLoading.set(false);

        this.handlePostClearanceBinding(
          response.preferredReportResponse,
          editedIndexes,
          () => this.propertyService.getGetPRApiResponseIndication()
        );
     this.setIndicationConfigData(response);
        const quoteId = response.quoteId;
        sessionStorage.setItem('quoteId', String(quoteId));
        this.quoteId.set(response.quoteId);
        

        const quoteAddressId = response.quoteAddressId;
        const policyTypeId = response.indication.policyTypeId;
        sessionStorage.setItem("policyTypeId", String(policyTypeId));
        this.propertyService.setVersionNo(response.indication?.versionNo);

        const currentFormValue = this.addressForm.getRawValue();
        sessionStorage.setItem('quoteAddressId', JSON.stringify(quoteAddressId));

        if (response.quoteNo) {
          sessionStorage.setItem('quoteNumber', String(response.quoteNo));
          this.quoteNumber.set(response.quoteNo);
        }

        const quoteDetails = {
          QuoteNo: response.quoteNo,
          namedInsured: response.nameInsured,
          tiv: response.tiv,
          status: response.status
        };
        sessionStorage.setItem('quoteDetails', JSON.stringify(quoteDetails));        
        

        const storedIndicationStatus = sessionStorage.getItem('indicationStatus');
        const indicationStatus = storedIndicationStatus ? +storedIndicationStatus : null;
        this.indicationStatus.set(indicationStatus);

        this.populatedNamedInsured = response?.indication.nameInsured || '';
        this.premium = this.formatCurrencyValue(response?.indication.targetPremium);

        const getTivData = this.propertyService.getTIV();
        this.populatedTiv = getTivData ? getTivData : '';
        this.populatedQuoteId = response?.indication?.indicationNo || '';
        this.onRiskSummaryStatusBindHandler(response?.indication, "indication");

        if (this.copeInfoSave() || sessionStorage.getItem('copeInfosave') === 'true') {
          // this.requestQuoteService.onUpdateCopeStepData(true);
          // this.fetchCopeStepDataHandler();
        } else {
          this.clearanceInfoSave.set(true);
          sessionStorage.setItem('clearanceInfoSave', JSON.stringify(true));
        }

        this.onGetSystemUserMessage();
        this.step.set(1);
        if (this.visitedStep() < 1) {
          this.visitedStep.update(i => i + 1);
        }
      },
      error: (error) => {
         this.isLoading.set(false);
        this.toastService.addNotification({
          message: "System error. Clearance failed. Please exit and contact help@AbacusAU.com.",
          type: ToastType.Error
        });
      }
    });
  } else {
    // Read-only handling remains unchanged
     this.isLoading.set(false);
    if (isSaveAndExit) {
      this.router.navigate(['/quote']);
      this.indicationQuoteService.removeIndicationQuoteStorageData();
      return;
    }
    this.requestQuoteService.resetClearanceStepData();
    if (this.copeInfoSave() || sessionStorage.getItem('clearanceInfoSave') === 'true') {
      // this.requestQuoteService.onUpdateCopeStepData(true);
      // this.fetchCopeStepDataHandler(); 
    }
          const storedDraftStatus = sessionStorage.getItem('indicationDraftStatus');
        if (storedDraftStatus) {
          const draftStatus = JSON.parse(storedDraftStatus);
          if (draftStatus.indicationDraft === 1) {
            // Draft status is 1, call getGetPRApiResponseIndication and patch building data
            this.propertyService.getGetPRApiResponseIndication().subscribe({
              next: (prResponse: any) => {
                  if (prResponse) {                 
                    const addressesFormArray = this.addressControls();
                    
                    // Store the prResponse for use in mapCopeData
                    this.tempPrResponse = prResponse;
                    
                    // Always call getCopeData - the logic will be handled inside mapCopeData
                    this.getCopeData();
                  
                }
              },
              error: (prError) => {
                      this.getCopeData(true);  
              }
            });
          }else{
            this.requestQuoteService.onUpdateCopeStepData(true);
             this.fetchCopeStepDataHandler();
          }
        }
    this.step.set(1);
    if (this.visitedStep() < 1) {
      this.visitedStep.update(i => i + 1);
    }
  }
}
 clearanceQuoteSave(formData:any, isSaveAndExit: boolean = false){
    this.isLoading.set(true);
    if(!this.isReadOnly()){
      const cleanedPremium = this.cleanCurrencyValue(this.premium);
      const trimmedNamedInsured = this.namedInsured()?.trim() || ''; 

      
    // Get edited addresses for Preferred Reports payload
    const editedIndexes = this.getEditedAddresses();
    const addressesFormArray = this.addressControls();
    const preferredReports: any[] = [];
    const preferredReportResponse: any[] = [];
    const storedQuoteAddress = sessionStorage.getItem('quoteAddressId');
  const quoteAddressIds: any[] = storedQuoteAddress ? JSON.parse(storedQuoteAddress) : [];

    if (editedIndexes.length > 0) {
  const externalRequestId = this.isIndicationType()
    ? sessionStorage.getItem('indicationNo')
    : sessionStorage.getItem('quoteNo');
  const userId = JSON.parse(sessionStorage.getItem('userDetails') || '{}').userId;

  const addresses: any[] = [];

  editedIndexes.forEach((index) => {
    const addressGroup = addressesFormArray.at(index);
    const raw = addressGroup.getRawValue();
    const { city, state } = addressGroup.value;

    const getStateName = Array.from(this.states().values())
      .flat()
      .find(s => String(s.stateId) === String(state));
    const getCityName = Array.from(this.cities().values())
      .flat()
      .find(c => String(c.cityId) === String(city));

    addresses.push({
      externalRequestId: externalRequestId !== null ? String(externalRequestId) : '12345',
      subRequestId: String(quoteAddressIds && quoteAddressIds.length > index && quoteAddressIds[index] ? quoteAddressIds[index] : 1),
      streetNumber: String(raw.streetNum)?.trim(),
      unit: String(raw.unitNum || '')?.trim(),
      city: String(getCityName?.cityName || raw.city)?.trim(),
      state: String(getStateName?.stateName || raw.state)?.trim(),
      zipcode: String(raw.zipcode),
      streetName: String(raw.street)?.trim(),
      userId: Number(this.authService?.getUserDetailsFromStorage()?.userDetails?.userId) // convert to number
      });
    });

    preferredReports.push({
      addresses: addresses
    });  
  }
    preferredReportResponse.push({
        success: true,
        errorMessage: "string",
        addresses: "string"
      });

      const isPRSubmit = !this.initialAddressesSnapshot || editedIndexes.length > 0;
      
      this.addressService.clearanceQuoteStep(formData,preferredReports,preferredReportResponse,this.selectedPolicyType(), trimmedNamedInsured,this.QuestionsQuote(),cleanedPremium, isPRSubmit, this.clearanceQuoteStep).subscribe({
        next: (response) => {
          this.setQuoteConfigData(response);
          this.mapClearanceData(response.quote, response.questions);
          this.triggerEQBDReferralCheckAfterClearance(response, 'Quote', isSaveAndExit);

          // Update isEdited address flags via POST API (only when there are edits)
          const payload = this.buildIsEditAddressPayload(this.pendingClearanceAddressIds);
          if (payload) {
            this.propertyService.updateIsEditAddress(payload).subscribe({
              next: () => {
                payload.addresses.forEach((addr: any) => {
                  this.isEditedAddressFlags.set(addr.addressId, addr.isEdited);
                  if (typeof addr.isClearanceAddressEdited !== 'undefined') {
                    this.clearanceEditedAddressFlags.set(addr.addressId, Number(addr.isClearanceAddressEdited));
                  }
                });
              },
              error: (updateError) => {
                console.error('Failed to update isEdited address flags:', updateError);
              }
            });
          }
                  this.updateClearanceAddressEditedAfterClearanceSave();

          if (isSaveAndExit) {
            const indicationDraft = isPRSubmit ? 1 : 0; // 1 if address edited/added, 0 otherwise
            this.propertyService.UpdateIndicationDraftQuote(indicationDraft).subscribe({
              next: (draftResponse) => {
                this.router.navigate(['/quote']); // redirect user to landing page
                this.indicationQuoteService.removeIndicationQuoteStorageData();
              },
              error: (draftError) => {
              }
            });
            return;
          }
          const indicationDraft = isPRSubmit ? 1 : 0; // 1 if address edited/added, 0 otherwise
            this.propertyService.UpdateIndicationDraftQuote(indicationDraft).subscribe({
              next: (draftResponse) => {
              
              },
              error: (draftError) => {
              }
            });
          
          this.isLoading.set(false);

          this.handlePostClearanceBinding(
            response.preferredReportResponse,
            editedIndexes,
            () => this.propertyService.getGetPRApiResponseQuote()
          );

           
          // this.PreferredReportsSave.set(false)
          this.propertyService.setVersionNo(response.quote?.versionNo);
          const quoteId = response.quoteId;
          
          sessionStorage.setItem('quoteId', String(quoteId));
          this.quoteId.set(response.quoteId);
          const quoteAddressId = response.quoteAddressId;
          
          const currentFormValue = this.addressForm.getRawValue();          
          
          sessionStorage.setItem('quoteAddressId', JSON.stringify(quoteAddressId));
          if (response.quoteNo) {
            sessionStorage.setItem('quoteNumber', String(response.quoteNo));
            this.quoteNumber.set(response.quoteNo);
          }
          const quoteDetails = {
            QuoteNo: response.quoteNo,
            namedInsured: response.nameInsured,
            tiv: response.tiv,
            status: response.status
          };
          sessionStorage.setItem('quoteDetails', JSON.stringify(quoteDetails))

       this.setQuoteConfigData(response);

        const nameInsured = sessionStorage.getItem('nameInsured');
        const IndicationNo = sessionStorage.getItem('indicationNo');
        const storedIndicationStatus = sessionStorage.getItem('indicationStatus');
        const getTivData = this.propertyService.getTIV();

        const indicationStatus = storedIndicationStatus ? +storedIndicationStatus : null;
        this.indicationStatus.set(indicationStatus);

        this.populatedNamedInsured = response?.quote.nameInsured || ''; // risk summary namedInsured
        this.premium = this.formatCurrencyValue(response?.quote.targetPremium); 
       
        this.populatedTiv = getTivData ? getTivData : ''; // risk summary tiv
        this.populatedQuoteId = this.quoteNoWithVersion(response?.quote?.quoteNo, response?.quote?.versionNo) || '';
        this.onRiskSummaryStatusBindHandler(response?.quote, "quote"); // setting the risk summary status
        if(this.copeInfoSave() || sessionStorage.getItem('copeInfosave') ==='true'){
          // this.requestQuoteService.onUpdateCopeStepData(true);
          // this.fetchCopeStepDataHandler()
          }else{
            this.clearanceInfoSave.set(true);
            sessionStorage.setItem('clearanceInfoSave',JSON.stringify(true))            
          }
        this.onGetSystemUserMessage();
          // update/setting the Indication details
          this.step.set(1);
          if(this.visitedStep() < 1) {
            this.visitedStep.update(i => i + 1);
          }
       },
        error: (error) => {
          this.isLoading.set(false);

          this.toastService.addNotification({message: "System error. Clearance failed. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
        }
      });
    }else{
        this.isLoading.set(false);

      if(isSaveAndExit){
        this.router.navigate(['/quote']); // redirect user to landing page
        this.indicationQuoteService.removeIndicationQuoteStorageData();
        return;
      }
       // update the requestQuote Service
       this.requestQuoteService.resetClearanceStepData(); // reset clearance step
      //  this.requestQuoteService.onUpdateCopeStepData(true); // update cope Step to receive data 
       if(this.copeInfoSave() || sessionStorage.getItem('clearanceInfoSave') === 'true'){
        // this.requestQuoteService.onUpdateCopeStepData(true);
        // this.fetchCopeStepDataHandler()
        }
         const storedDraftStatus = sessionStorage.getItem('quoteDraftStatus');
        if (storedDraftStatus) {
          const draftStatus = JSON.parse(storedDraftStatus);
          if (draftStatus.quoteDraft === 1) {
            // Draft status is 1, call getGetPRApiResponseIndication and patch building data
            this.propertyService.getGetPRApiResponseQuote().subscribe({
              next: (prResponse: any) => {
                  if (prResponse) {                 
                    const addressesFormArray = this.addressControls();
                    
                    // Store the prResponse for use in mapCopeData
                    this.tempPrResponse = prResponse;
                    
                    // Always call getCopeData - the logic will be handled inside mapCopeData
                    this.getCopeData();
                  
                }
              },
              error: (prError) => {
                       this.getCopeData(true); 
              }
            });
          }else{
            this.requestQuoteService.onUpdateCopeStepData(true);
             this.fetchCopeStepDataHandler();
          }
        }
                 
          
       this.step.set(1);
       if(this.visitedStep() < 1) {
        this.visitedStep.update(i => i + 1);
       }
    }
    
  }


    clearanceStepAccordianClose(isSaveAndExit: boolean = false, afterSave?: () => void) {

       if(this.suppressClearanceCloseSave){
      this.suppressClearanceCloseSave = false;
      return;
    }
    
    if(!this.selectedPolicyType()){
      this.toastService.addNotification({message: "Please select policy type before moving to next step", type: ToastType.Error}); // error notification
      return ;
    }

    if(this.isBroker() && !this.isReadOnly()){
      
      if(!this.onCheckApprovedStateSelection()){  // check for the ApprovedState selection
        const msg = "The premises address is not in an authorised State. You can edit the clearance information or select Exit to be directed to your landing page.";
          this.onInvalidStateSelection(msg)
          .subscribe((result: boolean) => {});
        return;
      }
      if(this.onCheckMultipleStateSelected()){ // address have different states not allow to save
        const msg = "Multi-State policies are out of scope under this program. Please edit submission to individual states or exit to return to landing page";
        this.onInvalidStateSelection(msg)
        .subscribe((result: boolean) => {});
        return;
      } 
      
    }

     if(!this.isReadOnly()){
      if (this.onCheckPrimaryEqualsAdditional()) { // primary and additional addresses are identical
       
        const msg = "Identical premises addresses are not permitted within a single submission. Please revise the addresses to ensure each property is unique or exit to return to your landing page.";
        this.onInvalidStateSelection(msg)
        .subscribe((result: boolean) => {});
        return;
      }
    }

     const questionList = this.questions(); // read signal
    const answers = this.questionAnswers();

    const allAnswered = questionList.every(q => {
      const val = Number(answers[q.questionId]);
      return val === 0 || val === 2;
    });

    if (!allAnswered && !this.isReadOnly()) {
      this.toastService.addNotification({
        message: "Please respond to the Clearance Questions",
        type: ToastType.Error
      });
      return;
    }

    const cleanedPremium = this.cleanCurrencyValue(this.premium);

    if (!cleanedPremium || isNaN(cleanedPremium) || cleanedPremium <= 0) {
      this.showPremiumError = true;
      this.toastService.addNotification({ 
        message: "Target Premium Amount is required", 
        type: ToastType.Error 
      });
      return;
    } else {
      this.showPremiumError = false;
    }
    const formData = this.trimFormValues(this.addressForm.value);    
    

    // const buildingForm = this.createBuildingGroup().value;
    let hasError = false;    

    const addressesArray = this.addressForm.get('addresses') as FormArray;

    addressesArray.controls.forEach((addressGroup: AbstractControl, index: number) => {
      const formGroup = addressGroup as FormGroup;

      const buildingDetailsControl = formGroup.get('buildingDetails') as FormArray;
      const structuresControl = formGroup.get('structures') as FormArray;

      buildingDetailsControl.disable();
      structuresControl.disable();

      Object.keys(formGroup.controls).forEach((key) => {
        const control = formGroup.get(key);
        control?.markAsTouched();
      });

      formGroup.updateValueAndValidity();

      if (formGroup.invalid) {
        hasError = true;
      }

      buildingDetailsControl.enable();
      structuresControl.enable();
    });
    if(this.namedInsured().trim() === ''){
      this.showNamedInsured.set(true);
      return;
    }else{
      this.showNamedInsured.set(false);
    }
     if (hasError) {
      this.scrollToTop();
      return;
    }     

    let anyOccupancyDeclined = false;
    let anyOccupancyReferred = false;
    let declinedOccupancyDescription = '';

    
     for (const address of this.addresses()) {
    const occupancyClassId = address.get('occupancy')?.value;
    if (occupancyClassId) {
      const associatedOccupancy = this.Occupancies().find(
        (occupancy) => Number(occupancy.classId.toString().trim()) === Number(occupancyClassId.toString().trim())
      );

      if (associatedOccupancy) {
        if (associatedOccupancy.ruleName === 'Decline') {
          anyOccupancyDeclined = true;
          if (!declinedOccupancyDescription) {
            declinedOccupancyDescription = associatedOccupancy.description || associatedOccupancy.name || '';
          }
        }
        else if (associatedOccupancy.ruleName === 'Referral') {
          anyOccupancyReferred = true;
        }
      }
    }
  }

  if (anyOccupancyDeclined) {
    this.showDeclineNotification(this.getOccupancyDeclineMessage(declinedOccupancyDescription));
    return; 
  } else if (anyOccupancyReferred) {
    // Only show referral message if no occupancy was declined
    const getPreviousMessage = this.messages();
    getPreviousMessage.push({
      sender: 'Admin',
      time: this.getCurrentDateTime(),
      text: 'This quote requires further review by Alchemy. Please complete your submission and submit in Step 4.',
      isAdmin: true,
      isInitial: false
    });
    this.messages.set(getPreviousMessage);
  }
 

    if (this.stateRule === 'Decline') {
      this.showDeclineNotification('This state is excluded and this risk is not in appetite. You can edit the clearance information or select Exit to be directed to your landing page.');
      return;
    }

    if(this.isPolicyType()){
      this.policySaveClearanceData(formData);
    }else{
      this.isIndicationType() ? this.clearanceIndicationSaveAccordianClose(formData, isSaveAndExit, afterSave) :
      this.clearanceQuoteSaveAccordianClose(formData, isSaveAndExit, afterSave);
    }
    this.previousOccupancyStatus = this.selectedOccupancy ? this.selectedOccupancy.status : null;

    // this.populatedNamedInsured = this.namedInsured;
  }

clearanceIndicationSaveAccordianClose(formData: any, isSaveAndExit: boolean = false, afterSave?: () => void) {
   this.isLoading.set(true);
  if (!this.isReadOnly()) {
    const cleanedPremium = this.cleanCurrencyValue(this.premium);
    const trimmedNamedInsured = this.namedInsured()?.trim() || '';

    // Get edited addresses for Preferred Reports payload
    const editedIndexes = this.getEditedAddresses();
    const addressesFormArray = this.addressControls();
    const preferredReports: any[] = [];
    const preferredReportResponse: any[] = [];

 if (editedIndexes.length > 0) {
  const externalRequestId = this.isIndicationType()
    ? sessionStorage.getItem('indicationNo')
    : sessionStorage.getItem('quoteNo');
  const userId = JSON.parse(sessionStorage.getItem('userDetails') || '{}').userId;

  const addresses: any[] = [];
  const storedIndicationAddress = sessionStorage.getItem('indicationAddressId');
  const indicationAddressIds: any[] = storedIndicationAddress ? JSON.parse(storedIndicationAddress) : [];

  editedIndexes.forEach((index) => {
    const addressGroup = addressesFormArray.at(index);
    const raw = addressGroup.getRawValue();
    const { city, state } = addressGroup.value;

    const getStateName = Array.from(this.states().values())
      .flat()
      .find(s => String(s.stateId) === String(state));
    const getCityName = Array.from(this.cities().values())
      .flat()
      .find(c => String(c.cityId) === String(city));

    addresses.push({
      externalRequestId:  externalRequestId !== null ? String(externalRequestId) : '12345',
      subRequestId: String(indicationAddressIds && indicationAddressIds.length > index && indicationAddressIds[index] ? indicationAddressIds[index] : 1),
      streetNumber: String(raw.streetNum)?.trim(),
      unit: String(raw.unitNum || '')?.trim(),
      city: String(getCityName?.cityName || raw.city)?.trim(),
      state: String(getStateName?.stateName || raw.state)?.trim(),
      zipcode: String(raw.zipcode),
      streetName: String(raw.street)?.trim(),
      userId: Number(this.authService?.getUserDetailsFromStorage()?.userDetails?.userId) // convert to number
      });
    });

    preferredReports.push({
      addresses: addresses
    });  
  }

    preferredReportResponse.push({
        success: true,
        errorMessage: "string",
        addresses: "string"
      });


    // Determine isPRSubmit based on whether initial data has been loaded and addresses have been edited
    // If initialAddressesSnapshot is not set, this is the first call, so isPRSubmit should be true
    // If initialAddressesSnapshot is set, check if addresses have been edited
    // If addresses are edited/added: isPRSubmit = true, if not edited: isPRSubmit = false
    const isPRSubmit = !this.initialAddressesSnapshot || editedIndexes.length > 0;
   
    
    this.addressService.clearanceStep(
      formData,preferredReports,preferredReportResponse,
      this.selectedPolicyType(),
      trimmedNamedInsured,
      this.Questions(),
      cleanedPremium,
      isPRSubmit,
      this.clearanceIndicationStep
    ).subscribe({
      next: (response) => {
        this.setIndicationConfigData(response);
        this.mapClearanceData(response.indication, response.questions);
        this.triggerEQBDReferralCheckAfterClearance(response, 'Indication', isSaveAndExit);

        const payload = this.buildIsEditAddressPayload(this.pendingClearanceAddressIds);
        if (payload) {
          this.propertyService.updateIsEditAddress(payload).subscribe({
            next: () => {
              payload.addresses.forEach((addr: any) => {
                this.isEditedAddressFlags.set(addr.addressId, addr.isEdited);
                if (typeof addr.isClearanceAddressEdited !== 'undefined') {
                  this.clearanceEditedAddressFlags.set(addr.addressId, Number(addr.isClearanceAddressEdited));
                }
              });
            },
            error: (updateError) => {
              console.error('Failed to update isEdited address flags:', updateError);
            }
          });
        }

         if (isSaveAndExit) {
            const indicationDraft = isPRSubmit ? 1 : 0; // 1 if address edited/added, 0 otherwise
            this.propertyService.UpdateIndicationDraftIndication(indicationDraft).subscribe({
              next: (draftResponse) => {
                this.router.navigate(['/quote']); // redirect user to landing page
                this.indicationQuoteService.removeIndicationQuoteStorageData();
              },
              error: (draftError) => {
              }
            });
            return;
          }
        // First handle normal clearance data mapping
        const indicationDraft = isPRSubmit ? 1 : 0; // 1 if address edited/added, 0 otherwise
            this.propertyService.UpdateIndicationDraftIndication(indicationDraft).subscribe({
              next: (draftResponse) => {
               
              },
              error: (draftError) => {
              }
            });
         this.isLoading.set(false);
        this.handlePostClearanceBinding(
          response.preferredReportResponse,
          editedIndexes,
          () => this.propertyService.getGetPRApiResponseIndication()
        );
     this.setIndicationConfigData(response);
        const quoteId = response.quoteId;
        sessionStorage.setItem('quoteId', String(quoteId));
        this.quoteId.set(response.quoteId);

        const quoteAddressId = response.quoteAddressId;
        const policyTypeId = response.indication.policyTypeId;
        sessionStorage.setItem("policyTypeId", String(policyTypeId));
        this.propertyService.setVersionNo(response.indication?.versionNo);

        const currentFormValue = this.addressForm.getRawValue();
        sessionStorage.setItem('quoteAddressId', JSON.stringify(quoteAddressId));

        if (response.quoteNo) {
          sessionStorage.setItem('quoteNumber', String(response.quoteNo));
          this.quoteNumber.set(response.quoteNo);
        }

        const quoteDetails = {
          QuoteNo: response.quoteNo,
          namedInsured: response.nameInsured,
          tiv: response.tiv,
          status: response.status
        };
        sessionStorage.setItem('quoteDetails', JSON.stringify(quoteDetails));        
        

        const storedIndicationStatus = sessionStorage.getItem('indicationStatus');
        const indicationStatus = storedIndicationStatus ? +storedIndicationStatus : null;
        this.indicationStatus.set(indicationStatus);

        this.populatedNamedInsured = response?.indication.nameInsured || '';
        this.premium = this.formatCurrencyValue(response?.indication.targetPremium);

        const getTivData = this.propertyService.getTIV();
        this.populatedTiv = getTivData ? getTivData : '';
        this.populatedQuoteId = response?.indication?.indicationNo || '';
        this.onRiskSummaryStatusBindHandler(response?.indication, "indication");

        if (this.copeInfoSave() || sessionStorage.getItem('copeInfosave') === 'true') {
          // this.requestQuoteService.onUpdateCopeStepData(true);
          // this.fetchCopeStepDataHandler();
        } else {
          this.clearanceInfoSave.set(true);
          sessionStorage.setItem('clearanceInfoSave', JSON.stringify(true));
        }

        this.onGetSystemUserMessage();
        afterSave?.();
        // this.step.set(1);
        // if (this.visitedStep() < 1) {
        //   this.visitedStep.update(i => i + 1);
        // }
      },
      error: (error) => {
         this.isLoading.set(false);
        this.toastService.addNotification({
          message: "System error. Clearance failed. Please exit and contact help@AbacusAU.com.",
          type: ToastType.Error
        });
      }
    });
  } else {
    // Read-only handling remains unchanged
     this.isLoading.set(false);
    if (isSaveAndExit) {
      this.router.navigate(['/quote']);
      this.indicationQuoteService.removeIndicationQuoteStorageData();
      return;
    }
    this.requestQuoteService.resetClearanceStepData();
    if (this.copeInfoSave() || sessionStorage.getItem('clearanceInfoSave') === 'true') {
      // this.requestQuoteService.onUpdateCopeStepData(true);
      // this.fetchCopeStepDataHandler(); 
    }
          const storedDraftStatus = sessionStorage.getItem('indicationDraftStatus');
        if (storedDraftStatus) {
          const draftStatus = JSON.parse(storedDraftStatus);
          if (draftStatus.indicationDraft === 1) {
            // Draft status is 1, call getGetPRApiResponseIndication and patch building data
            this.propertyService.getGetPRApiResponseIndication().subscribe({
              next: (prResponse: any) => {
                  if (prResponse) {                 
                    const addressesFormArray = this.addressControls();
                    
                    // Store the prResponse for use in mapCopeData
                    this.tempPrResponse = prResponse;
                    
                    // Always call getCopeData - the logic will be handled inside mapCopeData
                    this.getCopeData();
                  
                }
              },
              error: (prError) => {
                       this.getCopeData(true); 
              }
            });
          }else{
            this.requestQuoteService.onUpdateCopeStepData(true);
             this.fetchCopeStepDataHandler();
          }
        }
    // this.step.set(1);
    // if (this.visitedStep() < 1) {
    //   this.visitedStep.update(i => i + 1);
    // }
  }
}
 clearanceQuoteSaveAccordianClose(formData:any, isSaveAndExit: boolean = false, afterSave?: () => void){
    this.isLoading.set(true);
    if(!this.isReadOnly()){
      const cleanedPremium = this.cleanCurrencyValue(this.premium);
      const trimmedNamedInsured = this.namedInsured()?.trim() || ''; 

      
    // Get edited addresses for Preferred Reports payload
    const editedIndexes = this.getEditedAddresses();
    const addressesFormArray = this.addressControls();
    const preferredReports: any[] = [];
    const preferredReportResponse: any[] = [];
    const storedQuoteAddress = sessionStorage.getItem('quoteAddressId');
  const quoteAddressIds: any[] = storedQuoteAddress ? JSON.parse(storedQuoteAddress) : [];

    if (editedIndexes.length > 0) {
  const externalRequestId = this.isIndicationType()
    ? sessionStorage.getItem('indicationNo')
    : sessionStorage.getItem('quoteNo');
  const userId = JSON.parse(sessionStorage.getItem('userDetails') || '{}').userId;

  const addresses: any[] = [];

  editedIndexes.forEach((index) => {
    const addressGroup = addressesFormArray.at(index);
    const raw = addressGroup.getRawValue();
    const { city, state } = addressGroup.value;

    const getStateName = Array.from(this.states().values())
      .flat()
      .find(s => String(s.stateId) === String(state));
    const getCityName = Array.from(this.cities().values())
      .flat()
      .find(c => String(c.cityId) === String(city));

    addresses.push({
      externalRequestId: externalRequestId !== null ? String(externalRequestId) : '12345',
      subRequestId: String(quoteAddressIds && quoteAddressIds.length > index && quoteAddressIds[index] ? quoteAddressIds[index] : 1),
      streetNumber: String(raw.streetNum)?.trim(),
      unit: String(raw.unitNum || '')?.trim(),
      city: String(getCityName?.cityName || raw.city)?.trim(),
      state: String(getStateName?.stateName || raw.state)?.trim(),
      zipcode: String(raw.zipcode),
      streetName: String(raw.street)?.trim(),
      userId: Number(this.authService?.getUserDetailsFromStorage()?.userDetails?.userId) // convert to number
      });
    });

    preferredReports.push({
      addresses: addresses
    });  
  }
    preferredReportResponse.push({
        success: true,
        errorMessage: "string",
        addresses: "string"
      });

      // Determine isPRSubmit based on whether initial data has been loaded and addresses have been edited
      // If initialAddressesSnapshot is not set, this is the first call, so isPRSubmit should be true
      // If initialAddressesSnapshot is set, check if addresses have been edited
      // If addresses are edited/added: isPRSubmit = true, if not edited: isPRSubmit = false
      const isPRSubmit = !this.initialAddressesSnapshot || editedIndexes.length > 0;
      
      this.addressService.clearanceQuoteStep(formData,preferredReports,preferredReportResponse,this.selectedPolicyType(), trimmedNamedInsured,this.QuestionsQuote(),cleanedPremium, isPRSubmit, this.clearanceQuoteStep).subscribe({
        next: (response) => {
          this.setQuoteConfigData(response);
          this.mapClearanceData(response.quote, response.questions);
          this.triggerEQBDReferralCheckAfterClearance(response, 'Quote', isSaveAndExit);

          const payload = this.buildIsEditAddressPayload(this.pendingClearanceAddressIds);
          if (payload) {
            this.propertyService.updateIsEditAddress(payload).subscribe({
              next: () => {
                payload.addresses.forEach((addr: any) => {
                  this.isEditedAddressFlags.set(addr.addressId, addr.isEdited);
                  if (typeof addr.isClearanceAddressEdited !== 'undefined') {
                    this.clearanceEditedAddressFlags.set(addr.addressId, Number(addr.isClearanceAddressEdited));
                  }
                });
              },
              error: (updateError) => {
                console.error('Failed to update isEdited address flags:', updateError);
              }
            });
          }

          if (isSaveAndExit) {
            const indicationDraft = isPRSubmit ? 1 : 0; // 1 if address edited/added, 0 otherwise
            this.propertyService.UpdateIndicationDraftQuote(indicationDraft).subscribe({
              next: (draftResponse) => {
                this.router.navigate(['/quote']); // redirect user to landing page
                this.indicationQuoteService.removeIndicationQuoteStorageData();
              },
              error: (draftError) => {
              }
            });
            return;
          }
          const indicationDraft = isPRSubmit ? 1 : 0; // 1 if address edited/added, 0 otherwise
            this.propertyService.UpdateIndicationDraftQuote(indicationDraft).subscribe({
              next: (draftResponse) => {
              
              },
              error: (draftError) => {
              }
            });
          
          // Then patch Preferred Reports building details for edited addresses
        this.isLoading.set(false);

        this.handlePostClearanceBinding(
          response.preferredReportResponse,
          editedIndexes,
          () => this.propertyService.getGetPRApiResponseQuote()
        );

          // this.PreferredReportsSave.set(false)
          this.propertyService.setVersionNo(response.quote?.versionNo);
          const quoteId = response.quoteId;
          
          sessionStorage.setItem('quoteId', String(quoteId));
          this.quoteId.set(response.quoteId);
          const quoteAddressId = response.quoteAddressId;
          
          const currentFormValue = this.addressForm.getRawValue();          
          
          sessionStorage.setItem('quoteAddressId', JSON.stringify(quoteAddressId));
          if (response.quoteNo) {
            sessionStorage.setItem('quoteNumber', String(response.quoteNo));
            this.quoteNumber.set(response.quoteNo);
          }
          const quoteDetails = {
            QuoteNo: response.quoteNo,
            namedInsured: response.nameInsured,
            tiv: response.tiv,
            status: response.status
          };
          sessionStorage.setItem('quoteDetails', JSON.stringify(quoteDetails))

       this.setQuoteConfigData(response);

        const nameInsured = sessionStorage.getItem('nameInsured');
        const IndicationNo = sessionStorage.getItem('indicationNo');
        const storedIndicationStatus = sessionStorage.getItem('indicationStatus');
        const getTivData = this.propertyService.getTIV();

        const indicationStatus = storedIndicationStatus ? +storedIndicationStatus : null;
        this.indicationStatus.set(indicationStatus);

        this.populatedNamedInsured = response?.quote.nameInsured || ''; // risk summary namedInsured
        this.premium = this.formatCurrencyValue(response?.quote.targetPremium); 
       
        this.populatedTiv = getTivData ? getTivData : ''; // risk summary tiv
        this.populatedQuoteId = this.quoteNoWithVersion(response?.quote?.quoteNo, response?.quote?.versionNo) || '';
        this.onRiskSummaryStatusBindHandler(response?.quote, "quote"); // setting the risk summary status
        if(this.copeInfoSave() || sessionStorage.getItem('copeInfosave') ==='true'){
          // this.requestQuoteService.onUpdateCopeStepData(true);
          // this.fetchCopeStepDataHandler()
          }else{
            this.clearanceInfoSave.set(true);
            sessionStorage.setItem('clearanceInfoSave',JSON.stringify(true))            
          }
        this.onGetSystemUserMessage();
        afterSave?.();
          // update/setting the Indication details
          // this.step.set(1);
          // if(this.visitedStep() < 1) {
          //   this.visitedStep.update(i => i + 1);
          // }
       },
        error: (error) => {
          this.isLoading.set(false);

          this.toastService.addNotification({message: "System error. Clearance failed. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
        }
      });
    }else{
        this.isLoading.set(false);

      if(isSaveAndExit){
        this.router.navigate(['/quote']); // redirect user to landing page
        this.indicationQuoteService.removeIndicationQuoteStorageData();
        return;
      }
       // update the requestQuote Service
       this.requestQuoteService.resetClearanceStepData(); // reset clearance step
      //  this.requestQuoteService.onUpdateCopeStepData(true); // update cope Step to receive data 
       if(this.copeInfoSave() || sessionStorage.getItem('clearanceInfoSave') === 'true'){
        // this.requestQuoteService.onUpdateCopeStepData(true);
        // this.fetchCopeStepDataHandler()
        }
         const storedDraftStatus = sessionStorage.getItem('quoteDraftStatus');
        if (storedDraftStatus) {
          const draftStatus = JSON.parse(storedDraftStatus);
          if (draftStatus.quoteDraft === 1) {
            // Draft status is 1, call getGetPRApiResponseIndication and patch building data
            this.propertyService.getGetPRApiResponseQuote().subscribe({
              next: (prResponse: any) => {
                  if (prResponse) {                 
                    const addressesFormArray = this.addressControls();
                    
                    // Store the prResponse for use in mapCopeData
                    this.tempPrResponse = prResponse;
                    
                    // Always call getCopeData - the logic will be handled inside mapCopeData
                    this.getCopeData();
                  
                }
              },
              error: (prError) => {
                       this.getCopeData(true); 
              }
            });
          }else{
            this.requestQuoteService.onUpdateCopeStepData(true);
             this.fetchCopeStepDataHandler();
          }
        }
      
    }
    
  }




  isClearanceCheckEditing(): boolean {
    // Get current form values
    const currentFormValue = this.extractRelevantFieldsclearance({
      ...this.addressForm.getRawValue(),
      namedInsured: this.namedInsured() // Include namedInsured
  });
  const initialFormValue = this.extractRelevantFieldsclearance({
      ...this.initialFormValue,
      namedInsured: this.initialNamedInsured // Store initial namedInsured value
  });

    // Compare current form value with initial form value
    const isEdited = JSON.stringify(currentFormValue) !== JSON.stringify(initialFormValue);
    return isEdited; 
  }

  extractRelevantFieldsclearance(formValue: any): any {
    return {
      namedInsured: formValue.namedInsured?.trim() || '',
      addresses: formValue.addresses.map((address: any) => ({
        unitNum:address.unitNum?.trim() || '',
        streetNum:address.streetNum?.trim() || '',
        street: address.street?.trim() || '',
        city: address.city || '',
        state: address.state || '',
        country: address.country || '',
        zipcode: address.zipcode || '',
      })),
    };
  }

  isFormEdited(): boolean {
    // Get current form values
    const currentFormValue = this.extractRelevantFields(this.addressForm.getRawValue());
    const initialFormValue = this.extractRelevantFields(this.initialFormValue);    
  
    // Compare current form value with initial form value
    const isEdited = JSON.stringify(currentFormValue) !== JSON.stringify(initialFormValue);
    
    return isEdited;  }

  extractRelevantFields(formValue: any): any {
      return {
        addresses: formValue.addresses.map((address: any) => ({
          unitNum:address.unitNum || '',
          streetNum:address.streetNum || '',
          street: address.street || '',
          city: address.city || '',
          state: address.state || '',
          country: address.country || '',
          zipcode: address.zipcode || '',
        })),
      };
    }

    updateInitialFormValue(): void {
      const currentFormValue = this.addressForm.getRawValue();
      this.initialFormValue = this.extractRelevantFields(currentFormValue);
    }
  

 
  policySaveClearanceData(formData: any){
    if(!this.isReadOnly()){ // call clearanceStep save API when isReadonly is false
      const cleanedPremium = this.cleanCurrencyValue(this.premium);
      const trimmedNamedInsured = this.namedInsured()?.trim() || ''; 
      this.addressService.policySaveCleranceData(formData,this.selectedPolicyType(), trimmedNamedInsured,this.QuestionsPolicyClearance(), Number(cleanedPremium)).subscribe({
        next: (response) => {
          const currentFormValue = this.addressForm.getRawValue();

          this.addressControls().controls.forEach((control, index) => {
            if (control instanceof FormGroup) {
              control.get('hasBeenEditedSinceSave')?.setValue(false); // Reset the flag on save
            }
          });

          // Update isEdited address flags via POST API
          const payload = this.buildIsEditAddressPayload();
          if (payload) {
            this.propertyService.updateIsEditAddress(payload).subscribe({
              next: () => {
                payload.addresses.forEach((addr: any) => {
                  this.isEditedAddressFlags.set(addr.addressId, addr.isEdited);
                });
              },
              error: (updateError) => {
                console.error('Failed to update isEdited address flags:', updateError);
              }
            });
          }

          // this.initialFormValue = JSON.parse(JSON.stringify(currentFormValue));
          this.setPolicyDetailsConfigData(response);
          //const storedIndicationStatus = sessionStorage.getItem('indicationStatus');
          const getTivData = this.propertyService.getTIV();

          // const indicationStatus = storedIndicationStatus ? +storedIndicationStatus : null;
          // this.indicationStatus.set(indicationStatus);
          
          this.populatedNamedInsured = response?.policy.nameInsured || ''; // risk summary namedInsured
          this.populatedTiv = getTivData ? getTivData : ''; // risk summary tiv
          this.populatedQuoteId =  response?.policy?.policyNo || ''; // risk summary indicationNo
          this.onRiskSummaryStatusBindHandler(response?.policy, "policy"); // setting the risk summary status
          if(this.copeInfoSave() || sessionStorage.getItem('copeInfosave') ==='true'){
            // this.requestQuoteService.onUpdateCopeStepData(true);
            // this.fetchCopeStepDataHandler()
          }else{
            this.clearanceInfoSave.set(true);
            sessionStorage.setItem('clearanceInfoSave',JSON.stringify(true))
          }
          this.onGetSystemUserMessage();
          this.step.set(1);
          if(this.visitedStep() < 1) {
            this.visitedStep.update(i => i + 1);
          }
       },
        error: (error) => {
          this.toastService.addNotification({message: "System error. Clearance failed. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
        }
      });
    }else{
      // update the requestQuote Service
      this.requestQuoteService.resetClearanceStepData(); // reset clearance step
     //  this.requestQuoteService.onUpdateCopeStepData(true); // update cope Step to receive data 
      if(this.copeInfoSave() || sessionStorage.getItem('clearanceInfoSave') === 'true'){
      //  this.requestQuoteService.onUpdateCopeStepData(true);
      //  this.fetchCopeStepDataHandler()
       }
      this.step.set(1);
      if(this.visitedStep() < 1) {
       this.visitedStep.update(i => i + 1);
      }
   }
  }

  checkIfFormChanged() {
    // Compare initial form value with current form value to check if any changes were made
    const currentFormValue = this.addressForm.getRawValue();
  
    const isEdited = JSON.stringify(this.initialFormValue) !== JSON.stringify(currentFormValue);
  
    if (isEdited) {
      // Handle the changes if needed (e.g., set copeInfoSave to false)
      this.copeInfoSave.set(false);
      sessionStorage.setItem('copeInfosave', JSON.stringify(false));
    } else {
    }
  }

    CopeSaveForAccordianClose(isSaveAndExit: boolean = false, afterSave?: () => void) {
    // Skip close-save if this close was triggered by clicking Next (copeSave)
    if (this.suppressCopeCloseSave) {
      // Reset the guard after skipping once
      this.suppressCopeCloseSave = false;
      return;
    }
    if (this.isCopePreviousNavigationInProgress && !afterSave) {
      return;
    }

     const cleanedPremium = this.cleanCurrencyValue(this.premium);
    if(!this.isReadOnly()){
      if (!cleanedPremium || isNaN(cleanedPremium) || cleanedPremium <= 0) {
        this.showPremiumError = true;
        this.toastService.addNotification({ 
          message: "Target Premium Amount is required", 
          type: ToastType.Error 
        });
        if (afterSave) {
          this.isCopePreviousNavigationInProgress = false;
          this.suppressMainAccordionSaveStepUntil = 0;
        }
        return;
      } else {
        this.showPremiumError = false;
      }

      // Validate Year Built dependencies across all buildings before proceeding
      const addressesForValidation = this.addressForm.get('addresses') as FormArray;
      for (let a = 0; a < addressesForValidation.length; a++) {
        const addressControl = addressesForValidation.at(a) as FormGroup;
        const buildingDetailsFA = addressControl.get('buildingDetails') as FormArray;
        if (buildingDetailsFA && Array.isArray(buildingDetailsFA.controls)) {
          for (const b of buildingDetailsFA.controls) {
            const buildingGroup = b as FormGroup;
            const msg = this.getBuildingYearsValidationMessage(buildingGroup);
            if (msg) {
              this.toastService.addNotification({ message: msg, type: ToastType.Error });
              this.openCopeAddressAccordion(a);
              this.cdRef.detectChanges();
              if (afterSave) {
                this.isCopePreviousNavigationInProgress = false;
                this.suppressMainAccordionSaveStepUntil = 0;
              }
              return;
            }
          }
        }
      }

        if(this.isEditing['story'] || this.isEditing['sqFt'] || this.isEditing['RCV'] || this.isEditing['DistanceToCoast']){
          const editingLocation = this.findEditingFieldLocation();
          if (editingLocation) {
            this.openCopeAddressAccordion(
              editingLocation.addressIdx,
              editingLocation.buildingIdx,
              editingLocation.fieldName
            );
          }
          this.toastService.addNotification({message: "Please confirm/decline the editable field changes before proceeding", type: ToastType.Error})
          if (afterSave) {
            this.isCopePreviousNavigationInProgress = false;
            this.suppressMainAccordionSaveStepUntil = 0;
          }
          return;
        } 

        if(this.validateCopeFields()){
          if (afterSave) {
            this.isCopePreviousNavigationInProgress = false;
            this.suppressMainAccordionSaveStepUntil = 0;
          }
          return;
        }     
      }
    
    const addresses = this.addressForm.get('addresses') as FormArray;       

    addresses.controls.forEach((addressControl, index) => {
      const buildingDetails = addressControl.get('buildingDetails') as FormArray;
    });

    const buildingDetailsArray = addresses.controls.map((addressControl) =>
      addressControl.get('buildingDetails')?.value
    );

    const updatedAddresses = addresses.controls.map((addressControl, index) => {
     const addressId = Number(addressControl.get('addressid')?.value) || 0;
      const buildingDetails = addressControl.get('buildingDetails')?.value;
    
      const building = sessionStorage.getItem('buildingid')
      const storedbuildingId = building ? JSON.parse(building) : []
        const isConfirmed = addressControl.get('isConfirmed')?.value ? 1 : 0;

      // const buildingId = JSON.parse(sessionStorage.getItem('buildingid')||'')
      
      return {
        addressid: addressId,
         isConfirmed: isConfirmed,
        buildings: buildingDetails?.map((buildingDetail: { buildingid: any }, index: number) => ({
          buildingid: buildingDetail?.buildingid ? buildingDetail?.buildingid : 0,
            
          factors: this.mapFormDataToFactors(buildingDetail),
        })) || [],
      };
    });   

    const factors = buildingDetailsArray.flatMap(buildingDetails => {
      const details = Array.isArray(buildingDetails) ? buildingDetails[0] : buildingDetails;
      
      return this.mapFormDataToFactors(details);
    });

    
    const requestPayload = {
      factors: factors,
      addresses:updatedAddresses
      
    };    
  
    this.isIndicationType() ? this.copeIndicationSaveAccordianClose(requestPayload, afterSave) :
    this.copeQuoteSaveAccordianClose(requestPayload, afterSave);
  }

  copeIndicationSaveAccordianClose(requestPayload: any, afterSave?: () => void){
    if(!this.isReadOnly()){
      this.copeLoaderSignal.set(true)
      const cleanedPremium = this.cleanCurrencyValue(this.premium);

    this.addressService.copeStepIndication(requestPayload, cleanedPremium).subscribe({
      next: (response:any) => {
        sessionStorage.removeItem('indicationDraftStatus')
        sessionStorage.removeItem('quoteDraftStatus')
        // this.mapCopeData(response)       
        // Reset all isEdited flags to 0 via POST API
        const resetPayload = this.buildResetIsEditAddressPayload();
        if (resetPayload) {
          this.propertyService.updateIsEditAddress(resetPayload).subscribe({
            next: (updateResponse) => {
              // Update local flags map - set all to 0
              resetPayload.addresses.forEach((addr: any) => {
                this.isEditedAddressFlags.set(addr.addressId, 0);
              });
            },
            error: (updateError) => {
              console.error('Failed to reset isEdited address flags:', updateError);
            }
          });
        }
        this.propertyService.UpdateIndicationDraftIndication(0).subscribe({
              next: (draftResponse) => {
                
              },
              error: (draftError) => {
              }
            });
        this.copeLoaderSignal.set(false)        
        const dtcRule = response.dtcRule
        // if (dtcRule === "Decline"){
          this.OnStateRules(dtcRule);
           
        // }        
        this.setCopeConfigData(response);
        // this.copeInfoSave.set(true)        
        this.requestQuoteService.resetCopeStepData(); // reset clearance step
      
        if(!this.isPolicyType()){
          if((this.PolicyInfoSave() || sessionStorage.getItem('PolicyInfoSave') === 'true')){
          this.requestQuoteService.onUpdatePolicyParameterStepData(true);
          this.fetchPolicyParameterStepDataHandler()
          }
        }
      
        this.onGetSystemUserMessage();
        afterSave?.();
      },
        error: (error) => {
          this.copeLoaderSignal.set(false)
          if (afterSave) {
            this.isCopePreviousNavigationInProgress = false;
            this.suppressMainAccordionSaveStepUntil = 0;
          }
          this.toastService.addNotification({message: "System error. Cope Information failed. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
        }
    });
  }else{
   
    // update the requestQuote Service
    this.requestQuoteService.resetCopeStepData(); // reset clearance step
    // this.requestQuoteService.onUpdatePolicyParameterStepData(true); // update cope Step to receive data 
    if(this.PolicyInfoSave() || sessionStorage.getItem('PolicyInfoSave')=== 'true'){
      // this.requestQuoteService.onUpdateClearanceStepData(true);
      // this.fetchClearanceStepDataHandler()
      }
    // this.fetchPolicyParameterStepDataHandler()
    afterSave?.();
   
  }
  };

   copeQuoteSaveAccordianClose(requestPayload: any, afterSave?: () => void){
    if(!this.isReadOnly()){
      const cleanedPremium = this.cleanCurrencyValue(this.premium);

    this.addressService.copeStepQuote(requestPayload, cleanedPremium).subscribe({
      next: (response:any) => {
        sessionStorage.removeItem('indicationDraftStatus')
        sessionStorage.removeItem('quoteDraftStatus')
        // this.mapCopeData(response)
        const dtcRule = response.dtcRule
        this.OnStateRules(dtcRule);
        this.setCopeConfigData(response);
        // this.copeInfoSave.set(true)
        
        this.requestQuoteService.resetCopeStepData(); // reset clearance step
         // Reset all isEdited flags to 0 via POST API
        const resetPayload = this.buildResetIsEditAddressPayload();
        if (resetPayload) {
          this.propertyService.updateIsEditAddress(resetPayload).subscribe({
            next: (updateResponse) => {
              // Update local flags map - set all to 0
              resetPayload.addresses.forEach((addr: any) => {
                this.isEditedAddressFlags.set(addr.addressId, 0);
              });
            },
            error: (updateError) => {
              console.error('Failed to reset isEdited address flags:', updateError);
            }
          });
        }
         this.propertyService.UpdateIndicationDraftQuote(0).subscribe({
              next: (draftResponse) => {
            
              },
              error: (draftError) => {
              }
            });
        if(!this.isPolicyType()){
          if(this.PolicyInfoSave() || sessionStorage.getItem('PolicyInfoSave') === 'true'){
            this.requestQuoteService.onUpdatePolicyParameterStepData(true);
            this.fetchPolicyParameterStepDataHandler()
          }
        }
        this.onGetSystemUserMessage();
        afterSave?.();
          },
        error: (error) => {
          if (afterSave) {
            this.isCopePreviousNavigationInProgress = false;
            this.suppressMainAccordionSaveStepUntil = 0;
          }
          this.toastService.addNotification({message: "System error. Cope Information failed. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
        }
    });
    
  }else{
   
    // update the requestQuote Service
    this.requestQuoteService.resetCopeStepData(); // reset clearance step
    // this.requestQuoteService.onUpdatePolicyParameterStepData(true); // update cope Step to receive data 
    if(this.PolicyInfoSave() || sessionStorage.getItem('PolicyInfoSave')=== 'true'){
      // this.requestQuoteService.onUpdateClearanceStepData(true);
      // this.fetchClearanceStepDataHandler()
      }
    // this.fetchPolicyParameterStepDataHandler()
    afterSave?.();
   
  }

  }

  CopeSaveForPreviousClick(isSaveAndExit: boolean = false) {
    
    const addresses = this.addressForm.get('addresses') as FormArray;       

    addresses.controls.forEach((addressControl, index) => {
      const buildingDetails = addressControl.get('buildingDetails') as FormArray;
    });

    const buildingDetailsArray = addresses.controls.map((addressControl) =>
      addressControl.get('buildingDetails')?.value
    );

    const updatedAddresses = addresses.controls.map((addressControl, index) => {
     const addressId = Number(addressControl.get('addressid')?.value) || 0;
      const buildingDetails = addressControl.get('buildingDetails')?.value;
    
      const building = sessionStorage.getItem('buildingid')
      const storedbuildingId = building ? JSON.parse(building) : []
      
      // const buildingId = JSON.parse(sessionStorage.getItem('buildingid')||'')
      
      return {
        addressid: addressId,
        buildings: buildingDetails?.map((buildingDetail: { buildingid: any }, index: number) => ({
          buildingid: buildingDetail?.buildingid ? buildingDetail?.buildingid : 0,
            
          factors: this.mapFormDataToFactors(buildingDetail),
        })) || [],
      };
    });   

    const factors = buildingDetailsArray.flatMap(buildingDetails => {
      const details = Array.isArray(buildingDetails) ? buildingDetails[0] : buildingDetails;
      
      return this.mapFormDataToFactors(details);
    });

    
    const requestPayload = {
      factors: factors,
      addresses:updatedAddresses
      
    };    
  
    this.isIndicationType() ? this.copeIndicationSaveAccordianClose(requestPayload) :
    this.copeQuoteSaveAccordianClose(requestPayload);
  }

  

 
  
  copeIndicationSave(requestPayload: any, isSaveAndExit: boolean = false){
    if(!this.isReadOnly()){
      this.copeLoaderSignal.set(true)
      const cleanedPremium = this.cleanCurrencyValue(this.premium);

    this.addressService.copeStepIndication(requestPayload, cleanedPremium).subscribe({
      next: (response:any) => {
        sessionStorage.removeItem('indicationDraftStatus')
        sessionStorage.removeItem('quoteDraftStatus')
        this.mapCopeData(response)
        
        // Reset all isEdited flags to 0 via POST API
        const resetPayload = this.buildResetIsEditAddressPayload();
        if (resetPayload) {
          this.propertyService.updateIsEditAddress(resetPayload).subscribe({
            next: (updateResponse) => {
              // Update local flags map - set all to 0
              resetPayload.addresses.forEach((addr: any) => {
                this.isEditedAddressFlags.set(addr.addressId, 0);
              });
            },
            error: (updateError) => {
              console.error('Failed to reset isEdited address flags:', updateError);
            }
          });
        }
        
        this.propertyService.UpdateIndicationDraftIndication(0).subscribe({
              next: (draftResponse) => {
              
              },
              error: (draftError) => {
              }
            });
        if(isSaveAndExit){
          this.router.navigate(['/quote']); // redirect user to landing page
          this.indicationQuoteService.removeIndicationQuoteStorageData();
          return;
        }
        
        this.copeLoaderSignal.set(false)        
        const dtcRule = response.dtcRule
        // if (dtcRule === "Decline"){
          this.OnStateRules(dtcRule);

        // }        
        this.step.set(2); // if response success then move to the next step
        this.setCopeConfigData(response);
        this.copeInfoSave.set(true)        
        this.requestQuoteService.resetCopeStepData(); // reset clearance step
      
        this.addressControls().controls.forEach((control, index) => {
          if (control instanceof FormGroup) {
            control.get('isEdited')?.setValue(false);
          }
        });
         if(!this.isPolicyType()){
            if(this.PolicyInfoSave() || sessionStorage.getItem('PolicyInfoSave') === 'true'){
            this.requestQuoteService.onUpdatePolicyParameterStepData(true);
            this.fetchPolicyParameterStepDataHandler()
            }else{
            this.copeInfoSave.set(true)
            sessionStorage.setItem('copeInfosave',JSON.stringify(true))
            }
          }
      
        this.onGetSystemUserMessage();
        if(this.visitedStep() < 2) {
          this.visitedStep.update(i => i + 1);
        }
      },
        error: (error) => {
          this.copeLoaderSignal.set(false)
          this.toastService.addNotification({message: "System error. Cope Information failed. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
        }
    });
  }else{
    if(isSaveAndExit){
      this.router.navigate(['/quote']); // redirect user to landing page
      this.indicationQuoteService.removeIndicationQuoteStorageData();
      return;
    }
    // update the requestQuote Service
    this.requestQuoteService.resetCopeStepData(); // reset clearance step
    // this.requestQuoteService.onUpdatePolicyParameterStepData(true); // update cope Step to receive data 
     if(!this.isPolicyType()){
      if(this.PolicyInfoSave() || sessionStorage.getItem('PolicyInfoSave')=== 'true'){
        this.requestQuoteService.onUpdatePolicyParameterStepData(true);
        this.fetchPolicyParameterStepDataHandler()
        }
      }
    // this.fetchPolicyParameterStepDataHandler()
    this.step.set(2); // move to the next step
    if(this.visitedStep() < 2) {
      this.visitedStep.update(i => i + 1);
    }
  }
  };
  copeQuoteSave(requestPayload: any, isSaveAndExit: boolean = false){
    if(!this.isReadOnly()){
      const cleanedPremium = this.cleanCurrencyValue(this.premium);

    this.addressService.copeStepQuote(requestPayload, cleanedPremium).subscribe({
      next: (response:any) => {
        sessionStorage.removeItem('indicationDraftStatus')
        sessionStorage.removeItem('quoteDraftStatus')
        this.mapCopeData(response)
        
        // Reset all isEdited flags to 0 via POST API
        const resetPayload = this.buildResetIsEditAddressPayload();
        if (resetPayload) {
          this.propertyService.updateIsEditAddress(resetPayload).subscribe({
            next: (updateResponse) => {
              // Update local flags map - set all to 0
              resetPayload.addresses.forEach((addr: any) => {
                this.isEditedAddressFlags.set(addr.addressId, 0);
              });
            },
            error: (updateError) => {
              console.error('Failed to reset isEdited address flags:', updateError);
            }
          });
        }
        
        this.propertyService.UpdateIndicationDraftQuote(0).subscribe({
              next: (draftResponse) => {
                
              },
              error: (draftError) => {
              }
            });
        if(isSaveAndExit){
          this.router.navigate(['/quote']); // redirect user to landing page
          this.indicationQuoteService.removeIndicationQuoteStorageData();
          return;
        }
          
        this.step.set(2);
        const dtcRule = response.dtcRule
        // if (dtcRule === "Decline"){
          this.OnStateRules(dtcRule);

        // }  
        this.setCopeConfigData(response);
        this.copeInfoSave.set(true)
        this.requestQuoteService.resetCopeStepData(); // reset clearance step
        this.addressControls().controls.forEach((control, index) => {
          if (control instanceof FormGroup) {
            control.get('hasBeenEditedSinceSave')?.setValue(false); // Reset the flag on save
          }
        });
        // this.addressControls().controls.forEach((control, index) => {
        //   if (control instanceof FormGroup) {
        //     control.get('isEdited')?.setValue(false);
        //     control.get('isSaved')?.setValue(true); // Set isSaved to true
        //     control.get('isFetchBuildingDetailsCalled')?.setValue(false);
        //   }
        // });
         if(!this.isPolicyType()){
        if(this.PolicyInfoSave() || sessionStorage.getItem('PolicyInfoSave') === 'true'){
        this.requestQuoteService.onUpdatePolicyParameterStepData(true);
        this.fetchPolicyParameterStepDataHandler()
        }else{
          this.copeInfoSave.set(true)
          sessionStorage.setItem('copeInfosave',JSON.stringify(true))
        }
      }
    this.onGetSystemUserMessage();
        if(this.visitedStep() < 2) {
          this.visitedStep.update(i => i + 1);
        }
      },
        error: (error) => {
          this.toastService.addNotification({message: "System error. Cope Information failed. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
        }
    });
    
  }else{
    if(isSaveAndExit){
      this.router.navigate(['/quote']); // redirect user to landing page
      this.indicationQuoteService.removeIndicationQuoteStorageData();
      return;
    }
    // update the requestQuote Service
    this.requestQuoteService.resetCopeStepData(); // reset clearance step
    // this.requestQuoteService.onUpdatePolicyParameterStepData(true); // update cope Step to receive data 
     if(!this.isPolicyType()){
      if(this.PolicyInfoSave() || sessionStorage.getItem('PolicyInfoSave')=== 'true'){
        this.requestQuoteService.onUpdatePolicyParameterStepData(true);
        this.fetchPolicyParameterStepDataHandler()
        }
     }
    // this.fetchPolicyParameterStepDataHandler()
    this.step.set(2); // move to the next step
    if(this.visitedStep() < 2) {
      this.visitedStep.update(i => i + 1);
    }
  }

  }

  policySaveCopeData(requestPayload: any) {
    if(!this.isReadOnly()){
      const cleanedPremium = this.cleanCurrencyValue(this.premium);
      this.addressService.policySaveCopeData(requestPayload, cleanedPremium).subscribe({
        next: (response:any) => {
          this.mapCopeData(response)
          
          // Reset all isEdited flags to 0 via POST API
          const resetPayload = this.buildResetIsEditAddressPayload();
          if (resetPayload) {
            this.propertyService.updateIsEditAddress(resetPayload).subscribe({
              next: (updateResponse) => {
                // Update local flags map - set all to 0
                resetPayload.addresses.forEach((addr: any) => {
                  this.isEditedAddressFlags.set(addr.addressId, 0);
                });
              },
              error: (updateError) => {
                console.error('Failed to reset isEdited address flags:', updateError);
              }
            });
          }
          
          this.step.set(2);
          this.setCopeConfigData(response);
          const dtcRule = response.dtcRule
          this.OnStateRules(dtcRule);

          this.copeInfoSave.set(true)
          this.requestQuoteService.resetCopeStepData(); // reset clearance step
          
           if(!this.isPolicyType()){
            if(this.PolicyInfoSave() || sessionStorage.getItem('PolicyInfoSave') === 'true'){
              this.requestQuoteService.onUpdatePolicyParameterStepData(true);
              this.fetchPolicyParameterStepDataHandler()
            }else{
              this.copeInfoSave.set(true)
              sessionStorage.setItem('copeInfosave',JSON.stringify(true))
            }
          }
          this.onGetSystemUserMessage();
          if(this.visitedStep() < 2) {
            this.visitedStep.update(i => i + 1);
          }
        },
          error: (error) => {
            this.toastService.addNotification({message: "System error. Cope Information failed. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
          }
      });
    }else{
      // update the requestQuote Service
      this.requestQuoteService.resetCopeStepData(); // reset clearance step
      // this.requestQuoteService.onUpdatePolicyParameterStepData(true); // update cope Step to receive data 
      if(this.PolicyInfoSave() || sessionStorage.getItem('PolicyInfoSave')=== 'true'){
        // this.requestQuoteService.onUpdatePolicyParameterStepData(true);
        // this.fetchPolicyParameterStepDataHandler()
      }
      // this.fetchPolicyParameterStepDataHandler()
      this.step.set(2); // move to the next step
      if(this.visitedStep() < 2) {
        this.visitedStep.update(i => i + 1);
      }
    }
  }

  CopeSaveForPolicy() {
    const addresses = this.addressForm.get('addresses') as FormArray;

    const cleanedPremium = this.cleanCurrencyValue(this.premium);
    if(!this.isReadOnly()){
      if (!cleanedPremium || isNaN(cleanedPremium) || cleanedPremium <= 0) {
        this.showPremiumError = true;
        this.toastService.addNotification({ 
          message: "Target Premium Amount is required", 
          type: ToastType.Error 
        });
        return;
      } else {
        this.showPremiumError = false;
      }

      // Validate Year Built dependencies across all buildings before proceeding
      const addressesForValidation = this.addressForm.get('addresses') as FormArray;
      for (let a = 0; a < addressesForValidation.length; a++) {
        const addressControl = addressesForValidation.at(a) as FormGroup;
        const buildingDetailsFA = addressControl.get('buildingDetails') as FormArray;
        if (buildingDetailsFA && Array.isArray(buildingDetailsFA.controls)) {
          for (const b of buildingDetailsFA.controls) {
            const buildingGroup = b as FormGroup;
            const msg = this.getBuildingYearsValidationMessage(buildingGroup);
            if (msg) {
              this.toastService.addNotification({ message: msg, type: ToastType.Error });
              this.openCopeAddressAccordion(a);
              this.cdRef.detectChanges();
              return;
            }
          }
        }
      }

    if(this.isEditing['story'] || this.isEditing['sqFt'] || this.isEditing['RCV'] || this.isEditing['DistanceToCoast']){
      const editingLocation = this.findEditingFieldLocation();
      if (editingLocation) {
        this.openCopeAddressAccordion(
          editingLocation.addressIdx,
          editingLocation.buildingIdx,
          editingLocation.fieldName
        );
      }
      this.toastService.addNotification({message: "Please confirm/decline the editable field changes before proceeding", type: ToastType.Error})
      return;
    }

    if (this.validateCopeFields()) {
      return;
    }
  }
    addresses.controls.forEach((addressControl, index) => {
      const buildingDetails = addressControl.get('buildingDetails') as FormArray;
    });

    const buildingDetailsArray = addresses.controls.map((addressControl) =>
      addressControl.get('buildingDetails')?.value
    );

    this.addressControls().controls.forEach((control, index) => {
      if (control instanceof FormGroup) {
        control.get('hasBeenEditedSinceSave')?.setValue(false); // Reset the flag on save
      }
    });

    const updatedAddresses = addresses.controls.map((addressControl, index) => {
      const addressId = Number(addressControl.get('addressid')?.value) || 0;
      const buildingDetails = addressControl.get('buildingDetails')?.value;
      const building = sessionStorage.getItem('buildingid')
    const storedbuildingId = building ? JSON.parse(building) : []

      return {
        addressid: addressId,
        buildings: buildingDetails?.map((buildingDetail: { buildingid: any; },index:number) => ({
          buildingid:  buildingDetail?.buildingid ? buildingDetail?.buildingid : 0,
          // Array.isArray(storedbuildingId) && index < storedbuildingId.length
          //   ? storedbuildingId[index] // Use building ID if available
          //   : 0, // Default to 0 for missing IDs
          factors: this.mapFormDataToFactors(buildingDetail)
          })) || [] 
      };
    });

    const factors = buildingDetailsArray.flatMap(buildingDetails => {
      const details = Array.isArray(buildingDetails) ? buildingDetails[0] : buildingDetails;
      return this.mapFormDataToFactors(details);
    });

    const requestPayload = {
      factors: factors,
      addresses:updatedAddresses
    };    
    
    this.policySaveCopeData(requestPayload);
  }

 
validateCopeFields(): boolean {
  // Returns TRUE when there are validation errors (existing call sites expect: `if (validateCopeFields()) return;`)
  let firstInvalidFieldsAddressIdx: number | null = null;
  let firstInvalidFieldsBuildingIdx: number | null = null;
  let firstInvalidFieldName: string | null = null;
  let firstInvalidAlarmAddressIdx: number | null = null;
  let firstInvalidAlarmBuildingIdx: number | null = null;
  let firstInvalidAlarmFieldName: string | null = null;
  let firstUncheckedConfirmAddressIdx: number | null = null;

  const isAnswered = (v: any) => v === 0 || v === 2;

  const addresses = this.addressControls();
  for (let a = 0; a < addresses.length; a++) {
    const addressControl = addresses.at(a) as FormGroup;

    // Confirmation checkbox per address
    const isConfirmed = addressControl.get('isConfirmed')?.value === true;
    addressControl.get('isConfirmed')?.markAsTouched();
    if (!isConfirmed && firstUncheckedConfirmAddressIdx === null) {
      firstUncheckedConfirmAddressIdx = a;
    }

    const buildings = addressControl.get('buildingDetails') as FormArray;
    if (!buildings) continue;

    // Temporarily enable building details to validate even if they're disabled (e.g., when accordion is collapsed)
    const wasDisabled = buildings.disabled;
    if (wasDisabled) {
      buildings.enable({ emitEvent: false });
    }

    for (let b = 0; b < buildings.length; b++) {
      const group = this.getFormGroup(buildings.at(b));
      
      // Temporarily enable all controls in this building group for validation
      const controlStates: { [key: string]: boolean } = {};
      Object.keys(group.controls).forEach((key) => {
        const ctrl = group.get(key);
        if (ctrl) {
          controlStates[key] = ctrl.disabled;
          if (ctrl.disabled) {
            ctrl.enable({ emitEvent: false });
          }
          ctrl.markAsTouched();
        }
      });
      
      group.updateValueAndValidity({ emitEvent: false });

      // Form field validity - find the first invalid field
      // IMPORTANT: Only set if we haven't found an invalid field yet (firstInvalidFieldsAddressIdx === null)
      // This ensures we get the FIRST building with an error, not subsequent ones
      if (group.invalid && firstInvalidFieldsAddressIdx === null) {
        firstInvalidFieldsAddressIdx = a;
        firstInvalidFieldsBuildingIdx = b;
        
        // Find the first invalid control name within this building
        for (const key of Object.keys(group.controls)) {
          const ctrl = group.get(key);
          if (ctrl && ctrl.invalid) {
            firstInvalidFieldName = key;
            break; // Stop at first invalid field in this building
          }
        }
      }

      // Alarm/protection questions (explicitly validate regardless of reactive validators)
      const fire = group.get('FireAlarm')?.value;
      const sprk = group.get('sprinklers')?.value;
      const burg = group.get('Burglar')?.value;
      if ((!isAnswered(fire) || !isAnswered(sprk) || !isAnswered(burg)) && firstInvalidAlarmAddressIdx === null) {
        firstInvalidAlarmAddressIdx = a;
        firstInvalidAlarmBuildingIdx = b;
        // Find the first unanswered alarm field
        if (!isAnswered(burg)) {
          firstInvalidAlarmFieldName = 'Burglar';
        } else if (!isAnswered(fire)) {
          firstInvalidAlarmFieldName = 'FireAlarm';
        } else if (!isAnswered(sprk)) {
          firstInvalidAlarmFieldName = 'sprinklers';
        }
      }

      // Restore control disabled states
      Object.keys(controlStates).forEach((key) => {
        const ctrl = group.get(key);
        if (ctrl && controlStates[key]) {
          ctrl.disable({ emitEvent: false });
        }
      });
    }

    // Restore building details disabled state if it was disabled
    if (wasDisabled) {
      buildings.disable({ emitEvent: false });
    }
  }

  const hasErrors =
    firstInvalidFieldsAddressIdx !== null ||
    firstInvalidAlarmAddressIdx !== null ||
    firstUncheckedConfirmAddressIdx !== null;

  if (!hasErrors) return false;

  // Priority: fields > alarms > checkbox
  if (firstInvalidFieldsAddressIdx !== null) {
    this.openCopeAddressAccordion(
      firstInvalidFieldsAddressIdx,
      firstInvalidFieldsBuildingIdx ?? undefined,
      firstInvalidFieldName ?? undefined
    );
  } else if (firstInvalidAlarmAddressIdx !== null) {
    this.openCopeAddressAccordion(
      firstInvalidAlarmAddressIdx,
      firstInvalidAlarmBuildingIdx ?? undefined,
      firstInvalidAlarmFieldName ?? 'Burglar' // Use the specific alarm field name
    );
  } else if (firstUncheckedConfirmAddressIdx !== null) {
    this.openCopeAddressAccordion(firstUncheckedConfirmAddressIdx, undefined, 'isConfirmed');
  }

  if (firstInvalidFieldsAddressIdx === null && firstInvalidAlarmAddressIdx !== null) {
    this.toastService.addNotification({
      message: "Please respond for all protection options",
      type: ToastType.Error
    });
  } else if (
    firstInvalidFieldsAddressIdx === null &&
    firstInvalidAlarmAddressIdx === null &&
    firstUncheckedConfirmAddressIdx !== null
  ) {
    this.toastService.addNotification({
      message: "Please check the declaration box to proceed.",
      type: ToastType.Error
    });
  }

  return true;
}

private findEditingFieldLocation(): { addressIdx: number; buildingIdx: number; fieldName: string } | null {
  // Find which address and building has editable fields in edit mode
  // Search through the isEditingMap to find the first building with editing active
  
  // Search for all editable fields: story, sqFt, RCV, DistanceToCoast
  // Priority order: story, sqFt, RCV, DistanceToCoast
  const fieldsToSearch: (keyof EditingState)[] = ['story', 'sqFt', 'RCV', 'DistanceToCoast'];
  
  for (const fieldToFind of fieldsToSearch) {
    // Search through all keys in the map (convert to array for compatibility)
    const mapEntries = Array.from(this.isEditingMap.entries());
    for (const [key, isEditing] of mapEntries) {
      if (isEditing && key.endsWith(`-${fieldToFind}`)) {
        // Parse the key: format is `${addressIdx}-${buildingIdx}-${field}`
        const parts = key.split('-');
        if (parts.length >= 3) {
          const addressIdx = parseInt(parts[0]);
          const buildingIdx = parseInt(parts[1]);
          if (!isNaN(addressIdx) && !isNaN(buildingIdx)) {
            return { addressIdx, buildingIdx, fieldName: fieldToFind };
          }
        }
      }
    }
  }
  
  return null;
}

private ensureCopeAccordionStateSize(): void {
  const count = this.addressControls().length;
  if (this.copeAddressAccordionOpened.length !== count) {
    const next = new Array(count).fill(false);
    for (let i = 0; i < Math.min(count, this.copeAddressAccordionOpened.length); i++) {
      next[i] = !!this.copeAddressAccordionOpened[i];
    }
    this.copeAddressAccordionOpened = next;
  }
}

private openCopeAddressAccordion(index: number, buildingIdx?: number, fieldName?: string): void {
  this.ensureCopeAccordionStateSize();
  this.copeAddressAccordionOpened = this.copeAddressAccordionOpened.map((_, i) => i === index);
  this.cdRef.detectChanges();
  
  // Wait for Angular to update the DOM and accordion to expand
  // Note: buildingIdx can be undefined for checkbox (isConfirmed)
  if (fieldName) {
    // Wait for accordion expansion animation (Material accordions take ~300ms)
    setTimeout(() => {
      this.scrollToCopeField(index, buildingIdx, fieldName);
    }, 400); // Wait for accordion to fully expand before scrolling to field
  }
}

private scrollToCopeField(addressIdx: number, buildingIdx: number | undefined, fieldName: string): void {
  // Find the form control element within the specific address and building
  const addressPanel = this.copeAddressPanels?.toArray()?.[addressIdx]?.nativeElement;
  if (!addressPanel) {
    console.warn(`Address panel ${addressIdx} not found`);
    return;
  }

  // Find the scrollable container - it's the parent accordion-body with scroll-y class
  // The structure is: COPE accordion > accordion-body.h-550px.scroll-y > mat-accordion > address panels
  // The address panel is inside mat-accordion, which is inside accordion-body.h-550px.scroll-y
  let scrollContainer = addressPanel.closest('.accordion-body.h-550px.scroll-y') as HTMLElement;
  if (!scrollContainer) {
    // Try going up the DOM tree: addressPanel > mat-expansion-panel > mat-accordion > accordion-body
    const matAccordion = addressPanel.closest('mat-accordion');
    if (matAccordion) {
      scrollContainer = matAccordion.parentElement?.closest('.accordion-body.h-550px.scroll-y') as HTMLElement ||
                       matAccordion.parentElement?.closest('.accordion-body.scroll-y') as HTMLElement ||
                       matAccordion.parentElement?.closest('.accordion-body.h-550px') as HTMLElement;
    }
  }
  
  if (!scrollContainer) {
    // Fallback: find any scrollable accordion-body
    scrollContainer = addressPanel.closest('.accordion-body.scroll-y') as HTMLElement ||
                     addressPanel.closest('.accordion-body.h-550px') as HTMLElement;
  }
  
  if (!scrollContainer) {
    console.warn(`Scroll container not found for address ${addressIdx}. Attempting to find alternative.`);
  }
  
  let targetElement: HTMLElement | null = null;

  // Handle checkbox separately (it's at address level, not building level)
  if (fieldName === 'isConfirmed') {
    // The checkbox has id="deactivate-{{i}}" where i is the address index
    // Structure: <div class="row"> <div class="col-12 form-check-solid form-container"> <input id="deactivate-{{i}}">
    let checkbox = addressPanel.querySelector(`#deactivate-${addressIdx}`) as HTMLInputElement;
    
    // If not found by ID, try finding by label text
    if (!checkbox) {
      const labels = addressPanel.querySelectorAll('label.form-check-label');
      for (const label of Array.from(labels)) {
        const labelText = label.textContent?.trim() || '';
        if (labelText.includes('I confirm that the information above accurately represents the risk')) {
          const forAttr = label.getAttribute('for');
          if (forAttr) {
            checkbox = addressPanel.querySelector(`#${forAttr}`) as HTMLInputElement;
            if (checkbox) break;
          }
        }
      }
    }
    
    if (checkbox) {
      const checkboxEl = checkbox as HTMLElement;
      
      // First, try to find the .col-12.form-check-solid.form-container (most specific)
      let col12Container: HTMLElement | null = checkboxEl.closest('.col-12.form-check-solid.form-container') as HTMLElement | null;
      if (!col12Container) {
        // Try without all classes together
        const col12 = checkboxEl.closest('.col-12') as HTMLElement | null;
        if (col12 && col12.classList.contains('form-check-solid') && col12.classList.contains('form-container')) {
          col12Container = col12;
        }
      }
      
      if (col12Container) {
        targetElement = col12Container;
      } else {
        // Fallback to .form-check-solid
        const formCheckSolid = checkboxEl.closest('.form-check-solid') as HTMLElement | null;
        if (formCheckSolid) {
          targetElement = formCheckSolid;
        } else {
          // Fallback to .row (the parent row)
          const rowContainer = checkboxEl.closest('.row') as HTMLElement | null;
          if (rowContainer) {
            targetElement = rowContainer;
          } else {
            // Last resort: the checkbox itself
            targetElement = checkboxEl;
          }
        }
      }
    } else {
      console.warn(`Checkbox #deactivate-${addressIdx} not found in address panel ${addressIdx}`);
      // Try one more time - search the entire address panel for any checkbox with the label
      const allCheckboxes = addressPanel.querySelectorAll('input[type="checkbox"]');
      for (const cb of Array.from(allCheckboxes)) {
        const label = addressPanel.querySelector(`label[for="${cb.id}"]`);
        if (label) {
          const labelText = label.textContent?.trim() || '';
          if (labelText.includes('I confirm that the information above accurately represents the risk')) {
            const checkboxEl = cb as HTMLElement;
            const col12Container = checkboxEl.closest('.col-12') as HTMLElement | null;
            if (col12Container && col12Container.classList.contains('form-check-solid')) {
              targetElement = col12Container;
              break;
            }
          }
        }
      }
    }
  } else if (buildingIdx !== undefined && buildingIdx >= 0) {
    // Find building rows - they are div.row elements with [formGroup] attribute
    // Each building is in a <div class="row" *ngFor="let building of buildingControlsForAddress(i).controls; let j = index" [formGroup]="...">
    // The heading shows "Building 1", "Building 2", etc. where the number is j+1
    // So buildingIdx 0 = "Building 1", buildingIdx 1 = "Building 2", etc.
    const allRows = Array.from(addressPanel.querySelectorAll('.row')) as HTMLElement[];
    const buildingRows: HTMLElement[] = [];
    
    // Filter to only rows that contain building data (have formGroup and Building heading)
    for (const row of allRows) {
      // Check if this row has a Building heading (h5.text-gray-900 with "Building" text)
      const heading = row.querySelector('h5.text-gray-900');
      if (heading) {
        const headingText = heading.textContent?.trim() || '';
        // Match "Building 1", "Building 2", etc. - extract the number
        const buildingMatch = headingText.match(/^Building\s+(\d+)$/);
        if (buildingMatch) {
          // Also verify it has form controls (it's a building row, not just a heading row)
          const hasFormControls = row.querySelector('input[formcontrolname], select[formcontrolname]') !== null;
          if (hasFormControls) {
            buildingRows.push(row);
          }
        }
      }
    }

    // Sort building rows by their building number to ensure correct order
    buildingRows.sort((a, b) => {
      const headingA = a.querySelector('h5.text-gray-900')?.textContent?.trim() || '';
      const headingB = b.querySelector('h5.text-gray-900')?.textContent?.trim() || '';
      const numA = parseInt(headingA.match(/^Building\s+(\d+)$/)?.[1] || '0');
      const numB = parseInt(headingB.match(/^Building\s+(\d+)$/)?.[1] || '0');
      return numA - numB;
    });

    // Get the target building row by index (buildingIdx matches the j index in *ngFor)
    // buildingIdx 0 = Building 1 (heading shows "Building 1"), buildingIdx 1 = Building 2, etc.
    // So we need to find the building row where heading shows "Building {buildingIdx + 1}"
    let targetBuildingRow: HTMLElement | null = null;
    const buildingRowsCount = buildingRows.length;
    
    if (buildingIdx < buildingRowsCount) {
      // Double-check: verify the building row at this index has the correct building number
      const expectedBuildingNumber = buildingIdx + 1;
      const candidateRow = buildingRows[buildingIdx];
      const heading = candidateRow.querySelector('h5.text-gray-900')?.textContent?.trim() || '';
      const buildingMatch = heading.match(/^Building\s+(\d+)$/);
      const actualBuildingNumber = buildingMatch ? parseInt(buildingMatch[1]) : 0;
      
      if (actualBuildingNumber === expectedBuildingNumber) {
        targetBuildingRow = candidateRow;
      } else {
        // If the row at buildingIdx doesn't match, search for the correct one
        for (const row of buildingRows) {
          const rowHeading = row.querySelector('h5.text-gray-900')?.textContent?.trim() || '';
          const rowMatch = rowHeading.match(/^Building\s+(\d+)$/);
          const rowBuildingNumber = rowMatch ? parseInt(rowMatch[1]) : 0;
          if (rowBuildingNumber === expectedBuildingNumber) {
            targetBuildingRow = row;
            break;
          }
        }
      }
      
      if (targetBuildingRow) {
        if (fieldName === 'Burglar' || fieldName === 'FireAlarm' || fieldName === 'sprinklers') {
          // For alarm fields, find by label text within this building row
          const alarmLabels = targetBuildingRow.querySelectorAll('label.fs-6.fw-semibold.form-label');
          
          for (const label of Array.from(alarmLabels)) {
            const labelText = label.textContent?.trim() || '';
            let isMatch = false;
            
            if (fieldName === 'Burglar' && labelText.includes('Burglar Alarm')) {
              isMatch = true;
            } else if (fieldName === 'FireAlarm' && labelText.includes('Fire Alarm') && !labelText.includes('Sprinklers')) {
              isMatch = true;
            } else if (fieldName === 'sprinklers' && labelText.includes('Sprinklers')) {
              isMatch = true;
            }
            
            if (isMatch) {
              // Find the parent col-12 div that contains this label
              const parentCol = label.closest('.col-12.d-flex.flex-stack');
              if (parentCol) {
                targetElement = parentCol as HTMLElement;
                break;
              }
            }
          }
        } else {
          // For regular form fields, find by formControlName within THIS specific building row
          // Make sure we only find fields within targetBuildingRow, not in other buildings
          const fieldInput = targetBuildingRow.querySelector(`[formcontrolname="${fieldName}"]`);
          if (fieldInput) {
            // Verify the field is actually within this building row (not in a nested structure)
            const fieldParent = (fieldInput as HTMLElement).closest('.row');
            if (fieldParent === targetBuildingRow || targetBuildingRow.contains(fieldInput)) {
              targetElement = (fieldInput as HTMLElement).closest('.form-container') || 
                             (fieldInput as HTMLElement).closest('.col-4') || 
                             (fieldInput as HTMLElement).closest('.col-6') ||
                             fieldInput as HTMLElement;
            }
          }
        }
      } else {
        console.warn(`Target building row not found for building index ${buildingIdx}. Total building rows found: ${buildingRowsCount}`);
      }
    } else {
      console.warn(`Building index ${buildingIdx} out of range. Total building rows: ${buildingRowsCount}`);
    }
  }

  if (!targetElement) {
    const genericField = addressPanel.querySelector(`[formcontrolname="${fieldName}"]`) as HTMLElement | null;
    if (genericField) {
      targetElement =
        genericField.closest('.form-container') as HTMLElement ||
        genericField.closest('.col-4') as HTMLElement ||
        genericField.closest('.col-6') as HTMLElement ||
        genericField;
    }
  }

  if (!targetElement) {
    const firstInvalid = addressPanel.querySelector('.ng-invalid[formcontrolname]') as HTMLElement | null;
    if (firstInvalid) {
      targetElement =
        firstInvalid.closest('.form-container') as HTMLElement ||
        firstInvalid.closest('.col-4') as HTMLElement ||
        firstInvalid.closest('.col-6') as HTMLElement ||
        firstInvalid;
    }
  }

  if (!targetElement) {
    console.warn(`Target element not found for field: ${fieldName}, building: ${buildingIdx}, address: ${addressIdx}`);
    return;
  }

  // Wait a bit more to ensure accordion is fully expanded
  setTimeout(() => {
    if (scrollContainer) {
      const containerRect = scrollContainer.getBoundingClientRect();
      const elementRect = targetElement!.getBoundingClientRect();
      
      // Calculate scroll position to center the element in the container
      // For checkbox, scroll to show it at the bottom of the visible area (since it's at the end)
      let scrollTop: number;
      if (fieldName === 'isConfirmed') {
        // For checkbox, scroll to show it in lower 70% of container
        scrollTop = scrollContainer.scrollTop + 
                   (elementRect.top - containerRect.top) - 
                   (containerRect.height * 0.7) + 
                   (elementRect.height / 2);
      } else {
        // For other fields, center them
        scrollTop = scrollContainer.scrollTop + 
                   (elementRect.top - containerRect.top) - 
                   (containerRect.height / 2) + 
                   (elementRect.height / 2);
      }
      
      scrollContainer.scrollTo({
        top: Math.max(0, scrollTop),
        behavior: 'smooth'
      });
    } else {
      // Fallback if scroll container not found - use scrollIntoView
      targetElement!.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, 200); // Increased delay to ensure accordion is fully expanded
}

onCopeAddressAccordionOpened(index: number): void {
  this.ensureCopeAccordionStateSize();
  this.copeAddressAccordionOpened = this.copeAddressAccordionOpened.map((_, i) => i === index);
}

onCopeAddressAccordionClosed(index: number): void {
  this.ensureCopeAccordionStateSize();
  if (this.copeAddressAccordionOpened[index] !== undefined) {
    this.copeAddressAccordionOpened[index] = false;
  }
}

// NOTE: `validateAlarms`, `validateCheckboxes`, and helper "findFirstInvalid..." methods are no longer used.
// COPE validations are consolidated inside `validateCopeFields()` to ensure the correct address accordion is opened.

private openPolicyAddressAccordion(index: number): void {
  this.addressAccordionOpened = this.addresses().map((_, i) => i === index);
  this.cdRef.detectChanges();
  setTimeout(() => {
    const el = this.policyAddressPanels?.toArray()?.[index]?.nativeElement;
    el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, 0);
}



  private getBuildingYearsValidationMessage(buildingGroup: FormGroup): string | null {
    const ageValue = buildingGroup.get('Age')?.value;
    const builtYear = this.getYearNumber(ageValue);
    const updateKeys = ['roofReplaceUpdate', 'plumbing', 'hvac', 'electrical'];

    // If any update provided but no Year Built, block and prompt
    const anyUpdateProvided = updateKeys.some(k => !!buildingGroup.get(k)?.value);
    if (!builtYear && anyUpdateProvided) {
      return 'Please provide year built';
    }

    if (!builtYear) {
      return null; // Nothing to compare
    }

    for (const key of updateKeys) {
      const updateYear = this.getYearNumber(buildingGroup.get(key)?.value);
      if (updateYear && updateYear < builtYear) {
        return 'Update precedes year built. Please check dates.';
      }
    }

    return null;
  }

  CopeSaveForIndicationQuote(isSaveAndExit: boolean = false) {
    
    const addresses = this.addressForm.get('addresses') as FormArray;

    const cleanedPremium = this.cleanCurrencyValue(this.premium);
    if(!this.isReadOnly()){
      if (!cleanedPremium || isNaN(cleanedPremium) || cleanedPremium <= 0) {
        this.showPremiumError = true;
        this.toastService.addNotification({ 
          message: "Target Premium Amount is required", 
          type: ToastType.Error 
        });
        return;
      } else {
        this.showPremiumError = false;
      }

      // Validate Year Built dependencies across all buildings before proceeding
      // This validation should run early to catch year issues before other validations
      for (let a = 0; a < addresses.length; a++) {
        const addressControl = addresses.at(a) as FormGroup;
        const buildingDetailsFA = addressControl.get('buildingDetails') as FormArray;
        if (buildingDetailsFA && Array.isArray(buildingDetailsFA.controls)) {
          for (let b = 0; b < buildingDetailsFA.length; b++) {
            const buildingGroup = buildingDetailsFA.at(b) as FormGroup;
            const msg = this.getBuildingYearsValidationMessage(buildingGroup);
            if (msg) {
              this.toastService.addNotification({ message: msg, type: ToastType.Error });
              this.openCopeAddressAccordion(a);
              this.cdRef.detectChanges(); // Force change detection to display toast
              return; // Block save on first violation
            }
          }
        }
      }

        if(this.isEditing['story'] || this.isEditing['sqFt'] || this.isEditing['RCV'] || this.isEditing['DistanceToCoast']){
          const editingLocation = this.findEditingFieldLocation();
          if (editingLocation) {
            this.openCopeAddressAccordion(
              editingLocation.addressIdx,
              editingLocation.buildingIdx,
              editingLocation.fieldName
            );
          }
          this.toastService.addNotification({message: "Please confirm/decline the editable field changes before proceeding", type: ToastType.Error})
          return;
        } 

        if (this.validateCopeFields()) {
          return;
        }
      }
    addresses.controls.forEach((addressControl, index) => {
      const buildingDetails = addressControl.get('buildingDetails') as FormArray;
    });

   

    const buildingDetailsArray = addresses.controls.map((addressControl) =>
      addressControl.get('buildingDetails')?.value
    );

    const updatedAddresses = addresses.controls.map((addressControl, index) => {
     const addressId = Number(addressControl.get('addressid')?.value) || 0;
      const buildingDetails = addressControl.get('buildingDetails')?.value;
    
      const building = sessionStorage.getItem('buildingid')
      const storedbuildingId = building ? JSON.parse(building) : []
      const isConfirmed = addressControl.get('isConfirmed')?.value ? 1 : 0;

      // const buildingId = JSON.parse(sessionStorage.getItem('buildingid')||'')
      
      return {
        addressid: addressId,
        isConfirmed: isConfirmed,
        buildings: buildingDetails?.map((buildingDetail: { buildingid: any }, index: number) => ({
          buildingid: buildingDetail?.buildingid ? buildingDetail?.buildingid : 0,
            
          factors: this.mapFormDataToFactors(buildingDetail),
        })) || [],
      };
    });   

    const factors = buildingDetailsArray.flatMap(buildingDetails => {
      const details = Array.isArray(buildingDetails) ? buildingDetails[0] : buildingDetails;
      
      return this.mapFormDataToFactors(details);
    });

    
    const requestPayload = {
      factors: factors,
      addresses:updatedAddresses
      
    };    
  
    this.isIndicationType() ? this.copeIndicationSave(requestPayload, isSaveAndExit) :
    this.copeQuoteSave(requestPayload, isSaveAndExit);
  }

onCheckboxeChange(event: Event, index: number) {
  const inputElement = event.target as HTMLInputElement;
  const addressGroup = this.addressControls().at(index) as FormGroup;
  addressGroup.get('isConfirmed')?.setValue(inputElement.checked);
  if (inputElement.checked) {
    this.errorMessage.set(null);
  }
}
  
  copeSave(isSaveAndExit: boolean = false) {
    // When Next is clicked on COPE, prevent the accordion close handler from saving again
    this.suppressCopeCloseSave = true;
    if(this.isPolicyType()) {
      this.CopeSaveForPolicy();
    }else{
      this.CopeSaveForIndicationQuote(isSaveAndExit);
    }
  } 
    

 mapFormDataToFactors(formData: any): any[] {
  if (!formData || Object.keys(formData).length === 0) {
    return [];
  }

  const allowedKeys = [
    'DistanceToCoast',
    'PcClass',
    'CRIMERATING',
    'story',
    'RCV',
    'sqFt',
    'CONSTTYPE',
    'ROOFTYPE',
    'Age',
    'Occupancy',
    'roofReplaceUpdate',
    'plumbing',
    'hvac',
    'electrical',
    'Burglar',
    'sprinklers',
    'FireAlarm',
    'googleMapImageSrc',
    'googleStreetImageSrc'
  ];

  const factors: any[] = [];

    // List of keys associated with yearpicker fields
    const datepickerKeys = ['Age','roofReplaceUpdate', 'plumbing', 'hvac', 'electrical'];

     ['Burglar', 'sprinklers', 'FireAlarm'].forEach(key => {
    if (formData[key] === 1) {
      formData[key] = null;
    }
  });

     ['Burglar', 'sprinklers', 'FireAlarm'].forEach(key => {
    if (formData[key] === 1) {
      formData[key] = null;
    }
  });

  // Store formatted age year early if available
  let ageYear = '';
  if (formData['Age']) {
    const ageVal = formData['Age'];
    if (moment.isMoment(ageVal)) {
      ageYear = ageVal.year().toString();
    } else if (ageVal instanceof Date) {
      ageYear = ageVal.getFullYear().toString();
    } else if (typeof ageVal === 'string' && !isNaN(Date.parse(ageVal))) {
      ageYear = new Date(ageVal).getFullYear().toString();
    }
  }

  if (formData && typeof formData === 'object') {
    Object.entries(formData).forEach(([key, value]) => {
      if (allowedKeys.includes(key)) {
        let subFactorValue = value;

        // Enforce defaults for specific fields
        if ((value === null || value === undefined || value === '') && key === 'DistanceToCoast') {
          subFactorValue = 'Unknown';
        }

        if ((value === null || value === undefined || value === '') && (key === 'googleMapImageSrc' || key === 'googleStreetImageSrc')) {
          subFactorValue = "";
        }

        // Default value from Age if value is null/empty and key is one of the 4 fields
        if ((value === null || value === undefined || value === '') && ['roofReplaceUpdate', 'plumbing', 'hvac', 'electrical'].includes(key)) {
          if (ageYear) {
            subFactorValue = ageYear;
          }
        }

        // Skip if still null/empty after fallbacks, except for Google image fields which must be included as null
        if ((subFactorValue === null || subFactorValue === undefined || subFactorValue === '') &&
            !(key === 'googleMapImageSrc' || key === 'googleStreetImageSrc')) {
          return;
        }

        if (['FireAlarm', 'Burglar', 'sprinklers'].includes(key)) {
          subFactorValue = subFactorValue === 2 ? 'yes' : 'no';
        }

        if (key === 'RCV') {
          subFactorValue = typeof subFactorValue === 'string'
            ? String(parseFloat(subFactorValue.replace(/[^0-9.]/g, '')))
            : subFactorValue;
        }

        if (datepickerKeys.includes(key)) {
          if (moment.isMoment(subFactorValue)) {
            subFactorValue = subFactorValue.year().toString();
          } else if (subFactorValue instanceof Date) {
            subFactorValue = subFactorValue.getUTCFullYear().toString();
          } else if (typeof subFactorValue === 'string' && !isNaN(Date.parse(subFactorValue))) {
            subFactorValue = new Date(subFactorValue).getUTCFullYear().toString();
          }
        }

        factors.push({
          factorName: key,
          subFactorName: subFactorValue
        });
      }
    });
  }

  return factors;
}


  validationMessages: { [key: string]: string | null } = {
    startDate: null,
    endDate: null,
    causeOfLoss: null,
    aopDeductibleAmount: null,
    windDeductibleFactor: null,
    waterDamageId: null,
    vandalismId: null,
    oAndLCoverageAmount: null,
  };

  private hasSelection(value: any): boolean {
    return value !== null && value !== undefined && value !== '' && Number(value) !== 0;
  }

  private getFirstInvalidPolicyField(): string | null {
    const orderedFields = [
      'startDate',
      'endDate',
      'causeOfLoss',
      'aopDeductibleAmount',
      'windDeductibleFactor',
      'waterDamageId',
      'vandalismId'
    ];

    for (const key of orderedFields) {
      if (this.validationMessages[key]) {
        return key;
      }
    }
    return null;
  }

  private scrollToPolicyField(fieldName: string): void {
    const selectorMap: Record<string, string> = {
      startDate: '[name="startDate"]',
      endDate: '[name="endDate"]',
      causeOfLoss: '[name="causeOfLoss"]',
      aopDeductibleAmount: '[name="aopDeductible"]',
      windDeductibleFactor: '[name="windDeductible"]',
      waterDamageId: '[name="waterDeductible"]',
      vandalismId: '[name="vandalism"]'
    };

    const policyInfoPanel = document.querySelector('#policy-information-body') as HTMLElement | null;
    const target = document.querySelector(selectorMap[fieldName]) as HTMLElement | null;
    if (!target) return;

    const targetContainer =
      target.closest('.form-container') as HTMLElement ||
      target.closest('.col-6') as HTMLElement ||
      target;

    if (policyInfoPanel) {
      const containerRect = policyInfoPanel.getBoundingClientRect();
      const elementRect = targetContainer.getBoundingClientRect();
      const scrollTop = policyInfoPanel.scrollTop + (elementRect.top - containerRect.top) - 60;
      policyInfoPanel.scrollTo({ top: Math.max(0, scrollTop), behavior: 'smooth' });
    } else {
      targetContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    setTimeout(() => target.focus(), 250);
  }

  private hasPolicyValidationErrors(): boolean {
    this.validatePolicyParameters();
    const firstInvalidField = this.getFirstInvalidPolicyField();
    if (!firstInvalidField) {
      return false;
    }
    this.accordionOpen.set(true);
    this.cdRef.detectChanges();
    setTimeout(() => this.scrollToPolicyField(firstInvalidField), 300);
    return true;
  }

  validateField(fieldName: string): void {
    switch (fieldName) {
      case 'startDate':
        this.validationMessages['startDate'] = this.formData.startDate ? null : 'Start Date is required.';
        break;
      case 'endDate':
        this.validationMessages['endDate'] = this.formData.endDate ? null : 'End Date is required.';
        break;
      case 'causeOfLoss':
        this.validationMessages['causeOfLoss'] = this.hasSelection(this.formData.causeOfLoss) ? null : 'Cause of Loss is required.';
        break;
      case 'aopDeductibleAmount':
        this.validationMessages['aopDeductibleAmount'] = this.hasSelection(this.formData.aopDeductibleId) ? null : 'AOP Deductible is required.';
        break;
      case 'windDeductibleFactor':
        if (this.formData.windDeductibleFlag === 1) {
          this.validationMessages['windDeductibleFactor'] = null;
          break;
        }
        this.validationMessages['windDeductibleFactor'] = this.hasSelection(this.formData.windDeductibleId) ? null : 'Wind/Hail Deductible is required.';
        break;
      case 'waterDamageId':
        this.validationMessages['waterDamageId'] = this.hasSelection(this.formData.waterDamageId) ? null : 'Water Damage Coverage is required.';
        break;
      case 'vandalismId':
        this.validationMessages['vandalismId'] = this.hasSelection(this.formData.vandalismId) ? null : 'Theft Coverage is required.';
        break;
      // case 'oAndLCoverageAmount':
      //   this.validationMessages['oAndLCoverageAmount'] = this.formData.oAndLCoverageAmount ? null : 'O & L Coverage is required.';
      //   break;
    }
  }

  validatePolicyParameters(): void {
    // Reset validation messages
    this.validationMessages = {
      startDate: null,
      endDate: null,
      causeOfLoss: null,
      aopDeductibleAmount: null,
      windDeductibleFactor: null,
      waterDamageId: null,
      vandalismId: null,
      oAndLCoverageAmount: null,
    };

    // Validate all fields
    this.validateField('startDate');
    this.validateField('endDate');
    this.validateField('causeOfLoss');
    this.validateField('aopDeductibleAmount');
    this.validateField('windDeductibleFactor');
    this.validateField('waterDamageId');
    this.validateField('vandalismId');
    //this.validateField('oAndLCoverageAmount');
  }

// validationMessages: string[] = [];

onClearanceCheckPopup(message: string){
  const dialog = this.dialog.open(ClearanceCheckDialogComponent, {
      data: { message: message }
  });

  return dialog.afterClosed()
}

onConfirmationPopup(message: string){
  const dialog = this.dialog.open(ReferralDialogComponent, {
      data: { message: message }
  });

  return dialog.afterClosed()
}

onReferralSubmithandler(){
  const storageData = this.authService.getUserDetailsFromStorage();
  this.branchId.set(storageData.branchId);
  this.indicationId.set(storageData.indicationId);
  this.quoteId.set(storageData.quoteId);

  if(this.isIndicationType()){
    this.submitreferralIndication()
  }else{
    this.submitReferralQuote()
  }
}

submitreferralIndication(){
  this.indicationQuoteService.submitReferal(Number(this.indicationId()),Number(this.branchId())).subscribe({
    next: (response) => {
        if(response){
            this.toastService.addNotification({message: "Your referral has been successfully submitted", type: ToastType.Success}); 
            this.router.navigate(['/quote'])
            this.indicationQuoteService.removeIndicationQuoteStorageData();
        }
    },
    error: (error) => {
    }
    })
}

submitReferralQuote(){
  this.indicationQuoteService.submitReferralQuote(Number(this.quoteId()),Number(this.branchId())).subscribe({
    next: (response) => {
        if(response){
            this.toastService.addNotification({message: "Your referral has been successfully submitted", type: ToastType.Success}); 
            this.router.navigate(['/quote'])
            this.indicationQuoteService.removeIndicationQuoteStorageData();
        }
    },
    error: (error) => {
    }
    })
}

onProceed(isSaveAndExit: boolean = false): void{
  const msg = "Insured details have been found within system, this has been flagged for Clearance referral. Please complete and submit or exit to home page"
  this.onClearanceCheckPopup(msg)
  .subscribe((result: boolean) => {
      if(result){  
        this.shouldMarkClearanceAddressEdited = true;
        this.clearanceStep(isSaveAndExit);
      }else{
        this.router.navigate(['/quote'])
        this.indicationQuoteService.removeIndicationQuoteStorageData();

      }
  });
}

onsubmitClearanceReferral(){
  const msg = "Insured details have been found within system, this has been flagged for Clearance referral. Please submit referral"
  this.onConfirmationPopup(msg)
  .subscribe((result: boolean) => {
      if(result){        
        this.onReferralSubmithandler() 
      }
  });
}

onSubmitClearanceName(action: boolean){
  if(action){
    this.clearanceNameAddressCheck(false, true, true);
  }
}

private getClearanceEntityContext(): { id: number; type: string; userId: number } | null {
  const storageData = this.authService.getUserDetailsFromStorage();
  const userId = Number(storageData?.userDetails?.userId ?? 0);
  if (!userId) {
    return null;
  }

  if (this.isIndicationType()) {
    const indicationId = Number(storageData?.indicationId ?? 0);
    return indicationId ? { id: indicationId, type: "indication", userId } : null;
  }

  const quoteId = Number(storageData?.quoteId ?? 0);
  return quoteId ? { id: quoteId, type: "quote", userId } : null;
}

private extractClearanceAddressIds(response: any): number[] {
  return Array.isArray(response?.addressIds)
    ? response.addressIds
        .map((addressId: any) => Number(addressId))
        .filter((addressId: number) => !!addressId)
    : [];
}

private updateClearanceAddressEdited(clearanceAddressEdited: number, onSuccess: () => void): void {
  const context = this.getClearanceEntityContext();
  if (!context) {
    onSuccess();
    return;
  }

  this.propertyService.UpdateClearanceAddressEdit(
    context.id,
    context.userId,
    clearanceAddressEdited,
    context.type
  ).subscribe({
    next: () => onSuccess(),
    error: () => onSuccess()
  });
}

private updateClearanceAddressEditedAfterClearanceSave(): void {
  if (!this.shouldMarkClearanceAddressEdited) {
    return;
  }

  this.updateClearanceAddressEdited(1, () => {
    this.shouldMarkClearanceAddressEdited = false;
    this.pendingClearanceAddressIds = [];
  });
}

onSubmitAmend(): void{
  const msg = this.isIndicationType() ? "Your Indication has been marked referral as you exceeded the limit to amend the Indication. Please contact admin" :
  "Your quote has been marked referral as you exceeded the limit to amend the quote. Please contact admin"
  this.onConfirmationPopup(msg)
  .subscribe((result: boolean) => {
      if(result){        
        this.onReferralSubmithandler() 
      }
  });
}

cleanCurrencyValue(value: string | number): number {
  if (value === null || value === undefined || value === '') {
    return 0; // Default to 0 if value is empty
  }

  if (typeof value === "number") {
    return value; // Already a number, return as is
    
  }
  // Remove all non-numeric characters except the decimal point
  const cleanedValue = value.replace(/[^0-9.-]+/g, '');
  
  return parseFloat(cleanedValue) || 0; // Convert to number, default to 0 if invalid
}


formatCurrency(event: any): void {
  let value = event.target.value;
  value = value.replace(/[^0-9.-]+/g, ''); // Remove non-numeric characters
  
  if (value && !isNaN(value)) {
    let num = Number(value);
    // Format the number using 'en-US' locale (comma separators)
    let formattedValue = new Intl.NumberFormat('en-US', {
     
      minimumFractionDigits: 0, // You can adjust this if you need decimal points
      maximumFractionDigits:2

    }).format(num);

    // Update the input field with the formatted value
    // this.businessPropertyLimit = num;
    
    event.target.value = formattedValue;

    // this.calculateTotals();
  }
}


totalBusinessIncomeLimit: number = 0;

formatCurrencies(event: any, control: AbstractControl | null): void {

  let value = event.target.value.replace(/[^0-9.-]+/g, ''); // Remove non-numeric characters

  if (value && !isNaN(value)) {
    let num = parseFloat(value); // Convert to number

    if (control) {
      control.setValue(num, { emitEvent: false }); // Store numeric value in form control
      // Reset validation trigger when user changes otherStructuresLimit (Additional Property Coverages Limit)
      if (control.parent instanceof FormGroup && control.parent.get('otherStructuresLimit') === control) {
        this.structureValidationTriggered.set(false);
      }
    }

    // Format the number for display
    event.target.value = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(num);
  } else {
    if (control) {
      control.setValue(0, { emitEvent: false });
      // Reset validation trigger when user changes otherStructuresLimit
      if (control.parent instanceof FormGroup && control.parent.get('otherStructuresLimit') === control) {
        this.structureValidationTriggered.set(false);
      }
    }
    event.target.value = '0';
  }

  this.calculateTotals(); // Recalculate totals
}


formatCurrencybusiness(event: any,index: number): void {
  let value = event.target.value.replace(/[^0-9.-]+/g, ''); // Remove non-numeric characters

  if (value && !isNaN(value)) {
    let num = Number(value); // Convert to number
    
    this.business[index] = num; // Update the bound variable
    this.calculateTotals();

    // Format the number for display
    setTimeout(() => {
      event.target.value = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(num);
    }, 20); // Delay formatting to allow for user input
  }  else {
    this.business[index] = 0;;
    this.calculateTotals();
    event.target.value = '';
  }
}


  setOandLFlagOnPayload(buildingId: any) {
    const { oAndLCoverage } = this.policyOAndLForm.getRawValue();
    const checkedBuildingIds = oAndLCoverage.filter((item: any) => item.isPremisesChecked).map((item: any) => item.buildingId);
    if (checkedBuildingIds.includes(buildingId)) {
      return 1;  // Set to 1 if buildingId matches
    } else {
      return 0;  // Set to 0 if buildingId does not match
    }
  }

  policyMTAPolicyParameterSave() {
     const cleanedPremium = this.cleanCurrencyValue(this.premium);
     
    if(!this.isReadOnly()){
    if (this.hasPolicyValidationErrors()) {
      return; // Stop further execution if there are validation errors
    }

    

   if (!cleanedPremium || isNaN(cleanedPremium) || cleanedPremium <= 0) {
    this.showPremiumError = true;
    this.toastService.addNotification({ 
      message: "Target Premium Amount is required", 
      type: ToastType.Error 
    });
    return;
  } else {
    this.showPremiumError = false;
  }
}
    const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
    const userId = userDetails.userId;
    const building = sessionStorage.getItem('buildingid')
    const storedbuildingId = building ? JSON.parse(building) : ''
    const currentDate = new Date().toISOString();
    const addresses = this.addressControls().value;
    const address = sessionStorage.getItem('policyAddressId');
    const storedaddressId = address ? JSON.parse(address) : '';
    
    // const cleanedBusinessIncomeLimit = this.cleanCurrencyValue(this.business);

    let totalBuildingIdIndex = 0; // Track overall building ID position, declared outside updatedAddresses

    const updatedAddresses = addresses.map((address: { structures: any[]; buildingDetails: any[]; }, addressIndex: number) => {
    let buildingIdIndexForAddress = 0; // Reset for each address

    const additionalPropertyCoverage = address.structures
        .filter((structure) => {
          const coverageLimit = structure.coverageLimit;
          const otherStructuresLimit = structure.otherStructuresLimit;
          const cleanedAmount = this.cleanCurrencyValue(otherStructuresLimit);
          return coverageLimit && coverageLimit !== '' && coverageLimit !== null && coverageLimit !== undefined && cleanedAmount !== null && cleanedAmount !== undefined && cleanedAmount > 0;
        })
        .map((structure) => {
          const otherDescription = structure.isOthersSelected ? structure.otherDescription : '';
          return {
            otherStructureId: 0, 
            policyId: this.authService.getUserDetailsFromStorage()?.policyId,
            policyAddressId: storedaddressId && storedaddressId.length>0 ? storedaddressId[addressIndex]:0,
            OtherStructureOtherDesc: otherDescription,
            otherStructureFactorId: structure.coverageLimit || null,
            otherStructureFactorAmount: this.cleanCurrencyValue(structure.otherStructuresLimit) || null,
            isDeleted: 0,
            createdUserId: userId,
            createdDate: currentDate,
            updatedUserId: userId,
            updatedDate: currentDate
          };
        });

    return {
      addressid: storedaddressId && storedaddressId.length > addressIndex ? storedaddressId[addressIndex] : 0,
      businessIncomeLimit: this.cleanCurrencyValue(this.business[addressIndex]),
      ...(additionalPropertyCoverage.length > 0 ? { additionalPropertyCoverage } : {}),
      buildings: address.buildingDetails.map((buildingDetail) => {
        const buildingId = storedbuildingId && storedbuildingId.length > totalBuildingIdIndex ? storedbuildingId[totalBuildingIdIndex] : 0;
        totalBuildingIdIndex++; // Increment overall index
        buildingIdIndexForAddress++; // Increment address index

        return {
          buildingId: buildingId,
          buildingLimit: this.cleanCurrencyValue(buildingDetail.buildingLimit),
          businessPropertyLimit: this.cleanCurrencyValue(buildingDetail.businessPropertyLimit),
          OandLFlag: this.setOandLFlagOnPayload(buildingId),
        };
      }),
    };
  });


const payload = {
userid: this.userId,
targetPremium: cleanedPremium,
policyStartDate: this.formData.startDate,
policyEndDate: this.formData.endDate,
causeOfLoss: this.formData.causeOfLoss,
aopDeductibleId: this.formData.aopDeductibleId,
aopDeductibleAmount: this.formData.aopDeductibleAmount,
windDeductibleFlag: this.formData.windDeductibleFlag,
windDeductibleId: this.formData.windDeductibleId,
windDeductibleFactor: this.formData.windDeductibleFactor,
propertyExtCoverageType: this.formData.propertyExtCoverageType,
waterDamageId: this.formData.waterDamageId,
waterDamageAmount: this.formData.waterDamageAmount,
waterDamageDescription: this.formData.waterDamageDescription,
vandalismId: this.formData.vandalismId,
vandalismAmount: this.formData.vandalismAmount,
vandalismDescription: this.formData.vandalismDescription,
// aopDeductibleDescription: this.Aopdeductibles.filter((item) => String(item?.amount) === String(this.formData.aopDeductibleAmount))?.[0].description,
// windDeductibleDescription: this.filterWindDeductible()?.filter((item) => String(item.factor) === String(this.formData.windDeductibleFactor))?.[0].description,
aopDeductibleDescription: this.formData.aopDeductibleDescription,
windDeductibleDescription: this.formData.windDeductibleDescription,
addresses: updatedAddresses,
totalCoverageA: 0,
totalCoverageB: 0,
totalCoverageC: 0,
totalCoverageD: 0,
};

    this.policyParameterMTA(payload);   
  }

  accordianCloseForPolicyParameters(afterSave?: () => void){
    
    if(!this.isPolicyType()){
      this.policyParameterIndicationQuoteSaveAccordian(false, afterSave)
      this.getCopeData(true);
    }
    this.accordionOpen.set(false);  

  }

  accordianClose(){
    this.accordionOpen.set(false);
    
  }

    policyParameterIndicationQuoteSaveforPrevious(isSaveAndExit: boolean = false) {

     const cleanedPremium = this.cleanCurrencyValue(this.premium);
   if(!this.isReadOnly()){
    

    if (!cleanedPremium || isNaN(cleanedPremium) || cleanedPremium <= 0) {
      this.showPremiumError = true;
      this.toastService.addNotification({ 
        message: "Target Premium Amount is required", 
        type: ToastType.Error 
      });
      return;
    } else {
      this.showPremiumError = false;
    }
    
      if (this.getTotalTIVLimit() > 2500000){

        this.toastService.addNotification({message: "Maximum TIV limit allowed is $2.5M. Please amend the limits entered or exit to return to landing page.", type: ToastType.Error}); // error notification
        return
      }

      if(this.selectedPolicyType() !==3){
      for (let i = 0; i < this.addressControls().length; i++) {
        const buildings = this.getPolicyParametersForAddress(i);
        for (let j = 0; j < buildings.length; j++) {
            const buildingLimit = buildings[j].get('buildingLimit')?.value;
            if (buildingLimit === 0 || buildingLimit === '0' || buildingLimit === '' || buildingLimit === null || buildingLimit === undefined) {
              this.openPolicyAddressAccordion(i);
              this.toastService.addNotification({message: "This type of policy must include building limits. Please edit policy parameters or exit to return to landing page", type: ToastType.Error}); // error notification
              return;
            }
        }}}

         if(this.selectedPolicyType() ===3){
    for (let i = 0; i < this.addressControls().length; i++) {
      const buildings = this.getPolicyParametersForAddress(i);
      for (let j = 0; j < buildings.length; j++) {
        const buildingLimit = buildings[j].get('buildingLimit')?.value;
          const businessPropertyLimit = buildings[j].get('businessPropertyLimit')?.value;
          const businessIncomeLimit = this.business[i];
          if ((businessPropertyLimit === 0 || businessPropertyLimit === '0' || businessPropertyLimit === '' || businessPropertyLimit === null || businessPropertyLimit === undefined) && (businessIncomeLimit === 0  || businessIncomeLimit === null || businessIncomeLimit === undefined) && (buildingLimit === 0 || buildingLimit === '0' || buildingLimit === '' || buildingLimit === null || buildingLimit === undefined)) {
            this.openPolicyAddressAccordion(i);
            this.toastService.addNotification({message: 'This type of policy must include I&B Limit, or BPP Limit or BI Limit. Please edit policy parameters or exit to return to landing page', type: ToastType.Error}); // error notification
            return ;
          }
      }}}
          // Validate Additional Property Coverages/Limit per address/structure
    this.structureValidationTriggered.set(true); // Trigger validation display
    for (let i = 0; i < this.addressControls().length; i++) {
      const structures = this.structureControlsForAddress(i);
      const total = structures.length;
      for (let j = 0; j < total; j++) {
        const error = this.getStructureError(i, j);
        if (error) {    
          this.openPolicyAddressAccordion(i);      
          return;
        }
      }
    }
    if (this.hasPolicyValidationErrors()) {
      return;
    }
      } 
    

      const quoteId = sessionStorage.getItem('quoteId');
      const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
      const userId = userDetails.userId;
      const building = sessionStorage.getItem('buildingid')
      const storedbuildingId = building ? JSON.parse(building) : ''
      
      const currentDate = new Date().toISOString();
      const addresses = this.addressControls().value;
      const indicationAddress = sessionStorage.getItem('indicationAddressId')
      const quoteAddress = sessionStorage.getItem('quoteAddressId')
      const address = this.isIndicationType() ? indicationAddress : quoteAddress
      const storedaddressId = address ? JSON.parse(address) : ''
      const otherStructureIds = JSON.parse(sessionStorage.getItem('otherStructureIds') || '[]');

      const indicationQuoteId = this.isIndicationType() ? this.authService.getUserDetailsFromStorage().indicationId : this.authService.getUserDetailsFromStorage().quoteId;     

      let totalBuildingIdIndex = 0; // Track overall building ID position, declared outside updatedAddresses

      const updatedAddresses = addresses.map((address: { structures: any[]; buildingDetails: any[]; }, addressIndex: number) => {
      let buildingIdIndexForAddress = 0; // Reset for each address

      return {
        addressid: storedaddressId && storedaddressId.length > addressIndex ? storedaddressId[addressIndex] : 0,
        businessIncomeLimit: this.cleanCurrencyValue(this.business[addressIndex]),
        additionalPropertyCoverage: address.structures.map((structure) => {
          const otherDescription = structure.isOthersSelected ? structure.otherDescription : '';
          return {
            otherStructureId: 0,
            ...(this.isIndicationType()
              ? {
                  indicationId: Number(indicationQuoteId),
                  indicationAddressId: storedaddressId && storedaddressId.length > addressIndex ? storedaddressId[addressIndex] : 0,
                }
              : {
                  quoteId: Number(indicationQuoteId),
                  quoteAddressId: storedaddressId && storedaddressId.length > addressIndex ? storedaddressId[addressIndex] : 0,
                }),
            OtherStructureOtherDesc: otherDescription,
            otherStructureFactorId: structure.coverageLimit || null,
            otherStructureFactorAmount: this.cleanCurrencyValue(structure.otherStructuresLimit) || null,
            isDeleted: 0,
            createdUserId: userId,
            createdDate: currentDate,
            updatedUserId: userId,
            updatedDate: currentDate,
          };
        }),
        buildings: address.buildingDetails.map((buildingDetail) => {
          const buildingId = storedbuildingId && storedbuildingId.length > totalBuildingIdIndex ? storedbuildingId[totalBuildingIdIndex] : 0;
          totalBuildingIdIndex++; // Increment overall index
          buildingIdIndexForAddress++; // Increment address index

          return {
            buildingId: buildingId,
            buildingLimit: this.cleanCurrencyValue(buildingDetail.buildingLimit),
            businessPropertyLimit: this.cleanCurrencyValue(buildingDetail.businessPropertyLimit),
            OandLFlag: this.setOandLFlagOnPayload(buildingId),
          };
        }),
      };
    });



const payload = {
  userid: this.userId,
  targetPremium: cleanedPremium,
  policyStartDate: this.formData.startDate,
  policyEndDate: this.formData.endDate,
  causeOfLoss: this.formData.causeOfLoss,
  aopDeductibleId: this.formData.aopDeductibleId,
  aopDeductibleAmount: this.formData.aopDeductibleAmount,
  windDeductibleFlag: this.formData.windDeductibleFlag,
  windDeductibleId: this.formData.windDeductibleId,
  windDeductibleFactor: this.formData.windDeductibleFactor,
  propertyExtCoverageType: this.formData.propertyExtCoverageType,
  waterDamageId: this.formData.waterDamageId,
  waterDamageAmount: this.formData.waterDamageAmount,
  waterDamageDescription: this.formData.waterDamageDescription,
  vandalismId: this.formData.vandalismId,
  vandalismAmount: this.formData.vandalismAmount,
  vandalismDescription: this.formData.vandalismDescription,
  // aopDeductibleDescription: this.Aopdeductibles.filter((item) => String(item?.amount) === String(this.formData.aopDeductibleAmount))?.[0].description,
  // windDeductibleDescription: this.filterWindDeductible()?.filter((item) => String(item.factor) === String(this.formData.windDeductibleFactor))?.[0].description,
  aopDeductibleDescription: this.formData.aopDeductibleDescription,
  windDeductibleDescription: this.formData.windDeductibleDescription,
  addresses: updatedAddresses,
  totalCoverageA: 0,
  totalCoverageB: 0,
  totalCoverageC: 0,
  totalCoverageD: 0,
};

      
    this.isIndicationType() ? this.PolicyParametersIndicationforPrevious(payload, isSaveAndExit) : 
    this.PolicyParametersQuoteforPrevious(payload, isSaveAndExit)   
  }

  PolicyParametersIndicationforPrevious(payload:any, isSaveAndExit: boolean = false){
  const requestBodyIndication = {
    indicationId:  this.authService.getUserDetailsFromStorage().indicationId,
    ...payload,
    
  };

  if(!this.isReadOnly()){ // call policyparameter save API when isReadonly is false
    this.PolicyInfoSave.set(false)
    this.addressService.PolicyStepIndication(requestBodyIndication).subscribe({
      next: (response) => {
        if(isSaveAndExit){
          this.router.navigate(['/quote']); // redirect user to landing page
          this.indicationQuoteService.removeIndicationQuoteStorageData();
          return;
        }
        // Navigate only after Policy Parameters save completes.
        this.suppressCopePolicyParameterSave = true;
        this.navigateToPreviousMainAccordionAfterSave(1);
        
        if(this.authService?.getUserDetailsFromStorage()?.isAmendByUWAdmin === "1"){
          this.requestQuoteService.resetPolicyParameterStepData(); // reset Policy parameter step
          this.requestQuoteService.onUpdateIndicationToQuoteStepData(true); // update Indication to Quote Step to receive data 
        }
        this.PolicyInfoSave.set(true);
        sessionStorage.setItem('PolicyInfoSave',JSON.stringify(true))
        this.onGetSystemUserMessage();
        // this.isapiCallSuccessful.set(true)
        if(this.isapiCallSuccessful()){
        this.router.navigate(['/quote']);          
      sessionStorage.removeItem('indicationId')    
      sessionStorage.removeItem('indicationAddressId');
        
      this.isapiCallSuccessful.set(false)
        }

      },
      error: (error) => {
        this.isapiCallSuccessful.set(false)
        this.toastService.addNotification({message: "System error. Policy Parameters failed. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    });
  }else{
    if(isSaveAndExit){
      this.router.navigate(['/quote']); // redirect user to landing page
      this.indicationQuoteService.removeIndicationQuoteStorageData();
      return;
    }
    // update the requestQuote Service
    this.requestQuoteService.resetPolicyParameterStepData(); // reset clearance step
    this.suppressCopePolicyParameterSave = true;
    this.navigateToPreviousMainAccordionAfterSave(1);
  }
}

PolicyParametersQuoteforPrevious(payload:any, isSaveAndExit: boolean = false){
  const requestBodyQuote = {
    quoteId:  this.authService.getUserDetailsFromStorage().quoteId,
    ...payload,
    
  }

  if(!this.isReadOnly()){ // call policyparameter save API when isReadonly is false
    this.PolicyInfoSave.set(false)
    this.addressService.PolicyStepQuote(requestBodyQuote).subscribe({
      next: (response) => {
        if(isSaveAndExit){
          this.router.navigate(['/quote']); // redirect user to landing page
          this.indicationQuoteService.removeIndicationQuoteStorageData();
          return;
        }
        // Navigate only after Policy Parameters save completes.
        this.suppressCopePolicyParameterSave = true;
        this.navigateToPreviousMainAccordionAfterSave(1);

        if(this.authService?.getUserDetailsFromStorage()?.isAmendByUWAdmin === "1"){
          this.requestQuoteService.resetPolicyParameterStepData(); // reset Policy parameter step
          this.requestQuoteService.onUpdateIndicationToQuoteStepData(true); // update Indication to Quote Step to receive data 
        }
        this.PolicyInfoSave.set(true);
        sessionStorage.setItem('PolicyInfoSave',JSON.stringify(true))
        this.onGetSystemUserMessage();
        // this.isapiCallSuccessful.set(true)
        if(this.isapiCallSuccessful()){
        this.router.navigate(['/quote']);          
      sessionStorage.removeItem('indicationId')    
      sessionStorage.removeItem('indicationAddressId');
        
      this.isapiCallSuccessful.set(false)
        }

      },
      error: (error) => {
        this.isapiCallSuccessful.set(false)
        this.toastService.addNotification({message: "System error. Policy Parameters failed. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    });
  }else{
    if(isSaveAndExit){
      this.router.navigate(['/quote']); // redirect user to landing page
      this.indicationQuoteService.removeIndicationQuoteStorageData();
      return;
    }
    // update the requestQuote Service
    this.requestQuoteService.resetPolicyParameterStepData(); // reset clearance step
    this.suppressCopePolicyParameterSave = true;
    this.navigateToPreviousMainAccordionAfterSave(1);
  }

}

  policyParameterIndicationQuoteSave(isSaveAndExit: boolean = false) {

     const cleanedPremium = this.cleanCurrencyValue(this.premium);
   if(!this.isReadOnly()){   

  if (!cleanedPremium || isNaN(cleanedPremium) || cleanedPremium <= 0) {
    this.showPremiumError = true;
    this.toastService.addNotification({ 
      message: "Target Premium Amount is required", 
      type: ToastType.Error 
    });
    return;
  } else {
    this.showPremiumError = false;
  }
   
    if (this.getTotalTIVLimit() > 2500000){

      this.toastService.addNotification({message: "Maximum TIV limit allowed is $2.5M. Please amend the limits entered or exit to return to landing page.", type: ToastType.Error}); // error notification
      return
    }

    if(this.selectedPolicyType() !==3){
    for (let i = 0; i < this.addressControls().length; i++) {
      const buildings = this.getPolicyParametersForAddress(i);
      for (let j = 0; j < buildings.length; j++) {
          const buildingLimit = buildings[j].get('buildingLimit')?.value;
          if (buildingLimit === 0 || buildingLimit === '0' || buildingLimit === '' || buildingLimit === null || buildingLimit === undefined) {
            this.openPolicyAddressAccordion(i);
            this.toastService.addNotification({message: "This type of policy must include building limits. Please edit policy parameters or exit to return to landing page", type: ToastType.Error}); // error notification
            return;
          }
      }}}

   if(this.selectedPolicyType() ===3){
    for (let i = 0; i < this.addressControls().length; i++) {
      const buildings = this.getPolicyParametersForAddress(i);
      for (let j = 0; j < buildings.length; j++) {
        const buildingLimit = buildings[j].get('buildingLimit')?.value;
          const businessPropertyLimit = buildings[j].get('businessPropertyLimit')?.value;
          const businessIncomeLimit = this.business[i];
          if ((businessPropertyLimit === 0 || businessPropertyLimit === '0' || businessPropertyLimit === '' || businessPropertyLimit === null || businessPropertyLimit === undefined) && (businessIncomeLimit === 0  || businessIncomeLimit === null || businessIncomeLimit === undefined) && (buildingLimit === 0 || buildingLimit === '0' || buildingLimit === '' || buildingLimit === null || buildingLimit === undefined)) {
            this.openPolicyAddressAccordion(i);
            this.toastService.addNotification({message: 'This type of policy must include I&B Limit, or BPP Limit or BI Limit. Please edit policy parameters or exit to return to landing page', type: ToastType.Error}); // error notification
            return ;
          }
      }}}

        // Validate Additional Property Coverages/Limit per address/structure
    this.structureValidationTriggered.set(true); // Trigger validation display
    for (let i = 0; i < this.addressControls().length; i++) {
      const structures = this.structureControlsForAddress(i);
      const total = structures.length;
      for (let j = 0; j < total; j++) {
        const error = this.getStructureError(i, j);
        if (error) {          
          this.openPolicyAddressAccordion(i);
          return;
        }
      }
    }
    if (this.hasPolicyValidationErrors()) {
      return;
    }
    }

  

     const quoteId = sessionStorage.getItem('quoteId');
      const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
      const userId = userDetails.userId;
      const building = sessionStorage.getItem('buildingid')
      const storedbuildingId = building ? JSON.parse(building) : ''
      
      const currentDate = new Date().toISOString();
      const addresses = this.addressControls().value;
      const indicationAddress = sessionStorage.getItem('indicationAddressId')
      const quoteAddress = sessionStorage.getItem('quoteAddressId')
      const address = this.isIndicationType() ? indicationAddress : quoteAddress
      const storedaddressId = address ? JSON.parse(address) : ''
      const otherStructureIds = JSON.parse(sessionStorage.getItem('otherStructureIds') || '[]');

      const indicationQuoteId = this.isIndicationType() ? this.authService.getUserDetailsFromStorage().indicationId : this.authService.getUserDetailsFromStorage().quoteId;     

      let totalBuildingIdIndex = 0; // Track overall building ID position, declared outside updatedAddresses

      const updatedAddresses = addresses.map((address: { structures: any[]; buildingDetails: any[]; }, addressIndex: number) => {
      let buildingIdIndexForAddress = 0; // Reset for each address

      const additionalPropertyCoverage = address.structures
          .filter((structure) => {
            const coverageLimit = structure.coverageLimit;
            const otherStructuresLimit = structure.otherStructuresLimit;
            const cleanedAmount = this.cleanCurrencyValue(otherStructuresLimit);
            return coverageLimit && coverageLimit !== '' && coverageLimit !== null && coverageLimit !== undefined && cleanedAmount !== null && cleanedAmount !== undefined && cleanedAmount > 0;
          })
          .map((structure) => {
            const otherDescription = structure.isOthersSelected ? structure.otherDescription : '';
            return {
              otherStructureId: 0,
              ...(this.isIndicationType()
                ? {
                    indicationId: Number(indicationQuoteId),
                    indicationAddressId: storedaddressId && storedaddressId.length > addressIndex ? storedaddressId[addressIndex] : 0,
                  }
                : {
                    quoteId: Number(indicationQuoteId),
                    quoteAddressId: storedaddressId && storedaddressId.length > addressIndex ? storedaddressId[addressIndex] : 0,
                  }),
              OtherStructureOtherDesc: otherDescription,
              otherStructureFactorId: structure.coverageLimit || null,
              otherStructureFactorAmount: this.cleanCurrencyValue(structure.otherStructuresLimit) || null,
              isDeleted: 0,
              createdUserId: userId,
              createdDate: currentDate,
              updatedUserId: userId,
              updatedDate: currentDate,
            };
          });

      return {
        addressid: storedaddressId && storedaddressId.length > addressIndex ? storedaddressId[addressIndex] : 0,
        businessIncomeLimit: this.cleanCurrencyValue(this.business[addressIndex]),
        ...(additionalPropertyCoverage.length > 0 ? { additionalPropertyCoverage } : {}),
        buildings: address.buildingDetails.map((buildingDetail) => {
          const buildingId = storedbuildingId && storedbuildingId.length > totalBuildingIdIndex ? storedbuildingId[totalBuildingIdIndex] : 0;
          totalBuildingIdIndex++; // Increment overall index
          buildingIdIndexForAddress++; // Increment address index

          return {
            buildingId: buildingId,
            buildingLimit: this.cleanCurrencyValue(buildingDetail.buildingLimit),
            businessPropertyLimit: this.cleanCurrencyValue(buildingDetail.businessPropertyLimit),
            OandLFlag: this.setOandLFlagOnPayload(buildingId),
          };
        }),
      };
    });



const payload = {
  userid: this.userId,
  targetPremium: cleanedPremium,
  policyStartDate: this.formData.startDate,
  policyEndDate: this.formData.endDate,
  causeOfLoss: this.formData.causeOfLoss,
  aopDeductibleId: this.formData.aopDeductibleId,
  aopDeductibleAmount: this.formData.aopDeductibleAmount,
  windDeductibleFlag: this.formData.windDeductibleFlag,
  windDeductibleId: this.formData.windDeductibleId,
  windDeductibleFactor: this.formData.windDeductibleFactor,
  propertyExtCoverageType: this.formData.propertyExtCoverageType,
  waterDamageId: this.formData.waterDamageId,
  waterDamageAmount: this.formData.waterDamageAmount,
  waterDamageDescription: this.formData.waterDamageDescription,
  vandalismId: this.formData.vandalismId,
  vandalismAmount: this.formData.vandalismAmount,
  vandalismDescription: this.formData.vandalismDescription,
  // aopDeductibleDescription: this.Aopdeductibles.filter((item) => String(item?.amount) === String(this.formData.aopDeductibleAmount))?.[0].description,
  // windDeductibleDescription: this.filterWindDeductible()?.filter((item) => String(item.factor) === String(this.formData.windDeductibleFactor))?.[0].description,
  aopDeductibleDescription: this.formData.aopDeductibleDescription,
  windDeductibleDescription: this.formData.windDeductibleDescription,
  addresses: updatedAddresses,
  totalCoverageA: 0,
  totalCoverageB: 0,
  totalCoverageC: 0,
  totalCoverageD: 0,
};

      
    this.isIndicationType() ? this.PolicyParametersIndication(payload, isSaveAndExit) : 
    this.PolicyParametersQuote(payload, isSaveAndExit)   
  }

   policyParameterIndicationQuoteSaveAccordian(isSaveAndExit: boolean = false, afterSave?: () => void) {

    if(this.suppressCopePolicyParameterSave){
      this.suppressCopePolicyParameterSave = false; 
      return; // Skip this save operation
    }

     const cleanedPremium = this.cleanCurrencyValue(this.premium);    
     if(!this.isReadOnly()){   

  if (!cleanedPremium || isNaN(cleanedPremium) || cleanedPremium <= 0) {
    this.showPremiumError = true;
    this.toastService.addNotification({ 
      message: "Target Premium Amount is required", 
      type: ToastType.Error 
    });
    return;
  } else {
    this.showPremiumError = false;
  }
   
    if (this.getTotalTIVLimit() > 2500000){

      this.toastService.addNotification({message: "Maximum TIV limit allowed is $2.5M. Please amend the limits entered or exit to return to landing page.", type: ToastType.Error}); // error notification
      return
    }

    if(this.selectedPolicyType() !==3){
    for (let i = 0; i < this.addressControls().length; i++) {
      const buildings = this.getPolicyParametersForAddress(i);
      for (let j = 0; j < buildings.length; j++) {
          const buildingLimit = buildings[j].get('buildingLimit')?.value;
          if (buildingLimit === 0 || buildingLimit === '0' || buildingLimit === '' || buildingLimit === null || buildingLimit === undefined) {
            this.openPolicyAddressAccordion(i);
            this.toastService.addNotification({message: "This type of policy must include building limits. Please edit policy parameters or exit to return to landing page", type: ToastType.Error}); // error notification
            return;
          }
      }}}

      if(this.selectedPolicyType() ===3){
    for (let i = 0; i < this.addressControls().length; i++) {
      const buildings = this.getPolicyParametersForAddress(i);
      for (let j = 0; j < buildings.length; j++) {
        const buildingLimit = buildings[j].get('buildingLimit')?.value;
          const businessPropertyLimit = buildings[j].get('businessPropertyLimit')?.value;
          const businessIncomeLimit = this.business[i];
          if ((businessPropertyLimit === 0 || businessPropertyLimit === '0' || businessPropertyLimit === '' || businessPropertyLimit === null || businessPropertyLimit === undefined) && (businessIncomeLimit === 0  || businessIncomeLimit === null || businessIncomeLimit === undefined) && (buildingLimit === 0 || buildingLimit === '0' || buildingLimit === '' || buildingLimit === null || buildingLimit === undefined)) {
            this.openPolicyAddressAccordion(i);
            this.toastService.addNotification({message: 'This type of policy must include I&B Limit, or BPP Limit or BI Limit. Please edit policy parameters or exit to return to landing page', type: ToastType.Error}); // error notification
            return;
          }
      }}}
          // Validate Additional Property Coverages/Limit per address/structure
    this.structureValidationTriggered.set(true); // Trigger validation display
    for (let i = 0; i < this.addressControls().length; i++) {
      const structures = this.structureControlsForAddress(i);
      const total = structures.length;
      for (let j = 0; j < total; j++) {
        const error = this.getStructureError(i, j);
        if (error) {          
          this.openPolicyAddressAccordion(i);
          return;
        }
      }
    }
    if (this.hasPolicyValidationErrors()) {
      return;
    }
    }
      const quoteId = sessionStorage.getItem('quoteId');
      const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
      const userId = userDetails.userId;
      const building = sessionStorage.getItem('buildingid')
      const storedbuildingId = building ? JSON.parse(building) : ''
      
      const currentDate = new Date().toISOString();
      const addresses = this.addressControls().value;
      const indicationAddress = sessionStorage.getItem('indicationAddressId')
      const quoteAddress = sessionStorage.getItem('quoteAddressId')
      const address = this.isIndicationType() ? indicationAddress : quoteAddress
      const storedaddressId = address ? JSON.parse(address) : ''
      const otherStructureIds = JSON.parse(sessionStorage.getItem('otherStructureIds') || '[]');

      const indicationQuoteId = this.isIndicationType() ? this.authService.getUserDetailsFromStorage().indicationId : this.authService.getUserDetailsFromStorage().quoteId;     

      let totalBuildingIdIndex = 0; // Track overall building ID position, declared outside updatedAddresses

      const updatedAddresses = addresses.map((address: { structures: any[]; buildingDetails: any[]; }, addressIndex: number) => {
      let buildingIdIndexForAddress = 0; // Reset for each address

      const additionalPropertyCoverage = address.structures
          .filter((structure) => {
            const coverageLimit = structure.coverageLimit;
            const otherStructuresLimit = structure.otherStructuresLimit;
            const cleanedAmount = this.cleanCurrencyValue(otherStructuresLimit);
            return coverageLimit && coverageLimit !== '' && coverageLimit !== null && coverageLimit !== undefined && cleanedAmount !== null && cleanedAmount !== undefined && cleanedAmount > 0;
          })
          .map((structure) => {
            const otherDescription = structure.isOthersSelected ? structure.otherDescription : '';
            return {
              otherStructureId: 0,
              ...(this.isIndicationType()
                ? {
                    indicationId: Number(indicationQuoteId),
                    indicationAddressId: storedaddressId && storedaddressId.length > addressIndex ? storedaddressId[addressIndex] : 0,
                  }
                : {
                    quoteId: Number(indicationQuoteId),
                    quoteAddressId: storedaddressId && storedaddressId.length > addressIndex ? storedaddressId[addressIndex] : 0,
                  }),
              OtherStructureOtherDesc: otherDescription,
              otherStructureFactorId: structure.coverageLimit || null,
              otherStructureFactorAmount: this.cleanCurrencyValue(structure.otherStructuresLimit) || null,
              isDeleted: 0,
              createdUserId: userId,
              createdDate: currentDate,
              updatedUserId: userId,
              updatedDate: currentDate,
            };
          });

      return {
        addressid: storedaddressId && storedaddressId.length > addressIndex ? storedaddressId[addressIndex] : 0,
        businessIncomeLimit: this.cleanCurrencyValue(this.business[addressIndex]),
        ...(additionalPropertyCoverage.length > 0 ? { additionalPropertyCoverage } : {}),
        buildings: address.buildingDetails.map((buildingDetail) => {
          const buildingId = storedbuildingId && storedbuildingId.length > totalBuildingIdIndex ? storedbuildingId[totalBuildingIdIndex] : 0;
          totalBuildingIdIndex++; // Increment overall index
          buildingIdIndexForAddress++; // Increment address index

          return {
            buildingId: buildingId,
            buildingLimit: this.cleanCurrencyValue(buildingDetail.buildingLimit),
            businessPropertyLimit: this.cleanCurrencyValue(buildingDetail.businessPropertyLimit),
            OandLFlag: this.setOandLFlagOnPayload(buildingId),
          };
        }),
      };
    });





const payload = {
  userid: this.userId,
  targetPremium: cleanedPremium,
  policyStartDate: this.formData.startDate,
  policyEndDate: this.formData.endDate,
  causeOfLoss: this.formData.causeOfLoss,
  aopDeductibleId: this.formData.aopDeductibleId,
  aopDeductibleAmount: this.formData.aopDeductibleAmount,
  windDeductibleFlag: this.formData.windDeductibleFlag,
  windDeductibleId: this.formData.windDeductibleId,
  windDeductibleFactor: this.formData.windDeductibleFactor,
  propertyExtCoverageType: this.formData.propertyExtCoverageType,
  waterDamageId: this.formData.waterDamageId,
  waterDamageAmount: this.formData.waterDamageAmount,
  waterDamageDescription: this.formData.waterDamageDescription,
  vandalismId: this.formData.vandalismId,
  vandalismAmount: this.formData.vandalismAmount,
  vandalismDescription: this.formData.vandalismDescription,
  // aopDeductibleDescription: this.Aopdeductibles.filter((item) => String(item?.amount) === String(this.formData.aopDeductibleAmount))?.[0].description,
  // windDeductibleDescription: this.filterWindDeductible()?.filter((item) => String(item.factor) === String(this.formData.windDeductibleFactor))?.[0].description,
  aopDeductibleDescription: this.formData.aopDeductibleDescription,
  windDeductibleDescription: this.formData.windDeductibleDescription,
  addresses: updatedAddresses,
  totalCoverageA: 0,
  totalCoverageB: 0,
  totalCoverageC: 0,
  totalCoverageD: 0,
};

    this.isIndicationType() ? this.PolicyParametersIndicationAccordianClose(payload, isSaveAndExit, afterSave) :
    this.PolicyParametersQuoteAccordianClose(payload, isSaveAndExit, afterSave)   
  }

  
  PolicyParametersSave(isSaveAndExit: boolean = false) {
     this.suppressCopePolicyParameterSave = true;
    if(this.isPolicyType()){
      this.policyMTAPolicyParameterSave();
    }else{
      this.policyParameterIndicationQuoteSave(isSaveAndExit);
    }
    //this.isIndicationType() ? this.PolicyParametersIndication(payload) : this.PolicyParametersQuote(payload)   
  }

PolicyParametersIndication(payload:any, isSaveAndExit: boolean = false){
  const requestBodyIndication = {
    indicationId:  this.authService.getUserDetailsFromStorage().indicationId,
    ...payload,
    
  };

  if(!this.isReadOnly()){ // call policyparameter save API when isReadonly is false
    this.PolicyInfoSave.set(false)
    this.addressService.PolicyStepIndication(requestBodyIndication).subscribe({
      next: (response) => {
        if(isSaveAndExit){
          this.router.navigate(['/quote']); // redirect user to landing page
          this.indicationQuoteService.removeIndicationQuoteStorageData();
          return;
        }
        this.step.set(3); 
        if(this.visitedStep() < 3) {
          this.visitedStep.update(i => i + 1);
        }
        if(this.authService?.getUserDetailsFromStorage()?.isAmendByUWAdmin === "1"){
          this.requestQuoteService.resetPolicyParameterStepData(); // reset Policy parameter step
          this.requestQuoteService.onUpdateIndicationToQuoteStepData(true); // update Indication to Quote Step to receive data 
        }
        this.PolicyInfoSave.set(true);
        sessionStorage.setItem('PolicyInfoSave',JSON.stringify(true))
        this.onGetSystemUserMessage();
        // this.isapiCallSuccessful.set(true)
        if(this.isapiCallSuccessful()){
        this.router.navigate(['/quote']);          
      sessionStorage.removeItem('indicationId')    
      sessionStorage.removeItem('indicationAddressId');
        
      this.isapiCallSuccessful.set(false)
        }

      },
      error: (error) => {
        this.isapiCallSuccessful.set(false)
        this.toastService.addNotification({message: "System error. Policy Parameters failed. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    });
  }else{
    if(isSaveAndExit){
      this.router.navigate(['/quote']); // redirect user to landing page
      this.indicationQuoteService.removeIndicationQuoteStorageData();
      return;
    }
    // update the requestQuote Service
    this.requestQuoteService.resetPolicyParameterStepData(); // reset clearance step
    this.step.set(3); // move to next step
    if(this.visitedStep() < 3) {
      this.visitedStep.update(i => i + 1);
    }
  }
}
PolicyParametersQuote(payload:any, isSaveAndExit: boolean = false){
  const requestBodyQuote = {
    quoteId:  this.authService.getUserDetailsFromStorage().quoteId,
    ...payload,
    
  }

  if(!this.isReadOnly()){ // call policyparameter save API when isReadonly is false
    this.PolicyInfoSave.set(false)
    this.addressService.PolicyStepQuote(requestBodyQuote).subscribe({
      next: (response) => {
        if(isSaveAndExit){
          this.router.navigate(['/quote']); // redirect user to landing page
          this.indicationQuoteService.removeIndicationQuoteStorageData();
          return;
        }
       
        this.step.set(3)
        this.setIndicationStep(1);
        const versionNo = Number(sessionStorage.getItem("versionNo"))

        if(!this.isUwAdmin()){
          if(versionNo === 4){
            this.setIndicationStep(1);
          }
      }

        if(this.visitedStep() < 3) {
          this.visitedStep.update(i => i + 1);
        }
        if(this.authService?.getUserDetailsFromStorage()?.isAmendByUWAdmin === "1"){
          this.requestQuoteService.resetPolicyParameterStepData(); // reset Policy parameter step
          this.requestQuoteService.onUpdateIndicationToQuoteStepData(true); // update Indication to Quote Step to receive data 
        }
        this.PolicyInfoSave.set(true);
        sessionStorage.setItem('PolicyInfoSave',JSON.stringify(true))
        this.onGetSystemUserMessage();
        // this.isapiCallSuccessful.set(true)
        if(this.isapiCallSuccessful()){
        this.router.navigate(['/quote']);          
      sessionStorage.removeItem('indicationId')    
      sessionStorage.removeItem('indicationAddressId');
        
      this.isapiCallSuccessful.set(false)
        }

      },
      error: (error) => {
        this.isapiCallSuccessful.set(false)
        this.toastService.addNotification({message: "System error. Policy Parameters failed. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    });
  }else{
    if(isSaveAndExit){
      this.router.navigate(['/quote']); // redirect user to landing page
      this.indicationQuoteService.removeIndicationQuoteStorageData();
      return;
    }
    // update the requestQuote Service
    this.requestQuoteService.resetPolicyParameterStepData(); // reset clearance step
    this.step.set(3); // move to next step
    if(this.visitedStep() < 3) {
      this.visitedStep.update(i => i + 1);
    }
  }

}




PolicyParametersIndicationAccordianClose(payload:any, isSaveAndExit: boolean = false, afterSave?: () => void){
  const requestBodyIndication = {
    indicationId:  this.authService.getUserDetailsFromStorage().indicationId,
    ...payload,
  };

  if(!this.isReadOnly()){ // call policyparameter save API when isReadonly is false
    this.PolicyInfoSave.set(false)
    this.addressService.PolicyStepIndication(requestBodyIndication).subscribe({
      next: (response) => {
        if(isSaveAndExit){
          this.router.navigate(['/quote']); // redirect user to landing page
          this.indicationQuoteService.removeIndicationQuoteStorageData();
          return;
        }
        
        if(this.authService?.getUserDetailsFromStorage()?.isAmendByUWAdmin === "1"){
          this.requestQuoteService.resetPolicyParameterStepData(); // reset Policy parameter step
          this.requestQuoteService.onUpdateIndicationToQuoteStepData(true); // update Indication to Quote Step to receive data 
        }
        this.PolicyInfoSave.set(true);
        sessionStorage.setItem('PolicyInfoSave',JSON.stringify(true))
        this.onGetSystemUserMessage();
        this.getCopeData(true);
        afterSave?.();
        if(this.isapiCallSuccessful()){
          this.router.navigate(['/quote']);          
          sessionStorage.removeItem('indicationId')    
          sessionStorage.removeItem('indicationAddressId');
          this.isapiCallSuccessful.set(false)
        }
      },
      error: (error) => {
        this.isapiCallSuccessful.set(false)
        this.toastService.addNotification({message: "System error. Policy Parameters failed. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    });
  }else{
    if(isSaveAndExit){
      this.router.navigate(['/quote']); // redirect user to landing page
      this.indicationQuoteService.removeIndicationQuoteStorageData();
      return;
    }
    // update the requestQuote Service
    this.requestQuoteService.resetPolicyParameterStepData(); // reset policy parameter step
    // No step navigation on accordion close
  }
}

PolicyParametersQuoteAccordianClose(payload:any, isSaveAndExit: boolean = false, afterSave?: () => void){
  const requestBodyQuote = {
    quoteId:  this.authService.getUserDetailsFromStorage().quoteId,
    ...payload,
  }

  if(!this.isReadOnly()){ // call policyparameter save API when isReadonly is false
    this.PolicyInfoSave.set(false)
    this.addressService.PolicyStepQuote(requestBodyQuote).subscribe({
      next: (response) => {
        if(isSaveAndExit){
          this.router.navigate(['/quote']); // redirect user to landing page
          this.indicationQuoteService.removeIndicationQuoteStorageData();
          return;
        }
        
        if(this.authService?.getUserDetailsFromStorage()?.isAmendByUWAdmin === "1"){
          this.requestQuoteService.resetPolicyParameterStepData(); // reset Policy parameter step
          this.requestQuoteService.onUpdateIndicationToQuoteStepData(true); // update Indication to Quote Step to receive data 
        }
        this.PolicyInfoSave.set(true);
        sessionStorage.setItem('PolicyInfoSave',JSON.stringify(true))
        this.onGetSystemUserMessage();
        this.getCopeData(true);
        afterSave?.();
        if(this.isapiCallSuccessful()){
          this.router.navigate(['/quote']);          
          sessionStorage.removeItem('indicationId')    
          sessionStorage.removeItem('indicationAddressId');
          this.isapiCallSuccessful.set(false)
        }
      },
      error: (error) => {
        this.isapiCallSuccessful.set(false)
        this.toastService.addNotification({message: "System error. Policy Parameters failed. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    });
  }else{
    if(isSaveAndExit){
      this.router.navigate(['/quote']); // redirect user to landing page
      this.indicationQuoteService.removeIndicationQuoteStorageData();
      return;
    }
    // update the requestQuote Service
    this.requestQuoteService.resetPolicyParameterStepData(); // reset policy parameter step
    // No step navigation on accordion close
  }
}

policyParameterMTA(payload:any) {
  const requestBody = {
    policyId: Number(this.authService.getUserDetailsFromStorage()?.policyId),
    ...payload,
  }

  if(!this.isReadOnly()){ // call policyparameter save API when isReadonly is false
    this.PolicyInfoSave.set(false)
    this.addressService.policyMTASave(requestBody).subscribe({
      next: (response) => {
        this.step.set(3);
        
        this.setIndicationStep(1) // move to step 4a
        if(this.visitedStep() < 3) {
          this.visitedStep.update(i => i + 1);
        }
        if(this.authService?.getUserDetailsFromStorage()?.isAmendByUWAdmin === "1"){
          this.requestQuoteService.resetPolicyParameterStepData(); // reset Policy parameter step
          this.requestQuoteService.onUpdateIndicationToQuoteStepData(true); // update Indication to Quote Step to receive data 
        }
        this.PolicyInfoSave.set(true);
        sessionStorage.setItem('PolicyInfoSave',JSON.stringify(true))
        this.onGetSystemUserMessage();
      },
      error: (error) => {
        this.toastService.addNotification({message: "System error. Policy Parameters failed. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    });
  }else{
    // update the requestQuote Service
    this.requestQuoteService.resetPolicyParameterStepData(); // reset clearance step
    this.step.set(3); // move to next step
    this.setIndicationStep(1) // move to step 4a
    if(this.visitedStep() < 3) {
      this.visitedStep.update(i => i + 1);
    }
  }
}


  Aopdeductibles: any[] = [];

loadAopDeductibles() {
  this.addressService.getAopDeductibles().subscribe((response) => {
    // Sort by amount ascending
    this.Aopdeductibles = response.sort((a: { amount: number; }, b: { amount: number; }) => a.amount - b.amount);
    const selected = this.Aopdeductibles.find(c => c.deductibleId === this.formData.aopDeductibleId);
    if (selected) {
      this.formData.aopDeductibleDescription = selected.description;
      this.formData.aopDeductibleAmount = selected.amount;
    }
  });
}


  onDeductibleChange(event: any) {
    const selectedId = Number(this.formData.aopDeductibleId);

    const selectedDeductible = this.Aopdeductibles.find(c => c.deductibleId === selectedId);
    if (selectedDeductible) {
      this.formData.aopDeductibleDescription = selectedDeductible.description;
      this.formData.aopDeductibleId = selectedDeductible.deductibleId;
      this.formData.aopDeductibleAmount = selectedDeductible.amount
    } else {
      this.formData.aopDeductibleAmount = null;
      this.formData.aopDeductibleDescription = '';
    }
    this.validateField('aopDeductibleAmount');
  }

  causeOfLossOptions: any[] = [];

  loadCauseOfLossOptions() {
    this.addressService.getCauseOfLossOptions().subscribe((response) => {
      this.causeOfLossOptions = response;
      if (this.hasSelection(this.formData.causeOfLoss)) {
        this.causeoflossCondition(Number(this.formData.causeOfLoss));
      }
    });
  }

  causeoflossCondition(selectedId:number){
    const selectedCause = this.causeOfLossOptions.find(c => c.gencodeId === selectedId);
    if (selectedCause) {
      this.formData.causeOfLoss = selectedCause.gencodeId;
      const description = selectedCause.description.toLowerCase();     

      if (description.includes("basic")) {
        this.selectedCauseOfLoss.set("basic")
        this.isPropertyExtCoverageDisabled.set(true); 
        this.formData.propertyExtCoverageType = null;
          // Water Coverage: Excluded
          const waterExcluded = this.waterDamageCoverages.find(w => w.description === "Water Coverage Excluded");
          if (waterExcluded) {
              this.formData.waterDamageAmount = waterExcluded.amount;
              this.formData.waterDamageId = waterExcluded.coverageId;
              this.formData.waterDamageDescription = waterExcluded.description;
              this.filterWaterCoverage.set([waterExcluded]); // Only show "Water Coverage Excluded"
          }

          // Theft Coverage: Excluded
          const theftExcluded = this.vandalismCoverages.find(v => v.description === "Theft Coverage Excluded");
          if (theftExcluded) {
              this.formData.vandalismAmount = theftExcluded.amount;
              this.formData.vandalismId = theftExcluded.coverageId;
              this.formData.vandalismDescription = theftExcluded.description;
              this.filterTheftCoverage.set([theftExcluded]); // Only show "Theft Coverage Excluded"
          }

      } else if (description.includes("broad")) {
        this.selectedCauseOfLoss.set("broad")
        this.isPropertyExtCoverageDisabled.set(true); 
        this.formData.propertyExtCoverageType = null;
          // Water Coverage: Policy Limits (all options available)
          const policyLimitsWater = this.waterDamageCoverages.find(w => w.description === "Policy Limits");
          if (policyLimitsWater) {
              this.formData.waterDamageAmount = policyLimitsWater.amount;
              this.formData.waterDamageId = policyLimitsWater.coverageId;              
              this.formData.waterDamageDescription = policyLimitsWater.description;
              this.filterWaterCoverage.set(this.waterDamageCoverages); // Show all water options
          }

          // Theft Coverage: Excluded
          const theftExcluded = this.vandalismCoverages.find(v => v.description === "Theft Coverage Excluded");
          if (theftExcluded) {
              this.formData.vandalismAmount = theftExcluded.amount;
              this.formData.vandalismId = theftExcluded.coverageId;
              this.formData.vandalismDescription = theftExcluded.description;
              this.filterTheftCoverage.set([theftExcluded]); // Only show "Theft Coverage Excluded"
          }
      } else { // Special - RCV or ACV (Default Behavior)
        this.isPropertyExtCoverageDisabled.set(false); 
        this.selectedCauseOfLoss.set("special")

          const defaultWater = this.waterDamageCoverages.find(w => w.description === "Policy Limits");
          if (defaultWater) {
              this.formData.waterDamageAmount = defaultWater.amount;
              this.formData.waterDamageId = defaultWater.coverageId;
              this.formData.waterDamageDescription = defaultWater.description;
              this.filterWaterCoverage.set(this.waterDamageCoverages); // Show all water options
          }

          const defaultTheft = this.vandalismCoverages.find(v => v.description === "Policy Limits");
          if (defaultTheft) {
              this.formData.vandalismAmount = defaultTheft.amount;
              this.formData.vandalismId = defaultTheft.coverageId;
              this.formData.vandalismDescription = defaultTheft.description;
              this.filterTheftCoverage.set(this.vandalismCoverages); // Show all theft options
          }
      }
  }
  }

  onCauseOfLossChange(event: any) {
    const selectedId = Number(this.formData.causeOfLoss);
    if (this.hasSelection(selectedId)) {
      this.causeoflossCondition(selectedId);
    } else {
      this.selectedCauseOfLoss.set('');
      this.filterWaterCoverage.set(this.waterDamageCoverages);
      this.filterTheftCoverage.set(this.vandalismCoverages);
      this.formData.waterDamageId = null;
      this.formData.waterDamageAmount = null;
      this.formData.waterDamageDescription = '';
      this.formData.vandalismId = null;
      this.formData.vandalismAmount = null;
      this.formData.vandalismDescription = '';
    }
    this.validateField('causeOfLoss');
    this.validateField('waterDamageId');
    this.validateField('vandalismId');
  
}

getRadioTooltip(): string | null {
  if (this.selectedCauseOfLoss() === "basic") { 
    return "Option not available with Basic Coverage Form.";
  } else if (this.selectedCauseOfLoss() === "broad") {
    return "Option not available with Broad Coverage Form";
  } else {
    return null; 
  }
}

getWaterTooltip(): string | null {
  if (this.selectedCauseOfLoss() === "basic") { 
    return "Water Coverage excluded with Basic Coverage Form";
  } else if (this.selectedCauseOfLoss() === "broad") {
    return "Water Coverage excluded with Broad Coverage Form";
  } else {
    return null; 
  }
}

getTheftTooltip(): string | null {
  if (this.selectedCauseOfLoss() === "basic") { 
    return "Theft Coverage excluded with Basic Coverage Form";
  } else if (this.selectedCauseOfLoss() === "broad") {
    return "Theft Coverage excluded with Broad Coverage Form";
  } else {
    return null; 
  }
}

sortDeductibles(data: any[]): any[] {
  return data.sort((a, b) => {
    const getSortValue = (desc: string): number => {
      if (desc && desc.toLowerCase().includes('same as aop')) return -1; // Pin to top
      if (desc.includes('Wind/Hail Excluded')) return 999; // Push to end
      const match = desc.match(/^([\d.]+)%/); // Extract percentage
      return match ? parseFloat(match[1]) : 998; // Fallback for unknown format
    };
 
    const aVal = getSortValue(a.description);
    const bVal = getSortValue(b.description);
 
    if (aVal !== bVal) return aVal - bVal;
    return a.description.localeCompare(b.description); // Secondary sort
  });
}


  loadWindDeductibles() {
    this.addressService.getWindDeductibles().subscribe((response) => {
      this.windDeductibles = response;
        this.windDeductibles = this.sortDeductibles(this.windDeductibles);
      this.applyWindHailCoverageRules();
     
    });
  }

  updateFilteredDeductibles() {
    if (this.shouldForceWindHailExcluded() || this.formData.windDeductibleFlag === 1) {
        // Show only "Wind/Hail Excluded"
        const filteredOptions = this.windDeductibles.filter(d => d.description === "Wind/Hail Excluded");
        this.filterWindDeductible.set(filteredOptions);
        const defaultOption = filteredOptions[0];
        if (defaultOption) {
            this.formData.windDeductibleFactor = defaultOption.factor;
            this.formData.windDeductibleId = defaultOption.deductibleId;
            this.formData.windDeductibleDescription = defaultOption.description;
        }
    } else {
        // Show the first four options (excluding "Wind/Hail Excluded")
        
        const filteredOptions = this.windDeductibles.filter(d => d.description !== "Wind/Hail Excluded");
        this.filterWindDeductible.set(filteredOptions);
        const selectedDeductible = filteredOptions.find(d => d.deductibleId === this.formData.windDeductibleId);
        if (!selectedDeductible) {
          this.formData.windDeductibleFactor = null;
          this.formData.windDeductibleId = null;
          this.formData.windDeductibleDescription = '';
        }
    }
}

  onWindDeductibleChange(event: any) {
    const selectedId = Number(this.formData.windDeductibleId);

    const selectedDeductible = this.windDeductibles.find(deductible => deductible.deductibleId === selectedId);

    if (selectedDeductible) {
      this.formData.windDeductibleFactor = selectedDeductible.factor;
      
      this.formData.windDeductibleId = selectedDeductible.deductibleId;
      this.formData.windDeductibleDescription = selectedDeductible.description;

    } else {
      this.formData.windDeductibleFactor = null;
      this.formData.windDeductibleDescription = '';
    }
    this.validateField('windDeductibleFactor');
  }
  waterDamageCoverages: any[] = [];

  loadWaterDamageCoverages() {
    this.addressService.getWaterDamageCoverages().subscribe(response => {
      this.waterDamageCoverages = response;
      this.filterWaterCoverage.set(response);
    });
  }
  

  onWaterDamageChange(event: any) {
    const selectedId = Number(this.formData.waterDamageId);
    const selectedCoverage = this.waterDamageCoverages.find(
      coverage => coverage.coverageId === selectedId
    );
  
    if (selectedCoverage) {
      this.formData.waterDamageId = selectedCoverage.coverageId;
      this.formData.waterDamageAmount = selectedCoverage.amount;
      
      this.formData.waterDamageDescription = selectedCoverage.description;
    } else {
      this.formData.waterDamageAmount = null;
      this.formData.waterDamageDescription = '';
    }
    this.validateField('waterDamageId');
  }

  vandalismCoverages: any[] = [];


  loadVandalismCoverages() {
    this.addressService.getVandalismCoverages().subscribe(response => {
      this.vandalismCoverages = response;
      this.filterTheftCoverage.set(response);
    });
  }
  onVandalismChange(event: any) {
    const selectedId = Number(this.formData.vandalismId);
  const selectedCoverage = this.vandalismCoverages.find(
    coverage => coverage.coverageId === selectedId
  );

  if (selectedCoverage) {
    this.formData.vandalismId = selectedCoverage.coverageId;
    this.formData.vandalismAmount = selectedCoverage.amount;
    this.formData.vandalismDescription = selectedCoverage.description;
  } else {
    this.formData.vandalismAmount = null;
    this.formData.vandalismDescription = '';
  }
  this.validateField('vandalismId');
  }

  oAndLCoverages: any[] = [];
  loadOAndLCoverages() {
    this.addressService.getOAndLCoverages().subscribe(response => {
      this.oAndLCoverages = response;
    });
  }

  onOAndLChange(event: any) {
    const selectedAmount = event.target.value;
    const selectedCoverage = this.oAndLCoverages.find(coverage => coverage.amount === +selectedAmount);

    if (selectedCoverage) {
      this.formData.oAndLCoverageId = selectedCoverage.coverageId;
      this.formData.oAndLCoverageDescription = selectedCoverage.description;
      this.formData.oAndLCoverageAmount = selectedCoverage.amount;
    } else {
    }
  }

  onCheckboxChange(event: any) {
    this.formData.windDeductibleFlag = event.target.checked ? 1 : 0;
    this.updateFilteredDeductibles();
    this.validateField('windDeductibleFactor');
  }

  factorOptions: any[] = [];
  isOthersSelected = false;
  otherDescription = '';

  loadCoverageFactors(): void {
    this.addressService.getCoverageFactors().subscribe((data) => {
      this.factorOptions = data;
  
      // After loading options, loop through all address -> structures to apply the condition
      this.addressControls().controls.forEach((addressGroup, addressIndex) => {
        const structuresArray = this.structureControlsForAddress(addressIndex);
        structuresArray.controls.forEach((structureGroup, structureIndex) => {
          const selectedValue = structureGroup.get('coverageLimit')?.value;
          const otherStructuresLimitControl = structureGroup.get('otherStructuresLimit');
  
          // Apply same logic as in onCoverageLimitChange
          structureGroup.get('isOthersSelected')?.setValue(selectedValue === '12');
  
          if (selectedValue === '') {
            otherStructuresLimitControl?.reset();
            otherStructuresLimitControl?.disable();
          } else if (!this.isReadOnly()) {
            otherStructuresLimitControl?.enable();
          }
        });
      });
    });
  }
  
  

  onCoverageLimitChange(event: Event, addressIndex: number, structureIndex: number): void {
    const selectedValue = (event.target as HTMLSelectElement).value;
    
    const structureGroup = this.structureControlsForAddress(addressIndex).at(structureIndex) as FormGroup;
  
    // Determine if the selected option is "Others"
    const isOthers = selectedValue === '12';
    structureGroup.get('isOthersSelected')?.setValue(isOthers);
  
    const otherStructuresLimitControl = structureGroup.get('otherStructuresLimit');
    const otherDescriptionControl = structureGroup.get('otherDescription');
  
    if (selectedValue === '') {
      otherStructuresLimitControl?.reset(); 
      otherStructuresLimitControl?.disable();
      // Remove required validator from otherDescription when not "Others"
      otherDescriptionControl?.clearValidators();
      otherDescriptionControl?.setValidators([Validators.maxLength(64)]);
      otherDescriptionControl?.updateValueAndValidity();
    } else {
      otherStructuresLimitControl?.enable();
      // Add required validator to otherDescription when "Others" is selected
      if (isOthers) {
        otherDescriptionControl?.setValidators([Validators.required, noWhitespaceValidator, Validators.maxLength(64)]);
      } else {
        otherDescriptionControl?.clearValidators();
        otherDescriptionControl?.setValidators([Validators.maxLength(64)]);
        otherDescriptionControl?.reset();
      }
      otherDescriptionControl?.updateValueAndValidity();
    }
    // Reset validation trigger when user makes changes (errors will clear)
    this.structureValidationTriggered.set(false);
    this.calculateTotals();
  }

  getStructureCoverageError(addressIndex: number, structureIndex: number): string | null {
    // Only show errors if validation has been triggered (Next button clicked)
    if (!this.structureValidationTriggered()) {
      return null;
    }

    const structures = this.structureControlsForAddress(addressIndex);
    const totalStructures = structures.length;
    if (totalStructures === 0) {
      return null;
    }

    const structureGroup = structures.at(structureIndex) as FormGroup;
    const coverageLimit = structureGroup.get('coverageLimit')?.value;
    const hasCoverage = !!coverageLimit && coverageLimit !== '' && coverageLimit !== null && coverageLimit !== undefined;

    // Only show coverage error if coverage is missing (not if limit is missing)
    if (totalStructures > 1 && !hasCoverage) {
      return 'Additional Property Coverages is required';
    }

    return null;
  }

  getStructureLimitError(addressIndex: number, structureIndex: number): string | null {
    // Only show errors if validation has been triggered (Next button clicked)
    if (!this.structureValidationTriggered()) {
      return null;
    }

    const structures = this.structureControlsForAddress(addressIndex);
    const totalStructures = structures.length;
    if (totalStructures === 0) {
      return null;
    }

    const structureGroup = structures.at(structureIndex) as FormGroup;
    const coverageLimit = structureGroup.get('coverageLimit')?.value;
    const otherStructuresLimit = structureGroup.get('otherStructuresLimit')?.value;

    const hasCoverage = !!coverageLimit && coverageLimit !== '' && coverageLimit !== null && coverageLimit !== undefined;
    const hasLimit = otherStructuresLimit !== '' && otherStructuresLimit !== null && otherStructuresLimit !== undefined && this.cleanCurrencyValue(otherStructuresLimit) > 0;   
    
    if (totalStructures > 1 && !hasLimit) {
      return 'Additional Property Coverages Limit is required';
    } else if (totalStructures === 1 && hasCoverage && !hasLimit) {
      return 'Additional Property Coverages Limit is required';
    }

    return null;
  }

  getStructureOthersDescriptionError(addressIndex: number, structureIndex: number): string | null {
    // Only show errors if validation has been triggered (Next button clicked)
    if (!this.structureValidationTriggered()) {
      return null;
    }

    const structures = this.structureControlsForAddress(addressIndex);
    const totalStructures = structures.length;
    if (totalStructures === 0) {
      return null;
    }

    const structureGroup = structures.at(structureIndex) as FormGroup;
    const coverageLimit = structureGroup.get('coverageLimit')?.value;
    const otherDescription = structureGroup.get('otherDescription')?.value;
    const isOthersSelected = coverageLimit === '12' || coverageLimit === 12;

    // Show error if "Others" is selected but description is empty
    if (isOthersSelected) {
      const hasDescription = otherDescription && otherDescription.trim() !== '' && otherDescription !== null && otherDescription !== undefined;
      if (!hasDescription) {
        return 'Others Description is required';
      }
    }

    return null;
  }

  getStructureError(addressIndex: number, structureIndex: number): string | null {
    // This method is kept for backward compatibility but should use the specific methods
    const coverageError = this.getStructureCoverageError(addressIndex, structureIndex);
    const limitError = this.getStructureLimitError(addressIndex, structureIndex);
    const othersDescriptionError = this.getStructureOthersDescriptionError(addressIndex, structureIndex);
    return coverageError || limitError || othersDescriptionError;
  }

  canAddAdditionalStructure(addressIndex: number): boolean {
    const structures = this.structureControlsForAddress(addressIndex);
    if (structures.length === 0) {
      return false;
    }
    
    const lastStructureIndex = structures.length - 1;
    const lastStructure = structures.at(lastStructureIndex) as FormGroup;
    
    const coverageLimit = lastStructure.get('coverageLimit')?.value;
    const otherStructuresLimit = lastStructure.get('otherStructuresLimit')?.value;
    
    // Check if both fields have values
    const hasCoverageLimit = coverageLimit && coverageLimit !== '' && coverageLimit !== null && coverageLimit !== undefined;
    const hasOtherStructuresLimit = otherStructuresLimit && 
      otherStructuresLimit !== '' && 
      otherStructuresLimit !== null && 
      otherStructuresLimit !== undefined &&
      this.cleanCurrencyValue(otherStructuresLimit) > 0;
    
    return hasCoverageLimit && hasOtherStructuresLimit;
  }
  

  onOtherDescriptionChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.otherDescription = inputElement.value;
    // Reset validation trigger when user makes changes (errors will clear)
    this.structureValidationTriggered.set(false);
  }

  today = new Date().toISOString().split('T')[0];
  monthsRange = Array.from({ length: 13 }, (_, i) => i + 6); // Create an array from 6 to 18
  minEndDate: string = '';

  shouldShowDays(): boolean {
    return !!this.formData.startDate && !!this.formData.endDate && (this.formData.daysDifference ?? 0) > 0;
  }

  private computePolicyPeriodMonthsAndDays():
    | { months: number; days: number }
    | null {
    if (!this.formData.startDate || !this.formData.endDate) return null;

    const startDate = moment(this.formData.startDate, 'YYYY-MM-DD', true);
    const endDate = moment(this.formData.endDate, 'YYYY-MM-DD', true);
    if (!startDate.isValid() || !endDate.isValid()) return null;

    // Whole months between start and end
    let months = endDate.diff(startDate, 'months');

    // Remainder days after removing whole months
    let anchor = startDate.clone().add(months, 'months');
    let days = endDate.diff(anchor, 'days');

    // Defensive: if anchor overshot due to month boundary behavior, step back a month
    if (days < 0) {
      months = months - 1;
      anchor = startDate.clone().add(months, 'months');
      days = endDate.diff(anchor, 'days');
    }

    return { months, days };
  }

  private syncPolicyPeriodFromDates(): void {
    const period = this.computePolicyPeriodMonthsAndDays();
    if (!period) {
      this.formData.daysDifference = 0;
      return;
    }

    this.formData.monthsDifference = period.months;
    this.formData.daysDifference = period.days;
  }

  onStartDateChange(): void {
    this.validateField('startDate');

    // Use moment.js to parse the start date
    const startDate = moment(this.formData.startDate);

    // Calculate the max allowable end date as 18 months after the start date
    const maxEndDate = startDate.clone().add(18, 'months');
    this.policyEndDateMax.set(maxEndDate.format('YYYY-MM-DD'));

    // Calculate the end date as 1 year after the start date
    const endDate = startDate.clone().add(1, 'year');
    this.formData.endDate = endDate.format('YYYY-MM-DD'); // Set the end date as ISO string
    
    // Update minEndDate (Minimum selectable end date)
    this.minEndDate = startDate.clone().add(6, 'months').format('YYYY-MM-DD'); // 6 months after the start date
    this.policyEndDateMin.set(startDate.clone().add(6, 'months').format('YYYY-MM-DD'));

    // Calculate the difference between the start and end dates in months using moment
    const monthsDifference = endDate.diff(startDate, 'months'); // This calculates the difference in months
    
    // Assign the calculated months difference to the form data
    this.formData.monthsDifference = monthsDifference;
    this.formData.daysDifference = 0;

    // Revalidate end date field
    this.validateField('endDate');
}
    onEndDateChange(): void {
        // Use moment.js to parse the end date and start date
        const startDate = moment(this.formData.startDate);
        const endDate = moment(this.formData.endDate);

        // Validate that the end date is at least 6 months after the start date
        if (endDate.isBefore(startDate.clone().add(6, 'months'))) {
            this.validationMessages['endDate'] = 'End date must be at least 6 months after start date.';
        } else {
            this.validationMessages['endDate'] = '';
        }
        const maxEndDate = startDate.clone().add(18, 'months');
    this.policyEndDateMax.set(maxEndDate.format('YYYY-MM-DD'));
    this.minEndDate = startDate.clone().add(6, 'months').format('YYYY-MM-DD'); // 6 months after the start date
    this.policyEndDateMin.set(startDate.clone().add(6, 'months').format('YYYY-MM-DD'));

        // Calculate months + days (days shown only when non-zero)
        this.syncPolicyPeriodFromDates();

        this.validateField('endDate');
    }

    onMonthsDifferenceChange(): void {
        // Use moment.js to calculate the end date based on the selected months difference
        const startDate = moment(this.formData.startDate);
        const endDate = startDate.clone().add(this.formData.monthsDifference, 'months');

        // Set the end date in the form
        this.formData.endDate = endDate.format('YYYY-MM-DD');
        this.formData.daysDifference = 0;
        
        // Update the minimum allowed end date (6 months after start date)
        this.minEndDate = startDate.clone().add(6, 'months').format('YYYY-MM-DD');
    }
  
  updateCountyAndCityList(index: number, countiesList: any[] = [], citiesList: any[] = []) {
    this.counties.update((map) => map.set(index, countiesList));
    this.cities.update((map) => map.set(index, citiesList));
    this.filteredCounty.update((map) => map.set(index, countiesList));
    this.filteredCity.update((map) => map.set(index, citiesList));
    this.isCityStateListFetched.set(true);
  }
  
  
  updateStateList(index: number, stateList: any[], stateIDList: any[]) {
    const filteredStates = stateList.filter(state => stateIDList.includes(state.stateId));
    this.states.update((map) => map.set(index, filteredStates));
    this.filteredStates.update((map) => map.set(index, filteredStates));
    
    const state = Array.from(this.filteredStates().values()).flat().find(s => s.stateId === stateIDList[0]);;
    this.OnStateRules(state)

  }

  fetchCountyAndCity(stateId: number, index: number, stateList: any[], countiesList: any[] = [], citiesList: any[] = []){
    this.isLoading.set(true);
    forkJoin([
      this.addressService.getStates(),
      this.addressService.getCounties(stateId),
      this.addressService.getCities(stateId),
    ]).pipe(
      map(([statesList, countyList, cityList]) => { return {statesList, countyList, cityList}})
    ).subscribe({
      next: (response: any) => {
          if(response){
            this.isLoading.set(false);
            this.updateStateList(index, response.statesList, stateList);
            
            const countiesSortedList = this.propertyService.sortCountyRecords(response.countyList);
            const citiesSortedList = this.propertyService.sortCityRecords(response.cityList);
            if(countiesList?.length > 0 && citiesList?.length > 0){
              const filteredCounties = countiesSortedList.filter(county => countiesList.includes(county.countyId));
              
              const filteredCities = citiesSortedList.filter(city => citiesList.includes(city.cityId));
              
              this.updateCountyAndCityList(index, filteredCounties, filteredCities);
            }else{
              this.updateCountyAndCityList(index, countiesSortedList, citiesSortedList);
            }
          }
      },
      error: (error: any) => {
          this.isLoading.set(false);
          this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    })
  }

  loadStates():void{
    this.addressService.getStates().subscribe({
      next: (response: any) => {
        if(response){
          // this.states.set(response);
          // this.filteredStates.set(response);
          this.masterStateList.set(response);
          // const ruleNames = response.map((state: any) => state.ruleName);
          // this.stateConditionSignal.set(ruleNames);
        }
      },
      error: (error: any) => {
      }
    })
  }

  onStateSearch(index: number, event: Event) {
    const value = (event.target as HTMLInputElement).value; 

    this.propertyService.applyDelayedFilter(`state-${index}`, 1200, () => {
      this.updateStateSearchTerm(index, value);
    });
  }

  updateStateSearchTerm(index: number, value: string) {
    // const value = event.target ? (event.target as HTMLInputElement).value : '';

    this.searchState.update((map) => map.set(index, value));
    const states = this.states().get(index) || [];
    const filtered = states.filter((state) =>
      state.stateName.toLowerCase().includes(value.toLowerCase())
    );
    this.filteredStates.update((map) => map.set(index, filtered));
  }

  onCountySearch(index: number, event: Event) {
    const value = (event.target as HTMLInputElement).value; 

    this.propertyService.applyDelayedFilter(`county-${index}`, 1200, () => {
      this.updateCountySearchTerm(index, value);
    });
  }

  updateCountySearchTerm(index: number, value: string) {
    //const value = event.target ? (event.target as HTMLInputElement).value : '';
    this.searchCounty.update((map) => map.set(index, value));
    const counties = this.counties().get(index) || [];
    const filtered = counties.filter((county) =>
      county.countyName.toLowerCase().includes(value.toLowerCase())
    );
    this.filteredCounty.update((map) => map.set(index, filtered));
  }

  fetchStateByZipCode(index: number, zipcode: string) {
    this.propertyService.getZipCode(zipcode).subscribe({
      next: (response: any) => {
        if(response && response?.State?.length > 0){
          //this.updateStateList(index, response?.State); // update State List
          this.fetchCountyAndCity(response?.State[0], index, response?.State, response?.County, response?.City);
          this.addressControls().at(index).patchValue({city: response?.City[0], country: response?.County[0], state: response?.State[0]});         
          
        }else{
          this.toastService.addNotification({message: "Invalid Zip Code, please enter a valid Zip Code", type: ToastType.Error}); // error notification
          this.addressControls().at(index).patchValue({city: '', country: '', state: ''});
          this.states.update((map) => map.set(index, [])); // reset the list for invalid record
          this.counties.update((map) => map.set(index, [])); // reset the list for invalid record
          this.cities.update((map) => map.set(index, [])); // reset the list for invalid record
          this.filteredStates.update((map) => map.set(index, [])); // reset the list for invalid record
          this.filteredCounty.update((map) => map.set(index, [])); // reset the list for invalid record
          this.filteredCity.update((map) => map.set(index, [])); // reset the list for invalid record
        }
      },
      error: (error: any) => {
        this.addressControls().at(index).patchValue({city: '', country: '', state: ''});
        this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    })
  }

  onZipCodeBlur(index: number) {
    const zipcode = this.addressControls().at(index).get('zipcode')?.value;
    if (zipcode?.length >= 1) {
      this.fetchStateByZipCode(index, zipcode);
    }
  }

  onCitySearch(index: number, event: Event) {
    const value = (event.target as HTMLInputElement).value; 

    this.propertyService.applyDelayedFilter(`city-${index}`, 1200, () => {
      this.updateCitySearchTerm(index, value);
    });
  }

  updateCitySearchTerm(index: number, value: string) {
    //const value = event.target ? (event.target as HTMLInputElement).value : '';
    this.searchCity.update((map) => map.set(index, value));
    const cities = this.cities().get(index) || [];
    const filtered = cities.filter((city) =>
      city.cityName.toLowerCase().includes(value.toLowerCase())
    );
    this.filteredCity.update((map) => map.set(index, filtered));
  }

  onOccupancySearch(index: number, event: Event) {
    const value = (event.target as HTMLInputElement).value; 

    this.propertyService.applyDelayedFilter(`occupancy-${index}`, 1200, () => {
      this.updateOccupancySearchTerm(index, value);
    });
  }

  updateOccupancySearchTerm(index: number, value: string) {
    //const value = event.target ? (event.target as HTMLInputElement).value : '';
    const terms = [...this.searchOccupancy()];
    terms[index] = value;
    this.searchOccupancy.set(terms);
    const filtered = this.Occupancies().filter((occupancy) =>
      occupancy.description.toLowerCase().includes(value.toLowerCase())
    );
    this.filteredOccupancy.set(filtered);
  }
  
  // reset filtered states options
  onStateDropdownOpened(index: number, isOpen: boolean, inputElement: HTMLInputElement) {
    if (!isOpen) {
      this.searchState.update((map) => map.set(index, ''));
      const states = this.states().get(index) || [];
      this.filteredStates.update((map) => map.set(index, states));
    }else{
      setTimeout(() => {
        inputElement?.focus();
      }, 100);
    }
  }
  // reset filtered county options
  onCountyDropdownOpened(index: number, isOpen: boolean, inputElement: HTMLInputElement) {
    if (!isOpen) {
      this.searchCounty.update((map) => map.set(index, ''));
      const counties = this.counties().get(index) || [];
      this.filteredCounty.update((map) => map.set(index, counties));
    }else{
      setTimeout(() => {
        inputElement?.focus();
      }, 100);
    }
  }
  // reset filtered city options
  onCityDropdownOpened(index: number, isOpen: boolean, inputElement: HTMLInputElement) {
    if (!isOpen) {
      this.searchCity.update((map) => map.set(index, ''));
      const cities = this.cities().get(index) || [];
      this.filteredCity.update((map) => map.set(index, cities));
    }else{
      setTimeout(() => {
        inputElement?.focus();
      }, 100);
    }
  }
  // reset filtered occupancy options
  onOccupancyDropdownOpened(index: number, isOpen: boolean, inputElement: HTMLInputElement) {
    if (!isOpen) {
      const terms = [...this.searchOccupancy()];
      terms[index] = '';
      this.searchOccupancy.set(terms);
      const filtered = [...this.Occupancies()];
      this.filteredOccupancy.set(filtered);
    }else{
      setTimeout(() => {
        inputElement?.focus();
      }, 100);
    }
  }

  getPolicyTypes():void{
    this.addressService.getPolicyTypes().subscribe(
      (data) => this.policyTypes.set(data),      
      (error) =>  {}
    );  
  }

  getOccupaniesList():void{
    this.addressService.getOccupanciesList().subscribe(
      (data) => {
        const sortedData = data.sort((a, b) => a.description.localeCompare(b.description));
        this.Occupancies.set(sortedData);
        this.filteredOccupancy.set(sortedData);
      },
      (error) =>  {}
    )
  }

  getPropertyCoverages():void{
    this.addressService.getPropertyEnhancementCoverages().subscribe(
      (data) => this.coverageType.set(data),
      (error) =>  {}
    )
  }

  disableWindOptions: boolean = false;



  formData = {
    startDate: '',
    endDate: '',
    monthsDifference:12,
    daysDifference: 0,
    aopDeductibleId: null as number | null,
    aopDeductibleAmount: null as number | null,
    aopDeductibleDescription:'',
    windDeductibleFactor: null as number | null,
    windDeductibleId: null as number | null,
    windDeductibleDescription:'',
    waterDamageAmount: null as number | null,
    waterDamageId: null as number | null,
    waterDamageDescription: '',
    vandalismAmount: null as number | null,
    vandalismId: null as number | null,
    vandalismDescription: '',
    oAndLCoverageId: 0,
    oAndLCoverageAmount: 0,
    oAndLCoverageDescription: '',
    causeOfLoss: null as number | null,
    propertyExtCoverageType: null as number | null,
    windDeductibleFlag: this.shouldForceWindHailExcluded() ? 1 : 0,
    businessIncomeLimit: 0
  };

  onRadioClick(selectedValue: number) {
    // If the current radio button is clicked again (i.e., already selected), set the value to null (deselect)
    if (this.formData.propertyExtCoverageType === selectedValue) {
      this.formData.propertyExtCoverageType = null;
    } else {
      // Otherwise, set the selected value
      this.formData.propertyExtCoverageType = selectedValue;
    }
  }
  
  waterDamageOptions: any[] = [];
  windDeductibles: any[] = [];
  filterWindDeductible = signal<any[]>([])
  filterWaterCoverage = signal<any[]>([])
  filterTheftCoverage = signal<any[]>([])
  isPropertyExtCoverageDisabled = signal<boolean>(false);
  buildingLimit: number = 0;
  businessPropertyLimit: number = 0;
  businessIncomeLimit: number = 0;
  additionalCoverageLimit: number = 0;

  totalBPPBuildingsLimit: number = 0;
  totalBuildingLimit: number = 0;
  totalBPPPropertyLimit: number = 0;
  totalStructuresLimit: number = 0;
  // totalBusinessIncomeLimits: string = '';

  totalBuildingLimits: number[] = [];
  totalBPPPropertyLimits: number[] = [];
  totalBusinessIncomeLimits: number[] = [];
  totalStructuresLimits: number[] = [];
  
  
  // calculateTotals(): void {  
  //   this.totalBuildingLimit = 0;
  //   this.totalBPPPropertyLimit = 0;
  //   this.totalStructuresLimit = 0;
   
  //     this.addressControls().controls.forEach((addressControl, index) => {
  //     const structuresArray = this.structureControlsForAddress(index);
  
  //     structuresArray.controls.forEach((structureControl, sIndex) => {
  //       let rawValue = structureControl.get('otherStructuresLimit')?.value || 0;
  //       const numericValue = Number(String(rawValue).replace(/,/g, ''));
  //       this.totalStructuresLimit += numericValue;
  //     });
  //   });
  
  //   this.addressControls().controls.forEach((addressControl, index) => {
  //     const buildingArray = this.buildingControlsForAddress(index);
  
  //     buildingArray.controls.forEach((buildingControl, bIndex) => {
  //       let rawValue = buildingControl.get('buildingLimit')?.value || 0;
  //       const numericValue = Number(String(rawValue).replace(/,/g, ''));
  //       this.totalBuildingLimit += numericValue;
  //     });
  //   });
  
  //   this.addressControls().controls.forEach((addressControl, index) => {
  //     const buildingArray = this.buildingControlsForAddress(index);
  
  //     buildingArray.controls.forEach((buildingControl, bIndex) => {
  //       let rawValue = buildingControl.get('businessPropertyLimit')?.value || 0;
  //       const numericValue = Number(String(rawValue).replace(/,/g, ''));
  //       this.totalBPPPropertyLimit += numericValue;
  //     });
  //   });
  
  //   this.totalBusinessIncomeLimit = this.business.reduce((acc, curr) => acc + curr, 0);
  
  // }
  
  calculateTotals(): void {
    this.totalBuildingLimits = [];
    this.totalBPPPropertyLimits = [];
    this.totalBusinessIncomeLimits = [];
    this.totalStructuresLimits = [];
  
    this.addressControls().controls.forEach((addressControl, index) => {
      let buildingTotal = 0;
      let bppTotal = 0;
      let structureTotal = 0;
      let businessIncome = 0;
  
      const buildingArray = this.buildingControlsForAddress(index);
      buildingArray.controls.forEach((buildingControl) => {
        buildingTotal += +String(buildingControl.get('buildingLimit')?.value || 0).replace(/,/g, '');
        bppTotal += +String(buildingControl.get('businessPropertyLimit')?.value || 0).replace(/,/g, '');
      });
  
      const structuresArray = this.structureControlsForAddress(index);
      structuresArray.controls.forEach((structureControl) => {
        structureTotal += +String(structureControl.get('otherStructuresLimit')?.value || 0).replace(/,/g, '');
      });
  
      businessIncome = this.business[index] || 0;
  
      this.totalBuildingLimits[index] = buildingTotal;
      this.totalBPPPropertyLimits[index] = bppTotal;
      this.totalStructuresLimits[index] = structureTotal;
      this.totalBusinessIncomeLimits[index] = businessIncome;
    });
  }
  



// isReadOnly: WritableSignal<boolean> = signal(true);

  addOAndLCoverage() {
    const newCoverage = this.fb.group({
      premisesAddress: [''],
      premisesBuilding: [''],
      isPremisesChecked: [false]
    });

    this.oAndLCoverages.push(newCoverage);
  }

  // Method to get the oAndLCoverages FormArray
  get oAndLCoverage() {
    return this.policyOAndLForm.get('oAndLCoverage') as FormArray;
  }

  setOandLCoverage(addressList: any[]) {
   const oAndLCoverageArray = this.policyOAndLForm.get('oAndLCoverage') as FormArray;
   oAndLCoverageArray.clear(); // Clears all the controls inside the FormArray
   const updatedAddressList = this.propertyService.updateToBuildingListByAddressId(addressList);
   updatedAddressList.forEach((address) => {
    const addressName = `${address.streetNum} ${address.streetName} ${address.city} ${address.state} ${address.county}`
    const oandlChecked = address?.oandLFlag === 1 ? true : false;
    const newCoverage = this.fb.group({
      buildingId: [address.buildingId],
      premisesAddress: [addressName],  // Empty string as default value
      premisesBuilding: [address.buildingNum],  // Empty string as default value
      isPremisesChecked: [oandlChecked]  // Default to false
    }); 
    this.oAndLCoverage.push(newCoverage);
   })
  }

  isUwAdmin(): boolean {
    const role = sessionStorage.getItem('role')
    return role === "2";
  }

  isSysAdmin(): boolean {
    return this.role === 3;
  }

  isBroker(): boolean {
    return this.role ===1;
  }

  isIndicationType(): boolean {
    const quoteType = sessionStorage.getItem('quoteType');
    return quoteType === "indication";
  }

  makeEditable(): void { 
    this.isTargetOther.set(false);   
      this.step.update(i => i - 3);
      this.setVisitedStep(0); // reset visited step for accordion validation
      this.isReadOnly.set(false);   
      this.getClearanceData();
          const currentAccordionStepId = sessionStorage.getItem('currentStepId');
          if(!this.isPolicyType()){
            this.fetchRiskSummaryData();
            this.getRagData();
          }  
      this.onGetSystemUserMessage(); // update message center
      this.checkConditions();
      if(!this.isPolicyType()){
        if(this.isIndicationType()){           
          this.fetchIndicationRagdetails()
        }else{
          this.fetchQuoteRagdetails()
        }
      }
  }

  amend(data:boolean){
    if(data){
      this.makeEditable();
    }
  }

  TargetPremiumReadonly(data:boolean){
    if(data){
      this.isTargetOther.set(true);
    }
  }

  setIndicationConfigData(response: any) {
    if (response?.indication) {
      const { indicationId, branchId, indicationNo, nameInsured, indicationStatus } = response.indication;
      const addressList = response.indication.addresses;
      const addressIdList: any[] = addressList.map((address: any) => address.indicationAddressId);

      this.indicationDetails.set({ indicationId: indicationId, branchId: branchId, indicationNo: indicationNo, indicationAddressId: addressIdList, nameInsured: nameInsured, indicationStatus: indicationStatus });
      if (typeof sessionStorage !== "undefined") {
        sessionStorage.setItem("indicationId", String(indicationId));
        sessionStorage.setItem("branchId", String(branchId));
        sessionStorage.setItem("nameInsured", String(nameInsured));
        sessionStorage.setItem("indicationNo", String(indicationNo));
        sessionStorage.setItem("indicationStatus", String(indicationStatus));
        sessionStorage.setItem('indicationAddressId',JSON.stringify(addressIdList));
        this.indicationId.set(indicationId)
      }
    }
  }

  setQuoteConfigData(response: any) {
    if (response?.quote) {
      const { quoteId, branchId, quoteNo, nameInsured, quoteStatus } = response.quote;
      const addressList = response.quote.addresses;
      const addressIdList: any[] = addressList.map((address: any) => address.quoteAddressId);
      const addressTypeId: any[] = addressList.map((address: any) => address.addressTypeId)

      this.quoteDetails.set({ quoteId: quoteId, branchId: branchId, quoteNo: quoteNo, quoteAddressId: addressIdList,addressTypeId: addressTypeId, nameInsured: nameInsured, quoteStatus: quoteStatus });
      if (typeof sessionStorage !== "undefined") {
        sessionStorage.setItem("quoteId", String(quoteId));
        sessionStorage.setItem("branchId", String(branchId));
        sessionStorage.setItem("nameInsured", String(nameInsured));
        sessionStorage.setItem("quoteNo", String(quoteNo));
        sessionStorage.setItem("quoteStatus", String(quoteStatus));
        sessionStorage.setItem('quoteAddressId',JSON.stringify(addressIdList));
        sessionStorage.setItem('addressTypeId',JSON.stringify(addressTypeId));

        this.quoteId.set(quoteId)
      }
    }
  }

  setPolicyDetailsConfigData(response: any) {
    if (response?.policy) {
      const {
        policyId,
        quoteId,
        branchId,
        policyNo,
        policyDate,
        nameInsured,
        policyStartDate,
        policyEndDate,
        policyStatus,
      } = response.policy;
      const resolvedPolicyId = policyId ?? response.policy.id ?? null;
      const addressList = response.policy.addresses;
      const addressIdList: any[] = addressList.map((address: any) => address.policyAddressId);
      const addressTypeId: any[] = addressList.map((address: any) => address.addressTypeId)

      if (typeof sessionStorage !== "undefined") {
        if (resolvedPolicyId != null && resolvedPolicyId !== "") {
          this.indicationQuoteService.setPolicyId(Number(resolvedPolicyId));
        }
        sessionStorage.setItem("quoteIdForPolicy", String(quoteId));
        sessionStorage.setItem("branchId", String(branchId));
        sessionStorage.setItem("policyNo", String(policyNo));
        sessionStorage.setItem("policyDate", String(policyDate));
        sessionStorage.setItem("nameInsured", String(nameInsured));
        sessionStorage.setItem("policyStartDate", String(policyStartDate));
        sessionStorage.setItem("policyEndDate", String(policyEndDate));
        sessionStorage.setItem("policyStatus", String(policyStatus));
        sessionStorage.setItem('policyAddressId',JSON.stringify(addressIdList));
        sessionStorage.setItem('addressTypeId',JSON.stringify(addressTypeId));
      }
    }
  }

  setCopeConfigData(response: any) {
    if (response?.addresses) {
        const addressList = response.addresses;

        const buildingIdList: any[] = addressList.flatMap((address: any) => 
            address.buildings.map((building: any) => building.buildingid)
        );
        
        // Additionally store the first building ID for each address
        const firstBuildingIdForAddress: any[] = addressList.map((address: any) => 
            address.buildings.length > 0 ? address.buildings[0].buildingid : null
        );
        
        this.CopeDetails.set({ buildingid: buildingIdList });
        if (typeof sessionStorage !== "undefined") {
            sessionStorage.setItem("buildingid", JSON.stringify(buildingIdList));
            sessionStorage.setItem("buildingIdforaddress", JSON.stringify(firstBuildingIdForAddress));
        }
    }
}

fetchIndicationClearanceDataforpolicy() {
  const indicationClearanceId = this.authService.getUserDetailsFromStorage().indicationId;
  this.propertyService.getIndicationClearanceData(Number(indicationClearanceId)).subscribe({
          next: (response: clearanceIndicationData) => {
        if (response) {
          const data = response.indication;
        this.clearanceIndicationStep = (data as any)?.indicationStep ?? null;
        const questions = response.questions;
        const addressList = response.indication.addresses;
        const addressIdList: any[] = addressList.map((address: any) => address.indicationAddressId);
        this.getIndicationDetails.set({indicationAddressId: addressIdList });
        this.setIndicationConfigData(response);
      if (typeof sessionStorage !== "undefined") {
          sessionStorage.setItem('indicationAddressId',JSON.stringify(addressIdList));
      }
        const storedindicationQuestionId = sessionStorage.setItem('indicationQuestionId',JSON.stringify(response.questions))
        this.onRiskSummaryStatusBindHandler(response?.indication, "indication");
        this.propertyService.setVersionNo(response.indication?.versionNo);
        this.mapClearanceDataforPolicy(data, questions);
        // Set initial snapshot AFTER data has been loaded into the form
        this.initialFormValue = this.addressForm.getRawValue();
        this.initialAddressesSnapshot = JSON.parse(JSON.stringify(this.addressForm.getRawValue().addresses));
        
        const statusList = this.brokerQuoteService.getStatusListFromStorage();
           if(statusList){
             this.brokerQuoteService.setStatusId(data.indicationStatus); // set statusId            
             
           }
        // this.addressControls().controls.forEach((control, index) => {
        //   if (control instanceof FormGroup) {
        //     control.get('isEdited')?.setValue(false);
        //     control.get('isSaved')?.setValue(true);
        //     control.get('isFetchBuildingDetailsCalled')?.setValue(false);
        //   }
        // });
      }
    },
    error: (error) => {
      this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
    }
  });
}

fetchQuoteClearanceDataforPolicy() {
  const quoteId = this.authService.getUserDetailsFromStorage().quoteId ;
  this.propertyService.getQuoteClearanceData(Number(quoteId)).subscribe({
          next: (response: clearanceQuoteData) => {
        if (response) {
          const { quoteReferralLock,quoteNo } = response.quote;
        const data = response.quote;
        this.clearanceQuoteStep = (data as any)?.quoteStep ?? null;
        const questions = response.questions
        const addressList = response.quote.addresses;
        const addressIdList: any[] = addressList.map((address: any) => address.quoteAddressId);
        const addressTypeId: any[] = addressList.map((address: any) => address.addressTypeId);
        this.setQuoteConfigData(response);
        this.getquoteDetails.set({quoteAddressId: addressIdList,addressTypeId:addressTypeId, quoteReferralLock:quoteReferralLock });
      if (typeof sessionStorage !== "undefined") {
          sessionStorage.setItem('quoteAddressId',JSON.stringify(addressIdList));
          sessionStorage.setItem('addressTypeId',JSON.stringify(addressTypeId));
          sessionStorage.setItem("quoteReferralLock",String(quoteReferralLock));
          sessionStorage.setItem("quoteNo",String(quoteNo));
      }
      
      this.onRiskSummaryStatusBindHandler(response?.quote, "quote");
      const statusList = this.brokerQuoteService.getStatusListFromStorage();
      if(statusList){
        this.brokerQuoteService.setStatusId(statusList[data.quoteStatus]?.gencodeId); // set statusId
      }
        const storedQuoteQuestionId = sessionStorage.setItem('quoteQuestionId',JSON.stringify(response.questions))
       
        this.propertyService.setVersionNo(response.quote?.versionNo);
        this.mapClearanceDataforPolicy(data, questions);

        // Set initial snapshot AFTER data has been loaded into the form
        this.initialFormValue = this.addressForm.getRawValue();
        this.initialAddressesSnapshot = JSON.parse(JSON.stringify(this.addressForm.getRawValue().addresses));
        // this.addressControls().controls.forEach((control, index) => {
        //   if (control instanceof FormGroup) {
        //     control.get('isEdited')?.setValue(false);
        //     control.get('isSaved')?.setValue(true);
        //     control.get('isFetchBuildingDetailsCalled')?.setValue(false);
        //   }
        // });
      }
    },
    error: (error) => {
      this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
    }
  });
}

fetchIndicationClearanceData() {
  const indicationClearanceId = this.authService.getUserDetailsFromStorage().indicationId;
  this.propertyService.getIndicationClearanceData(Number(indicationClearanceId)).subscribe({
          next: (response: clearanceIndicationData) => {
        if (response) {
          const data = response.indication;
        this.clearanceIndicationStep = (data as any)?.indicationStep ?? null;
        const questions = response.questions;
        const addressList = response.indication.addresses;
        const addressIdList: any[] = addressList.map((address: any) => address.indicationAddressId);
        this.getIndicationDetails.set({indicationAddressId: addressIdList });
        this.setIndicationConfigData(response);
      if (typeof sessionStorage !== "undefined") {
          sessionStorage.setItem('indicationAddressId',JSON.stringify(addressIdList));
      }
        const storedindicationQuestionId = sessionStorage.setItem('indicationQuestionId',JSON.stringify(response.questions))
        this.onRiskSummaryStatusBindHandler(response?.indication, "indication");
        this.propertyService.setVersionNo(response.indication?.versionNo);
        this.mapClearanceData(data, questions);
        
        // Set initial snapshot AFTER data has been loaded into the form
        this.initialFormValue = this.addressForm.getRawValue();
        this.initialAddressesSnapshot = JSON.parse(JSON.stringify(this.addressForm.getRawValue().addresses));
        
        const statusList = this.brokerQuoteService.getStatusListFromStorage();
           if(statusList){
             this.brokerQuoteService.setStatusId(data.indicationStatus); // set statusId            
             
           }
        // this.addressControls().controls.forEach((control, index) => {
        //   if (control instanceof FormGroup) {
        //     control.get('isEdited')?.setValue(false);
        //     control.get('isSaved')?.setValue(true);
        //     control.get('isFetchBuildingDetailsCalled')?.setValue(false);
        //   }
        // });
      }
    },
    error: (error) => {
      this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
    }
  });
}



fetchQuoteClearanceData() {
  const quoteId = this.authService.getUserDetailsFromStorage().quoteId ;
  this.propertyService.getQuoteClearanceData(Number(quoteId)).subscribe({
          next: (response: clearanceQuoteData) => {
        if (response) {
          const { quoteReferralLock,quoteNo } = response.quote;
          const quoteDate = this.formatDate(response.quote.quoteDate);
        const data = response.quote;
        this.clearanceQuoteStep = (data as any)?.quoteStep ?? null;
        const questions = response.questions
        const addressList = response.quote.addresses;
        const addressIdList: any[] = addressList.map((address: any) => address.quoteAddressId);
        const addressTypeId: any[] = addressList.map((address: any) => address.addressTypeId);
        this.setQuoteConfigData(response);
        this.getquoteDetails.set({quoteAddressId: addressIdList,addressTypeId:addressTypeId, quoteReferralLock:quoteReferralLock });
      if (typeof sessionStorage !== "undefined") {
          sessionStorage.setItem('quoteAddressId',JSON.stringify(addressIdList));
          sessionStorage.setItem('addressTypeId',JSON.stringify(addressTypeId));
          sessionStorage.setItem("quoteReferralLock",String(quoteReferralLock));
          sessionStorage.setItem("quoteNo",String(quoteNo));
          sessionStorage.setItem("quoteDate",quoteDate);
          
      }
      
      this.onRiskSummaryStatusBindHandler(response?.quote, "quote");
      const statusList = this.brokerQuoteService.getStatusListFromStorage();
      if(statusList){
        this.brokerQuoteService.setStatusId(statusList[data.quoteStatus]?.gencodeId); // set statusId
      }
        const storedQuoteQuestionId = sessionStorage.setItem('quoteQuestionId',JSON.stringify(response.questions))
       
        this.propertyService.setVersionNo(response.quote?.versionNo);
        this.mapClearanceData(data,questions)
        
        // Set initial snapshot AFTER data has been loaded into the form
        this.initialFormValue = this.addressForm.getRawValue();
        this.initialAddressesSnapshot = JSON.parse(JSON.stringify(this.addressForm.getRawValue().addresses));
        // this.addressControls().controls.forEach((control, index) => {
        //   if (control instanceof FormGroup) {
        //     control.get('isEdited')?.setValue(false);
        //     control.get('isSaved')?.setValue(true);
        //     control.get('isFetchBuildingDetailsCalled')?.setValue(false);
        //   }
        // });
      }
    },
    error: (error) => {
      this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
    }
  });
}
fetchPolicyDataClearanceStep(){
  this.propertyService.getPolicyClearanceStepData(Number(this.authService.getUserDetailsFromStorage()?.policyId), 
  Number(this.authService.getUserDetailsFromStorage()?.userDetails?.userId)).subscribe({
    next: (response: any) => {
      if (response) {
        this.initialFormValue = this.addressForm.getRawValue();
        const data = response.policy;
        const questions = response.questions
        this.setPolicyDetailsConfigData(response);
        //this.getquoteDetails.set({quoteAddressId: addressIdList,addressTypeId:addressTypeId, quoteReferralLock:quoteReferralLock });
      
        const statusList = this.brokerQuoteService.getStatusListFromStorage();
        if(statusList){
          this.brokerQuoteService.setStatusId(statusList[data.policyStatus]?.gencodeId); // set statusId
        }
        
        sessionStorage.setItem('policyQuestionId',JSON.stringify(response.questions))
        //this.propertyService.setVersionNo(response.quote?.versionNo);
        this.mapClearanceData(data,questions)
        
        // Set initial snapshot AFTER data has been loaded into the form
        this.initialFormValue = this.addressForm.getRawValue();
        this.initialAddressesSnapshot = JSON.parse(JSON.stringify(this.addressForm.getRawValue().addresses));
        // this.addressControls().controls.forEach((control, index) => {
        //   if (control instanceof FormGroup) {
        //     control.get('isEdited')?.setValue(false);
        //     control.get('isSaved')?.setValue(true);
        //     control.get('isFetchBuildingDetailsCalled')?.setValue(false);
        //   }
        // });
      }
    },
    error: (error: any) => {
      this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
    }
  })
}

getclearanceDataforPolicyParam() {
 if(this.isPolicyType()){
    this.fetchPolicyDataClearanceStep();    
    // this.fetchPolicyDataCopeStep();
    this.fetchPolicyRagDetails();
  }else{
    this.isIndicationType() ? this.fetchIndicationClearanceDataforpolicy()  : this.fetchQuoteClearanceDataforPolicy();
  }
}

fetchIndicationDraftStatus() {
  const indicationId = this.authService.getUserDetailsFromStorage().indicationId;
  this.propertyService.getindicationDraftStatusIndication().subscribe({
    next: (response: any) => {
      if (response) {
        // Store the draft status for later use in clearanceIndicationSave
        sessionStorage.setItem('indicationDraftStatus', JSON.stringify(response));
      }
    },
    error: (error) => {
      console.error('Failed to fetch indication draft status:', error);
    }
  });
}

fetchQuoteDraftStatus() {
  this.propertyService.getindicationDraftStatusQuote().subscribe({
    next: (response: any) => {
      if (response) {
        // Store the draft status for later use in clearanceQuoteSave
        sessionStorage.setItem('quoteDraftStatus', JSON.stringify(response));
      }
    },
    error: (error) => {
      console.error('Failed to fetch quote draft status:', error);
    }
  });
}

getDraftStatusData() {
  this.isIndicationType() ? this.fetchIndicationDraftStatus() : this.fetchQuoteDraftStatus();
}

getClearanceData() {
  
  if(this.isPolicyType()){
    this.fetchPolicyDataClearanceStep();
    
    // this.fetchPolicyDataCopeStep();
    this.fetchPolicyRagDetails();
  }else{
    this.isIndicationType() ? this.fetchIndicationClearanceData() : this.fetchQuoteClearanceData();
  }
}

mapClearanceDataforPolicy(data:any,questions:questions[]){  
        this.namedInsured.set(data.nameInsured);
        this.selectedPolicyType.set(data.policyTypeId);
        this.premium =  this.formatCurrencyValue(data.targetPremium);
        this.initialNamedInsured = this.namedInsured();
        
        // Set initial snapshot only if it hasn't been set yet (first time loading clearance data)
        // if (!this.initialAddressesSnapshot) {
        //   this.initialFormValue = this.addressForm.getRawValue();
        //   this.initialAddressesSnapshot = JSON.parse(JSON.stringify(this.addressForm.getRawValue().addresses));
        //   console.log("📸 Initial addresses snapshot set:", this.initialAddressesSnapshot);
        // }
        
        // Check for addresses with empty building data and mark them for Preferred Reports
        
        // this.premium = this.formatCurrencyValue(data.targetPremium);   
         
        if (questions?.length) {

            // Clone the current answers object
            const updatedAnswers = { ...this.questionAnswers() };

            // Process each question and update the answer
            for (const { questionId, answer } of questions) {
              const value = answer === 'yes' ? 2 : answer === 'no' ? 0 : 1;

              updatedAnswers[questionId] = value;
            }

            // Update the signal with new answers
            this.questionAnswers.set(updatedAnswers);
          }else{
            const defaultAnswers = this.questions().reduce((acc, q) => {
            acc[q.questionId] = 1; // Center position (grey)
            return acc;
          }, {} as { [key: number]: number });

          this.questionAnswers.set(defaultAnswers);
          }

        // Creating form group without async validators
        const addresses = this.addressForm.get('addresses') as FormArray;
        const addressList = Array.isArray(data?.addresses) ? data.addresses : [];

        while (addresses.length < addressList.length) {
          addresses.push(this.createAddressGroup());
        }

        addressList.forEach((address:Address, index: number) => {
          if (!address) {
            return;
          }

          const addressGroup = addresses.at(index) as FormGroup; 
          addressGroup.patchValue({
            addressid: this.resolveAddressId(address),
            street: address.streetName,
            streetNum: String(address.streetNum),
            unitNum: address.unitNum,
            zipcode: address.zipCode,
            city: address.cityId,  
            state: address.stateId,  
            country: address.countyId,
            occupancy: address.occupanyClassId
            
          });
          this.initialFormValue = this.addressForm.getRawValue();


          const state =Array.from(this.states().values()).flat().find(s => s.stateId === address.stateId);
          if (state) {
            addressGroup.get('state')?.setValue(state.stateId);  
          }

          if(!this.isCityStateListFetched() && address.zipCode){
            this.fetchStateByZipCode(index, String(address.zipCode));
          }
          const occupancy = this.Occupancies().find(
            (occupancy) => occupancy.classId === address.occupanyClassId
          );
          
          if (occupancy) {
            addressGroup.get('occupancy')?.setValue(occupancy.classId);
          }
          
        });  
        this.initialFormValue = this.addressForm.getRawValue();
        
        this.cdRef.detectChanges();
}

mapClearanceData(data:any,questions:questions[]){  
        this.namedInsured.set(data.nameInsured);
        this.selectedPolicyType.set(data.policyTypeId);
        this.premium =  this.formatCurrencyValue(data.targetPremium);
        this.initialNamedInsured = this.namedInsured();
      
       this.getCopeDataforPolicyParameters();
        // this.premium = this.formatCurrencyValue(data.targetPremium);    
        if (questions?.length) {

            // Clone the current answers object
            const updatedAnswers = { ...this.questionAnswers() };

            // Process each question and update the answer
            for (const { questionId, answer } of questions) {
              const value = answer === 'yes' ? 2 : answer === 'no' ? 0 : 1;

              updatedAnswers[questionId] = value;
            }

            // Update the signal with new answers
            this.questionAnswers.set(updatedAnswers);
          }else{
            const defaultAnswers = this.questions().reduce((acc, q) => {
            acc[q.questionId] = 1; // Center position (grey)
            return acc;
          }, {} as { [key: number]: number });

          this.questionAnswers.set(defaultAnswers);
          }

        // Creating form group without async validators
        const addresses = this.addressForm.get('addresses') as FormArray;
        const addressList = Array.isArray(data?.addresses) ? data.addresses : [];

        while (addresses.length < addressList.length) {
          addresses.push(this.createAddressGroup());
        }

        addressList.forEach((address:Address, index: number) => {
          if (!address) {
            return;
          }

          const addressGroup = addresses.at(index) as FormGroup; 
          addressGroup.patchValue({
            addressid: this.resolveAddressId(address),
            street: address.streetName,
            streetNum: String(address.streetNum),
            unitNum: address.unitNum,
            zipcode: address.zipCode,
            city: address.cityId,  
            state: address.stateId,  
            country: address.countyId,
            occupancy: address.occupanyClassId
            
          });
          this.initialFormValue = this.addressForm.getRawValue();


          const state =Array.from(this.states().values()).flat().find(s => s.stateId === address.stateId);
          if (state) {
            addressGroup.get('state')?.setValue(state.stateId);  
          }

          if(!this.isCityStateListFetched() && address.zipCode){
            this.fetchStateByZipCode(index, String(address.zipCode));
          }
          const occupancy = this.Occupancies().find(
            (occupancy) => occupancy.classId === address.occupanyClassId
          );
          
          if (occupancy) {
            addressGroup.get('occupancy')?.setValue(occupancy.classId);
          }
          
        });  
        this.initialFormValue = this.addressForm.getRawValue();
        
        this.cdRef.detectChanges();
}

// Method to fetch city name by ID
getCityName(cityId: string | null): string {
  if (!cityId) return '';
  const city = Array.from(this.cities().values()).flat().find(c => c.cityId === cityId);
  return city ? city.cityName : '';
}

// Method to fetch state name by ID
getStateName(stateId: string | null): string {
  if (!stateId) return '';
  const state =Array.from(this.states().values()).flat().find(s => s.stateId === stateId);
  return state ? state.stateName : '';
}

// Method to fetch county name by ID
getCountyName(countyId: string | null): string {
  if (!countyId) return '';
  const county = Array.from(this.counties().values()).flat().find(c => c.countyId === countyId);
  return county ? county.countyName : '';
}

// Method to fetch occupancy name by ID
getOccupancyName(classId: string | null): string {
  if (!classId) return '';
  const occupancy = this.Occupancies().find(o => o.classId === classId);
  return occupancy ? occupancy.description : '';
}

// Method to check addresses for empty building data and mark them for Preferred Reports
checkAddressesForEmptyBuildings(addresses: any[]) {
  this.addressesForPreferredReports = [];
  
  addresses.forEach((address: any, index: number) => {
    // Check if buildings array is empty or doesn't exist
    if (!address.buildings || address.buildings.length === 0) {
      this.addressesForPreferredReports.push(index);
    }
  });
  
}

getOandLPolicyParametersData() {
  if(this.isPolicyType()) {
    this.fetchOandLPolicyParamaterData();
  }else{
    this.isIndicationType() ? this.fetchOandLIndicationPolicyParametersData() : this.fetchOandLQuotePolicyParametersData();
  }
}

updateOandLPolicyParameterData(payload: any[]) {
  this.propertyService.policyParamerterUpdateOanL(payload).subscribe({
    next: (response: any) => {
    },
    error: (error) => {
      this.toastService.addNotification({message: "System error. Failed to save data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
    },
  });
}

updateQuoteOandLPolicyParameterData(payload: any[]) {
  this.propertyService.policyParamerterUpdateQuoteOanL(payload).subscribe({
    next: (response: any) => {
    },
    error: (error) => {
      this.toastService.addNotification({message: "System error. Failed to save data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
    },
  });
}

fetchOandLIndicationPolicyParametersData() {
  const indicationId = Number(this.authService.getUserDetailsFromStorage().indicationId);
  this.propertyService.fetchPolicyParameterIndicationOandL(indicationId).subscribe({
    next: (response: any) => {
      if (response) {
        this.oAndLDataList.set(response);
        this.setOandLCoverage(response);
      }
    },
    error: (error) => {
      this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
    },
  });
}

fetchOandLQuotePolicyParametersData() {
  const quoteId = Number(this.authService.getUserDetailsFromStorage().quoteId);
  const versionId = Number(sessionStorage.getItem('versionNo'));
  this.propertyService.fetchPolicyParameterQuoteOandL(quoteId, versionId).subscribe({
    next: (response: any) => {
      if (response) {
        this.oAndLDataList.set(response);
        this.setOandLCoverage(response);
      }
    },
    error: (error) => {
      this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
    },
  });
}

fetchOandLPolicyParamaterData() {
  this.propertyService.getPolicyOandLDetails(Number(this.authService.getUserDetailsFromStorage()?.policyId)).subscribe({
    next: (response: any) => {
      if (response) {
        this.oAndLDataList.set(response);
        this.setOandLCoverage(response);
      }
    },
    error: (error) => {
      this.toastService.addNotification({message: "Failed to retrieve o and l data", type: ToastType.Error}); // error notification
    },
  });
}

getPolicyParametersData() {
  const indicationId = Number(sessionStorage.getItem('indicationId'));
  const QuoteId = Number(sessionStorage.getItem('quoteId'));

  this.getPolicyDataSignal.set(true)
  const apiCall = this.isIndicationType()
    ? this.propertyService.getPolicyParametersIndication(indicationId)
    : this.propertyService.getPolicyParametersQuote(QuoteId);

  apiCall.subscribe({
    next: (response: PolicyParametersData) => {
      if (response) {
        const otherStructureIds = response.addresses.flatMap(address =>
          (address.additionalPropertyCoverage || []).map(coverage => coverage.otherStructureId)
        );
        sessionStorage.setItem('otherStructureIds', JSON.stringify(otherStructureIds));
        this.mapPolicyParametersData(response);
        this.getPolicyDataSignal.set(false)

      }
    },
    error: (error) => {
      this.getPolicyDataSignal.set(false)
      this.toastService.addNotification({message: "Failed to retrieve policy parameter data", type: ToastType.Error}); // error notification
    },
  });
}

getPolicyDataPolicyParameterStep(){
  this.getPolicyDataSignal.set(true)
  this.propertyService.getPolicyForPolicyParamaterStepData(Number(this.authService.getUserDetailsFromStorage()?.policyId), 
    Number(this.authService.getUserDetailsFromStorage()?.userDetails?.userId)).subscribe({
    next: (response: any) => {
      const otherStructureIds = response.addresses.flatMap((address: any) =>
        (address.additionalPropertyCoverage || []).map((coverage: any) => coverage.otherStructureId)
      );
      sessionStorage.setItem('otherStructureIds', JSON.stringify(otherStructureIds));
      this.mapPolicyParametersData(response);
      this.getPolicyDataSignal.set(false)

    },
    error: (error: any) => {
      this.getPolicyDataSignal.set(false)
      this.toastService.addNotification({message: "Failed to retrieve policy parameter data", type: ToastType.Error}); // error notification
    }
  })
}

calculateMonthsDifference() {
  const startDate = moment(this.formData.startDate);
  const endDate = moment(this.formData.endDate);

  // Calculate the difference in months
  const monthsDifference = endDate.diff(startDate, 'months'); 
  
  // Update the monthsDifference in formData
  this.formData.monthsDifference = monthsDifference ?? 12;
 
  const maxEndDate = startDate.clone().add(18, 'months');
  this.policyEndDateMax.set(maxEndDate.format('YYYY-MM-DD'));

  this.minEndDate = startDate.clone().add(6, 'months').format('YYYY-MM-DD'); // 6 months after the start date
  this.policyEndDateMin.set(startDate.clone().add(6, 'months').format('YYYY-MM-DD'));
  
  this.syncPolicyPeriodFromDates();
}

formatCurrencyValue(value: any): string {
  if (value == null || value === '') {
    return '';
  }
  return formatNumber(Number(value), 'en-US', '1.0-2'); }

  resetFormData() {
    this.formData.waterDamageId = null;
    this.formData.waterDamageAmount = null;
    this.formData.waterDamageDescription = '';
  
    this.formData.vandalismId = null;
    this.formData.vandalismAmount = null;
    this.formData.vandalismDescription = '';
  
    // Reset other relevant properties if needed
  }

mapPolicyParametersData(data: PolicyParametersData) {  

 
  // this.resetFormData();
  this.formData.startDate = this.formatDate(data.policyStartDate); 
  this.formData.endDate = this.formatDate(data.policyEndDate);
  this.formData.causeOfLoss = data.causeOfLoss ?? null;
  this.formData.aopDeductibleId = data.aopDeductibleId ?? null;
  this.formData.aopDeductibleDescription= data.aopDeductibleDescription || '';
  this.formData.aopDeductibleAmount = data.aopDeductibleAmount ?? null;
  this.formData.propertyExtCoverageType = data.propertyExtCoverageType || null;  
  this.formData.waterDamageId = data.waterDamageId ?? null;
  this.formData.waterDamageAmount = data.waterDamageAmount ?? null;
  this.formData.waterDamageDescription = data.waterDamageDescription || '';
  this.formData.vandalismId = data.vandalismId ?? null;
  this.formData.vandalismAmount = data.vandalismAmount ?? null;
  this.formData.vandalismDescription = data.vandalismDescription || '';
  this.formData.oAndLCoverageId = data.oAndLCoverageId || 0
  this.formData.oAndLCoverageAmount = data.oAndLCoverageAmount|| 0;
  this.formData.windDeductibleFlag = data.windDeductibleFlag || 0;
  this.formData.windDeductibleFactor = data.windDeductibleFactor ?? null;  
  this.formData.windDeductibleId = data.windDeductibleId ?? null;
  this.formData.windDeductibleDescription = data.windDeductibleDescription || '';
  this.updateFilteredDeductibles();
  // this.businessIncomeLimits.set(data.businessIncomeLimit);  
  this.calculateMonthsDifference();
  this.business = [];
  this.formData.businessIncomeLimit = this.extractBusinessIncomeLimit(data.addresses); 
  if (data.addresses?.length > 0) {
    data.addresses.forEach((address: any, addressIndex: number) => {
      // this.isChecked[addressIndex] = () => true;
      // Set form data values for the current address
      const businessIncomeLimit = address.businessIncomeLimit != null ? Number(address.businessIncomeLimit) : 0;
      
      this.business[addressIndex] = businessIncomeLimit;    
      this.formattedBusinessIncomeLimits[addressIndex] = this.formatCurrencyValue(businessIncomeLimit);
     
      const buildingDetailsFormArray = this.buildingControlsForAddress(addressIndex);
  
      // Ensure the form array has the correct number of building groups
      while (buildingDetailsFormArray.length < address.buildings?.length) {
        buildingDetailsFormArray.push(this.createBuildingGroup());
      }
  
      // Patch values for each building
      address.buildings?.forEach((building: any, buildingIndex: number) => {
        const buildingGroup = buildingDetailsFormArray.at(buildingIndex) as FormGroup;
        buildingGroup.patchValue({
          buildingLimit: this.formatCurrencyValue(building?.buildingLimit),
          businessPropertyLimit: this.formatCurrencyValue(building?.businessPropertyLimit)
        });
        this.cdRef.markForCheck();
      });
    });
  }

  if (data.addresses?.length > 0) {
    data.addresses.forEach((address: any, addressIndex: number) => {
      // Get the form array for the current address
      const structureDetailsFormArray = this.structureControlsForAddress(addressIndex);
  
      // Clear existing form controls in the array
      structureDetailsFormArray.clear();
  
      // Check if additionalPropertyCoverage exists and has items
      const hasAdditionalPropertyCoverage = address.additionalPropertyCoverage && address.additionalPropertyCoverage.length > 0;
      
      if (hasAdditionalPropertyCoverage) {
        // Add form groups based on the response length
        address.additionalPropertyCoverage.forEach((coverage: any) => {
          structureDetailsFormArray.push(this.createStructureGroup());
        });
      } else {
        // If no additionalPropertyCoverage in response, create at least one empty structure form control
        structureDetailsFormArray.push(this.createStructureGroup());
      }
  
      // Patch values for each additional property coverage
      if (hasAdditionalPropertyCoverage) {
        address.additionalPropertyCoverage.forEach((coverage: any, structureIndex: number) => {
          const structureGroup = structureDetailsFormArray.at(structureIndex) as FormGroup;
          structureGroup.patchValue({
            coverageLimit: coverage?.otherStructureFactorId ? coverage?.otherStructureFactorId  : '',
            otherStructuresLimit: this.formatCurrencyValue(coverage?.otherStructureFactorAmount),
            otherDescription: coverage?.otherStructureOtherDesc,
            
          });        
        });
      }
      
      // Apply logic to all structure groups (both from response and empty ones)
      this.addressControls().controls.forEach((addressGroup, addrIndex) => {
        const structuresArray = this.structureControlsForAddress(addrIndex);
        structuresArray.controls.forEach((structureGroup, structIndex) => {
          const selectedValue = structureGroup.get('coverageLimit')?.value;
          const otherStructuresLimitControl = structureGroup.get('otherStructuresLimit');
  
          structureGroup.get('isOthersSelected')?.setValue(selectedValue == '12');
  
          if (selectedValue === '') {                            
            otherStructuresLimitControl?.reset();
            otherStructuresLimitControl?.disable();
          } else if (!this.isReadOnly()) {
            otherStructuresLimitControl?.enable();
          }
        });
      });
    });
  }
 this.calculateTotals();
  if (this.step() === 2 && this.addresses().length > 0) {
    const hasOpenAddress = this.addressAccordionOpened.some((opened) => opened);
    if (!hasOpenAddress || this.addressAccordionOpened.length !== this.addresses().length) {
      this.addressAccordionOpened = this.addresses().map((_, i) => i === 0);
    }
  }
  if(!this.isUwAdmin()){
     const todayMoment = moment(); // Current date
    this.today1 = todayMoment.format('YYYY-MM-DD'); // For [min]

    if(this.isIndicationType()){
      const maxlimit = sessionStorage.getItem("inDtMaxLimit")
      this.maxStartDate = todayMoment.clone().add(maxlimit, 'days').format('YYYY-MM-DD'); // For [max]
      this.minStartDate = todayMoment.format('YYYY-MM-DD');    
    }else{
      const maxlimit = sessionStorage.getItem("inDtMaxLimit")
      this.maxStartDate = todayMoment.clone().add(maxlimit, 'days').format('YYYY-MM-DD'); // For [max]
      this.minStartDate = todayMoment.format('YYYY-MM-DD');
    }
  }else{
     this.minStartDate = undefined;
  this.maxStartDate = undefined;
  }

  this.applyWindHailCoverageRules();
}

formatDate(date: Date): string {
  return this.datePipe.transform(date, 'yyyy-MM-dd') || '';
}

extractBusinessIncomeLimit(addresses: addresses[]): number {
  return addresses?.[0]?.businessIncomeLimit || 0;
}

fetchIndicationCopeDataforPolicyParameters(){
  this.clearanceId = Number(sessionStorage.getItem('indicationId'));

  this.propertyService.getIndicationCopeData(this.clearanceId).subscribe({
    next: (response:any) => {
      if (response) {
        const addressList = response.addresses;
        
        const buildingIdList: any[] = addressList.flatMap((address: any) => 
            address.buildings.map((building: any) => building.buildingid)
        );
        
        // Additionally store the first building ID for each address
        const firstBuildingIdForAddress: any[] = addressList.map((address: any) => 
            address.buildings.length > 0 ? address.buildings[0].buildingid : null
        );

        this.getCopeDetails.set({ buildingid: buildingIdList });
        if (typeof sessionStorage !== "undefined") {
            sessionStorage.setItem("buildingid", JSON.stringify(buildingIdList));
            sessionStorage.setItem("buildingIdforaddress", JSON.stringify(firstBuildingIdForAddress));
        }

      }
    },
    error: (error) => {
      this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
    }
  });
}

fetchQuoteCopeDataforPolicyParameters() {
  this.clearanceId = Number(sessionStorage.getItem('quoteId'));

  this.propertyService.getQuoteCopeData(this.clearanceId).subscribe({
    next: (response: any) => {
      if (response) {
        const addressList = response.addresses;
        const buildingIdList: any[] = addressList.flatMap((address: any) => 
            address.buildings.map((building: any) => building.buildingid)
        );
        
        // Additionally store the first building ID for each address
        const firstBuildingIdForAddress: any[] = addressList.map((address: any) => 
            address.buildings.length > 0 ? address.buildings[0].buildingid : null
        );

        this.getCopeDetails.set({ buildingid: buildingIdList });
        if (typeof sessionStorage !== "undefined") {
            sessionStorage.setItem("buildingid", JSON.stringify(buildingIdList));
            sessionStorage.setItem("buildingIdforaddress", JSON.stringify(firstBuildingIdForAddress));
        }
      }
    },
    error: (error) => {
      this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
    }
  });
}

fetchPolicyDataCopeStepforPolicyParameters() {
  this.propertyService.getPolicyCopeStepData(Number(this.authService.getUserDetailsFromStorage()?.policyId), 
    Number(this.authService.getUserDetailsFromStorage()?.userDetails?.userId))
    .subscribe({
    next: (response: any) => {
      if (response) {
        const addressList = response.addresses;
        const buildingIdList: any[] = addressList.flatMap((address: any) => 
            address.buildings.map((building: any) => building.buildingid)
        );
        
        // Additionally store the first building ID for each address
        const firstBuildingIdForAddress: any[] = addressList.map((address: any) => 
            address.buildings.length > 0 ? address.buildings[0].buildingid : null
        );

        this.getCopeDetails.set({ buildingid: buildingIdList });
        if (typeof sessionStorage !== "undefined") {
            sessionStorage.setItem("buildingid", JSON.stringify(buildingIdList));
            sessionStorage.setItem("buildingIdforaddress", JSON.stringify(firstBuildingIdForAddress));
        }
      }
    },
    error: (error: any) => {
      this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
    }
  })
}

fetchIndicationCopeData(forceBindAll: boolean = false){
  this.getcopeDataSignal.set(true)
  this.clearanceId = Number(sessionStorage.getItem('indicationId'));

  this.propertyService.getIndicationCopeData(this.clearanceId).subscribe({
    next: (response:any) => {
      if (response) {
        this.mapCopeData(response, forceBindAll);
        // this.checkAddressesForEmptyBuildings(response.addresses);

        this.getcopeDataSignal.set(false);
        const addressList = response.addresses;
        
        const buildingIdList: any[] = addressList.flatMap((address: any) => 
            address.buildings.map((building: any) => building.buildingid)
        );
        
        // Additionally store the first building ID for each address
        const firstBuildingIdForAddress: any[] = addressList.map((address: any) => 
            address.buildings.length > 0 ? address.buildings[0].buildingid : null
        );

        this.getCopeDetails.set({ buildingid: buildingIdList });
        if (typeof sessionStorage !== "undefined") {
            sessionStorage.setItem("buildingid", JSON.stringify(buildingIdList));
            sessionStorage.setItem("buildingIdforaddress", JSON.stringify(firstBuildingIdForAddress));
        }

      }
    },
    error: (error) => {
      this.getcopeDataSignal.set(false)

      this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
    }
  });
}

fetchQuoteCopeData(forceBindAll: boolean = false) {
  this.getcopeDataSignal.set(true)
  this.clearanceId = Number(sessionStorage.getItem('quoteId'));

  this.propertyService.getQuoteCopeData(this.clearanceId).subscribe({
    next: (response: any) => {
      if (response) {
        this.mapCopeData(response, forceBindAll);
        // this.checkAddressesForEmptyBuildings(response.addresses);
        this.getcopeDataSignal.set(false)
        const addressList = response.addresses;
        const buildingIdList: any[] = addressList.flatMap((address: any) => 
            address.buildings.map((building: any) => building.buildingid)
        );
        const firstBuildingIdForAddress: any[] = addressList.map((address: any) => 
            address.buildings.length > 0 ? address.buildings[0].buildingid : null
        );

        this.getCopeDetails.set({ buildingid: buildingIdList });
        if (typeof sessionStorage !== "undefined") {
            sessionStorage.setItem("buildingid", JSON.stringify(buildingIdList));
            sessionStorage.setItem("buildingIdforaddress", JSON.stringify(firstBuildingIdForAddress));

        }
      }
    },
    error: (error) => {
      this.getcopeDataSignal.set(false)

      this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
    }
  });
}

fetchPolicyDataCopeStep() {
  this.getcopeDataSignal.set(true)
  this.propertyService.getPolicyCopeStepData(Number(this.authService.getUserDetailsFromStorage()?.policyId), 
    Number(this.authService.getUserDetailsFromStorage()?.userDetails?.userId))
    .subscribe({
    next: (response: any) => {
      if (response) {
        this.mapCopeData(response);
        this.getcopeDataSignal.set(false)
        const addressList = response.addresses;
        const buildingIdList: any[] = addressList.flatMap((address: any) => 
            address.buildings.map((building: any) => building.buildingid)
        );
         const firstBuildingIdForAddress: any[] = addressList.map((address: any) => 
            address.buildings.length > 0 ? address.buildings[0].buildingid : null
        );

        this.getCopeDetails.set({ buildingid: buildingIdList });
        if (typeof sessionStorage !== "undefined") {
            sessionStorage.setItem("buildingid", JSON.stringify(buildingIdList));
            sessionStorage.setItem("buildingIdforaddress", JSON.stringify(firstBuildingIdForAddress));

        }
      }
    },
    error: (error: any) => {
      this.getcopeDataSignal.set(false)
      this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
    }
  })
}

getEditedAddresses(): number[] {
  const currentAddresses = this.addressForm.getRawValue().addresses;
  const editedIndexes: number[] = [];

  const fieldsToCompare = ['street', 'city', 'state', 'country', 'zipcode', 'unitNum', 'streetNum'];

  currentAddresses.forEach((current: any, index: number) => {
    const currentAddressId = current?.addressid;
    
    // If current address has no addressid, it's a new address - mark as edited
    if (!currentAddressId || currentAddressId === '') {
      editedIndexes.push(index);
      return;
    }

    // Find the initial address with the same addressid
    const initial = this.initialAddressesSnapshot?.find((addr: any) => 
      addr?.addressid === currentAddressId || 
      addr?.addressId === currentAddressId ||
      addr?.indicationAddressId === currentAddressId ||
      addr?.quoteAddressId === currentAddressId ||
      addr?.policyAddressId === currentAddressId
    );

    // If no matching initial address found by ID, it's a new address - mark as edited
    if (!initial) {
      editedIndexes.push(index);
      return;
    }

    // Compare fields only for addresses with the same ID
    const isEdited = fieldsToCompare.some(field => {
      const currentValue = current[field] ?? '';
      const initialValue = initial[field] ?? '';
      return String(currentValue).trim() !== String(initialValue).trim();
    });

    if (isEdited) {
      editedIndexes.push(index);
    }
  });

  return editedIndexes;
}

// Helper method to get current ID and type
getCurrentIdAndType(): { id: number | null, type: string } {
  if (this.isPolicyType()) {
    const policyId =
      this.authService.getPolicyIdAsNumber() ??
      (this.route.snapshot.paramMap.get('id')
        ? Number(this.route.snapshot.paramMap.get('id'))
        : null);
    return { id: policyId, type: 'Policy' };
  } else if (this.isIndicationType()) {
    const indicationId = sessionStorage.getItem('indicationId');
    return { id: indicationId ? Number(indicationId) : null, type: 'Indication' };
  } else {
    const quoteId = sessionStorage.getItem('quoteId');
    return { id: quoteId ? Number(quoteId) : null, type: 'Quote' };
  }
}

// Method to build payload for UpdateIsEditAddress API
buildIsEditAddressPayload(clearanceAddressIds: number[] = []): any {
  const { id, type } = this.getCurrentIdAndType();
  if (!id) return null;

  const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
  const userId = userDetails.userId || 0;

  const currentAddresses = this.addressForm.getRawValue().addresses;
  const editedIndexes = this.getEditedAddresses();
  const clearanceAddressIdSet = new Set(
    clearanceAddressIds
      .map((addressId: number) => Number(addressId))
      .filter((addressId: number) => !!addressId)
  );
  const addressPayloadMap = new Map<number, any>();

  editedIndexes.forEach((index: number) => {
    const addressId = Number(currentAddresses[index]?.addressid) || 0;
    if (!addressId) {
      return;
    }
    addressPayloadMap.set(addressId, {
      addressId,
      isEdited: 1,
      ...(clearanceAddressIdSet.has(addressId) ? { isClearanceAddressEdited: 1 } : {})
    });
  });

  clearanceAddressIdSet.forEach((addressId: number) => {
    if (addressPayloadMap.has(addressId)) {
      return;
    }
    addressPayloadMap.set(addressId, {
      addressId,
      isEdited: Number(this.isEditedAddressFlags.get(addressId) ?? 0),
      isClearanceAddressEdited: 1
    });
  });

  const addresses = Array.from(addressPayloadMap.values());

  if (addresses.length === 0) {
    return null;
  }

  return {
    id: id,
    userId: userId,
    type: type,
    addresses: addresses
  };
}

// Method to build payload with all isEdited flags set to 0 (for cope save)
buildResetIsEditAddressPayload(): any {
  const { id, type } = this.getCurrentIdAndType();
  if (!id) return null;

  const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
  const userId = userDetails.userId || 0;

  const currentAddresses = this.addressForm.getRawValue().addresses;
  
  const addresses = currentAddresses.map((address: any) => {
    const addressId = Number(address?.addressid) || 0;
    return {
      addressId: addressId,
      isEdited: 0  // Reset all to 0
    };
  });

  return {
    id: id,
    userId: userId,
    type: type,
    addresses: addresses
  };
}

private handlePostClearanceBinding(
  preferredReportResponse: any[] | undefined,
  editedIndexes: number[],
  prApiFactory?: () => Observable<any>
): void {
  const addressesFormArray = this.addressControls();
  const normalizedEditedIndexes = editedIndexes || [];

  const handleEditedAndNonEditedBinding = (skipIndexes: Set<number>) => {
    if (normalizedEditedIndexes.length === 0) {
      if (skipIndexes.size > 0) {
        this.getCopeData();
      } else {
        this.getCopeData(true);
      }
      return;
    }

    const remainingEditedQueue = normalizedEditedIndexes.filter(index => !skipIndexes.has(index));
    if (remainingEditedQueue.length > 0) {
      const pendingIndexes = [...remainingEditedQueue];
      const getNextEditedIndex = () => pendingIndexes.shift();

      preferredReportResponse?.forEach((addrResp: any) => {
        if (!pendingIndexes.length) {
          return;
        }
        const addrList = Array.isArray(addrResp?.addresses)
          ? (Array.isArray(addrResp.addresses[0]) ? addrResp.addresses.flat() : addrResp.addresses)
          : [];

        addrList.forEach((singleAddr: any) => {
          if (!pendingIndexes.length) {
            return;
          }
          const targetIndex = getNextEditedIndex();
          if (targetIndex !== undefined) {
            this.patchBuildingDataToForm([singleAddr], targetIndex);
          }
        });
      });
    }

    const hasNonEdited = addressesFormArray.length > normalizedEditedIndexes.length;
    if (hasNonEdited) {
      this.getCopeData();
    }
  };

  const prEditedAddressIds = Array.from(this.isEditedAddressFlags.entries())
    .filter(([id, flag]) => flag === 1 && Number(id))
    .map(([id]) => Number(id));

  if (prEditedAddressIds.length > 0 && prApiFactory) {
    prApiFactory().subscribe({
      next: (prResponse: any) => {
        const prBoundIndexes = new Set<number>();

        if (prResponse) {
          this.tempPrResponse = prResponse;

          prEditedAddressIds.forEach((addressId) => {
            const addressIndex = addressesFormArray.controls.findIndex(
              (control) => Number(control.get('addressid')?.value) === addressId
            );

            if (addressIndex !== -1) {
              const matchingPrAddress = prResponse.addresses?.find(
                (prAddr: any) =>
                  prAddr.AddressId === addressId || prAddr.addressId === addressId
              );

              if (matchingPrAddress) {
                this.patchBuildingDataToForm([matchingPrAddress], addressIndex);
                prBoundIndexes.add(addressIndex);
              }
            }
          });
        }

        handleEditedAndNonEditedBinding(prBoundIndexes);
      },
      error: () => {
        handleEditedAndNonEditedBinding(new Set<number>());
      }
    });
  } else {
    handleEditedAndNonEditedBinding(new Set<number>());
  }
}







getCopeData(forceBindAll: boolean = false) {
  this.isIndicationType() ? this.fetchIndicationCopeData(forceBindAll) : this.fetchQuoteCopeData(forceBindAll);
}
refreshCopeInformation(event: Event) {
  // Prevent event propagation to avoid triggering expansion panel open/close
  event.stopPropagation();
  event.preventDefault();
  
  // Force refresh all COPE data
  this.getCopeData(true);
}

getCopeDataforPolicyParameters() {
  this.isIndicationType() ? this.fetchIndicationCopeDataforPolicyParameters() : this.fetchQuoteCopeDataforPolicyParameters();
}

mapCopeData(response: any, forceBindAll: boolean = false) {
  if (response.addresses?.length > 0) {
    
    
    this.buildingCounter = 0; // Reset counter for each mapCopeData call
    const editedIndexes = forceBindAll ? [] : this.getEditedAddresses();

  response.addresses.forEach((address: any, addressIndex: number) => {
    
    if (!forceBindAll && editedIndexes.includes(addressIndex)) return;
    
    const storedDraftStatus = sessionStorage.getItem('indicationDraftStatus');
    const storedDraftStatusQuote = sessionStorage.getItem('quoteDraftStatus');
        if (storedDraftStatus || storedDraftStatusQuote) {
          
    // Additional logic for draft mode: check for empty building data and bind accordingly
          if (this.tempPrResponse && this.tempPrResponse.addresses) {
            // Check if current address has empty building data
            const addressId = address.addressId || address.indicationAddressId || address.quoteAddressId || address.policyAddressId;
    
    // Check isEdited flag for this addressId
    const isEdited = this.isEditedAddressFlags.get(Number(addressId)) || 0;
    
    // If isEdited = 1, bind from PR response (GetPRApiResponse)
    if (isEdited === 1 && this.tempPrResponse && this.tempPrResponse.addresses) {
      // Find matching PR response by address ID
      const matchingPrAddress = this.tempPrResponse.addresses.find((prAddr: any) => 
        prAddr.AddressId === addressId || prAddr.addressId === addressId
      );
      
      if (matchingPrAddress) {
        // Bind from PR response for this address
        this.patchBuildingDataToForm([matchingPrAddress], addressIndex);
        return; // Skip the normal COPE binding
      }
    }
          }
      }

    const addressControl = this.addressControls().at(addressIndex) as FormGroup;
    const buildingDetailsArray = addressControl.get('buildingDetails') as FormArray;

    // Capture previously entered limits to preserve them across COPE patches
    const previousLimits = (buildingDetailsArray?.controls || []).map((ctrl: any) => ({
      buildingLimit: ctrl?.get('buildingLimit')?.value,
      businessPropertyLimit: ctrl?.get('businessPropertyLimit')?.value,
    }));

    while (buildingDetailsArray.length !== 0) {
      buildingDetailsArray.removeAt(0);
    }

    if (address.buildings?.length > 0) {
       
        address.buildings?.forEach((building: any, index: any) => {
          const buildingGroup = this.createBuildingGroup();
          buildingDetailsArray.push(buildingGroup);

          const factors = building.factors;

          const propertyData = factors.reduce((acc: any, factor: any) => {
            let key = factor.factorName;
            if (key === "RCV") key = "replacementCost";
            acc[key] = factor.subFactorName;
            return acc;
          }, {});

          // Ensure COPE mapping never patches policy parameter limits
          if (propertyData) {
            delete (propertyData as any).buildingLimit;
            delete (propertyData as any).businessPropertyLimit;
          }

          // Get Occupancy from the first building only
          let occupancyValue = '';
          const firstBuilding = address.buildings?.[0];
          if (firstBuilding) {
            const occupancyFactor = firstBuilding.factors?.find((f: any) => f.factorName === 'Occupancy');
            occupancyValue = occupancyFactor?.subFactorName || '';
            this.descriptionMap.set(addressIndex, occupancyValue); // store occupancy in map
          }

          buildingGroup.patchValue({
            buildingid: building?.buildingid,
            DistanceToCoast: propertyData.DistanceToCoast || null,
            sqFt: propertyData.sqFt || null,
            CRIMERATING: propertyData.CRIMERATING || null,
            story: propertyData.story || null,
            valuationMin: propertyData.valuationMin || null,
            valuationMax: propertyData.valuationMax || null,
            PcClass: propertyData.PcClass || null,
            RCV: this.formatCurrencyValue(propertyData.replacementCost) || null,
            CONSTTYPE: propertyData.CONSTTYPE || null,
            ROOFTYPE: propertyData.ROOFTYPE || null,
            Age: propertyData.Age || null,
            Occupancy: occupancyValue || null,
            roofReplaceUpdate: propertyData.roofReplaceUpdate === "0" ? "" : propertyData.roofReplaceUpdate,
            plumbing: propertyData.plumbing === "0" ? "" : propertyData.plumbing,
            electrical: propertyData.electrical === "0" ? "" : propertyData.electrical,
            hvac: propertyData.hvac === "0" ? "" : propertyData.hvac,
            sprinklers: propertyData.FireProtectionSprinklers != null
              ? (propertyData.FireProtectionSprinklers === "yes" ? 2 : 0)
              : 1,

            Burglar: propertyData.CentralMonitoredBurglarAlarm != null
              ? (propertyData.CentralMonitoredBurglarAlarm === "yes" ? 2 : 0)
              : 1,

            FireAlarm: propertyData.CentralMonitoredFireAlarm != null
              ? (propertyData.CentralMonitoredFireAlarm === "yes" ? 2 : 0)
              : 1,
            googleStreetImageSrc: propertyData.googleStreetImageSrc || '',
            googleMapImageSrc: propertyData.googleMapImageSrc || '',
          });
          this.googleStreetImageSrc.update((map) => map.set(addressIndex, propertyData.googleStreetImageSrc));
          this.googleMapImageSrc.update((map) => map.set(addressIndex, propertyData.googleMapImageSrc));
      
          this.buildingCounter++;          
          
          // this.isChecked.update((map) => map.set(addressIndex, true));
           if ('isConfirmed' in address) {
            addressControl.get('isConfirmed')?.setValue(address.isConfirmed === 1);      

            }
          const preserved = previousLimits?.[index];
          if (preserved) {
            buildingGroup.patchValue({
              buildingLimit: preserved.buildingLimit,
              businessPropertyLimit: preserved.businessPropertyLimit,
            });
          }

        });
      }else{
        // Create a building group with default values when no buildings exist
        const buildingGroup = this.createBuildingGroup();
        buildingDetailsArray.push(buildingGroup);
        
        // Get Occupancy from the address if available
        let occupancyValue = '';
        if (address.buildings?.length > 0) {
          const firstBuilding = address.buildings?.[0];
          if (firstBuilding) {
            const occupancyFactor = firstBuilding.factors?.find((f: any) => f.factorName === 'Occupancy');
            occupancyValue = occupancyFactor?.subFactorName || '';
            this.descriptionMap.set(addressIndex, occupancyValue);
          }
        }

        buildingGroup.patchValue({
          Burglar: 1,
          sprinklers: 1,
          FireAlarm: 1,
          occupancy: occupancyValue,
          CRIMERATING: "U - Unknown",
          PcClass: "",
          CONSTTYPE: "",
          ROOFTYPE: "",
          Age: "",
          roofReplaceUpdate: "",
          plumbing: "",
          hvac: "",
          electrical: "",
        });

        // Restore preserved limits for the first building if available
        const preserved = previousLimits?.[0];
        if (preserved) {
          buildingGroup.patchValue({
            buildingLimit: preserved.buildingLimit,
            businessPropertyLimit: preserved.businessPropertyLimit,
          });
        }

        this.buildingCounter++;
        this.isChecked.update((map) => map.set(addressIndex, true));
      }
      
      //}
    });
    
    // Handle draft mode: bind remaining addresses from patchBuildingDataToForm
      const storedDraftStatus = sessionStorage.getItem('indicationDraftStatus');
      const storedDraftStatusQuote = sessionStorage.getItem('quoteDraftStatus');

        if (storedDraftStatus || storedDraftStatusQuote) {
        if (this.tempPrResponse && this.tempPrResponse.addresses) {
          const addressesFormArray = this.addressControls();
          const copeAddresses = response.addresses;

          // Check each COPE address for empty buildings and bind from PR response accordingly
          copeAddresses.forEach((copeAddress: any, copeIndex: number) => {
            const hasEmptyBuildings = !copeAddress.buildings || copeAddress.buildings.length === 0;
            
            if (hasEmptyBuildings) {
             
              // Find matching PR response by address ID
              const matchingPrAddress = this.tempPrResponse.addresses.find((prAddr: any) => 
                prAddr.AddressId === copeAddress.addressId || prAddr.addressId === copeAddress.addressId
              );         
              
              
              
              if (matchingPrAddress) {
                
                // Bind from PR response for this address
                this.patchBuildingDataToForm([matchingPrAddress], copeIndex);
              }
            }
            // If address has building data, it's already handled by the normal COPE binding above
          });
          
          // Clear the temporary PR response after use
          this.tempPrResponse = null;
        }
      }
  }
}

getData(){
  if (!this.startupHydrationReady) {
    return;
  }
  // Header click to Clearance: validate current step first
  const current = this.step();
  if (!this.canLeaveCurrentStep(0)) {
    return;
  }

  // Save current step before switching back
  if (current === 1) {
    this.CopeSaveForAccordianClose();
  } else if (current === 2) {
    this.accordianCloseForPolicyParameters();
  }

  if(this.isPolicyType()){
    this.loadQuestions()
    this.fetchPolicyDataClearanceStep()
  }else{
    if(this.visitedStep()>0){
      this.clearanceId = Number(sessionStorage.getItem('indicationId'));
      this.loadQuestions()
      this.getClearanceData();      
    }
  }
  this.setStep(0);
}

fetchClearanceAndCopeData(){
  this.fetchPolicyDataClearanceStep();
  this.fetchPolicyDataCopeStep();
  this.fetchPolicyRagDetails();
}

CopeAPICallDetermine() {
  this.getClearanceData();

  const editedIndexes = this.getEditedAddresses();

  if (editedIndexes.length === 0) {
    // All from COPE
    this.getCopeData();
  } else if (editedIndexes.length === this.addressControls().length) {
    // All edited → Now handled inside clearanceIndicationSave API, no separate call
    // No direct call to fetchAllBuildingDetails() here
  } else {
    // Some edited → COPE will still handle unedited ones
    this.getCopeData(); 
    // Edited address building details now come from clearanceIndicationSave API
  }
}


getaddressData() {
  if (!this.startupHydrationReady) {
    return;
  }
  // Header click to COPE: validate current step first
  const current = this.step();
  if (!this.canLeaveCurrentStep(1)) {
    return;
  }

  // Save current step when moving from Policy
  if (current === 2) {
    this.accordianCloseForPolicyParameters();
  }

  this.setStep(1);
  // Default-open first COPE address accordion so validations can auto-focus correctly
  this.ensureCopeAccordionStateSize();
  if (this.copeAddressAccordionOpened.length > 0) {
    this.copeAddressAccordionOpened = this.copeAddressAccordionOpened.map((_, i) => i === 0);
  }
  this.clearanceId = Number(sessionStorage.getItem('indicationId'));
  const copeInfoSave = sessionStorage.getItem("copeInfosave");

  if(this.isPolicyType()) {
    this.fetchPolicyDataCopeStep();
    this.fetchPolicySummaryData()
  }else{  
    // this.getCopeData();
    // this.fetchAllBuildingDetails();
    
    // this.getClearanceData()
  }
}


getPolicy(){
    if (!this.startupHydrationReady) {
      return;
    }
    // Header click to Policy Parameters: validate current step first
    if (!this.canLeaveCurrentStep(2)) {
      return;
    }
    // Save COPE when moving forward
    if (this.step() === 1) {
      this.CopeSaveForAccordianClose();
    }
    const PolicyInfoSave = sessionStorage.getItem('PolicyInfoSave')
    const versionNo = Number(sessionStorage.getItem('versionNo'))
   
    this.withPolicyParamContext(() => {
      this.clearanceId = Number(sessionStorage.getItem('indicationId'));
      this.getOandLPolicyParametersData();
      this.getclearanceDataforPolicyParam();
      this.dtcRule = null;
      this.CheckDtcRule();
      if(!this.isIndicationType()&& !this.isPolicyType()){
        this.fetchQuoteRiskSummaryData()
      }
      if(this.isPolicyType()){
        this.fetchPolicyDataCopeStepforPolicyParameters();
        this.getPolicyDataPolicyParameterStep();
        this.fetchPolicySummaryData()
      }else{
        this.getCopeDataforPolicyParameters();
        if(PolicyInfoSave === "true" || (!this.isIndicationType()&& !this.isPolicyType()) || versionNo !== 1){
          this.getPolicyParametersData();
          this.getRagData();        
        }else{
          this.loadCoverageFactors();
        }
      }
    });
 
    this.policyParametersOpened = true;
    this.addressAccordionOpened = this.addresses().map((_, i) => i === 0);
    this.setStep(2)
    this.scrollToPolicy();
}

// ...existing code...
onAccordionHeaderClick(targetStep: number, event: Event) {
  event.preventDefault();
  event.stopPropagation();

  const currentStep = this.step();

  // Don't do anything if already on this step
  if (currentStep === targetStep) return;

  //Clearance validation
  if (currentStep === 0) {
    if(!this.isReadOnly()){
        if(!this.selectedPolicyType()){
    this.toastService.addNotification({message: "Please select policy type before moving to next step", type: ToastType.Error}); // error notification
    return ;
  }
  const cleanedPremium = this.cleanCurrencyValue(this.premium);

  if (!cleanedPremium || isNaN(cleanedPremium) || cleanedPremium <= 0) {
    this.showPremiumError = true;
    this.toastService.addNotification({ 
      message: "Target Premium Amount is required", 
      type: ToastType.Error 
    });
    return;
  } else {
    this.showPremiumError = false;
  }
  
  const questionList = this.questions(); // read signal
    const answers = this.questionAnswers();

    const allAnswered = questionList.every(q => {
      const val = Number(answers[q.questionId]);
      return val === 0 || val === 2;
    });

    if (!allAnswered && !this.isReadOnly()) {
      this.toastService.addNotification({
        message: "Please respond to the Clearance Questions",
        type: ToastType.Error
      });
      return;
    }
  // const formData = this.addressForm.value;

  const formData = this.trimFormValues(this.addressForm.value); 
  
 
  // const buildingForm = this.createBuildingGroup().value;
  let hasError = false;    

  const addressesArray = this.addressForm.get('addresses') as FormArray;

  addressesArray.controls.forEach((addressGroup: AbstractControl, index: number) => {
    const formGroup = addressGroup as FormGroup;

    const buildingDetailsControl = formGroup.get('buildingDetails') as FormArray;
    const structuresControl = formGroup.get('structures') as FormArray;

    buildingDetailsControl.disable();
    structuresControl.disable();

    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      control?.markAsTouched();
   
    });

    formGroup.updateValueAndValidity();

    if (formGroup.invalid) {
    
      hasError = true;
    }

    buildingDetailsControl.enable();
    structuresControl.enable();
    });


    if(this.namedInsured().trim() === ''){
      this.showNamedInsured.set(true);
      return;
    }else{
      this.showNamedInsured.set(false);
    }

    if (hasError) {
    this.scrollToTop();
    return;
     } 
    }
  }

  // --- COPE VALIDATION (when leaving COPE) ---
  if (currentStep === 1) {
    const cleanedPremium = this.cleanCurrencyValue(this.premium);
    if (!this.isReadOnly()) {
      if (!cleanedPremium || isNaN(cleanedPremium) || cleanedPremium <= 0) {
        this.showPremiumError = true;
        this.toastService.addNotification({
          message: "Target Premium Amount is required",
          type: ToastType.Error
        });
        return;
      } else {
        this.showPremiumError = false;
      }

      // Validate Year Built dependencies across all buildings before proceeding
      const addressesForValidation = this.addressForm.get('addresses') as FormArray;
      for (let a = 0; a < addressesForValidation.length; a++) {
        const addressControl = addressesForValidation.at(a) as FormGroup;
        const buildingDetailsFA = addressControl.get('buildingDetails') as FormArray;
        if (buildingDetailsFA && Array.isArray(buildingDetailsFA.controls)) {
          for (const b of buildingDetailsFA.controls) {
            const buildingGroup = b as FormGroup;
            const msg = this.getBuildingYearsValidationMessage(buildingGroup);
            if (msg) {
              this.toastService.addNotification({ message: msg, type: ToastType.Error });
              this.openCopeAddressAccordion(a);
              this.cdRef.detectChanges();
              return;
            }
          }
        }
      }

      if (this.isEditing['story'] || this.isEditing['sqFt'] || this.isEditing['RCV'] || this.isEditing['DistanceToCoast']) {
        const editingLocation = this.findEditingFieldLocation();
        if (editingLocation) {
          this.openCopeAddressAccordion(
            editingLocation.addressIdx,
            editingLocation.buildingIdx,
            editingLocation.fieldName
          );
        }
        this.toastService.addNotification({ message: "Please confirm/decline the editable field changes before proceeding", type: ToastType.Error });
        return;
      }

      if (this.validateCopeFields()) {
        return;
      }
    }
  }

  // --- POLICY PARAMETERS VALIDATION (when leaving Policy Parameters) ---
  if (currentStep === 2) {
    const cleanedPremium = this.cleanCurrencyValue(this.premium);
    if (!this.isReadOnly()) {     

      if (!cleanedPremium || isNaN(cleanedPremium) || cleanedPremium <= 0) {
        this.showPremiumError = true;
        this.toastService.addNotification({
          message: "Target Premium Amount is required",
          type: ToastType.Error
        });
        return;
      } else {
        this.showPremiumError = false;
      }

      if (this.getTotalTIVLimit() > 2500000) {
        this.toastService.addNotification({
          message: "Maximum TIV limit allowed is $2.5M. Please amend the limits entered or exit to return to landing page.",
          type: ToastType.Error
        });
        return;
      }

      if (this.selectedPolicyType() !== 3) {
        for (let i = 0; i < this.addressControls().length; i++) {
          const buildings = this.getPolicyParametersForAddress(i);
          for (let j = 0; j < buildings.length; j++) {
            const buildingLimit = buildings[j].get('buildingLimit')?.value;
            if (
              buildingLimit === 0 ||
              buildingLimit === '0' ||
              buildingLimit === '' ||
              buildingLimit === null ||
              buildingLimit === undefined
            ) {
              this.openPolicyAddressAccordion(i);
              this.toastService.addNotification({
                message: "This type of policy must include building limits. Please edit policy parameters or exit to return to landing page",
                type: ToastType.Error
              });
              return;
            }
          }
        }
      }      

        if(this.selectedPolicyType() ===3){
        for (let i = 0; i < this.addressControls().length; i++) {
          const buildings = this.getPolicyParametersForAddress(i);
          for (let j = 0; j < buildings.length; j++) {
            const buildingLimit = buildings[j].get('buildingLimit')?.value;
              const businessPropertyLimit = buildings[j].get('businessPropertyLimit')?.value;
              const businessIncomeLimit = this.business[i];
              if ((businessPropertyLimit === 0 || businessPropertyLimit === '0' || businessPropertyLimit === '' || businessPropertyLimit === null || businessPropertyLimit === undefined) && (businessIncomeLimit === 0  || businessIncomeLimit === null || businessIncomeLimit === undefined) && (buildingLimit === 0 || buildingLimit === '0' || buildingLimit === '' || buildingLimit === null || buildingLimit === undefined)) {
                this.openPolicyAddressAccordion(i);
                this.toastService.addNotification({message: 'This type of policy must include I&B Limit, or BPP Limit or BI Limit. Please edit policy parameters or exit to return to landing page', type: ToastType.Error}); // error notification
                return;
              }
          }}}
          // Validate Additional Property Coverages/Limit per address/structure
        this.structureValidationTriggered.set(true); // Trigger validation display
        for (let i = 0; i < this.addressControls().length; i++) {
          const structures = this.structureControlsForAddress(i);
          const total = structures.length;
          for (let j = 0; j < total; j++) {
            const error = this.getStructureError(i, j);
            if (error) {       
              this.openPolicyAddressAccordion(i);   
              return;
            }
          }
        }
        if (this.hasPolicyValidationErrors()) {
          return;
        }
        }
  }

  // If validation passes, save the current accordion before opening the target.
  this.saveCurrentAccordionThenNavigate(targetStep);
}


onBindAndIssuePolicyStepCompleted() {
  this.isPolicyType.set(true); // show the step 5
  this.fetchPolicySummaryData(); // update Risk summary panel
  this.isReadOnly.set(true);
  //this.setStep(4);
}
  
onAddressAccordionClose(index: number) {
  this.addressAccordionOpened[index] = false;
}

loadCrimeRating(){
  this.propertyService.fetchCrimeRatingList().subscribe({
    next: (response: any) => {
      if(response){
        this.crimeRatingList.set(response);
      }
    },
    error: (error: any) => {
    }
  });
}


loadConstructionType(){
  this.propertyService.fetchConstructionTypeList().subscribe({
    next: (response: any) => {
      if(response){
        this.constructionTypeList.set(response);
      }
    },
    error: (error: any) => {
    }
  });
}

loadRoofType() {
  this.propertyService.fetchRoofTypeList().subscribe({
    next: (response: any) => {
      if(response){
        this.roofTypeList.set(response);
      }
    },
    error: (error: any) => {
    }
  });
}

loadProtectionClass(){
  this.propertyService.fetchProtectionClassList().subscribe({
    next: (response: any) => {
      if(response){
        this.protectionClassList.set(response);
      }
    },
    error: (error: any) => {
    }
  });
}

CheckDtcRule() {
  let type: string;
  let id: number;

  if (this.isIndicationType()) {
    type = "Indication";
    id = Number(this.authService.getUserDetailsFromStorage().indicationId);
  } else {
    type = "Quote";
    id = Number(this.authService.getUserDetailsFromStorage().quoteId);
  }

  this.propertyService.getDtcRule(id, type).subscribe({
    next: (response: any) => {
      if (response) {
        this.setDtcRule(response.message);
      }
    },
    error: (err: any) => {
   
    }
  });
}

getStoryIconTop(control: AbstractControl): string {
  const storyControl = control.get ? control.get('story') : null;
  const SqFtControl = control.get ? control.get('sqFt') : null;
  if ((storyControl && storyControl.invalid && storyControl.touched) || (SqFtControl && SqFtControl.invalid && SqFtControl.touched)) {
    return '37%';
  }
  return '50%';
}

// ...existing code...
canVisitStep(targetStep: number): boolean {
  // Step 4 and above: all previous steps are disabled
  if (this.step() >= 3 || this.visitedStep() >= 3) {
  
    return false;
    
  }
  // Only allow navigation to steps <= visitedStep
  return targetStep <= this.visitedStep();
}
// ...existing code...


getTotalTIVLimit(): number {
  return [
    this.totalBuildingLimits,
    this.totalBPPPropertyLimits,
    this.totalBusinessIncomeLimits,
    this.totalStructuresLimits
  ].flat().reduce((acc, curr) => acc + curr, 0);
}

ngOnDestroy(): void {
  // Unsubscribe to prevent memory leaks
  this.clearanceDataSubs.unsubscribe();
  this.copeDataSubs.unsubscribe();
  this.policyParameterSubs.unsubscribe();
  this.targetPremiumSubs.unsubscribe();
  if (this.routeSubscription) {
    this.routeSubscription.unsubscribe(); // Unsubscribe when the component is destroyed
  }
  if (this.navLogoClickSubscription) {
    this.navLogoClickSubscription.unsubscribe();
  }
}
}